<template>
  <div class="FLOORPLAN">
    <div class="floorcontent">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1789.36 694.54">

        <g id="图层_2" data-name="图层 2">

          <g id="Layer_2" data-name="Layer 2">
            <g id="Unit_size_legend" data-name="Unit size legend">
              <path
                d="M1555.69,465.74h-2.39v-.12l.21,0a.9.9,0,0,0,.39-.12.44.44,0,0,0,.16-.31,3.89,3.89,0,0,0,0-.68v-2.17c0-.85-.34-1.28-1-1.27a1.69,1.69,0,0,0-.75.18,2.49,2.49,0,0,0-.65.48,1.45,1.45,0,0,1,0,.25c0,.11,0,.2,0,.3v2.23a5.66,5.66,0,0,0,0,.68.45.45,0,0,0,.17.31.81.81,0,0,0,.38.12l.22,0v.12h-2.4v-.12l.21,0a.9.9,0,0,0,.39-.12.44.44,0,0,0,.16-.31,3.89,3.89,0,0,0,0-.68v-2.17c0-.85-.34-1.28-1-1.27a1.65,1.65,0,0,0-.72.17,2.79,2.79,0,0,0-.63.45v2.82a5.66,5.66,0,0,0,0,.68.45.45,0,0,0,.17.31.81.81,0,0,0,.38.12l.21,0v.12H1547v-.12l.22,0a.8.8,0,0,0,.37-.12.48.48,0,0,0,.16-.31,5.37,5.37,0,0,0,0-.68V462a1,1,0,0,0-.1-.53.69.69,0,0,0-.39-.26l-.31-.12V461l1.5-.36.1.07v.76a4.43,4.43,0,0,1,.79-.61,1.77,1.77,0,0,1,.9-.23,1.51,1.51,0,0,1,.91.24,1.17,1.17,0,0,1,.45.65,5.11,5.11,0,0,1,.85-.64,2,2,0,0,1,.92-.25c1,0,1.46.52,1.46,1.59v2.29a3.89,3.89,0,0,0,0,.68.41.41,0,0,0,.16.31.76.76,0,0,0,.36.12l.23,0Zm-10.32-2.47a2.89,2.89,0,0,1-.33,1.34,2.46,2.46,0,0,1-.87.91,2.37,2.37,0,0,1-1.23.34,2.46,2.46,0,0,1-1.21-.29,2.18,2.18,0,0,1-.88-.9,3.18,3.18,0,0,1-.34-1.49,2.74,2.74,0,0,1,.34-1.34,2.38,2.38,0,0,1,.86-.92,2.44,2.44,0,0,1,1.23-.34,2.49,2.49,0,0,1,1.21.3,2.24,2.24,0,0,1,.88.9A3.15,3.15,0,0,1,1545.37,463.27Zm-.91.2a3.67,3.67,0,0,0-.47-2,1.44,1.44,0,0,0-1.22-.76,1.13,1.13,0,0,0-1,.52,3.16,3.16,0,0,0-.37,1.69,3.81,3.81,0,0,0,.47,2,1.44,1.44,0,0,0,1.23.75,1.08,1.08,0,0,0,1-.51A3.2,3.2,0,0,0,1544.46,463.47Zm-5.8-.2a2.89,2.89,0,0,1-.33,1.34,2.46,2.46,0,0,1-.87.91,2.37,2.37,0,0,1-1.23.34,2.46,2.46,0,0,1-1.21-.29,2.18,2.18,0,0,1-.88-.9,3.18,3.18,0,0,1-.34-1.49,2.74,2.74,0,0,1,.34-1.34,2.38,2.38,0,0,1,.86-.92,2.44,2.44,0,0,1,1.23-.34,2.49,2.49,0,0,1,1.21.3,2.24,2.24,0,0,1,.88.9A3.15,3.15,0,0,1,1538.66,463.27Zm-.91.2a3.67,3.67,0,0,0-.47-2,1.44,1.44,0,0,0-1.22-.76,1.13,1.13,0,0,0-1,.52,3.16,3.16,0,0,0-.37,1.69,3.81,3.81,0,0,0,.47,2,1.44,1.44,0,0,0,1.23.75,1.08,1.08,0,0,0,1-.51A3.2,3.2,0,0,0,1537.75,463.47Zm-5.32-2.43a.85.85,0,0,1-.14.47.33.33,0,0,1-.27.16.84.84,0,0,1-.33-.11,4.8,4.8,0,0,1-.55-.37,3.21,3.21,0,0,0-.46.29,1.87,1.87,0,0,0-.38.36v2.64a3.89,3.89,0,0,0,0,.68.46.46,0,0,0,.22.31,1.29,1.29,0,0,0,.49.12l.28,0v.12h-2.62v-.12l.22,0a.76.76,0,0,0,.37-.12.48.48,0,0,0,.16-.31,5.37,5.37,0,0,0,0-.68V462a1,1,0,0,0-.1-.53.69.69,0,0,0-.39-.26l-.31-.12V461l1.5-.36.1.07v.88a4.12,4.12,0,0,1,.84-.75,1.39,1.39,0,0,1,.72-.22.71.71,0,0,1,.41.11A.39.39,0,0,1,1532.43,461Zm-5,4.7c-.61,0-1.14,0-1.58,0v-.66a3.85,3.85,0,0,1-.72.52,2,2,0,0,1-2-.11,2,2,0,0,1-.72-.83,2.63,2.63,0,0,1-.26-1.16,3.45,3.45,0,0,1,.35-1.53,2.59,2.59,0,0,1,.92-1,2.54,2.54,0,0,1,1.31-.34,5,5,0,0,1,1.12.1v-1.54a1.05,1.05,0,0,0-.1-.54.73.73,0,0,0-.39-.25l-.31-.12v-.09l1.5-.35.1.07v6.53a5.66,5.66,0,0,0,0,.68.48.48,0,0,0,.16.31.8.8,0,0,0,.37.12l.22,0Zm-1.58-3.35a1.74,1.74,0,0,0-.36-1.15,1.2,1.2,0,0,0-.94-.39,1.5,1.5,0,0,0-1.19.53,2.38,2.38,0,0,0-.46,1.56,3.43,3.43,0,0,0,.21,1.24,2,2,0,0,0,.62.85,1.49,1.49,0,0,0,1,.32,1.72,1.72,0,0,0,.62-.1,2.28,2.28,0,0,0,.55-.35Zm-9.22.24v.14a3.19,3.19,0,0,0,.55,1.89,1.72,1.72,0,0,0,2.22.47,2.83,2.83,0,0,0,.68-.63l.13.05a2.83,2.83,0,0,1-.84.94,2,2,0,0,1-1.18.37,2.21,2.21,0,0,1-1.68-.67,2.65,2.65,0,0,1-.65-1.85,2.89,2.89,0,0,1,.36-1.47,2.55,2.55,0,0,1,.89-.95,2.09,2.09,0,0,1,1.13-.34c1.28,0,1.94.67,2,2.05Zm2.67-.18a2.22,2.22,0,0,0-.35-1.23,1,1,0,0,0-.86-.43,1.25,1.25,0,0,0-1,.44,2.18,2.18,0,0,0-.46,1.22Zm-5.17,1.18a1.87,1.87,0,0,1-.79,1.53,3.4,3.4,0,0,1-2,.58h-3v-.12l.39-.05a.59.59,0,0,0,.51-.32,2.64,2.64,0,0,0,.12-1.05V460a2.64,2.64,0,0,0-.12-1.05.56.56,0,0,0-.51-.31l-.39-.06v-.11h3a3.13,3.13,0,0,1,1.74.42,1.4,1.4,0,0,1,.66,1.22,1.35,1.35,0,0,1-.38,1,2.93,2.93,0,0,1-1,.64,2.64,2.64,0,0,1,1.26.67A1.8,1.8,0,0,1,1514.18,463.63Zm-1.29-3.38a1.73,1.73,0,0,0-.41-1.2,1.61,1.61,0,0,0-1.22-.45,4.06,4.06,0,0,0-1,.1v3.14h.74a2.37,2.37,0,0,0,1.41-.38A1.4,1.4,0,0,0,1512.89,460.25Zm.35,3.65a1.71,1.71,0,0,0-.58-1.4,2.42,2.42,0,0,0-1.53-.46h-.87v2.16a1.59,1.59,0,0,0,.26,1.11,1.36,1.36,0,0,0,1,.27,1.77,1.77,0,0,0,1.24-.45A1.63,1.63,0,0,0,1513.24,463.9Zm-10.27-.8a2.52,2.52,0,0,1-.51,1.51,3.13,3.13,0,0,1-1.18.93,3.31,3.31,0,0,1-1.36.31,1.34,1.34,0,0,1-.76-.17.5.5,0,0,1-.25-.43.37.37,0,0,1,.14-.32.4.4,0,0,1,.3-.11,1,1,0,0,1,.55.17,2.29,2.29,0,0,1,.53.57,2.3,2.3,0,0,0,.93-.29,2,2,0,0,0,.7-.68,1.93,1.93,0,0,0,.28-1,1.39,1.39,0,0,0-.43-1.09,1.72,1.72,0,0,0-1.15-.36,2.1,2.1,0,0,0-.51.06,4.44,4.44,0,0,0-.49.19l-.11-.19a10.78,10.78,0,0,0,1.52-.94,2.57,2.57,0,0,0,.7-.73,1.29,1.29,0,0,0,.17-.67.92.92,0,0,0-.29-.7,1.26,1.26,0,0,0-.87-.27,2.07,2.07,0,0,0-1,.22,4.23,4.23,0,0,0-.83.63l-.11-.12a4.11,4.11,0,0,1,1.15-1,2.43,2.43,0,0,1,1.19-.29,1.63,1.63,0,0,1,1.09.33,1.17,1.17,0,0,1,.41.93,1.52,1.52,0,0,1-.4,1,5.25,5.25,0,0,1-1.23,1,2.21,2.21,0,0,1,1.31.46A1.43,1.43,0,0,1,1503,463.1Z"
              />
              <path
                d="M1608.09,497.5h-2.39v-.12l.22,0a.85.85,0,0,0,.38-.12.44.44,0,0,0,.16-.31,3.89,3.89,0,0,0,0-.68v-2.17c0-.85-.34-1.28-1-1.27a1.65,1.65,0,0,0-.74.18,2.2,2.2,0,0,0-.65.48c0,.07,0,.15,0,.25s0,.2,0,.3v2.23a3.89,3.89,0,0,0,0,.68.44.44,0,0,0,.16.31.85.85,0,0,0,.38.12l.22,0v.12h-2.4v-.12l.21,0a.9.9,0,0,0,.39-.12.44.44,0,0,0,.16-.31,3.89,3.89,0,0,0,0-.68v-2.17c0-.85-.34-1.28-1-1.27a1.65,1.65,0,0,0-.72.17,2.51,2.51,0,0,0-.63.45v2.82a5.66,5.66,0,0,0,0,.68.45.45,0,0,0,.17.31.81.81,0,0,0,.38.12l.22,0v.12h-2.39v-.12l.22,0a.76.76,0,0,0,.37-.12.45.45,0,0,0,.16-.32,3.76,3.76,0,0,0,0-.67v-2.52a1,1,0,0,0-.1-.54.73.73,0,0,0-.39-.25l-.31-.12v-.08l1.5-.36.1.07v.76a4.15,4.15,0,0,1,.8-.61,1.71,1.71,0,0,1,.89-.23,1.51,1.51,0,0,1,.91.24,1.14,1.14,0,0,1,.45.65,5.11,5.11,0,0,1,.85-.64,2,2,0,0,1,.92-.25c1,0,1.46.52,1.46,1.59v2.29a3.89,3.89,0,0,0,0,.68.44.44,0,0,0,.16.31.76.76,0,0,0,.37.12l.22,0Zm-10.24,0c-.61,0-1.14,0-1.58,0v-.76a4.23,4.23,0,0,1-.82.61,1.77,1.77,0,0,1-.9.22c-1,0-1.47-.51-1.49-1.59v-2.29a1,1,0,0,0-.09-.54.81.81,0,0,0-.4-.25l-.31-.12v-.08l1.5-.36.1.07v3.46a1.44,1.44,0,0,0,.27,1,.94.94,0,0,0,.75.32,1.6,1.6,0,0,0,.75-.18,2.71,2.71,0,0,0,.64-.44v-2.83a1.05,1.05,0,0,0-.1-.54.73.73,0,0,0-.39-.25l-.31-.12v-.08l1.5-.36.1.07v3.8a5.66,5.66,0,0,0,0,.68.48.48,0,0,0,.16.31.8.8,0,0,0,.37.12l.22,0Zm-7.63-6.83a.53.53,0,0,1-.57.55.57.57,0,0,1-.4-.15.59.59,0,0,1,0-.81.54.54,0,0,1,.4-.16.54.54,0,0,1,.41.16A.58.58,0,0,1,1590.22,490.67Zm.73,6.83h-2.38v-.12l.22,0a.8.8,0,0,0,.37-.12.49.49,0,0,0,.16-.32,5.47,5.47,0,0,0,0-.67v-2.52a1,1,0,0,0-.09-.54.73.73,0,0,0-.4-.25l-.3-.12v-.08l1.5-.36.09.07v3.8a5.24,5.24,0,0,0,0,.68.45.45,0,0,0,.17.31.81.81,0,0,0,.38.12l.21,0Zm-3.74,0h-2.38v-.12l.21,0a.81.81,0,0,0,.38-.12.45.45,0,0,0,.17-.31,5.24,5.24,0,0,0,0-.68v-2.17c0-.85-.34-1.28-1-1.27a1.66,1.66,0,0,0-.75.18,2.33,2.33,0,0,0-.65.48,1.56,1.56,0,0,1,0,.25c0,.11,0,.2,0,.3v2.23a5.24,5.24,0,0,0,0,.68.45.45,0,0,0,.17.31.81.81,0,0,0,.38.12l.21,0v.12h-2.39v-.12l.21,0a.81.81,0,0,0,.38-.12.45.45,0,0,0,.17-.31,5.66,5.66,0,0,0,0-.68v-2.17c0-.85-.33-1.28-1-1.27a1.65,1.65,0,0,0-.71.17,2.39,2.39,0,0,0-.64.45v2.82a3.89,3.89,0,0,0,0,.68.44.44,0,0,0,.16.31.9.9,0,0,0,.39.12l.21,0v.12h-2.39v-.12l.23,0a.85.85,0,0,0,.37-.12.49.49,0,0,0,.16-.32,5.47,5.47,0,0,0,0-.67v-2.52a1,1,0,0,0-.09-.54.77.77,0,0,0-.4-.25l-.31-.12v-.08l1.51-.36.09.07v.76a4.47,4.47,0,0,1,.8-.61,1.73,1.73,0,0,1,.89-.23,1.53,1.53,0,0,1,.92.24,1.24,1.24,0,0,1,.45.65,4.68,4.68,0,0,1,.84-.64,2,2,0,0,1,.93-.25c1,0,1.46.52,1.46,1.59v2.29a5.66,5.66,0,0,0,0,.68.48.48,0,0,0,.16.31.8.8,0,0,0,.37.12l.22,0Zm-13.65-3.11v.14a3.12,3.12,0,0,0,.54,1.89,1.67,1.67,0,0,0,1.34.69,1.6,1.6,0,0,0,.88-.22,2.86,2.86,0,0,0,.69-.63l.13.05a2.75,2.75,0,0,1-.85.94,2,2,0,0,1-1.18.37,2.22,2.22,0,0,1-1.68-.67,2.71,2.71,0,0,1-.65-1.85,3.1,3.1,0,0,1,.36-1.47,2.66,2.66,0,0,1,.9-.95,2.07,2.07,0,0,1,1.13-.34c1.28,0,1.94.67,2,2.05Zm2.66-.18a2.19,2.19,0,0,0-.35-1.23,1,1,0,0,0-.85-.44,1.31,1.31,0,0,0-1,.45,2.14,2.14,0,0,0-.45,1.22Zm-4.92-1.41a.85.85,0,0,1-.13.47.33.33,0,0,1-.27.16.84.84,0,0,1-.33-.11,4.77,4.77,0,0,1-.56-.37,2.92,2.92,0,0,0-.46.29,2.6,2.6,0,0,0-.38.36v2.64a3.7,3.7,0,0,0,0,.68.42.42,0,0,0,.21.31,1.35,1.35,0,0,0,.5.12l.27,0v.12h-2.62v-.12l.23,0a.85.85,0,0,0,.37-.12.44.44,0,0,0,.15-.32,3.76,3.76,0,0,0,0-.67v-2.52a1,1,0,0,0-.09-.54.77.77,0,0,0-.4-.25l-.31-.12v-.08l1.51-.36.09.07v.88a4.12,4.12,0,0,1,.84-.75,1.4,1.4,0,0,1,.73-.22.73.73,0,0,1,.41.11A.38.38,0,0,1,1571.3,492.8Zm-5.22-.56a1.88,1.88,0,0,1-.76,1.55,3.72,3.72,0,0,1-2,.65l0-.12a2.38,2.38,0,0,0,1.34-.59,2,2,0,0,0,.45-1.43,1.93,1.93,0,0,0-.52-1.47,2,2,0,0,0-1.36-.47,3.63,3.63,0,0,0-.5,0l-.39.08V496a4.19,4.19,0,0,0,.07.83.58.58,0,0,0,.24.39,1.13,1.13,0,0,0,.49.15l.42.05v.12h-3.09v-.12l.39-.05a.59.59,0,0,0,.51-.32,2.64,2.64,0,0,0,.12-1.05v-4.25a2.64,2.64,0,0,0-.12-1,.56.56,0,0,0-.51-.31l-.39-.06v-.11h3a3.8,3.8,0,0,1,1.36.22,2.07,2.07,0,0,1,.94.68A1.83,1.83,0,0,1,1566.08,492.24Zm-10.39,5.26h-2.39v-.12l.21,0a.9.9,0,0,0,.39-.12.44.44,0,0,0,.16-.31,3.89,3.89,0,0,0,0-.68v-2.17c0-.85-.34-1.28-1-1.27a1.69,1.69,0,0,0-.75.18,2.49,2.49,0,0,0-.65.48,1.45,1.45,0,0,1,0,.25c0,.11,0,.2,0,.3v2.23a5.66,5.66,0,0,0,0,.68.45.45,0,0,0,.17.31.81.81,0,0,0,.38.12l.22,0v.12h-2.4v-.12l.21,0a.9.9,0,0,0,.39-.12.44.44,0,0,0,.16-.31,3.89,3.89,0,0,0,0-.68v-2.17c0-.85-.34-1.28-1-1.27a1.65,1.65,0,0,0-.72.17,2.51,2.51,0,0,0-.63.45v2.82a5.66,5.66,0,0,0,0,.68.45.45,0,0,0,.17.31.81.81,0,0,0,.38.12l.21,0v.12H1547v-.12l.22,0a.8.8,0,0,0,.37-.12.49.49,0,0,0,.16-.32,5.06,5.06,0,0,0,0-.67v-2.52a1.05,1.05,0,0,0-.1-.54.73.73,0,0,0-.39-.25l-.31-.12v-.08l1.5-.36.1.07v.76a4.43,4.43,0,0,1,.79-.61,1.77,1.77,0,0,1,.9-.23,1.51,1.51,0,0,1,.91.24,1.14,1.14,0,0,1,.45.65,5.11,5.11,0,0,1,.85-.64,2,2,0,0,1,.92-.25c1,0,1.46.52,1.46,1.59v2.29a3.89,3.89,0,0,0,0,.68.41.41,0,0,0,.16.31.76.76,0,0,0,.36.12l.23,0ZM1545.37,495a2.89,2.89,0,0,1-.33,1.34,2.46,2.46,0,0,1-.87.91,2.37,2.37,0,0,1-1.23.34,2.57,2.57,0,0,1-1.21-.29,2.18,2.18,0,0,1-.88-.9,3.18,3.18,0,0,1-.34-1.49,2.74,2.74,0,0,1,.34-1.34,2.38,2.38,0,0,1,.86-.92,2.44,2.44,0,0,1,1.23-.34,2.49,2.49,0,0,1,1.21.3,2.24,2.24,0,0,1,.88.9A3.15,3.15,0,0,1,1545.37,495Zm-.91.2a3.67,3.67,0,0,0-.47-2,1.44,1.44,0,0,0-1.22-.76,1.13,1.13,0,0,0-1,.52,3.16,3.16,0,0,0-.37,1.69,3.81,3.81,0,0,0,.47,2,1.44,1.44,0,0,0,1.23.75,1.08,1.08,0,0,0,1-.51A3.2,3.2,0,0,0,1544.46,495.23Zm-5.8-.2a2.89,2.89,0,0,1-.33,1.34,2.46,2.46,0,0,1-.87.91,2.37,2.37,0,0,1-1.23.34,2.57,2.57,0,0,1-1.21-.29,2.18,2.18,0,0,1-.88-.9,3.18,3.18,0,0,1-.34-1.49,2.74,2.74,0,0,1,.34-1.34,2.38,2.38,0,0,1,.86-.92,2.44,2.44,0,0,1,1.23-.34,2.49,2.49,0,0,1,1.21.3,2.24,2.24,0,0,1,.88.9A3.15,3.15,0,0,1,1538.66,495Zm-.91.2a3.67,3.67,0,0,0-.47-2,1.44,1.44,0,0,0-1.22-.76,1.13,1.13,0,0,0-1,.52,3.16,3.16,0,0,0-.37,1.69,3.81,3.81,0,0,0,.47,2,1.44,1.44,0,0,0,1.23.75,1.08,1.08,0,0,0,1-.51A3.2,3.2,0,0,0,1537.75,495.23Zm-5.32-2.43a.85.85,0,0,1-.14.47.33.33,0,0,1-.27.16.84.84,0,0,1-.33-.11,4.8,4.8,0,0,1-.55-.37,2.52,2.52,0,0,0-.46.29,1.87,1.87,0,0,0-.38.36v2.64a3.89,3.89,0,0,0,0,.68.46.46,0,0,0,.22.31,1.29,1.29,0,0,0,.49.12l.28,0v.12h-2.62v-.12l.22,0a.76.76,0,0,0,.37-.12.49.49,0,0,0,.16-.32,5.06,5.06,0,0,0,0-.67v-2.52a1.05,1.05,0,0,0-.1-.54.73.73,0,0,0-.39-.25l-.31-.12v-.08l1.5-.36.1.07v.88a4.12,4.12,0,0,1,.84-.75,1.39,1.39,0,0,1,.72-.22.71.71,0,0,1,.41.11A.39.39,0,0,1,1532.43,492.8Zm-5,4.7c-.61,0-1.14,0-1.58,0v-.66a3.85,3.85,0,0,1-.72.52,2,2,0,0,1-.91.21,1.87,1.87,0,0,1-1.09-.32,2,2,0,0,1-.72-.83,2.63,2.63,0,0,1-.26-1.16,3.45,3.45,0,0,1,.35-1.53,2.59,2.59,0,0,1,.92-1,2.54,2.54,0,0,1,1.31-.34,5,5,0,0,1,1.12.1V491a1.05,1.05,0,0,0-.1-.54.73.73,0,0,0-.39-.25l-.31-.12V490l1.5-.35.1.07v6.53a5.66,5.66,0,0,0,0,.68.48.48,0,0,0,.16.31.8.8,0,0,0,.37.12l.22,0Zm-1.58-3.35a1.74,1.74,0,0,0-.36-1.15,1.2,1.2,0,0,0-.94-.39,1.5,1.5,0,0,0-1.19.53,2.38,2.38,0,0,0-.46,1.56,3.43,3.43,0,0,0,.21,1.24,2,2,0,0,0,.62.85,1.55,1.55,0,0,0,1,.32,1.72,1.72,0,0,0,.62-.1,2.28,2.28,0,0,0,.55-.35Zm-9.22.24v.14a3.19,3.19,0,0,0,.55,1.89,1.65,1.65,0,0,0,1.34.69,1.62,1.62,0,0,0,.88-.22,2.83,2.83,0,0,0,.68-.63l.13.05a2.83,2.83,0,0,1-.84.94,2,2,0,0,1-1.18.37,2.21,2.21,0,0,1-1.68-.67,2.67,2.67,0,0,1-.65-1.85,2.89,2.89,0,0,1,.36-1.47,2.55,2.55,0,0,1,.89-.95,2.09,2.09,0,0,1,1.13-.34c1.28,0,1.94.67,2,2.05Zm2.67-.18A2.19,2.19,0,0,0,1519,493a1,1,0,0,0-.86-.44,1.29,1.29,0,0,0-1,.45,2.15,2.15,0,0,0-.46,1.22Zm-5.17,1.18a1.84,1.84,0,0,1-.79,1.52,3.41,3.41,0,0,1-2,.59h-.74l-.75,0h-1.47v-.12l.39-.05a.59.59,0,0,0,.51-.32,2.64,2.64,0,0,0,.12-1.05v-4.25a2.64,2.64,0,0,0-.12-1,.56.56,0,0,0-.51-.31l-.39-.06v-.11h3a3.13,3.13,0,0,1,1.74.42,1.4,1.4,0,0,1,.66,1.22,1.35,1.35,0,0,1-.38,1,2.93,2.93,0,0,1-1,.64,2.64,2.64,0,0,1,1.26.67A1.78,1.78,0,0,1,1514.18,495.39Zm-1.29-3.38a1.73,1.73,0,0,0-.41-1.2,1.61,1.61,0,0,0-1.22-.45,4.06,4.06,0,0,0-1,.1v3.14h.74a2.37,2.37,0,0,0,1.41-.38A1.4,1.4,0,0,0,1512.89,492Zm.35,3.65a1.7,1.7,0,0,0-.58-1.4,2.42,2.42,0,0,0-1.53-.46h-.87V496a1.59,1.59,0,0,0,.26,1.11,1.36,1.36,0,0,0,1,.27,1.77,1.77,0,0,0,1.24-.45A1.63,1.63,0,0,0,1513.24,495.66Zm-10.27-.8a2.52,2.52,0,0,1-.51,1.51,3.13,3.13,0,0,1-1.18.93,3.31,3.31,0,0,1-1.36.31,1.34,1.34,0,0,1-.76-.17.5.5,0,0,1-.25-.43.37.37,0,0,1,.14-.32.4.4,0,0,1,.3-.11,1,1,0,0,1,.55.17,2.41,2.41,0,0,1,.53.56,2.15,2.15,0,0,0,.93-.28,2,2,0,0,0,.7-.68,1.93,1.93,0,0,0,.28-1,1.38,1.38,0,0,0-.43-1.09,1.72,1.72,0,0,0-1.15-.36,2.1,2.1,0,0,0-.51.06l-.49.18-.11-.18a10.78,10.78,0,0,0,1.52-.94,2.57,2.57,0,0,0,.7-.73,1.29,1.29,0,0,0,.17-.67.92.92,0,0,0-.29-.7,1.31,1.31,0,0,0-.87-.28,2.07,2.07,0,0,0-1,.23,4.23,4.23,0,0,0-.83.63l-.11-.12a4.11,4.11,0,0,1,1.15-1,2.43,2.43,0,0,1,1.19-.29,1.63,1.63,0,0,1,1.09.33,1.17,1.17,0,0,1,.41.93,1.48,1.48,0,0,1-.4,1,5,5,0,0,1-1.23,1,2.27,2.27,0,0,1,1.31.45A1.47,1.47,0,0,1,1503,494.86Z"
              />
              <line
                class="cls-3"
                x1="1499.42"
                y1="449.1"
                x2="1788.53"
                y2="449.1"
              />
              <line
                class="cls-3"
                x1="1499.42"
                y1="525.03"
                x2="1788.53"
                y2="525.03"
              />
              <line
                class="cls-3"
                x1="1499.42"
                y1="569.7"
                x2="1788.53"
                y2="569.7"
              />
              <path
                class="cls-4"
                d="M1483.29,470.69a8.49,8.49,0,0,0,8.19-8.44,8.32,8.32,0,1,0-16.63,0A8.53,8.53,0,0,0,1483.29,470.69Z"
              />
              <path
                d="M1555.15,334h-2.38v-.11l.21,0a1.07,1.07,0,0,0,.39-.11.44.44,0,0,0,.16-.31,4,4,0,0,0,0-.69v-2.16c0-.86-.34-1.28-1-1.27a1.66,1.66,0,0,0-.75.18,2.33,2.33,0,0,0-.65.48.85.85,0,0,1,0,.25c0,.1,0,.2,0,.29v2.23a5.29,5.29,0,0,0,0,.69.45.45,0,0,0,.17.31,1,1,0,0,0,.38.11l.21,0V334h-2.39v-.11l.21,0a1,1,0,0,0,.38-.11.45.45,0,0,0,.17-.31,5.29,5.29,0,0,0,0-.69v-2.16c0-.86-.34-1.28-1-1.27a1.65,1.65,0,0,0-.72.17,2.32,2.32,0,0,0-.64.45v2.81a4,4,0,0,0,0,.69.44.44,0,0,0,.16.31,1.07,1.07,0,0,0,.39.11l.21,0V334h-2.38v-.11l.22,0a1,1,0,0,0,.37-.11.49.49,0,0,0,.16-.32,5.66,5.66,0,0,0,0-.68v-2.51a1,1,0,0,0-.09-.54.73.73,0,0,0-.4-.25l-.31-.12v-.09l1.51-.35.09.07v.75a4.75,4.75,0,0,1,.8-.6,1.77,1.77,0,0,1,.9-.23,1.51,1.51,0,0,1,.91.24,1.24,1.24,0,0,1,.45.65,4.3,4.3,0,0,1,.85-.64,1.92,1.92,0,0,1,.92-.25c1,0,1.46.52,1.46,1.59v2.28a5.73,5.73,0,0,0,0,.69.48.48,0,0,0,.16.31,1,1,0,0,0,.37.11l.22,0Zm-10.32-2.46a2.69,2.69,0,0,1-.33,1.34,2.35,2.35,0,0,1-2.09,1.25,2.47,2.47,0,0,1-1.21-.3,2.16,2.16,0,0,1-.88-.89,3.08,3.08,0,0,1-.34-1.5,2.8,2.8,0,0,1,.33-1.34,2.53,2.53,0,0,1,.87-.91,2.47,2.47,0,0,1,2.43,0,2.18,2.18,0,0,1,.88.9A3,3,0,0,1,1544.83,331.5Zm-.9.2a3.71,3.71,0,0,0-.47-2,1.47,1.47,0,0,0-1.22-.75,1.11,1.11,0,0,0-1,.52,3.13,3.13,0,0,0-.37,1.69,3.81,3.81,0,0,0,.47,2,1.43,1.43,0,0,0,1.23.75,1.09,1.09,0,0,0,1-.52A3.13,3.13,0,0,0,1543.93,331.7Zm-5.7-.2a2.92,2.92,0,0,1-.33,1.34,2.38,2.38,0,0,1-2.1,1.25,2.49,2.49,0,0,1-1.21-.3,2.22,2.22,0,0,1-.88-.89,3.2,3.2,0,0,1-.34-1.5,2.8,2.8,0,0,1,.34-1.34,2.53,2.53,0,0,1,.87-.91,2.4,2.4,0,0,1,1.22-.34,2.47,2.47,0,0,1,1.21.3,2.18,2.18,0,0,1,.88.9A3.13,3.13,0,0,1,1538.23,331.5Zm-.9.2a3.81,3.81,0,0,0-.47-2,1.48,1.48,0,0,0-1.23-.75,1.08,1.08,0,0,0-1,.52,3.13,3.13,0,0,0-.37,1.69,3.71,3.71,0,0,0,.47,2,1.41,1.41,0,0,0,1.22.75,1.09,1.09,0,0,0,1-.52A3.13,3.13,0,0,0,1537.33,331.7Zm-5.44-2.43a.77.77,0,0,1-.13.47.33.33,0,0,1-.27.16.84.84,0,0,1-.33-.11,5.78,5.78,0,0,1-.56-.37,2.85,2.85,0,0,0-.45.29,2.25,2.25,0,0,0-.39.36v2.63a3.74,3.74,0,0,0,0,.69.42.42,0,0,0,.21.31,1.62,1.62,0,0,0,.5.11l.28,0V334h-2.62v-.11l.22,0a1,1,0,0,0,.37-.11.49.49,0,0,0,.16-.32,5.66,5.66,0,0,0,0-.68v-2.51a1,1,0,0,0-.09-.54.73.73,0,0,0-.4-.25l-.3-.12v-.09l1.5-.35.09.07v.88a4.35,4.35,0,0,1,.84-.75,1.31,1.31,0,0,1,.73-.22.71.71,0,0,1,.41.11A.38.38,0,0,1,1531.89,329.27ZM1527,334c-.61,0-1.14,0-1.59,0v-.67a3.2,3.2,0,0,1-.71.53,2.15,2.15,0,0,1-.92.21,2,2,0,0,1-1.09-.32,2.07,2.07,0,0,1-.72-.83,2.63,2.63,0,0,1-.25-1.16,3.29,3.29,0,0,1,.35-1.53,2.45,2.45,0,0,1,.92-1,2.51,2.51,0,0,1,1.31-.34,4.89,4.89,0,0,1,1.11.1v-1.55a1,1,0,0,0-.09-.53.68.68,0,0,0-.4-.25l-.3-.12v-.09l1.5-.35.09.06v6.53a5.29,5.29,0,0,0,0,.69.48.48,0,0,0,.16.31.9.9,0,0,0,.37.11l.22,0Zm-1.59-3.35a1.67,1.67,0,0,0-.35-1.14,1.21,1.21,0,0,0-1-.39,1.45,1.45,0,0,0-1.18.53,2.44,2.44,0,0,0-.47,1.56,3.47,3.47,0,0,0,.22,1.24,2,2,0,0,0,.62.85,1.55,1.55,0,0,0,.94.32,1.77,1.77,0,0,0,.63-.11,1.79,1.79,0,0,0,.54-.34Zm-9.1.25V331a3.12,3.12,0,0,0,.54,1.89,1.67,1.67,0,0,0,1.34.69,1.62,1.62,0,0,0,.88-.22,2.86,2.86,0,0,0,.69-.63l.13,0a3,3,0,0,1-.85.94,2,2,0,0,1-1.18.37,2.19,2.19,0,0,1-1.68-.68,2.63,2.63,0,0,1-.65-1.85,3.06,3.06,0,0,1,.36-1.46,2.58,2.58,0,0,1,.9-1,2.07,2.07,0,0,1,1.13-.34c1.27,0,1.94.67,2,2.05Zm2.66-.18a2.23,2.23,0,0,0-.35-1.24,1,1,0,0,0-.85-.43,1.31,1.31,0,0,0-1,.45,2.14,2.14,0,0,0-.45,1.22Zm-5.27,1.18a1.88,1.88,0,0,1-.79,1.52,3.34,3.34,0,0,1-2,.58h-3v-.11l.4-.06a.53.53,0,0,0,.5-.31,2.79,2.79,0,0,0,.13-1.05v-4.25a2.79,2.79,0,0,0-.13-1.05.56.56,0,0,0-.5-.32l-.4-.05v-.12h3.06a3.07,3.07,0,0,1,1.74.43,1.45,1.45,0,0,1,.28,2.19,3,3,0,0,1-1,.64,2.56,2.56,0,0,1,1.25.67A1.75,1.75,0,0,1,1513.65,331.86Zm-1.29-3.38a1.66,1.66,0,0,0-.42-1.2,1.55,1.55,0,0,0-1.21-.45,4.06,4.06,0,0,0-1,.1v3.14h.73a2.32,2.32,0,0,0,1.41-.38A1.41,1.41,0,0,0,1512.36,328.48Zm.35,3.65a1.73,1.73,0,0,0-.58-1.4,2.38,2.38,0,0,0-1.53-.46h-.87v2.16a1.61,1.61,0,0,0,.26,1.11,1.32,1.32,0,0,0,1,.26,1.72,1.72,0,0,0,1.24-.44A1.68,1.68,0,0,0,1512.71,332.13Zm-6.44-.95h-2.73v-.36h2.73ZM1502,334h-3.14v-.11l.42-.06a1.14,1.14,0,0,0,.49-.14.6.6,0,0,0,.24-.4,3.39,3.39,0,0,0,.07-.82v-4.09a3.6,3.6,0,0,0-.07-.79.5.5,0,0,0-.27-.35,1.55,1.55,0,0,0-.59-.08h-.29V327a10.17,10.17,0,0,0,1-.22,7.77,7.77,0,0,0,.9-.31l.1.06v5.89a4.15,4.15,0,0,0,.06.82.63.63,0,0,0,.23.4,1,1,0,0,0,.45.14l.36.06Z"
              />
              <path
                d="M1557,376.14h-2.39V376l.21,0a.9.9,0,0,0,.39-.12.42.42,0,0,0,.16-.31,3.75,3.75,0,0,0,0-.68v-2.16c0-.86-.34-1.28-1-1.27a1.66,1.66,0,0,0-.75.18,2.33,2.33,0,0,0-.65.48.81.81,0,0,1,0,.25c0,.1,0,.2,0,.29v2.23a5.43,5.43,0,0,0,0,.68.43.43,0,0,0,.17.31.81.81,0,0,0,.38.12l.21,0v.12h-2.39V376l.21,0a.81.81,0,0,0,.38-.12.43.43,0,0,0,.17-.31,5,5,0,0,0,0-.68v-2.16c0-.86-.34-1.28-1-1.27a1.53,1.53,0,0,0-.72.17,2.52,2.52,0,0,0-.64.44v2.82a5,5,0,0,0,0,.68.43.43,0,0,0,.17.31.81.81,0,0,0,.38.12l.21,0v.12h-2.38V376l.22,0a.8.8,0,0,0,.37-.12.46.46,0,0,0,.16-.31,5.66,5.66,0,0,0,0-.68v-2.52a.93.93,0,0,0-.09-.53.73.73,0,0,0-.4-.26l-.3-.11v-.09l1.5-.35.09.06v.76a4.86,4.86,0,0,1,.8-.61,1.77,1.77,0,0,1,.9-.22,1.59,1.59,0,0,1,.91.23,1.32,1.32,0,0,1,.45.65,4.65,4.65,0,0,1,.85-.63,1.92,1.92,0,0,1,.92-.25c1,0,1.46.51,1.46,1.59v2.28a5.43,5.43,0,0,0,0,.68.46.46,0,0,0,.16.31.85.85,0,0,0,.37.12l.23,0Zm-10.33-2.46a2.69,2.69,0,0,1-.33,1.34,2.43,2.43,0,0,1-.86.91,2.49,2.49,0,0,1-2.44,0,2.18,2.18,0,0,1-.88-.9,3,3,0,0,1-.34-1.49,2.77,2.77,0,0,1,.33-1.34,2.46,2.46,0,0,1,.87-.91,2.32,2.32,0,0,1,1.23-.34,2.49,2.49,0,0,1,1.21.3,2.14,2.14,0,0,1,.87.89A3.08,3.08,0,0,1,1546.64,373.68Zm-.9.2a3.71,3.71,0,0,0-.47-2,1.41,1.41,0,0,0-1.22-.75,1.09,1.09,0,0,0-1,.52,3.13,3.13,0,0,0-.37,1.69,3.81,3.81,0,0,0,.47,2,1.48,1.48,0,0,0,1.23.75,1.12,1.12,0,0,0,1-.52A3.16,3.16,0,0,0,1545.74,373.88Zm-5.81-.2a2.69,2.69,0,0,1-.33,1.34,2.43,2.43,0,0,1-.86.91,2.49,2.49,0,0,1-2.44,0,2.18,2.18,0,0,1-.88-.9,3,3,0,0,1-.34-1.49,2.77,2.77,0,0,1,.33-1.34,2.46,2.46,0,0,1,.87-.91,2.32,2.32,0,0,1,1.23-.34,2.43,2.43,0,0,1,1.2.3,2.1,2.1,0,0,1,.88.89A3.08,3.08,0,0,1,1539.93,373.68Zm-.9.2a3.71,3.71,0,0,0-.47-2,1.41,1.41,0,0,0-1.22-.75,1.09,1.09,0,0,0-1,.52,3.13,3.13,0,0,0-.37,1.69,3.81,3.81,0,0,0,.47,2,1.48,1.48,0,0,0,1.23.75,1.12,1.12,0,0,0,1-.52A3.16,3.16,0,0,0,1539,373.88Zm-5.43-2.43a.8.8,0,0,1-.14.47.36.36,0,0,1-.27.16.74.74,0,0,1-.33-.12,4.1,4.1,0,0,1-.55-.36,2.46,2.46,0,0,0-.46.28,2.23,2.23,0,0,0-.38.37v2.63a2.87,2.87,0,0,0,0,.68.4.4,0,0,0,.21.31,1.29,1.29,0,0,0,.49.12l.28,0v.12h-2.62V376l.22,0a.76.76,0,0,0,.37-.12.42.42,0,0,0,.16-.31,3.89,3.89,0,0,0,0-.68v-2.52a.92.92,0,0,0-.1-.53.74.74,0,0,0-.39-.26l-.31-.11v-.09l1.5-.35.1.06V372a3.84,3.84,0,0,1,.84-.75,1.23,1.23,0,0,1,.72-.22.71.71,0,0,1,.41.1A.39.39,0,0,1,1533.6,371.45Zm-4.94,4.69c-.62,0-1.14,0-1.59,0v-.66a3.45,3.45,0,0,1-.72.52,2,2,0,0,1-.91.22,2.05,2.05,0,0,1-1.09-.32,2.14,2.14,0,0,1-.72-.83,2.64,2.64,0,0,1-.26-1.17,3.38,3.38,0,0,1,.35-1.52,2.47,2.47,0,0,1,2.23-1.34,4.91,4.91,0,0,1,1.12.11v-1.55a.9.9,0,0,0-.1-.53.74.74,0,0,0-.39-.26l-.31-.12v-.08l1.5-.35.1.06v6.53a5.43,5.43,0,0,0,0,.68.46.46,0,0,0,.16.31.85.85,0,0,0,.37.12l.23,0Zm-1.59-3.35a1.75,1.75,0,0,0-.36-1.15,1.19,1.19,0,0,0-.94-.39,1.48,1.48,0,0,0-1.19.54,2.4,2.4,0,0,0-.46,1.56,3.17,3.17,0,0,0,.22,1.23,2,2,0,0,0,.61.86,1.62,1.62,0,0,0,1,.32,1.71,1.71,0,0,0,.62-.11,2,2,0,0,0,.55-.34ZM1518,373v.13a3.14,3.14,0,0,0,.55,1.89,1.69,1.69,0,0,0,2.22.47,3,3,0,0,0,.68-.63l.13.06a3,3,0,0,1-.85.94,2.06,2.06,0,0,1-1.17.37,2.24,2.24,0,0,1-1.69-.68,2.72,2.72,0,0,1-.65-1.85,3,3,0,0,1,.37-1.46,2.66,2.66,0,0,1,.89-1,2.14,2.14,0,0,1,1.13-.33c1.28,0,1.94.67,2,2.05Zm2.66-.19a2.14,2.14,0,0,0-.35-1.23,1,1,0,0,0-.85-.43,1.29,1.29,0,0,0-1,.45,2,2,0,0,0-.46,1.21Zm-5.27,1.19a1.83,1.83,0,0,1-.79,1.52,3.4,3.4,0,0,1-2,.58h-2l-.57,0h-.39V376l.39,0a.58.58,0,0,0,.51-.31,2.67,2.67,0,0,0,.12-1.06v-4.24a2.61,2.61,0,0,0-.12-1.05.57.57,0,0,0-.51-.32l-.39-.05v-.12h3.06a3.15,3.15,0,0,1,1.74.42,1.4,1.4,0,0,1,.65,1.22,1.38,1.38,0,0,1-.38,1,3.14,3.14,0,0,1-1,.64,2.64,2.64,0,0,1,1.25.66A1.78,1.78,0,0,1,1515.35,374Zm-1.29-3.38a1.65,1.65,0,0,0-.41-1.2,1.62,1.62,0,0,0-1.22-.46,4.07,4.07,0,0,0-1,.11v3.14h.74a2.39,2.39,0,0,0,1.41-.38A1.43,1.43,0,0,0,1514.06,370.66Zm.36,3.65a1.72,1.72,0,0,0-.59-1.4,2.34,2.34,0,0,0-1.52-.46h-.88v2.15a1.68,1.68,0,0,0,.26,1.12,1.36,1.36,0,0,0,1,.26,1.75,1.75,0,0,0,1.24-.45A1.67,1.67,0,0,0,1514.42,374.31Zm-6.45-.95h-2.73V373H1508Zm-4.41.82-.64,1.95h-4l-.08-.11,2-2.19a12.31,12.31,0,0,0,1-1.16,3.76,3.76,0,0,0,.51-1,3,3,0,0,0,.15-.94,1.45,1.45,0,0,0-.39-1,1.5,1.5,0,0,0-1.09-.41,1.58,1.58,0,0,0-1,.33,3.91,3.91,0,0,0-.85,1l-.13-.07a3.87,3.87,0,0,1,1-1.35,2.14,2.14,0,0,1,1.37-.49,1.91,1.91,0,0,1,1.31.48,1.78,1.78,0,0,1,.51,1.33,2.56,2.56,0,0,1-.2,1,4.27,4.27,0,0,1-.59.94c-.26.32-.57.68-1,1.08l-1.8,2h1.7a4.47,4.47,0,0,0,.91-.07,1.19,1.19,0,0,0,.56-.28,2.91,2.91,0,0,0,.44-.6l.21-.35Z"
              />
              <path
                d="M1609.26,392h-2.39v-.11l.22,0a1,1,0,0,0,.38-.11.45.45,0,0,0,.17-.31,5.73,5.73,0,0,0,0-.69v-2.16c0-.86-.33-1.28-1-1.27a1.65,1.65,0,0,0-.74.18,2.33,2.33,0,0,0-.65.48c0,.06,0,.15,0,.25s0,.2,0,.29v2.23a4,4,0,0,0,0,.69.44.44,0,0,0,.16.31,1.07,1.07,0,0,0,.39.11l.21,0V392h-2.4v-.11l.22,0a1,1,0,0,0,.38-.11.44.44,0,0,0,.16-.31,4,4,0,0,0,0-.69v-2.16c0-.86-.34-1.28-1-1.27a1.65,1.65,0,0,0-.72.17,2.28,2.28,0,0,0-.63.45v2.81a4,4,0,0,0,0,.69.44.44,0,0,0,.16.31,1,1,0,0,0,.38.11l.22,0V392h-2.39v-.11l.23,0a.9.9,0,0,0,.36-.11.45.45,0,0,0,.16-.32,3.89,3.89,0,0,0,0-.68v-2.51a1,1,0,0,0-.1-.54.73.73,0,0,0-.39-.25l-.31-.12v-.09l1.5-.35.1.07v.75a4.38,4.38,0,0,1,.8-.6,1.71,1.71,0,0,1,.89-.23,1.49,1.49,0,0,1,.91.24,1.2,1.2,0,0,1,.46.65,4.26,4.26,0,0,1,.84-.64,2,2,0,0,1,.92-.25c1,0,1.46.52,1.46,1.59v2.28a5.29,5.29,0,0,0,0,.69.44.44,0,0,0,.16.31.9.9,0,0,0,.37.11l.22,0Zm-10.13,0c-.61,0-1.14,0-1.59,0v-.76a4.3,4.3,0,0,1-.81.61,1.82,1.82,0,0,1-.9.22c-1,0-1.48-.52-1.49-1.59v-2.29a1,1,0,0,0-.1-.54.73.73,0,0,0-.39-.25l-.31-.12v-.09l1.5-.35.1.07v3.45a1.45,1.45,0,0,0,.27,1,.93.93,0,0,0,.75.31,1.59,1.59,0,0,0,.75-.17,2.28,2.28,0,0,0,.63-.45v-2.82a1,1,0,0,0-.09-.54.73.73,0,0,0-.4-.25l-.3-.12v-.09l1.5-.35.09.07v3.79a5.29,5.29,0,0,0,0,.69.48.48,0,0,0,.16.31.9.9,0,0,0,.37.11l.22,0Zm-7.63-6.83a.54.54,0,0,1-.16.4.56.56,0,0,1-.41.16.52.52,0,0,1-.4-.16.54.54,0,0,1-.16-.4.58.58,0,0,1,.16-.4.52.52,0,0,1,.4-.16.56.56,0,0,1,.41.16A.58.58,0,0,1,1591.5,385.2Zm.73,6.83h-2.39v-.11l.23,0a1,1,0,0,0,.37-.11.49.49,0,0,0,.16-.32,5.66,5.66,0,0,0,0-.68v-2.51a1,1,0,0,0-.09-.54.77.77,0,0,0-.4-.25l-.31-.12v-.09l1.51-.35.09.07v3.79a4,4,0,0,0,0,.69.44.44,0,0,0,.16.31,1.07,1.07,0,0,0,.39.11l.21,0Zm-3.74,0h-2.38v-.11l.21,0a1,1,0,0,0,.38-.11.45.45,0,0,0,.17-.31,5.73,5.73,0,0,0,0-.69v-2.16c0-.86-.33-1.28-1-1.27a1.65,1.65,0,0,0-.74.18,2.33,2.33,0,0,0-.65.48c0,.06,0,.15,0,.25s0,.2,0,.29v2.23a4,4,0,0,0,0,.69.44.44,0,0,0,.16.31,1.07,1.07,0,0,0,.39.11l.21,0V392H1583v-.11l.22,0a1,1,0,0,0,.38-.11.45.45,0,0,0,.17-.31,5.73,5.73,0,0,0,0-.69v-2.16c0-.86-.33-1.28-1-1.27a1.65,1.65,0,0,0-.72.17,2.28,2.28,0,0,0-.63.45v2.81a4,4,0,0,0,0,.69.44.44,0,0,0,.16.31,1,1,0,0,0,.39.11l.21,0V392h-2.39v-.11l.23,0a.9.9,0,0,0,.36-.11.41.41,0,0,0,.16-.32,3.89,3.89,0,0,0,0-.68v-2.51a.88.88,0,0,0-.1-.54.73.73,0,0,0-.39-.25l-.31-.12v-.09l1.5-.35.1.07v.75a4.38,4.38,0,0,1,.8-.6,1.71,1.71,0,0,1,.89-.23,1.49,1.49,0,0,1,.91.24,1.2,1.2,0,0,1,.46.65,4.26,4.26,0,0,1,.84-.64,2,2,0,0,1,.92-.25c1,0,1.46.52,1.46,1.59v2.28a5.29,5.29,0,0,0,0,.69.48.48,0,0,0,.16.31.9.9,0,0,0,.37.11l.22,0Zm-13.65-3.1v.14a3.12,3.12,0,0,0,.54,1.89,1.67,1.67,0,0,0,1.34.69,1.71,1.71,0,0,0,.88-.22,2.86,2.86,0,0,0,.69-.63l.13.05a3,3,0,0,1-.85.94,2.11,2.11,0,0,1-1.18.37,2.23,2.23,0,0,1-1.68-.68,2.63,2.63,0,0,1-.65-1.85,3.06,3.06,0,0,1,.36-1.46,2.58,2.58,0,0,1,.9-.95,2.07,2.07,0,0,1,1.13-.34c1.27,0,1.94.67,2,2.05Zm2.66-.18a2.23,2.23,0,0,0-.35-1.24,1,1,0,0,0-.85-.43,1.29,1.29,0,0,0-1,.45,2.14,2.14,0,0,0-.45,1.22Zm-4.92-1.41a.87.87,0,0,1-.13.47.39.39,0,0,1-.28.16,1,1,0,0,1-.33-.11,5.88,5.88,0,0,1-.55-.37,2.52,2.52,0,0,0-.46.29,2.18,2.18,0,0,0-.38.36v2.63a3.74,3.74,0,0,0,0,.69.42.42,0,0,0,.21.31,1.62,1.62,0,0,0,.5.11l.27,0V392h-2.62v-.11l.23,0a.9.9,0,0,0,.36-.11.45.45,0,0,0,.16-.32,3.89,3.89,0,0,0,0-.68v-2.51a.88.88,0,0,0-.1-.54.73.73,0,0,0-.39-.25l-.31-.12v-.09l1.5-.35.1.07v.88a3.84,3.84,0,0,1,.84-.75,1.31,1.31,0,0,1,.72-.22.69.69,0,0,1,.41.11A.37.37,0,0,1,1572.58,387.34Zm-5.22-.57a1.87,1.87,0,0,1-.77,1.56,3.66,3.66,0,0,1-2,.65l0-.13a2.28,2.28,0,0,0,1.33-.58,2.37,2.37,0,0,0-.07-2.9,1.89,1.89,0,0,0-1.35-.48,3.37,3.37,0,0,0-.5,0,3.33,3.33,0,0,0-.39.08v5.49a3.39,3.39,0,0,0,.07.82.6.6,0,0,0,.24.4,1.14,1.14,0,0,0,.49.14l.42.06V392h-3.09v-.11l.39-.06a.56.56,0,0,0,.51-.31,2.64,2.64,0,0,0,.12-1.05v-4.25a2.64,2.64,0,0,0-.12-1.05.59.59,0,0,0-.51-.32l-.39-.05v-.12h3a3.84,3.84,0,0,1,1.36.23,2,2,0,0,1,.94.68A1.89,1.89,0,0,1,1567.36,386.77ZM1557,392h-2.39v-.11l.21,0a1.07,1.07,0,0,0,.39-.11.44.44,0,0,0,.16-.31,4,4,0,0,0,0-.69v-2.16c0-.86-.34-1.28-1-1.27a1.66,1.66,0,0,0-.75.18,2.33,2.33,0,0,0-.65.48.85.85,0,0,1,0,.25c0,.1,0,.2,0,.29v2.23a5.73,5.73,0,0,0,0,.69.45.45,0,0,0,.17.31,1,1,0,0,0,.38.11l.21,0V392h-2.39v-.11l.21,0a1,1,0,0,0,.38-.11.45.45,0,0,0,.17-.31,5.29,5.29,0,0,0,0-.69v-2.16c0-.86-.34-1.28-1-1.27a1.65,1.65,0,0,0-.72.17,2.32,2.32,0,0,0-.64.45v2.81a5.29,5.29,0,0,0,0,.69.45.45,0,0,0,.17.31,1,1,0,0,0,.38.11l.21,0V392h-2.38v-.11l.22,0a1,1,0,0,0,.37-.11.49.49,0,0,0,.16-.32,5.66,5.66,0,0,0,0-.68v-2.51a1,1,0,0,0-.09-.54.73.73,0,0,0-.4-.25l-.3-.12v-.09l1.5-.35.09.07v.75a4.75,4.75,0,0,1,.8-.6,1.77,1.77,0,0,1,.9-.23,1.51,1.51,0,0,1,.91.24,1.24,1.24,0,0,1,.45.65,4.3,4.3,0,0,1,.85-.64,1.92,1.92,0,0,1,.92-.25c1,0,1.46.52,1.46,1.59v2.28a5.73,5.73,0,0,0,0,.69.48.48,0,0,0,.16.31,1,1,0,0,0,.37.11l.23,0Zm-10.33-2.46a2.69,2.69,0,0,1-.33,1.34,2.36,2.36,0,0,1-.86.91,2.49,2.49,0,0,1-2.44,0,2.16,2.16,0,0,1-.88-.89,3.08,3.08,0,0,1-.34-1.5,2.8,2.8,0,0,1,.33-1.34,2.53,2.53,0,0,1,.87-.91,2.41,2.41,0,0,1,1.23-.34,2.49,2.49,0,0,1,1.21.3,2.26,2.26,0,0,1,.87.89A3.08,3.08,0,0,1,1546.64,389.57Zm-.9.2a3.71,3.71,0,0,0-.47-2,1.46,1.46,0,0,0-1.22-.75,1.11,1.11,0,0,0-1,.52,3.13,3.13,0,0,0-.37,1.69,3.81,3.81,0,0,0,.47,2,1.44,1.44,0,0,0,1.23.75,1.07,1.07,0,0,0,1-.52A3.13,3.13,0,0,0,1545.74,389.77Zm-5.81-.2a2.69,2.69,0,0,1-.33,1.34,2.36,2.36,0,0,1-.86.91,2.49,2.49,0,0,1-2.44,0,2.16,2.16,0,0,1-.88-.89,3.08,3.08,0,0,1-.34-1.5,2.8,2.8,0,0,1,.33-1.34,2.53,2.53,0,0,1,.87-.91,2.47,2.47,0,0,1,2.43,0,2.22,2.22,0,0,1,.88.89A3.08,3.08,0,0,1,1539.93,389.57Zm-.9.2a3.71,3.71,0,0,0-.47-2,1.46,1.46,0,0,0-1.22-.75,1.11,1.11,0,0,0-1,.52,3.13,3.13,0,0,0-.37,1.69,3.81,3.81,0,0,0,.47,2,1.44,1.44,0,0,0,1.23.75,1.07,1.07,0,0,0,1-.52A3.13,3.13,0,0,0,1539,389.77Zm-5.43-2.43a.8.8,0,0,1-.14.47.36.36,0,0,1-.27.16.84.84,0,0,1-.33-.11,5.88,5.88,0,0,1-.55-.37,2.52,2.52,0,0,0-.46.29,1.87,1.87,0,0,0-.38.36v2.63a3,3,0,0,0,0,.69.42.42,0,0,0,.21.31,1.55,1.55,0,0,0,.49.11l.28,0V392h-2.62v-.11l.22,0a.9.9,0,0,0,.37-.11.45.45,0,0,0,.16-.32,3.89,3.89,0,0,0,0-.68v-2.51a1,1,0,0,0-.1-.54.73.73,0,0,0-.39-.25l-.31-.12v-.09l1.5-.35.1.07v.88a3.84,3.84,0,0,1,.84-.75,1.31,1.31,0,0,1,.72-.22.71.71,0,0,1,.41.11A.37.37,0,0,1,1533.6,387.34Zm-4.94,4.69c-.62,0-1.14,0-1.59,0v-.67a3.5,3.5,0,0,1-.72.53,2.11,2.11,0,0,1-.91.21,2,2,0,0,1-1.09-.32,2.07,2.07,0,0,1-.72-.83,2.64,2.64,0,0,1-.26-1.17,3.41,3.41,0,0,1,.35-1.52A2.44,2.44,0,0,1,1526,387a5,5,0,0,1,1.12.1v-1.55a.94.94,0,0,0-.1-.53.74.74,0,0,0-.39-.26l-.31-.11v-.09l1.5-.35.1.06v6.53a5.73,5.73,0,0,0,0,.69.48.48,0,0,0,.16.31,1,1,0,0,0,.37.11l.23,0Zm-1.59-3.35a1.73,1.73,0,0,0-.36-1.14,1.19,1.19,0,0,0-.94-.39,1.47,1.47,0,0,0-1.19.53,2.44,2.44,0,0,0-.46,1.56,3.26,3.26,0,0,0,.22,1.24,2,2,0,0,0,.61.85,1.55,1.55,0,0,0,1,.32,1.71,1.71,0,0,0,.62-.11,2,2,0,0,0,.55-.34Zm-9.11.25v.14a3.19,3.19,0,0,0,.55,1.89,1.65,1.65,0,0,0,1.34.69,1.71,1.71,0,0,0,.88-.22,3,3,0,0,0,.68-.63l.13.05a2.85,2.85,0,0,1-.85.94,2.06,2.06,0,0,1-1.17.37,2.24,2.24,0,0,1-1.69-.68,2.72,2.72,0,0,1-.65-1.85,3,3,0,0,1,.37-1.46,2.55,2.55,0,0,1,.89-.95,2.07,2.07,0,0,1,1.13-.34c1.28,0,1.94.67,2,2.05Zm2.66-.18a2.15,2.15,0,0,0-.35-1.24,1,1,0,0,0-.85-.43,1.29,1.29,0,0,0-1,.45,2.08,2.08,0,0,0-.46,1.22Zm-5.27,1.18a1.83,1.83,0,0,1-.79,1.52,3.34,3.34,0,0,1-2,.58h-3v-.11l.39-.06a.56.56,0,0,0,.51-.31,2.64,2.64,0,0,0,.12-1.05v-4.25a2.64,2.64,0,0,0-.12-1.05.59.59,0,0,0-.51-.32l-.39-.05v-.12h3.06a3.07,3.07,0,0,1,1.74.43,1.38,1.38,0,0,1,.65,1.22,1.35,1.35,0,0,1-.38,1,3,3,0,0,1-1,.64,2.65,2.65,0,0,1,1.25.67A1.74,1.74,0,0,1,1515.35,389.93Zm-1.29-3.38a1.65,1.65,0,0,0-.41-1.2,1.62,1.62,0,0,0-1.22-.46,4.07,4.07,0,0,0-1,.11v3.14h.74a2.39,2.39,0,0,0,1.41-.38A1.43,1.43,0,0,0,1514.06,386.55Zm.36,3.65a1.73,1.73,0,0,0-.59-1.4,2.34,2.34,0,0,0-1.52-.46h-.88v2.16a1.67,1.67,0,0,0,.26,1.11,1.32,1.32,0,0,0,1,.26,1.67,1.67,0,0,0,1.24-.45A1.65,1.65,0,0,0,1514.42,390.2Zm-6.45-.95h-2.73v-.36H1508Zm-4.41.82-.64,1.95h-4l-.08-.1,2-2.2a12.31,12.31,0,0,0,1-1.16,3.76,3.76,0,0,0,.51-1,2.92,2.92,0,0,0,.15-.93,1.42,1.42,0,0,0-.39-1.05,1.47,1.47,0,0,0-1.09-.42,1.53,1.53,0,0,0-1,.34,3.91,3.91,0,0,0-.85,1l-.13-.08a4.06,4.06,0,0,1,1-1.35,2.08,2.08,0,0,1,1.37-.48,1.86,1.86,0,0,1,1.31.47,1.78,1.78,0,0,1,.51,1.33,2.53,2.53,0,0,1-.2,1,4.27,4.27,0,0,1-.59.94c-.26.32-.57.68-1,1.08l-1.8,1.95h1.7a4.47,4.47,0,0,0,.91-.07,1.18,1.18,0,0,0,.56-.27,2.75,2.75,0,0,0,.44-.61l.21-.35Z"
              />
              <path
                class="cls-5"
                d="M1546.31,307.9h-2.38v-.12l.21,0a.9.9,0,0,0,.39-.12.42.42,0,0,0,.16-.31,3.82,3.82,0,0,0,0-.68v-2.17q0-1.28-1-1.26a1.66,1.66,0,0,0-.75.18,2.33,2.33,0,0,0-.65.48.81.81,0,0,1,0,.25c0,.1,0,.2,0,.29v2.23a5.11,5.11,0,0,0,0,.68.43.43,0,0,0,.17.31.81.81,0,0,0,.38.12l.21,0v.12h-2.39v-.12l.21,0a.81.81,0,0,0,.38-.12.43.43,0,0,0,.17-.31,5.11,5.11,0,0,0,0-.68v-2.17c0-.85-.34-1.27-1-1.26a1.51,1.51,0,0,0-.71.17,2.52,2.52,0,0,0-.64.44v2.82a3.82,3.82,0,0,0,0,.68.42.42,0,0,0,.16.31.9.9,0,0,0,.39.12l.21,0v.12h-2.38v-.12l.22,0a.85.85,0,0,0,.37-.12.46.46,0,0,0,.16-.31,5.66,5.66,0,0,0,0-.68v-2.52a.93.93,0,0,0-.09-.53.73.73,0,0,0-.4-.26l-.31-.11v-.09l1.51-.35.09.06v.76a4.86,4.86,0,0,1,.8-.61,1.74,1.74,0,0,1,.9-.22,1.59,1.59,0,0,1,.91.23,1.32,1.32,0,0,1,.45.65,4.65,4.65,0,0,1,.85-.63,1.81,1.81,0,0,1,.92-.25c1,0,1.46.51,1.46,1.59v2.28a5.54,5.54,0,0,0,0,.68.46.46,0,0,0,.16.31.8.8,0,0,0,.37.12l.22,0ZM1536,305.44a2.62,2.62,0,0,1-.33,1.33,2.38,2.38,0,0,1-.86.92,2.49,2.49,0,0,1-2.44,0,2.18,2.18,0,0,1-.88-.9,3,3,0,0,1-.34-1.49,2.77,2.77,0,0,1,.33-1.34,2.46,2.46,0,0,1,.87-.91,2.32,2.32,0,0,1,1.23-.34,2.43,2.43,0,0,1,1.2.3,2.1,2.1,0,0,1,.88.89A3.08,3.08,0,0,1,1536,305.44Zm-.9.2a3.71,3.71,0,0,0-.47-2,1.43,1.43,0,0,0-1.23-.75,1.09,1.09,0,0,0-1,.52,3.13,3.13,0,0,0-.37,1.69,3.77,3.77,0,0,0,.47,1.95,1.46,1.46,0,0,0,1.23.76,1.13,1.13,0,0,0,1-.52A3.16,3.16,0,0,0,1535.09,305.64Zm-5.81-.2a2.62,2.62,0,0,1-.33,1.33,2.38,2.38,0,0,1-.86.92,2.49,2.49,0,0,1-2.44,0,2.18,2.18,0,0,1-.88-.9,3,3,0,0,1-.34-1.49,2.77,2.77,0,0,1,.33-1.34,2.46,2.46,0,0,1,.87-.91,2.32,2.32,0,0,1,1.23-.34,2.43,2.43,0,0,1,1.2.3,2.1,2.1,0,0,1,.88.89A3.08,3.08,0,0,1,1529.28,305.44Zm-.9.2a3.71,3.71,0,0,0-.47-2,1.43,1.43,0,0,0-1.23-.75,1.09,1.09,0,0,0-1,.52,3.13,3.13,0,0,0-.37,1.69,3.77,3.77,0,0,0,.47,1.95,1.46,1.46,0,0,0,1.23.76,1.13,1.13,0,0,0,1-.52A3.16,3.16,0,0,0,1528.38,305.64Zm-5.43-2.43a.74.74,0,0,1-.14.46.33.33,0,0,1-.27.16.7.7,0,0,1-.33-.11,3.09,3.09,0,0,1-.55-.37,3.21,3.21,0,0,0-.46.29,2.23,2.23,0,0,0-.38.37v2.63a3.82,3.82,0,0,0,0,.68.44.44,0,0,0,.22.31,1.29,1.29,0,0,0,.49.12l.28,0v.12h-2.62v-.12l.22,0a.76.76,0,0,0,.37-.12.42.42,0,0,0,.16-.31,3.89,3.89,0,0,0,0-.68v-2.52a1,1,0,0,0-.1-.53.74.74,0,0,0-.39-.26l-.31-.11v-.09l1.5-.35.1.06v.89a3.84,3.84,0,0,1,.84-.75,1.23,1.23,0,0,1,.72-.22.71.71,0,0,1,.41.1A.38.38,0,0,1,1523,303.21Zm-5,4.69c-.61,0-1.14,0-1.58,0v-.66a3.45,3.45,0,0,1-.72.52,2,2,0,0,1-.91.22,2.05,2.05,0,0,1-1.09-.32,2.1,2.1,0,0,1-.72-.84,2.57,2.57,0,0,1-.26-1.16,3.38,3.38,0,0,1,.35-1.52,2.45,2.45,0,0,1,2.23-1.34,4.91,4.91,0,0,1,1.12.11v-1.55a1,1,0,0,0-.1-.53.74.74,0,0,0-.39-.26l-.31-.12v-.08l1.5-.35.1.06v6.53a5.54,5.54,0,0,0,0,.68.46.46,0,0,0,.16.31.85.85,0,0,0,.37.12l.22,0Zm-1.58-3.35a1.74,1.74,0,0,0-.36-1.15,1.19,1.19,0,0,0-.94-.39,1.48,1.48,0,0,0-1.19.54,2.33,2.33,0,0,0-.46,1.55,3.19,3.19,0,0,0,.22,1.24,2,2,0,0,0,.61.86,1.62,1.62,0,0,0,1,.32,1.71,1.71,0,0,0,.62-.11,2.22,2.22,0,0,0,.55-.34Zm-9.11.25v.13a3.21,3.21,0,0,0,.54,1.89,1.7,1.7,0,0,0,2.23.47,3,3,0,0,0,.68-.63l.13.06a2.81,2.81,0,0,1-.85.93,2,2,0,0,1-1.17.38,2.24,2.24,0,0,1-1.69-.68,2.68,2.68,0,0,1-.65-1.85,3,3,0,0,1,.37-1.46,2.58,2.58,0,0,1,.89-1,2.14,2.14,0,0,1,1.13-.33c1.28,0,1.94.66,2,2.05Zm2.66-.19a2.14,2.14,0,0,0-.35-1.23,1,1,0,0,0-.85-.43,1.32,1.32,0,0,0-1,.45,2.11,2.11,0,0,0-.45,1.21Zm-5.27,1.19a1.85,1.85,0,0,1-.79,1.52,3.4,3.4,0,0,1-2,.58h-3v-.12l.39,0a.57.57,0,0,0,.51-.32,2.58,2.58,0,0,0,.12-1.05v-4.24a2.58,2.58,0,0,0-.12-1.05.57.57,0,0,0-.51-.32l-.39-.05v-.12h3a3.17,3.17,0,0,1,1.75.42,1.4,1.4,0,0,1,.65,1.22,1.38,1.38,0,0,1-.38,1,3.14,3.14,0,0,1-1,.64,2.64,2.64,0,0,1,1.25.66A1.83,1.83,0,0,1,1504.7,305.8Zm-1.29-3.38a1.74,1.74,0,0,0-.41-1.21,1.65,1.65,0,0,0-1.22-.45,4.07,4.07,0,0,0-1,.11V304l.74,0a2.35,2.35,0,0,0,1.41-.37A1.43,1.43,0,0,0,1503.41,302.42Zm.35,3.64a1.68,1.68,0,0,0-.58-1.39,2.34,2.34,0,0,0-1.52-.46h-.88v2.15a1.68,1.68,0,0,0,.26,1.12,1.36,1.36,0,0,0,1,.26,1.75,1.75,0,0,0,1.24-.45A1.63,1.63,0,0,0,1503.76,306.06Z"
              />
              <path
                d="M1637.47,334h-3.14v-.11l.42-.06a1.14,1.14,0,0,0,.49-.14.6.6,0,0,0,.24-.4,3.39,3.39,0,0,0,.07-.82v-4.09a3.6,3.6,0,0,0-.07-.79.5.5,0,0,0-.27-.35,1.55,1.55,0,0,0-.59-.08h-.29V327a10.17,10.17,0,0,0,1-.22,7.77,7.77,0,0,0,.9-.31l.1.06v5.89a4.15,4.15,0,0,0,.06.82.63.63,0,0,0,.23.4,1,1,0,0,0,.45.14l.36.06Zm-4.59,0H1630v-.11l.39-.05c.36,0,.54-.2.53-.48a1.73,1.73,0,0,0-.14-.64l-.62-1.65h-2.78l-.47,1.21a2.88,2.88,0,0,0-.15.47,2.07,2.07,0,0,0-.06.45.59.59,0,0,0,.57.64l.37.05V334h-2.47v-.11l.21,0a.85.85,0,0,0,.56-.29,2.3,2.3,0,0,0,.44-.76l2.28-5.74.55-.56h.09l2.48,6.45a1.8,1.8,0,0,0,.37.64.74.74,0,0,0,.47.24l.3,0Zm-2.86-3.19-1.28-3.37-1.31,3.37Z"
              />
              <path
                d="M1639.07,347.87l-.64,2h-4l-.08-.11,2-2.2a12.34,12.34,0,0,0,.94-1.16,3.46,3.46,0,0,0,.51-1,2.92,2.92,0,0,0,.15-.93,1.45,1.45,0,0,0-.39-1.05,1.42,1.42,0,0,0-1.09-.41,1.58,1.58,0,0,0-1,.33,3.91,3.91,0,0,0-.85,1l-.13-.08a4.06,4.06,0,0,1,1-1.35,2.19,2.19,0,0,1,1.37-.48,1.91,1.91,0,0,1,1.31.47,1.79,1.79,0,0,1,.51,1.33,2.61,2.61,0,0,1-.2,1,4.47,4.47,0,0,1-.59.93,13.36,13.36,0,0,1-1,1.08l-1.8,2h1.7a5.34,5.34,0,0,0,.91-.07,1.19,1.19,0,0,0,.56-.28,2.59,2.59,0,0,0,.44-.6l.21-.36Zm-6.19,2H1630v-.12l.39,0c.36-.05.54-.21.53-.48a1.65,1.65,0,0,0-.14-.64l-.62-1.66h-2.78l-.47,1.21a2.88,2.88,0,0,0-.15.47,2.15,2.15,0,0,0-.06.46.59.59,0,0,0,.57.64l.37,0v.12h-2.47v-.12l.21,0a.91.91,0,0,0,.56-.3,2.2,2.2,0,0,0,.44-.76l2.28-5.74.55-.55h.09l2.48,6.44a1.85,1.85,0,0,0,.37.65.85.85,0,0,0,.47.24l.3,0Zm-2.86-3.19-1.28-3.38-1.31,3.38Z"
              />
              <path
                d="M1636.52,376.14h-.4l-.59,0h-1.08l-.65,0h-.43V376l.42,0a1.14,1.14,0,0,0,.49-.14.6.6,0,0,0,.24-.4,3.48,3.48,0,0,0,.07-.83v-4.08a3.21,3.21,0,0,0-.07-.8.48.48,0,0,0-.27-.34,1.37,1.37,0,0,0-.59-.08h-.29v-.12a7.71,7.71,0,0,0,1-.22,5.91,5.91,0,0,0,.9-.3l.1,0v5.89a4.27,4.27,0,0,0,.06.83.63.63,0,0,0,.23.4,1,1,0,0,0,.45.14l.37,0Zm-5.25-2.1a1.88,1.88,0,0,1-.79,1.52,3.44,3.44,0,0,1-2,.58h-2l-.56,0h-.4V376l.4,0a.58.58,0,0,0,.5-.31,2.67,2.67,0,0,0,.12-1.06v-4.24a2.61,2.61,0,0,0-.12-1.05.57.57,0,0,0-.5-.32l-.4-.05v-.12h3.06a3.15,3.15,0,0,1,1.74.42,1.48,1.48,0,0,1,.28,2.2,3.31,3.31,0,0,1-1,.64,2.59,2.59,0,0,1,1.25.66A1.79,1.79,0,0,1,1631.27,374Zm-1.29-3.38a1.66,1.66,0,0,0-.42-1.2,1.61,1.61,0,0,0-1.21-.46,4,4,0,0,0-1,.11v3.14h.73a2.39,2.39,0,0,0,1.41-.38A1.41,1.41,0,0,0,1630,370.66Zm.35,3.65a1.69,1.69,0,0,0-.59-1.4,2.34,2.34,0,0,0-1.52-.46h-.87v2.15a1.62,1.62,0,0,0,.26,1.12,1.35,1.35,0,0,0,1,.26,1.75,1.75,0,0,0,1.24-.45A1.63,1.63,0,0,0,1630.33,374.31Z"
              />
              <path
                d="M1643.87,392h-3.15v-.11l.42-.06a1.14,1.14,0,0,0,.49-.14.6.6,0,0,0,.24-.4,3.39,3.39,0,0,0,.07-.82v-4.09a3.6,3.6,0,0,0-.07-.79.5.5,0,0,0-.27-.35,1.55,1.55,0,0,0-.59-.08h-.29v-.11a10.17,10.17,0,0,0,1-.22,7.77,7.77,0,0,0,.9-.31l.1.06v5.89a4.15,4.15,0,0,0,.06.82.63.63,0,0,0,.23.4,1,1,0,0,0,.45.14l.37.06Zm-4.8-5.26a1.89,1.89,0,0,1-.76,1.56,3.72,3.72,0,0,1-2,.65l0-.13a2.31,2.31,0,0,0,1.34-.58,2,2,0,0,0,.45-1.43,1.74,1.74,0,0,0-1.88-1.95,3.49,3.49,0,0,0-.5,0l-.39.08v5.49a4,4,0,0,0,.07.82.6.6,0,0,0,.24.4,1.14,1.14,0,0,0,.49.14l.42.06V392h-3.09v-.11l.39-.06a.56.56,0,0,0,.51-.31,2.64,2.64,0,0,0,.12-1.05v-4.25a2.64,2.64,0,0,0-.12-1.05.59.59,0,0,0-.51-.32l-.39-.05v-.12h3a3.8,3.8,0,0,1,1.36.23,2,2,0,0,1,.94.68A1.82,1.82,0,0,1,1639.07,386.77Zm-7.8,3.16a1.88,1.88,0,0,1-.79,1.52,3.37,3.37,0,0,1-2,.58h-3v-.11l.4-.06a.56.56,0,0,0,.5-.31,2.64,2.64,0,0,0,.12-1.05v-4.25a2.64,2.64,0,0,0-.12-1.05.58.58,0,0,0-.5-.32l-.4-.05v-.12h3.06a3.07,3.07,0,0,1,1.74.43,1.36,1.36,0,0,1,.65,1.22,1.34,1.34,0,0,1-.37,1,3.13,3.13,0,0,1-1,.64,2.6,2.6,0,0,1,1.25.67A1.75,1.75,0,0,1,1631.27,389.93Zm-1.29-3.38a1.66,1.66,0,0,0-.42-1.2,1.61,1.61,0,0,0-1.21-.46,4,4,0,0,0-1,.11v3.14h.73a2.39,2.39,0,0,0,1.41-.38A1.41,1.41,0,0,0,1630,386.55Zm.35,3.65a1.7,1.7,0,0,0-.59-1.4,2.34,2.34,0,0,0-1.52-.46h-.87v2.16a1.61,1.61,0,0,0,.26,1.11,1.31,1.31,0,0,0,1,.26,1.67,1.67,0,0,0,1.24-.45A1.61,1.61,0,0,0,1630.33,390.2Z"
              />
              <path
                d="M1645.46,406l-.64,1.95h-4l-.07-.1,2-2.2a13.77,13.77,0,0,0,.94-1.16,3.76,3.76,0,0,0,.51-1,2.92,2.92,0,0,0,.15-.93,1.5,1.5,0,0,0-.38-1.06,1.54,1.54,0,0,0-1.1-.41,1.58,1.58,0,0,0-1,.33,4.18,4.18,0,0,0-.85,1l-.13-.08a4.06,4.06,0,0,1,1-1.35,2.08,2.08,0,0,1,1.37-.48,1.86,1.86,0,0,1,1.31.47,1.78,1.78,0,0,1,.51,1.33,2.53,2.53,0,0,1-.2,1,4.27,4.27,0,0,1-.59.94c-.25.32-.57.68-1,1.08l-1.8,1.95h1.7a4.47,4.47,0,0,0,.91-.07,1.18,1.18,0,0,0,.56-.27,2.47,2.47,0,0,0,.44-.61l.21-.35Zm-6.39-3.3a1.89,1.89,0,0,1-.76,1.56,3.72,3.72,0,0,1-2,.65l0-.13a2.31,2.31,0,0,0,1.34-.58,2,2,0,0,0,.45-1.43,1.74,1.74,0,0,0-1.88-2,3.49,3.49,0,0,0-.5,0l-.39.08v5.49a4,4,0,0,0,.07.82.6.6,0,0,0,.24.4,1.14,1.14,0,0,0,.49.14l.42.06v.11h-3.09v-.11l.39-.06a.56.56,0,0,0,.51-.31,2.64,2.64,0,0,0,.12-1.05v-4.25a2.64,2.64,0,0,0-.12-1.05.59.59,0,0,0-.51-.32l-.39-.05v-.12h3a3.8,3.8,0,0,1,1.36.23,2,2,0,0,1,.94.68A1.82,1.82,0,0,1,1639.07,402.65Zm-7.8,3.16a1.88,1.88,0,0,1-.79,1.52,3.37,3.37,0,0,1-2,.58h-3v-.11l.4-.06a.56.56,0,0,0,.5-.31,2.64,2.64,0,0,0,.12-1.05v-4.25a2.64,2.64,0,0,0-.12-1.05.58.58,0,0,0-.5-.32l-.4-.05v-.12h3.06a3.07,3.07,0,0,1,1.74.43,1.36,1.36,0,0,1,.65,1.22,1.34,1.34,0,0,1-.37,1,3.13,3.13,0,0,1-1,.64,2.6,2.6,0,0,1,1.25.67A1.75,1.75,0,0,1,1631.27,405.81Zm-1.29-3.38a1.66,1.66,0,0,0-.42-1.2,1.61,1.61,0,0,0-1.21-.46,4,4,0,0,0-1,.11V404h.73a2.39,2.39,0,0,0,1.41-.38A1.41,1.41,0,0,0,1630,402.43Zm.35,3.65a1.7,1.7,0,0,0-.59-1.4,2.34,2.34,0,0,0-1.52-.46h-.87v2.16a1.61,1.61,0,0,0,.26,1.11,1.31,1.31,0,0,0,1,.26,1.67,1.67,0,0,0,1.24-.45A1.61,1.61,0,0,0,1630.33,406.08Z"
              />
              <path
                d="M1644.87,420.91a2.52,2.52,0,0,1-.51,1.51,3.13,3.13,0,0,1-1.18.93,3.31,3.31,0,0,1-1.36.31,1.34,1.34,0,0,1-.76-.17.5.5,0,0,1-.25-.43.4.4,0,0,1,.14-.32.42.42,0,0,1,.31-.11,1,1,0,0,1,.54.17,2.29,2.29,0,0,1,.53.57,2.25,2.25,0,0,0,.93-.29,2,2,0,0,0,.7-.68,1.93,1.93,0,0,0,.28-1,1.39,1.39,0,0,0-.43-1.09,1.72,1.72,0,0,0-1.15-.36,2,2,0,0,0-.5.06,3.9,3.9,0,0,0-.5.19l-.11-.19a10.78,10.78,0,0,0,1.52-.94,2.57,2.57,0,0,0,.7-.73,1.29,1.29,0,0,0,.17-.67.92.92,0,0,0-.29-.7,1.26,1.26,0,0,0-.87-.27,2.07,2.07,0,0,0-1,.22,4.23,4.23,0,0,0-.83.63l-.11-.12a4.26,4.26,0,0,1,1.15-1,2.45,2.45,0,0,1,1.2-.29,1.62,1.62,0,0,1,1.08.33,1.17,1.17,0,0,1,.41.93,1.47,1.47,0,0,1-.4,1,5.25,5.25,0,0,1-1.23,1,2.27,2.27,0,0,1,1.31.45A1.47,1.47,0,0,1,1644.87,420.91Zm-5.8-2.62a1.88,1.88,0,0,1-.76,1.55,3.72,3.72,0,0,1-2,.65l0-.12a2.32,2.32,0,0,0,1.34-.59,2,2,0,0,0,.45-1.43,1.93,1.93,0,0,0-.52-1.47,2,2,0,0,0-1.36-.47,3.63,3.63,0,0,0-.5,0,2.23,2.23,0,0,0-.39.09V422a4.19,4.19,0,0,0,.07.83.55.55,0,0,0,.24.39,1.13,1.13,0,0,0,.49.15l.42.05v.12h-3.09v-.12l.39-.05a.59.59,0,0,0,.51-.32,2.64,2.64,0,0,0,.12-1.05v-4.25a2.64,2.64,0,0,0-.12-1.05.56.56,0,0,0-.51-.31l-.39-.06v-.11h3a3.8,3.8,0,0,1,1.36.22,2.07,2.07,0,0,1,.94.68A1.83,1.83,0,0,1,1639.07,418.29Zm-7.8,3.15a1.87,1.87,0,0,1-.79,1.52,3.37,3.37,0,0,1-2,.59h-3v-.12l.4-.05a.58.58,0,0,0,.5-.32,2.64,2.64,0,0,0,.12-1.05v-4.25a2.64,2.64,0,0,0-.12-1.05.56.56,0,0,0-.5-.31l-.4-.06v-.11h3.06a3.15,3.15,0,0,1,1.74.42,1.37,1.37,0,0,1,.65,1.22,1.34,1.34,0,0,1-.37,1,3.13,3.13,0,0,1-1,.64,2.6,2.6,0,0,1,1.25.67A1.75,1.75,0,0,1,1631.27,421.44Zm-1.29-3.38a1.69,1.69,0,0,0-.42-1.2,1.61,1.61,0,0,0-1.21-.45,4.06,4.06,0,0,0-1,.1v3.14h.73a2.32,2.32,0,0,0,1.41-.38A1.38,1.38,0,0,0,1630,418.06Zm.35,3.65a1.72,1.72,0,0,0-.59-1.4,2.39,2.39,0,0,0-1.52-.46h-.87V422a1.59,1.59,0,0,0,.26,1.11,1.35,1.35,0,0,0,1,.27,1.75,1.75,0,0,0,1.24-.45A1.63,1.63,0,0,0,1630.33,421.71Z"
              />
              <path
                d="M1667.5,439.43h-3v-.11l.49-.07a.59.59,0,0,0,.54-.31,2.35,2.35,0,0,0,.13-1v-2h-4v2a2.51,2.51,0,0,0,.13,1,.61.61,0,0,0,.54.31l.49.07v.11h-3v-.11l.39-.06a.56.56,0,0,0,.51-.31,2.64,2.64,0,0,0,.12-1.05v-4.25a2.64,2.64,0,0,0-.12-1,.57.57,0,0,0-.51-.32l-.39,0v-.12h3v.12l-.49.06a.65.65,0,0,0-.54.31,2.6,2.6,0,0,0-.13,1v2h4v-2a2.43,2.43,0,0,0-.13-1,.62.62,0,0,0-.54-.31l-.49-.06v-.12h3v.12l-.39,0a.57.57,0,0,0-.51.32,2.64,2.64,0,0,0-.12,1v4.25a2.64,2.64,0,0,0,.12,1.05.56.56,0,0,0,.51.31l.39.06Zm-9.58-5.26a1.89,1.89,0,0,1-.76,1.56,3.72,3.72,0,0,1-2,.65l0-.13a2.31,2.31,0,0,0,1.33-.58,2,2,0,0,0,.46-1.43,2,2,0,0,0-.53-1.47,1.93,1.93,0,0,0-1.36-.48,2.47,2.47,0,0,0-.5,0l-.38.08v5.49a4.22,4.22,0,0,0,.06.82.6.6,0,0,0,.24.4,1.19,1.19,0,0,0,.49.14l.42.06v.11h-3.09v-.11l.4-.06a.56.56,0,0,0,.5-.31,2.64,2.64,0,0,0,.12-1.05v-4.25a2.64,2.64,0,0,0-.12-1,.57.57,0,0,0-.5-.32l-.4,0v-.12h3a3.9,3.9,0,0,1,1.37.23,2,2,0,0,1,.93.67A1.87,1.87,0,0,1,1657.92,434.17Zm-7.94,2.48h-2.73v-.37H1650Zm-5.11.15a2.54,2.54,0,0,1-.51,1.51,3.13,3.13,0,0,1-1.18.93,3.31,3.31,0,0,1-1.36.31,1.43,1.43,0,0,1-.76-.17.5.5,0,0,1-.25-.44.42.42,0,0,1,.14-.32.46.46,0,0,1,.31-.1.91.91,0,0,1,.54.17,2.41,2.41,0,0,1,.53.56,2.12,2.12,0,0,0,.93-.29,1.87,1.87,0,0,0,.7-.67,1.93,1.93,0,0,0,.28-1,1.41,1.41,0,0,0-.43-1.1,1.77,1.77,0,0,0-1.15-.35,2,2,0,0,0-.5.06,2.75,2.75,0,0,0-.5.18l-.11-.18a11.81,11.81,0,0,0,1.52-.94,2.46,2.46,0,0,0,.7-.74,1.26,1.26,0,0,0,.17-.67.91.91,0,0,0-.29-.69,1.31,1.31,0,0,0-.87-.28,2.07,2.07,0,0,0-1,.23,3.57,3.57,0,0,0-.83.63l-.11-.12a4.09,4.09,0,0,1,1.15-1,2.45,2.45,0,0,1,1.2-.29,1.62,1.62,0,0,1,1.08.32,1.2,1.2,0,0,1,.41.94,1.45,1.45,0,0,1-.4,1,5,5,0,0,1-1.23,1,2.14,2.14,0,0,1,1.31.45A1.45,1.45,0,0,1,1644.87,436.8Zm-5.8-2.63a1.89,1.89,0,0,1-.76,1.56,3.72,3.72,0,0,1-2,.65l0-.13a2.31,2.31,0,0,0,1.34-.58,2,2,0,0,0,.45-1.43,1.74,1.74,0,0,0-1.88-1.95,2.47,2.47,0,0,0-.5,0l-.39.08v5.49a4.07,4.07,0,0,0,.07.82.6.6,0,0,0,.24.4,1.14,1.14,0,0,0,.49.14l.42.06v.11h-3.09v-.11l.39-.06a.56.56,0,0,0,.51-.31,2.64,2.64,0,0,0,.12-1.05v-4.25a2.64,2.64,0,0,0-.12-1,.57.57,0,0,0-.51-.32l-.39,0v-.12h3a3.8,3.8,0,0,1,1.36.23,2.05,2.05,0,0,1,.94.67A1.87,1.87,0,0,1,1639.07,434.17Zm-7.8,3.16a1.88,1.88,0,0,1-.79,1.52,3.37,3.37,0,0,1-2,.58h-3v-.11l.4-.06a.56.56,0,0,0,.5-.31,2.64,2.64,0,0,0,.12-1.05v-4.25a2.64,2.64,0,0,0-.12-1,.57.57,0,0,0-.5-.32l-.4,0v-.12h3.06a3.15,3.15,0,0,1,1.74.42,1.39,1.39,0,0,1,.65,1.23,1.36,1.36,0,0,1-.37,1,3.13,3.13,0,0,1-1,.64,2.68,2.68,0,0,1,1.25.66A1.79,1.79,0,0,1,1631.27,437.33ZM1630,434a1.66,1.66,0,0,0-.42-1.2,1.61,1.61,0,0,0-1.21-.46,4,4,0,0,0-1,.11v3.14h.73a2.39,2.39,0,0,0,1.41-.38A1.41,1.41,0,0,0,1630,434Zm.35,3.65a1.7,1.7,0,0,0-.59-1.4,2.34,2.34,0,0,0-1.52-.46h-.87v2.16a1.61,1.61,0,0,0,.26,1.11,1.31,1.31,0,0,0,1,.26,1.67,1.67,0,0,0,1.24-.45A1.61,1.61,0,0,0,1630.33,437.6Z"
              />
              <path
                d="M1637.47,465.74h-3.14v-.12l.42-.05a1.13,1.13,0,0,0,.49-.15.55.55,0,0,0,.24-.39,3.54,3.54,0,0,0,.07-.83v-4.09a3.67,3.67,0,0,0-.07-.79.5.5,0,0,0-.27-.35,1.4,1.4,0,0,0-.59-.07h-.29v-.12a8,8,0,0,0,1-.22c.34-.1.65-.2.9-.3l.1.05v5.89a4.34,4.34,0,0,0,.06.83.58.58,0,0,0,.23.39,1,1,0,0,0,.45.15l.36.05Zm-5.22-1.91-.26,1.49a4.42,4.42,0,0,1-1,.4,6.46,6.46,0,0,1-1.41.14,4.16,4.16,0,0,1-2-.45,3.36,3.36,0,0,1-1.37-1.3,3.87,3.87,0,0,1-.51-2,3.72,3.72,0,0,1,.57-2,3.89,3.89,0,0,1,3.23-1.76,5.8,5.8,0,0,1,1.38.14,4.68,4.68,0,0,1,1,.37l.26,1.53H1632l-.14-.3a2.83,2.83,0,0,0-.86-1.12,2.53,2.53,0,0,0-1.53-.44,2.47,2.47,0,0,0-2,.93,4.08,4.08,0,0,0-.75,2.58,4.26,4.26,0,0,0,.82,2.72,2.64,2.64,0,0,0,2.14,1,2.36,2.36,0,0,0,1.42-.38,2.81,2.81,0,0,0,.9-1.17l.14-.3Z"
              />
              <path
                d="M1659.72,481.62h-3v-.12l.49-.06a.65.65,0,0,0,.54-.31,2.6,2.6,0,0,0,.13-1.05v-2h-4v2a2.43,2.43,0,0,0,.13,1.05.64.64,0,0,0,.54.31l.49.06v.12h-3v-.12l.4-.05a.58.58,0,0,0,.5-.32,2.64,2.64,0,0,0,.12-1.05v-4.25a2.64,2.64,0,0,0-.12-1.05.56.56,0,0,0-.5-.31l-.4-.06v-.11h3v.11l-.49.07a.6.6,0,0,0-.54.31,2.35,2.35,0,0,0-.13,1v2h4v-2a2.51,2.51,0,0,0-.13-1,.61.61,0,0,0-.54-.31l-.49-.07v-.11h3v.11l-.39.06a.56.56,0,0,0-.51.31,2.85,2.85,0,0,0-.12,1.05v4.25a2.85,2.85,0,0,0,.12,1.05.59.59,0,0,0,.51.32l.39.05Zm-9.78-5.26a1.89,1.89,0,0,1-.77,1.55,3.69,3.69,0,0,1-2,.65l0-.12a2.32,2.32,0,0,0,1.33-.59,2.37,2.37,0,0,0-.07-2.9,2,2,0,0,0-1.36-.47,3.63,3.63,0,0,0-.5,0l-.38.08v5.49a4.34,4.34,0,0,0,.06.83.55.55,0,0,0,.24.39,1.18,1.18,0,0,0,.5.15l.41.05v.12h-3.09v-.12l.4-.05a.57.57,0,0,0,.5-.32,2.79,2.79,0,0,0,.13-1.05v-4.25a2.79,2.79,0,0,0-.13-1.05.55.55,0,0,0-.5-.31l-.4-.06v-.11h3a3.86,3.86,0,0,1,1.37.22,2,2,0,0,1,.93.68A1.9,1.9,0,0,1,1649.94,476.36Zm-7.63,2.47h-2.73v-.36h2.73Zm-4.84,2.79h-3.14v-.12l.42-.05a1.13,1.13,0,0,0,.49-.15.55.55,0,0,0,.24-.39,3.54,3.54,0,0,0,.07-.83V476a3.67,3.67,0,0,0-.07-.79.5.5,0,0,0-.27-.35,1.4,1.4,0,0,0-.59-.07h-.29v-.12a8,8,0,0,0,1-.22c.34-.1.65-.2.9-.3l.1.05v5.89a4.34,4.34,0,0,0,.06.83.58.58,0,0,0,.23.39,1,1,0,0,0,.45.15l.36.05Zm-5.22-1.91-.26,1.49a4.42,4.42,0,0,1-1,.4,6.46,6.46,0,0,1-1.41.14,4.16,4.16,0,0,1-2-.45,3.36,3.36,0,0,1-1.37-1.3,3.87,3.87,0,0,1-.51-2,3.72,3.72,0,0,1,.57-2,3.89,3.89,0,0,1,3.23-1.76,5.8,5.8,0,0,1,1.38.14,4.68,4.68,0,0,1,1,.37l.26,1.53H1632l-.14-.3a2.83,2.83,0,0,0-.86-1.12,2.53,2.53,0,0,0-1.53-.44,2.47,2.47,0,0,0-2,.93,4.08,4.08,0,0,0-.75,2.58,4.26,4.26,0,0,0,.82,2.72,2.64,2.64,0,0,0,2.14,1,2.36,2.36,0,0,0,1.42-.38,2.81,2.81,0,0,0,.9-1.17l.14-.3Z"
              />
              <path
                d="M1644.93,497.5h-3.14v-.12l.41-.05a1.18,1.18,0,0,0,.5-.15.58.58,0,0,0,.24-.39,4.34,4.34,0,0,0,.06-.83v-4.09a3.12,3.12,0,0,0-.07-.79.45.45,0,0,0-.27-.35,1.35,1.35,0,0,0-.58-.07h-.29v-.12a7.91,7.91,0,0,0,1-.22c.35-.1.65-.2.91-.3l.09.05V496a3.54,3.54,0,0,0,.07.83.6.6,0,0,0,.23.39,1,1,0,0,0,.45.15l.36.05Zm-4.9-5.26a1.86,1.86,0,0,1-.77,1.55,3.66,3.66,0,0,1-2,.65l0-.12a2.35,2.35,0,0,0,1.33-.59,2,2,0,0,0-1.42-3.37,3.53,3.53,0,0,0-.5,0,3.33,3.33,0,0,0-.39.08V496a3.54,3.54,0,0,0,.07.83.58.58,0,0,0,.24.39,1.13,1.13,0,0,0,.49.15l.42.05v.12h-3.09v-.12l.39-.05a.59.59,0,0,0,.51-.32,2.64,2.64,0,0,0,.12-1.05v-4.25a2.64,2.64,0,0,0-.12-1,.56.56,0,0,0-.51-.31l-.39-.06v-.11h3a3.84,3.84,0,0,1,1.36.22,2.07,2.07,0,0,1,.94.68A1.89,1.89,0,0,1,1640,492.24Zm-7.78,3.35-.26,1.49a4,4,0,0,1-1,.39,5.86,5.86,0,0,1-1.41.15,4.16,4.16,0,0,1-2-.45,3.36,3.36,0,0,1-1.37-1.3,3.87,3.87,0,0,1-.51-2,3.72,3.72,0,0,1,.57-2,3.89,3.89,0,0,1,3.23-1.76,5.8,5.8,0,0,1,1.38.14,4.68,4.68,0,0,1,1,.37l.26,1.53H1632l-.14-.3a2.83,2.83,0,0,0-.86-1.12,2.53,2.53,0,0,0-1.53-.44,2.47,2.47,0,0,0-2,.93,4.08,4.08,0,0,0-.75,2.58,4.28,4.28,0,0,0,.82,2.72,2.64,2.64,0,0,0,2.14,1,2.43,2.43,0,0,0,1.42-.38,2.79,2.79,0,0,0,.9-1.18l.14-.29Z"
              />
              <path
                d="M1667.18,513.14h-3V513l.49-.07a.59.59,0,0,0,.54-.31,2.47,2.47,0,0,0,.14-1v-2h-4v2a2.31,2.31,0,0,0,.14,1,.58.58,0,0,0,.53.31l.49.07v.12h-3V513l.39-.06a.56.56,0,0,0,.51-.31,2.64,2.64,0,0,0,.12-1v-4.25a2.64,2.64,0,0,0-.12-1.05.56.56,0,0,0-.51-.31l-.39-.06v-.11h3v.11l-.49.07a.58.58,0,0,0-.53.31,2.31,2.31,0,0,0-.14,1v2h4v-2a2.47,2.47,0,0,0-.14-1,.59.59,0,0,0-.54-.31l-.49-.07v-.11h3v.11l-.39.06a.56.56,0,0,0-.51.31,2.64,2.64,0,0,0-.12,1.05v4.25a2.64,2.64,0,0,0,.12,1,.56.56,0,0,0,.51.31l.39.06Zm-9.58-5.27a1.89,1.89,0,0,1-.76,1.56,3.72,3.72,0,0,1-2,.65l0-.12a2.38,2.38,0,0,0,1.33-.59,2.37,2.37,0,0,0-.07-2.9,1.93,1.93,0,0,0-1.36-.47,3.63,3.63,0,0,0-.5,0l-.38.08v5.49a4.34,4.34,0,0,0,.06.83.58.58,0,0,0,.24.39,1.06,1.06,0,0,0,.5.14l.41.06v.12H1652V513l.4-.06a.56.56,0,0,0,.5-.31,2.64,2.64,0,0,0,.12-1v-4.25a2.64,2.64,0,0,0-.12-1.05.56.56,0,0,0-.5-.31l-.4-.06v-.11h3a3.9,3.9,0,0,1,1.37.22,2,2,0,0,1,.93.68A1.82,1.82,0,0,1,1657.6,507.87Zm-7.94,2.48h-2.73V510h2.73Zm-4.73,2.79h-3.14V513l.41-.06a1.06,1.06,0,0,0,.5-.14.58.58,0,0,0,.24-.39,4.34,4.34,0,0,0,.06-.83v-4.09a3.12,3.12,0,0,0-.07-.79.45.45,0,0,0-.27-.35,1.35,1.35,0,0,0-.58-.07h-.29v-.12a7.91,7.91,0,0,0,1-.22c.35-.1.65-.2.91-.3l.09,0v5.89a3.54,3.54,0,0,0,.07.83.6.6,0,0,0,.23.39.92.92,0,0,0,.45.14l.36.06Zm-4.9-5.27a1.87,1.87,0,0,1-.77,1.56,3.66,3.66,0,0,1-2,.65l0-.12a2.35,2.35,0,0,0,1.33-.59,2.37,2.37,0,0,0-.07-2.9,1.88,1.88,0,0,0-1.35-.47,3.53,3.53,0,0,0-.5,0,3.33,3.33,0,0,0-.39.08v5.49a3.54,3.54,0,0,0,.07.83.58.58,0,0,0,.24.39,1,1,0,0,0,.49.14l.42.06v.12h-3.09V513l.39-.06a.56.56,0,0,0,.51-.31,2.64,2.64,0,0,0,.12-1v-4.25a2.64,2.64,0,0,0-.12-1.05.56.56,0,0,0-.51-.31l-.39-.06v-.11h3a3.84,3.84,0,0,1,1.36.22,2.07,2.07,0,0,1,.94.68A1.89,1.89,0,0,1,1640,507.87Zm-7.78,3.36-.26,1.49a4.42,4.42,0,0,1-1,.39,5.86,5.86,0,0,1-1.41.15,4.16,4.16,0,0,1-2-.45,3.36,3.36,0,0,1-1.37-1.3,3.87,3.87,0,0,1-.51-2,3.72,3.72,0,0,1,.57-2,3.89,3.89,0,0,1,3.23-1.76,5.8,5.8,0,0,1,1.38.14,4.68,4.68,0,0,1,1,.37l.26,1.53H1632l-.14-.3a2.83,2.83,0,0,0-.86-1.12,2.53,2.53,0,0,0-1.53-.44,2.47,2.47,0,0,0-2,.93,4.08,4.08,0,0,0-.75,2.58,4.28,4.28,0,0,0,.82,2.72,2.64,2.64,0,0,0,2.14,1,2.43,2.43,0,0,0,1.42-.38,2.79,2.79,0,0,0,.9-1.18l.14-.29Z"
              />
              <path
                d="M1722.17,334h-2.39v-.11l.22,0a1,1,0,0,0,.38-.11.45.45,0,0,0,.17-.31,5.73,5.73,0,0,0,0-.69v-2.16c0-.86-.33-1.28-1-1.27a1.65,1.65,0,0,0-.74.18,2.33,2.33,0,0,0-.65.48c0,.06,0,.15,0,.25s0,.2,0,.29v2.23a4,4,0,0,0,0,.69.44.44,0,0,0,.16.31,1.07,1.07,0,0,0,.39.11l.21,0V334h-2.4v-.11l.22,0a1,1,0,0,0,.38-.11.44.44,0,0,0,.16-.31,4,4,0,0,0,0-.69v-2.16c0-.86-.34-1.28-1-1.27a1.65,1.65,0,0,0-.72.17,2.28,2.28,0,0,0-.63.45v2.81a4,4,0,0,0,0,.69.44.44,0,0,0,.16.31,1,1,0,0,0,.38.11l.22,0V334h-2.39v-.11l.22,0a.9.9,0,0,0,.37-.11.45.45,0,0,0,.16-.32,3.89,3.89,0,0,0,0-.68v-2.51a1,1,0,0,0-.1-.54.73.73,0,0,0-.39-.25l-.31-.12v-.09l1.5-.35.1.07v.75a4.07,4.07,0,0,1,.8-.6,1.71,1.71,0,0,1,.89-.23,1.49,1.49,0,0,1,.91.24,1.14,1.14,0,0,1,.45.65,4.61,4.61,0,0,1,.85-.64,2,2,0,0,1,.92-.25c1,0,1.46.52,1.46,1.59v2.28a4,4,0,0,0,0,.69.44.44,0,0,0,.16.31.9.9,0,0,0,.37.11l.22,0Zm-9.77,2.28h-2.73v-.12l.27,0a1.35,1.35,0,0,0,.5-.12.42.42,0,0,0,.21-.31,3.7,3.7,0,0,0,0-.68v-1.65a3.5,3.5,0,0,1-.72.53,2.11,2.11,0,0,1-.91.21,2,2,0,0,1-1.09-.32,2.07,2.07,0,0,1-.72-.83,2.63,2.63,0,0,1-.26-1.16,3.42,3.42,0,0,1,.35-1.53,2.44,2.44,0,0,1,2.23-1.33,3.37,3.37,0,0,1,.82.09,3.2,3.2,0,0,1,.62.24l.4-.42h.08V335a4,4,0,0,0,0,.68.46.46,0,0,0,.18.31,1,1,0,0,0,.43.12l.25,0Zm-1.7-5.63a1.73,1.73,0,0,0-.36-1.14,1.19,1.19,0,0,0-.94-.39,1.47,1.47,0,0,0-1.19.53,2.44,2.44,0,0,0-.46,1.56,3.26,3.26,0,0,0,.22,1.24,2,2,0,0,0,.61.85,1.58,1.58,0,0,0,1,.32,1.71,1.71,0,0,0,.62-.11,2,2,0,0,0,.55-.34Zm-5.49,2a1.2,1.2,0,0,1-.28.8,1.72,1.72,0,0,1-.69.48,2.37,2.37,0,0,1-.88.16,3.59,3.59,0,0,1-.9-.1,3.52,3.52,0,0,1-.77-.27v-1h.31a1.63,1.63,0,0,0,.45.94,1.44,1.44,0,0,0,1,.3,1.16,1.16,0,0,0,.79-.26.87.87,0,0,0,.31-.7.78.78,0,0,0-.27-.66,3.07,3.07,0,0,0-1-.46,2.91,2.91,0,0,1-1.16-.6,1.23,1.23,0,0,1-.38-.94,1.37,1.37,0,0,1,.25-.78,1.54,1.54,0,0,1,.63-.49,2.13,2.13,0,0,1,.88-.18,2.78,2.78,0,0,1,.8.1,2.43,2.43,0,0,1,.61.24v1h-.3a2,2,0,0,0-.37-.9,1,1,0,0,0-.8-.31,1.12,1.12,0,0,0-.75.27.92.92,0,0,0-.29.7.81.81,0,0,0,.29.65,2.69,2.69,0,0,0,1,.45,3,3,0,0,1,1.23.62A1.21,1.21,0,0,1,1705.21,332.63Zm-9.11-3.32a4.27,4.27,0,0,1-.92,2.73,7.3,7.3,0,0,1-3.09,2.13L1692,334a6.85,6.85,0,0,0,2-1.33,3.54,3.54,0,0,0,.91-1.51,5.8,5.8,0,0,0,.21-1.69,4.21,4.21,0,0,0-.43-2.09,1.3,1.3,0,0,0-1.17-.7,1.09,1.09,0,0,0-1,.55,3,3,0,0,0-.32,1.5,4.06,4.06,0,0,0,.13,1,1.49,1.49,0,0,0,.46.74,1.29,1.29,0,0,0,.86.28,2.72,2.72,0,0,0,.62-.07l0,.14a3.29,3.29,0,0,1-.95.17,2,2,0,0,1-1.49-.56,2.07,2.07,0,0,1-.55-1.51,2.45,2.45,0,0,1,.32-1.25,2.39,2.39,0,0,1,.84-.86,2.3,2.3,0,0,1,1.18-.32,2.25,2.25,0,0,1,1.2.32,2.3,2.3,0,0,1,.87,1A3.48,3.48,0,0,1,1696.1,329.31Zm-6.1,2.54h-1.17V334h-.77v-2.16h-3.34l-.07-.11,3.8-5.14h.38v4.9H1690Zm-1.94-.35v-4l-2.94,4Z"
              />
              <path
                d="M1722.17,349.84h-2.39v-.12l.22,0a.81.81,0,0,0,.38-.12.45.45,0,0,0,.17-.31,5.66,5.66,0,0,0,0-.68v-2.17c0-.85-.33-1.28-1-1.27a1.65,1.65,0,0,0-.74.18,2.33,2.33,0,0,0-.65.48c0,.07,0,.15,0,.25s0,.21,0,.3v2.23a3.89,3.89,0,0,0,0,.68.44.44,0,0,0,.16.31.9.9,0,0,0,.39.12l.21,0v.12h-2.4v-.12l.22,0a.85.85,0,0,0,.38-.12.44.44,0,0,0,.16-.31,3.89,3.89,0,0,0,0-.68v-2.17c0-.85-.34-1.28-1-1.27a1.65,1.65,0,0,0-.72.17,2.79,2.79,0,0,0-.63.45v2.82a3.89,3.89,0,0,0,0,.68.44.44,0,0,0,.16.31.85.85,0,0,0,.38.12l.22,0v.12h-2.39v-.12l.22,0a.76.76,0,0,0,.37-.12.44.44,0,0,0,.16-.31,4,4,0,0,0,0-.68v-2.52a.9.9,0,0,0-.1-.53.69.69,0,0,0-.39-.26l-.31-.12v-.08l1.5-.35.1.06v.76a4.15,4.15,0,0,1,.8-.61,1.71,1.71,0,0,1,.89-.23,1.49,1.49,0,0,1,.91.24,1.17,1.17,0,0,1,.45.65,5,5,0,0,1,.85-.63,2,2,0,0,1,.92-.26c1,0,1.46.52,1.46,1.59v2.29a3.89,3.89,0,0,0,0,.68.44.44,0,0,0,.16.31.76.76,0,0,0,.37.12l.22,0Zm-9.77,2.27h-2.73V352l.27,0a1.35,1.35,0,0,0,.5-.12.4.4,0,0,0,.21-.31,3.62,3.62,0,0,0,0-.68v-1.64a3.45,3.45,0,0,1-.72.52,1.85,1.85,0,0,1-.91.21,1.89,1.89,0,0,1-1.09-.32,2,2,0,0,1-.72-.83,2.63,2.63,0,0,1-.26-1.16,3.45,3.45,0,0,1,.35-1.53,2.51,2.51,0,0,1,.93-1,2.39,2.39,0,0,1,1.3-.35,3.37,3.37,0,0,1,.82.09,4,4,0,0,1,.62.24l.4-.42h.08v6.17a3.89,3.89,0,0,0,0,.68.43.43,0,0,0,.18.31,1,1,0,0,0,.43.12l.25,0Zm-1.7-5.62a1.74,1.74,0,0,0-.36-1.15,1.19,1.19,0,0,0-.94-.39,1.5,1.5,0,0,0-1.19.53,2.44,2.44,0,0,0-.46,1.56,3.23,3.23,0,0,0,.22,1.24,1.94,1.94,0,0,0,.61.85,1.51,1.51,0,0,0,1,.32,1.72,1.72,0,0,0,.62-.1,2,2,0,0,0,.55-.35Zm-5.49,2a1.2,1.2,0,0,1-.28.8,1.54,1.54,0,0,1-.69.48,2.37,2.37,0,0,1-.88.16,3.47,3.47,0,0,1-1.67-.37v-1h.31a1.6,1.6,0,0,0,.45.93,1.44,1.44,0,0,0,1,.3,1.15,1.15,0,0,0,.79-.25.89.89,0,0,0,.31-.71.77.77,0,0,0-.27-.65,3,3,0,0,0-1-.47,2.91,2.91,0,0,1-1.16-.6,1.21,1.21,0,0,1-.38-.93,1.32,1.32,0,0,1,.25-.78,1.56,1.56,0,0,1,.63-.5,2.13,2.13,0,0,1,.88-.18,3.18,3.18,0,0,1,.8.1,2.43,2.43,0,0,1,.61.25v1h-.3a2,2,0,0,0-.37-.9,1,1,0,0,0-.8-.3,1.07,1.07,0,0,0-.75.26,1,1,0,0,0-.29.71.83.83,0,0,0,.29.65,3.08,3.08,0,0,0,1,.45,3,3,0,0,1,1.23.61A1.22,1.22,0,0,1,1705.21,348.5Zm-9.11-3.32a4.3,4.3,0,0,1-.92,2.74,7.38,7.38,0,0,1-3.09,2.12l-.07-.16a6.66,6.66,0,0,0,2-1.33,3.51,3.51,0,0,0,.91-1.5,5.85,5.85,0,0,0,.21-1.69,4.23,4.23,0,0,0-.43-2.1,1.3,1.3,0,0,0-1.17-.7,1.11,1.11,0,0,0-1,.55,3,3,0,0,0-.32,1.5,4,4,0,0,0,.13,1,1.49,1.49,0,0,0,.46.74,1.35,1.35,0,0,0,.86.29,2.67,2.67,0,0,0,.62-.08l0,.14a3,3,0,0,1-.95.17,2,2,0,0,1-1.49-.56,2.06,2.06,0,0,1-.55-1.51,2.47,2.47,0,0,1,.32-1.25,2.3,2.3,0,0,1,2-1.18,2.25,2.25,0,0,1,2.07,1.27A3.51,3.51,0,0,1,1696.1,345.18Zm-6.1,2.54h-1.17v2.16h-.77v-2.16h-3.34l-.07-.1,3.8-5.15h.38v4.9H1690Zm-1.94-.35v-4l-2.94,4Z"
              />
              <path
                d="M1722.24,376.14h-2.38V376l.21,0a.9.9,0,0,0,.39-.12.42.42,0,0,0,.16-.31,3.75,3.75,0,0,0,0-.68v-2.16c0-.86-.34-1.28-1-1.27a1.66,1.66,0,0,0-.75.18,2.33,2.33,0,0,0-.65.48.81.81,0,0,1,0,.25c0,.1,0,.2,0,.29v2.23a5,5,0,0,0,0,.68.43.43,0,0,0,.17.31.81.81,0,0,0,.38.12l.21,0v.12h-2.39V376l.21,0a.81.81,0,0,0,.38-.12.43.43,0,0,0,.17-.31,5,5,0,0,0,0-.68v-2.16c0-.86-.34-1.28-1-1.27a1.53,1.53,0,0,0-.72.17,2.52,2.52,0,0,0-.64.44v2.82a5,5,0,0,0,0,.68.42.42,0,0,0,.16.31.9.9,0,0,0,.39.12l.21,0v.12h-2.38V376l.22,0a.8.8,0,0,0,.37-.12.46.46,0,0,0,.16-.31,5.66,5.66,0,0,0,0-.68v-2.52a.93.93,0,0,0-.09-.53.73.73,0,0,0-.4-.26l-.31-.11v-.09l1.51-.35.09.06v.76a4.86,4.86,0,0,1,.8-.61,1.77,1.77,0,0,1,.9-.22,1.59,1.59,0,0,1,.91.23,1.32,1.32,0,0,1,.45.65,4.65,4.65,0,0,1,.85-.63,1.92,1.92,0,0,1,.92-.25c1,0,1.46.51,1.46,1.59v2.28a5.43,5.43,0,0,0,0,.68.46.46,0,0,0,.16.31.85.85,0,0,0,.37.12l.22,0Zm-9.76,2.27h-2.74v-.11l.28,0a1.55,1.55,0,0,0,.49-.11.46.46,0,0,0,.22-.31,4,4,0,0,0,0-.69v-1.64a3,3,0,0,1-.72.52,1.94,1.94,0,0,1-.91.22,2.08,2.08,0,0,1-1.09-.32,2.14,2.14,0,0,1-.72-.83,2.64,2.64,0,0,1-.25-1.17,3.25,3.25,0,0,1,.35-1.52,2.45,2.45,0,0,1,.92-1,2.52,2.52,0,0,1,1.31-.35,2.9,2.9,0,0,1,.81.1,2.78,2.78,0,0,1,.62.23l.41-.41h.07v6.16a3.7,3.7,0,0,0,0,.68.4.4,0,0,0,.18.32,1.14,1.14,0,0,0,.42.11l.26,0Zm-1.71-5.62a1.7,1.7,0,0,0-.35-1.15,1.21,1.21,0,0,0-1-.39,1.46,1.46,0,0,0-1.18.54,2.4,2.4,0,0,0-.47,1.56,3.37,3.37,0,0,0,.22,1.23,2,2,0,0,0,.62.86,1.61,1.61,0,0,0,.94.32,1.77,1.77,0,0,0,.63-.11,1.79,1.79,0,0,0,.54-.34Zm-5.48,2a1.27,1.27,0,0,1-.28.8,1.75,1.75,0,0,1-.7.48,2.58,2.58,0,0,1-.87.16,3.49,3.49,0,0,1-.9-.1,3.17,3.17,0,0,1-.78-.28v-1h.31a1.76,1.76,0,0,0,.45.94,1.44,1.44,0,0,0,1,.3,1.2,1.2,0,0,0,.8-.26.9.9,0,0,0,.31-.7.81.81,0,0,0-.27-.66,3.07,3.07,0,0,0-1-.46,3.25,3.25,0,0,1-1.17-.6,1.24,1.24,0,0,1-.37-.94,1.26,1.26,0,0,1,.25-.78,1.65,1.65,0,0,1,.63-.5,2.21,2.21,0,0,1,.87-.17,3.23,3.23,0,0,1,.81.09,3.1,3.1,0,0,1,.61.25v1h-.31a1.87,1.87,0,0,0-.37-.9,1,1,0,0,0-.79-.3,1.1,1.1,0,0,0-.76.27.92.92,0,0,0-.28.7.78.78,0,0,0,.29.65,2.9,2.9,0,0,0,1,.45,2.92,2.92,0,0,1,1.23.61A1.22,1.22,0,0,1,1705.29,374.81Zm-9,1.33h-.39l-.59,0h-1.09l-.65,0h-.42V376l.41,0a1.19,1.19,0,0,0,.5-.14.6.6,0,0,0,.24-.4,4.27,4.27,0,0,0,.06-.83v-4.08a3.21,3.21,0,0,0-.07-.8.44.44,0,0,0-.27-.34,1.32,1.32,0,0,0-.58-.08h-.29v-.12a7.91,7.91,0,0,0,1-.22,6.47,6.47,0,0,0,.91-.3l.09,0v5.89a3.48,3.48,0,0,0,.07.83.63.63,0,0,0,.23.4,1,1,0,0,0,.45.14l.36,0Zm-4.62-2.3a2.52,2.52,0,0,1-.33,1.24,2.31,2.31,0,0,1-.84.86,2.34,2.34,0,0,1-1.17.33,2.27,2.27,0,0,1-1.21-.33,2.22,2.22,0,0,1-.86-.95,3.45,3.45,0,0,1-.33-1.52,4.28,4.28,0,0,1,.91-2.73,7.42,7.42,0,0,1,3.09-2.12l.08.16a6.54,6.54,0,0,0-2,1.33,3.72,3.72,0,0,0-.91,1.5,5.48,5.48,0,0,0-.2,1.69,4.17,4.17,0,0,0,.43,2.1,1.29,1.29,0,0,0,1.16.7,1.08,1.08,0,0,0,1-.56,2.87,2.87,0,0,0,.32-1.49,3.68,3.68,0,0,0-.13-1,1.51,1.51,0,0,0-.45-.73,1.29,1.29,0,0,0-.86-.29,2.17,2.17,0,0,0-.62.08l0-.14a2.92,2.92,0,0,1,.94-.17,2,2,0,0,1,1.5.56A2.1,2.1,0,0,1,1691.7,373.84Z"
              />
              <path
                d="M1722.24,392h-2.38v-.11l.21,0a1.07,1.07,0,0,0,.39-.11.44.44,0,0,0,.16-.31,4,4,0,0,0,0-.69v-2.16c0-.86-.34-1.28-1-1.27a1.66,1.66,0,0,0-.75.18,2.33,2.33,0,0,0-.65.48.85.85,0,0,1,0,.25c0,.1,0,.2,0,.29v2.23a5.29,5.29,0,0,0,0,.69.45.45,0,0,0,.17.31,1,1,0,0,0,.38.11l.21,0V392h-2.39v-.11l.21,0a1,1,0,0,0,.38-.11.45.45,0,0,0,.17-.31,5.29,5.29,0,0,0,0-.69v-2.16c0-.86-.34-1.28-1-1.27a1.65,1.65,0,0,0-.72.17,2.32,2.32,0,0,0-.64.45v2.81a5.29,5.29,0,0,0,0,.69.41.41,0,0,0,.17.31,1,1,0,0,0,.38.11l.21,0V392h-2.38v-.11l.22,0a1,1,0,0,0,.37-.11.49.49,0,0,0,.16-.32,5.66,5.66,0,0,0,0-.68v-2.51a1,1,0,0,0-.09-.54.73.73,0,0,0-.4-.25l-.31-.12v-.09l1.51-.35.09.07v.75a4.75,4.75,0,0,1,.8-.6,1.77,1.77,0,0,1,.9-.23,1.51,1.51,0,0,1,.91.24,1.24,1.24,0,0,1,.45.65,4.3,4.3,0,0,1,.85-.64,1.92,1.92,0,0,1,.92-.25c1,0,1.46.52,1.46,1.59v2.28a5.73,5.73,0,0,0,0,.69.48.48,0,0,0,.16.31,1,1,0,0,0,.37.11l.22,0Zm-9.76,2.28h-2.74v-.12l.28,0a1.29,1.29,0,0,0,.49-.12.46.46,0,0,0,.22-.31,3.89,3.89,0,0,0,0-.68V391.4a3,3,0,0,1-.72.53,2.07,2.07,0,0,1-.91.21,2,2,0,0,1-1.09-.32,2.07,2.07,0,0,1-.72-.83,2.64,2.64,0,0,1-.25-1.17,3.28,3.28,0,0,1,.35-1.52,2.45,2.45,0,0,1,.92-1,2.51,2.51,0,0,1,1.31-.34,3.35,3.35,0,0,1,.81.09,2.77,2.77,0,0,1,.62.24l.41-.42h.07v6.17a3.78,3.78,0,0,0,0,.68.39.39,0,0,0,.18.31,1,1,0,0,0,.42.12l.26,0Zm-1.71-5.63a1.67,1.67,0,0,0-.35-1.14,1.21,1.21,0,0,0-1-.39,1.45,1.45,0,0,0-1.18.53,2.44,2.44,0,0,0-.47,1.56,3.47,3.47,0,0,0,.22,1.24,2,2,0,0,0,.62.85,1.55,1.55,0,0,0,.94.32,1.77,1.77,0,0,0,.63-.11,1.79,1.79,0,0,0,.54-.34Zm-5.8,2a1.25,1.25,0,0,1-.28.8,1.75,1.75,0,0,1-.7.48,2.35,2.35,0,0,1-.87.16,3.49,3.49,0,0,1-.9-.1,3.6,3.6,0,0,1-.78-.27v-1h.31a1.7,1.7,0,0,0,.46.94,1.4,1.4,0,0,0,1,.3,1.2,1.2,0,0,0,.8-.26.9.9,0,0,0,.31-.7.78.78,0,0,0-.27-.66,3.07,3.07,0,0,0-1-.46,3,3,0,0,1-1.17-.6,1.22,1.22,0,0,1-.37-.94,1.3,1.3,0,0,1,.25-.78,1.54,1.54,0,0,1,.63-.49,2.05,2.05,0,0,1,.87-.18,2.8,2.8,0,0,1,.81.1,2.59,2.59,0,0,1,.61.24v1h-.31a1.79,1.79,0,0,0-.37-.9,1,1,0,0,0-.79-.31,1.15,1.15,0,0,0-.76.27.92.92,0,0,0-.28.7.78.78,0,0,0,.29.65,2.54,2.54,0,0,0,1,.45,2.91,2.91,0,0,1,1.23.62A1.18,1.18,0,0,1,1705,390.7Zm-8.71-.78h-1.17v2.16h-.78v-2.16H1691l-.07-.11,3.8-5.14h.39v4.9h1.17Zm-2-.35v-4l-2.94,4Zm-4.85.16a2.58,2.58,0,0,1-.32,1.25,2.3,2.3,0,0,1-4.09-.09,3.51,3.51,0,0,1-.33-1.52,4.3,4.3,0,0,1,.92-2.74,7.38,7.38,0,0,1,3.09-2.12l.07.16a6.66,6.66,0,0,0-2,1.33,3.51,3.51,0,0,0-.91,1.5,5.26,5.26,0,0,0-.21,1.7,4.21,4.21,0,0,0,.43,2.09,1.3,1.3,0,0,0,1.17.7,1.12,1.12,0,0,0,1-.55,3,3,0,0,0,.32-1.5,3.59,3.59,0,0,0-.14-1,1.47,1.47,0,0,0-.45-.74,1.35,1.35,0,0,0-.86-.29,2.22,2.22,0,0,0-.62.08l0-.14a2.93,2.93,0,0,1,1-.17,2,2,0,0,1,1.49.56A2.12,2.12,0,0,1,1689.46,389.73Z"
              />
              <path
                d="M1722.24,407.91h-2.38v-.11l.21,0a1.07,1.07,0,0,0,.39-.11.44.44,0,0,0,.16-.31,4,4,0,0,0,0-.69v-2.16c0-.86-.34-1.28-1-1.27a1.66,1.66,0,0,0-.75.18,2.33,2.33,0,0,0-.65.48.85.85,0,0,1,0,.25c0,.1,0,.2,0,.29v2.23a5.29,5.29,0,0,0,0,.69.45.45,0,0,0,.17.31,1,1,0,0,0,.38.11l.21,0v.11h-2.39v-.11l.21,0a1,1,0,0,0,.38-.11.45.45,0,0,0,.17-.31,5.29,5.29,0,0,0,0-.69v-2.16c0-.86-.34-1.28-1-1.27a1.65,1.65,0,0,0-.72.17,2.32,2.32,0,0,0-.64.45v2.81a4,4,0,0,0,0,.69.44.44,0,0,0,.16.31,1.07,1.07,0,0,0,.39.11l.21,0v.11h-2.38v-.11l.22,0a1,1,0,0,0,.37-.11.51.51,0,0,0,.16-.32,5.66,5.66,0,0,0,0-.68v-2.51a1,1,0,0,0-.09-.54.73.73,0,0,0-.4-.25l-.31-.12v-.09l1.51-.35.09.07v.75a5.49,5.49,0,0,1,.8-.61,1.87,1.87,0,0,1,.9-.22,1.51,1.51,0,0,1,.91.24,1.24,1.24,0,0,1,.45.65,4.3,4.3,0,0,1,.85-.64,1.92,1.92,0,0,1,.92-.25c1,0,1.46.52,1.46,1.59v2.28a5.73,5.73,0,0,0,0,.69.48.48,0,0,0,.16.31,1,1,0,0,0,.37.11l.22,0Zm-9.76,2.28h-2.74v-.12l.28,0a1.29,1.29,0,0,0,.49-.12.46.46,0,0,0,.22-.31,3.89,3.89,0,0,0,0-.68v-1.65a3,3,0,0,1-.72.53,2.07,2.07,0,0,1-.91.21,2,2,0,0,1-1.09-.32,2.07,2.07,0,0,1-.72-.83,2.64,2.64,0,0,1-.25-1.17,3.16,3.16,0,0,1,.35-1.52,2.45,2.45,0,0,1,.92-1,2.52,2.52,0,0,1,1.31-.35,3.32,3.32,0,0,1,.81.1,2.36,2.36,0,0,1,.62.24l.41-.42h.07v6.17a3.57,3.57,0,0,0,0,.67.4.4,0,0,0,.18.32,1,1,0,0,0,.42.12l.26,0Zm-1.71-5.63a1.67,1.67,0,0,0-.35-1.14,1.21,1.21,0,0,0-1-.39,1.45,1.45,0,0,0-1.18.53,2.42,2.42,0,0,0-.47,1.56,3.47,3.47,0,0,0,.22,1.24,2,2,0,0,0,.62.85,1.55,1.55,0,0,0,.94.32,1.77,1.77,0,0,0,.63-.11,1.79,1.79,0,0,0,.54-.34Zm-5.48,2a1.25,1.25,0,0,1-.28.8,1.75,1.75,0,0,1-.7.48,2.35,2.35,0,0,1-.87.16,3.49,3.49,0,0,1-.9-.1,3.6,3.6,0,0,1-.78-.27v-1h.31a1.76,1.76,0,0,0,.45.94,1.44,1.44,0,0,0,1,.3,1.2,1.2,0,0,0,.8-.26.9.9,0,0,0,.31-.7.81.81,0,0,0-.27-.66,3.07,3.07,0,0,0-1-.46,3,3,0,0,1-1.17-.6,1.22,1.22,0,0,1-.37-.94,1.3,1.3,0,0,1,.25-.78,1.54,1.54,0,0,1,.63-.49,2.05,2.05,0,0,1,.87-.18,2.8,2.8,0,0,1,.81.1,2.59,2.59,0,0,1,.61.24v1h-.31a1.79,1.79,0,0,0-.37-.9,1,1,0,0,0-.79-.31,1.15,1.15,0,0,0-.76.27.92.92,0,0,0-.28.7.78.78,0,0,0,.29.65,2.54,2.54,0,0,0,1,.45,2.91,2.91,0,0,1,1.23.62A1.18,1.18,0,0,1,1705.29,406.58Zm-9-5.88-1.51,3c-.51,1-.93,1.86-1.24,2.53s-.55,1.19-.7,1.57c0,.1-.11.17-.18.18a.44.44,0,0,1-.23-.06.17.17,0,0,1-.09-.14.49.49,0,0,1,.08-.23c.24-.36.53-.86.88-1.5s.77-1.46,1.26-2.47l1.18-2.36h-2.38a3.9,3.9,0,0,0-.67.05,1,1,0,0,0-.41.18,1.73,1.73,0,0,0-.3.4l-.21.36h-.1l.6-1.85h.07a.59.59,0,0,0,.23.14,1.35,1.35,0,0,0,.49.06h3.17Zm-6.09,4.91a2.58,2.58,0,0,1-.33,1.25,2.39,2.39,0,0,1-.84.86,2.28,2.28,0,0,1-3.24-1,3.25,3.25,0,0,1-.33-1.52,4.29,4.29,0,0,1,.91-2.74,7.51,7.51,0,0,1,3.09-2.12l.08.16a6.72,6.72,0,0,0-2,1.33,3.61,3.61,0,0,0-.91,1.5,5.87,5.87,0,0,0-.21,1.7,4.2,4.2,0,0,0,.44,2.09,1.29,1.29,0,0,0,1.16.7,1.1,1.1,0,0,0,1-.55,2.91,2.91,0,0,0,.32-1.5,3.6,3.6,0,0,0-.13-1,1.55,1.55,0,0,0-.45-.74,1.38,1.38,0,0,0-.87-.29,2.15,2.15,0,0,0-.61.08l0-.14a3,3,0,0,1,1-.17,2,2,0,0,1,1.5.56A2.1,2.1,0,0,1,1690.21,405.61Z"
              />
              <path
                d="M1722.17,423.55h-2.39v-.12l.22,0a.81.81,0,0,0,.38-.12.45.45,0,0,0,.17-.31,5.66,5.66,0,0,0,0-.68v-2.17c0-.85-.33-1.28-1-1.27a1.65,1.65,0,0,0-.74.18,2.33,2.33,0,0,0-.65.48c0,.07,0,.15,0,.25s0,.2,0,.3v2.23a3.89,3.89,0,0,0,0,.68.44.44,0,0,0,.16.31.9.9,0,0,0,.39.12l.21,0v.12h-2.4v-.12l.22,0a.85.85,0,0,0,.38-.12.44.44,0,0,0,.16-.31,3.89,3.89,0,0,0,0-.68v-2.17c0-.85-.34-1.28-1-1.27a1.65,1.65,0,0,0-.72.17,2.79,2.79,0,0,0-.63.45v2.82a3.89,3.89,0,0,0,0,.68.44.44,0,0,0,.16.31.85.85,0,0,0,.38.12l.22,0v.12h-2.39v-.12l.22,0a.76.76,0,0,0,.37-.12.45.45,0,0,0,.16-.32,3.76,3.76,0,0,0,0-.67v-2.52a.9.9,0,0,0-.1-.53.69.69,0,0,0-.39-.26l-.31-.12v-.08l1.5-.36.1.07v.76a4.15,4.15,0,0,1,.8-.61,1.71,1.71,0,0,1,.89-.23,1.49,1.49,0,0,1,.91.24,1.14,1.14,0,0,1,.45.65,5.11,5.11,0,0,1,.85-.64,2,2,0,0,1,.92-.25c1,0,1.46.52,1.46,1.59v2.29a3.89,3.89,0,0,0,0,.68.44.44,0,0,0,.16.31.76.76,0,0,0,.37.12l.22,0Zm-9.77,2.27h-2.73v-.12l.27,0a1.35,1.35,0,0,0,.5-.12.4.4,0,0,0,.21-.31,3.62,3.62,0,0,0,0-.68v-1.64a3.85,3.85,0,0,1-.72.52,2,2,0,0,1-.91.21,1.89,1.89,0,0,1-1.09-.32,2,2,0,0,1-.72-.83,2.63,2.63,0,0,1-.26-1.16,3.45,3.45,0,0,1,.35-1.53,2.54,2.54,0,0,1,.93-1,2.47,2.47,0,0,1,1.3-.34,3.37,3.37,0,0,1,.82.09,4,4,0,0,1,.62.24l.4-.42h.08v6.17a4,4,0,0,0,0,.68.43.43,0,0,0,.18.31,1,1,0,0,0,.43.12l.25,0Zm-1.7-5.62a1.74,1.74,0,0,0-.36-1.15,1.19,1.19,0,0,0-.94-.39,1.5,1.5,0,0,0-1.19.53,2.44,2.44,0,0,0-.46,1.56A3.23,3.23,0,0,0,1708,422a1.94,1.94,0,0,0,.61.85,1.51,1.51,0,0,0,1,.32,1.72,1.72,0,0,0,.62-.1,2.28,2.28,0,0,0,.55-.35Zm-5.7,2a1.25,1.25,0,0,1-.28.8,1.54,1.54,0,0,1-.69.48,2.41,2.41,0,0,1-.88.16,4,4,0,0,1-.9-.09,3.92,3.92,0,0,1-.77-.28v-1h.3a1.7,1.7,0,0,0,.46.94,1.41,1.41,0,0,0,1,.3,1.18,1.18,0,0,0,.8-.25.93.93,0,0,0,.31-.71.76.76,0,0,0-.27-.65,3,3,0,0,0-1-.47,2.91,2.91,0,0,1-1.16-.6,1.17,1.17,0,0,1-.38-.93,1.26,1.26,0,0,1,.25-.78,1.56,1.56,0,0,1,.63-.5,2.08,2.08,0,0,1,.87-.18,3.2,3.2,0,0,1,.81.1,2.6,2.6,0,0,1,.61.25v1h-.31a1.88,1.88,0,0,0-.36-.9,1,1,0,0,0-.8-.31,1.1,1.1,0,0,0-.75.27.91.91,0,0,0-.29.71.83.83,0,0,0,.29.65,2.82,2.82,0,0,0,1,.44,3,3,0,0,1,1.23.62A1.19,1.19,0,0,1,1705,422.21Zm-9-.51a1.81,1.81,0,0,1-.33,1,2.07,2.07,0,0,1-.85.69,2.78,2.78,0,0,1-1.17.24,2.82,2.82,0,0,1-1.09-.2,2.08,2.08,0,0,1-.82-.6,1.56,1.56,0,0,1-.32-.93,1.85,1.85,0,0,1,.41-1.21,3.59,3.59,0,0,1,1.26-.9,2.6,2.6,0,0,1-1.06-.77,1.88,1.88,0,0,1-.4-1.19,1.63,1.63,0,0,1,.6-1.25,2.39,2.39,0,0,1,1.55-.52,2.28,2.28,0,0,1,1.44.47,1.49,1.49,0,0,1,.57,1.13,1.62,1.62,0,0,1-.41,1.05,3.27,3.27,0,0,1-1.1.78,3.36,3.36,0,0,1,1.31.92A1.85,1.85,0,0,1,1696,421.7Zm-1-3.86a1.71,1.71,0,0,0-.35-1.14,1.36,1.36,0,0,0-1.07-.43,1.28,1.28,0,0,0-1,.39,1.42,1.42,0,0,0-.36,1,1.29,1.29,0,0,0,.41,1,4.85,4.85,0,0,0,1.41.83,2,2,0,0,0,.68-.63A1.8,1.8,0,0,0,1695,417.84Zm.32,4.1a1.42,1.42,0,0,0-.43-1.09,5.12,5.12,0,0,0-1.62-.94,2.14,2.14,0,0,0-.81.8,2.3,2.3,0,0,0-.22,1.1,1.78,1.78,0,0,0,.43,1.25,1.49,1.49,0,0,0,1.15.44,1.47,1.47,0,0,0,1.08-.42A1.62,1.62,0,0,0,1695.31,421.94Zm-5.6-.7a2.55,2.55,0,0,1-.33,1.25,2.39,2.39,0,0,1-.84.86,2.37,2.37,0,0,1-2.38,0,2.27,2.27,0,0,1-.86-1,3.22,3.22,0,0,1-.33-1.52,4.28,4.28,0,0,1,.91-2.73A7.43,7.43,0,0,1,1689,416l.08.16a6.92,6.92,0,0,0-2,1.33,3.71,3.71,0,0,0-.91,1.51,5.8,5.8,0,0,0-.21,1.69,4.09,4.09,0,0,0,.44,2.09,1.28,1.28,0,0,0,1.16.7,1.08,1.08,0,0,0,1-.55,2.88,2.88,0,0,0,.32-1.5,3.65,3.65,0,0,0-.13-1,1.55,1.55,0,0,0-.45-.74,1.32,1.32,0,0,0-.87-.28,2.18,2.18,0,0,0-.61.07l0-.14a3.29,3.29,0,0,1,1-.17,2.08,2.08,0,0,1,1.5.56A2.12,2.12,0,0,1,1689.71,421.24Z"
              />
              <path
                d="M1722.24,439.43h-2.38v-.11l.21,0a1.07,1.07,0,0,0,.39-.11.44.44,0,0,0,.16-.31,4,4,0,0,0,0-.69V436c0-.86-.34-1.28-1-1.27a1.66,1.66,0,0,0-.75.18,2.33,2.33,0,0,0-.65.48.85.85,0,0,1,0,.25c0,.1,0,.2,0,.29v2.23a5.29,5.29,0,0,0,0,.69.45.45,0,0,0,.17.31,1,1,0,0,0,.38.11l.21,0v.11h-2.39v-.11l.21,0a1,1,0,0,0,.38-.11.45.45,0,0,0,.17-.31,5.29,5.29,0,0,0,0-.69V436c0-.86-.34-1.28-1-1.27a1.53,1.53,0,0,0-.72.17,2.32,2.32,0,0,0-.64.45v2.81a4,4,0,0,0,0,.69.44.44,0,0,0,.16.31,1.07,1.07,0,0,0,.39.11l.21,0v.11h-2.38v-.11l.22,0a1,1,0,0,0,.37-.11.51.51,0,0,0,.16-.32,5.66,5.66,0,0,0,0-.68v-2.51a1,1,0,0,0-.09-.54.73.73,0,0,0-.4-.25l-.31-.12v-.09l1.51-.35.09.06v.76a5.49,5.49,0,0,1,.8-.61,1.77,1.77,0,0,1,.9-.22,1.59,1.59,0,0,1,.91.23,1.31,1.31,0,0,1,.45.66,4.3,4.3,0,0,1,.85-.64,1.92,1.92,0,0,1,.92-.25c1,0,1.46.52,1.46,1.59v2.28a5.73,5.73,0,0,0,0,.69.48.48,0,0,0,.16.31,1,1,0,0,0,.37.11l.22,0Zm-9.76,2.28h-2.74v-.12l.28,0a1.51,1.51,0,0,0,.49-.12.46.46,0,0,0,.22-.31,3.89,3.89,0,0,0,0-.68V438.8a3,3,0,0,1-.72.53,2.07,2.07,0,0,1-.91.21,2,2,0,0,1-1.09-.32,2.07,2.07,0,0,1-.72-.83,2.64,2.64,0,0,1-.25-1.17,3.25,3.25,0,0,1,.35-1.52,2.45,2.45,0,0,1,.92-1,2.52,2.52,0,0,1,1.31-.35,3.32,3.32,0,0,1,.81.1,2.36,2.36,0,0,1,.62.24l.41-.42h.07v6.17a3.57,3.57,0,0,0,0,.67.4.4,0,0,0,.18.32,1.11,1.11,0,0,0,.42.12l.26,0Zm-1.71-5.63a1.65,1.65,0,0,0-.35-1.14,1.21,1.21,0,0,0-1-.39,1.45,1.45,0,0,0-1.18.53,2.4,2.4,0,0,0-.47,1.56,3.37,3.37,0,0,0,.22,1.23,2,2,0,0,0,.62.86,1.61,1.61,0,0,0,.94.32,1.77,1.77,0,0,0,.63-.11,1.79,1.79,0,0,0,.54-.34Zm-5.48,2a1.25,1.25,0,0,1-.28.8,1.75,1.75,0,0,1-.7.48,2.35,2.35,0,0,1-.87.16,3.49,3.49,0,0,1-.9-.1,3.6,3.6,0,0,1-.78-.27v-1h.31a1.76,1.76,0,0,0,.45.94,1.44,1.44,0,0,0,1,.3,1.2,1.2,0,0,0,.8-.26.9.9,0,0,0,.31-.7.81.81,0,0,0-.27-.66,3.07,3.07,0,0,0-1-.46,3.1,3.1,0,0,1-1.17-.6,1.22,1.22,0,0,1-.37-.94,1.3,1.3,0,0,1,.25-.78,1.54,1.54,0,0,1,.63-.49,2.05,2.05,0,0,1,.87-.18,2.8,2.8,0,0,1,.81.1,2.59,2.59,0,0,1,.61.24v1h-.31a1.79,1.79,0,0,0-.37-.9,1,1,0,0,0-.79-.31,1.15,1.15,0,0,0-.76.27.92.92,0,0,0-.28.7.78.78,0,0,0,.29.65,2.54,2.54,0,0,0,1,.45,3,3,0,0,1,1.23.61A1.22,1.22,0,0,1,1705.29,438.1Zm-9.18-.63-.64,1.95h-4l-.07-.1,2-2.2a12,12,0,0,0,.94-1.16,3.76,3.76,0,0,0,.51-1,2.68,2.68,0,0,0,.16-.93,1.46,1.46,0,0,0-.39-1.06,1.52,1.52,0,0,0-1.09-.41,1.61,1.61,0,0,0-1,.33,3.91,3.91,0,0,0-.85,1l-.12-.07a4.18,4.18,0,0,1,1-1.35,2.17,2.17,0,0,1,1.37-.49,1.9,1.9,0,0,1,1.31.48,1.7,1.7,0,0,1,.51,1.33,2.37,2.37,0,0,1-.2,1,4.21,4.21,0,0,1-.58.94c-.26.32-.58.68-1,1.08l-1.8,1.95h1.69a4.41,4.41,0,0,0,.91-.07,1.07,1.07,0,0,0,.56-.28,2.39,2.39,0,0,0,.45-.6l.2-.35Zm-6.13.12a1.7,1.7,0,0,1-.33,1,2.2,2.2,0,0,1-.84.69,2.86,2.86,0,0,1-1.18.24,2.81,2.81,0,0,1-1.08-.21,2.09,2.09,0,0,1-.82-.59,1.53,1.53,0,0,1-.33-.94,1.8,1.8,0,0,1,.41-1.2,3.73,3.73,0,0,1,1.27-.9A2.64,2.64,0,0,1,1686,435a1.83,1.83,0,0,1-.39-1.19,1.58,1.58,0,0,1,.59-1.25,2.4,2.4,0,0,1,1.56-.53,2.37,2.37,0,0,1,1.43.47,1.45,1.45,0,0,1,.57,1.14,1.65,1.65,0,0,1-.4,1.05,3.37,3.37,0,0,1-1.1.78,3.43,3.43,0,0,1,1.31.91A1.89,1.89,0,0,1,1690,437.59Zm-1-3.87a1.69,1.69,0,0,0-.35-1.14,1.3,1.3,0,0,0-1.06-.42,1.25,1.25,0,0,0-1,.38,1.41,1.41,0,0,0-.35,1,1.27,1.27,0,0,0,.4,1,4.92,4.92,0,0,0,1.42.84,2.14,2.14,0,0,0,.67-.63A1.81,1.81,0,0,0,1689,433.72Zm.32,4.1a1.39,1.39,0,0,0-.43-1.09,5.37,5.37,0,0,0-1.61-.94,2.14,2.14,0,0,0-.81.8,2.32,2.32,0,0,0-.23,1.1,1.83,1.83,0,0,0,.44,1.26,1.65,1.65,0,0,0,2.23,0A1.54,1.54,0,0,0,1689.31,437.82Z"
              />
              <path
                d="M1722.21,465.74h-2.38v-.12l.21,0a.81.81,0,0,0,.38-.12.45.45,0,0,0,.17-.31,5.24,5.24,0,0,0,0-.68v-2.17c0-.85-.34-1.28-1-1.27a1.66,1.66,0,0,0-.75.18,2.33,2.33,0,0,0-.65.48c0,.07,0,.15,0,.25s0,.2,0,.3v2.23a5.24,5.24,0,0,0,0,.68.44.44,0,0,0,.16.31.9.9,0,0,0,.39.12l.21,0v.12h-2.39v-.12l.21,0a.81.81,0,0,0,.38-.12.45.45,0,0,0,.17-.31,5.66,5.66,0,0,0,0-.68v-2.17c0-.85-.33-1.28-1-1.27a1.69,1.69,0,0,0-.72.17,2.79,2.79,0,0,0-.63.45v2.82a3.89,3.89,0,0,0,0,.68.44.44,0,0,0,.16.31.9.9,0,0,0,.39.12l.21,0v.12h-2.39v-.12l.23,0a.76.76,0,0,0,.36-.12.41.41,0,0,0,.16-.31,4,4,0,0,0,0-.68V462a.91.91,0,0,0-.09-.53.72.72,0,0,0-.4-.26l-.31-.12V461l1.5-.36.1.07v.76a4.47,4.47,0,0,1,.8-.61,1.73,1.73,0,0,1,.89-.23,1.49,1.49,0,0,1,.91.24,1.24,1.24,0,0,1,.46.65,4.68,4.68,0,0,1,.84-.64,2,2,0,0,1,.93-.25c1,0,1.45.52,1.45,1.59v2.29a5.24,5.24,0,0,0,0,.68.48.48,0,0,0,.16.31.8.8,0,0,0,.37.12l.22,0Zm-9.76,2.27h-2.74v-.12l.28,0a1.29,1.29,0,0,0,.49-.12.4.4,0,0,0,.21-.31,2.92,2.92,0,0,0,0-.68v-1.64a3.55,3.55,0,0,1-.72.52,1.83,1.83,0,0,1-.91.21,1.89,1.89,0,0,1-1.09-.32,2,2,0,0,1-.72-.83,2.63,2.63,0,0,1-.25-1.16,3.2,3.2,0,0,1,.35-1.53,2.45,2.45,0,0,1,.92-1,2.5,2.5,0,0,1,1.3-.34,3.37,3.37,0,0,1,.82.09,3.65,3.65,0,0,1,.62.24l.41-.42h.07v6.17a3.89,3.89,0,0,0,0,.68.43.43,0,0,0,.18.31,1.05,1.05,0,0,0,.43.12l.26,0Zm-1.71-5.62a1.73,1.73,0,0,0-.35-1.15,1.22,1.22,0,0,0-1-.39,1.51,1.51,0,0,0-1.19.53,2.44,2.44,0,0,0-.46,1.56,3.23,3.23,0,0,0,.22,1.24,2,2,0,0,0,.62.85,1.47,1.47,0,0,0,.94.32,1.72,1.72,0,0,0,.62-.1,2.11,2.11,0,0,0,.55-.35Zm-5.48,2a1.2,1.2,0,0,1-.29.8,1.54,1.54,0,0,1-.69.48,2.37,2.37,0,0,1-.88.16,4.16,4.16,0,0,1-.9-.09,4.45,4.45,0,0,1-.77-.28v-1h.31a1.76,1.76,0,0,0,.45.94,1.44,1.44,0,0,0,1,.3,1.2,1.2,0,0,0,.8-.25.93.93,0,0,0,.31-.71.79.79,0,0,0-.28-.65,2.88,2.88,0,0,0-1-.47,2.89,2.89,0,0,1-1.17-.6,1.21,1.21,0,0,1-.38-.93,1.32,1.32,0,0,1,.25-.78,1.53,1.53,0,0,1,.64-.5,2.05,2.05,0,0,1,.87-.18,3.12,3.12,0,0,1,.8.1,2.51,2.51,0,0,1,.62.25v1h-.31a1.88,1.88,0,0,0-.37-.9,1,1,0,0,0-.79-.31,1.15,1.15,0,0,0-.76.27,1,1,0,0,0-.29.71.81.81,0,0,0,.3.65,2.72,2.72,0,0,0,1,.44,3.18,3.18,0,0,1,1.23.62A1.27,1.27,0,0,1,1705.26,464.4Zm-9.34-.51a1.81,1.81,0,0,1-.33,1,2.13,2.13,0,0,1-.85.69,3,3,0,0,1-2.26,0,2,2,0,0,1-.82-.6,1.44,1.44,0,0,1-.32-.93,1.79,1.79,0,0,1,.41-1.21,3.59,3.59,0,0,1,1.26-.9,2.64,2.64,0,0,1-1.07-.77,1.93,1.93,0,0,1-.39-1.19,1.6,1.6,0,0,1,.6-1.25,2.37,2.37,0,0,1,1.55-.52,2.23,2.23,0,0,1,1.43.47,1.43,1.43,0,0,1,.57,1.13,1.56,1.56,0,0,1-.4,1.05,3.27,3.27,0,0,1-1.1.78,3.44,3.44,0,0,1,1.31.92A1.9,1.9,0,0,1,1695.92,463.89Zm-1-3.86a1.66,1.66,0,0,0-.36-1.14,1.34,1.34,0,0,0-1.06-.43,1.28,1.28,0,0,0-1,.39,1.37,1.37,0,0,0-.36,1,1.31,1.31,0,0,0,.4,1,4.93,4.93,0,0,0,1.42.83,2,2,0,0,0,.68-.63A1.8,1.8,0,0,0,1694.93,460Zm.31,4.1a1.36,1.36,0,0,0-.43-1.09,5.37,5.37,0,0,0-1.61-.94,2.14,2.14,0,0,0-.81.8,2.19,2.19,0,0,0-.22,1.1,1.74,1.74,0,0,0,.43,1.25,1.66,1.66,0,0,0,2.23,0A1.58,1.58,0,0,0,1695.24,464.13Zm-5.5-.24a1.81,1.81,0,0,1-.33,1,2.07,2.07,0,0,1-.85.69,3,3,0,0,1-2.26,0,2.08,2.08,0,0,1-.82-.6,1.5,1.5,0,0,1-.32-.93,1.85,1.85,0,0,1,.41-1.21,3.59,3.59,0,0,1,1.26-.9,2.6,2.6,0,0,1-1.06-.77,1.88,1.88,0,0,1-.4-1.19,1.63,1.63,0,0,1,.6-1.25,2.39,2.39,0,0,1,1.55-.52,2.28,2.28,0,0,1,1.44.47,1.49,1.49,0,0,1,.57,1.13,1.62,1.62,0,0,1-.41,1.05,3.27,3.27,0,0,1-1.1.78,3.36,3.36,0,0,1,1.31.92A1.85,1.85,0,0,1,1689.74,463.89Zm-1-3.86a1.71,1.71,0,0,0-.35-1.14,1.36,1.36,0,0,0-1.07-.43,1.28,1.28,0,0,0-1,.39,1.42,1.42,0,0,0-.36,1,1.29,1.29,0,0,0,.41,1,4.72,4.72,0,0,0,1.41.83,2,2,0,0,0,.68-.63A1.8,1.8,0,0,0,1688.75,460Zm.32,4.1a1.42,1.42,0,0,0-.43-1.09,5.45,5.45,0,0,0-1.62-.94,2.14,2.14,0,0,0-.81.8,2.3,2.3,0,0,0-.22,1.1,1.78,1.78,0,0,0,.43,1.25,1.49,1.49,0,0,0,1.15.44,1.47,1.47,0,0,0,1.08-.42A1.62,1.62,0,0,0,1689.07,464.13Z"
              />
              <path
                d="M1722.21,481.62h-2.38v-.12l.21,0a.81.81,0,0,0,.38-.12.45.45,0,0,0,.17-.31,5.24,5.24,0,0,0,0-.68v-2.17c0-.85-.34-1.28-1-1.27a1.66,1.66,0,0,0-.75.18,2.33,2.33,0,0,0-.65.48c0,.07,0,.15,0,.25s0,.2,0,.3v2.23a5.24,5.24,0,0,0,0,.68.44.44,0,0,0,.16.31.9.9,0,0,0,.39.12l.21,0v.12h-2.4v-.12l.22,0a.81.81,0,0,0,.38-.12.45.45,0,0,0,.17-.31,5.66,5.66,0,0,0,0-.68v-2.17c0-.85-.33-1.28-1-1.27a1.69,1.69,0,0,0-.72.17,2.79,2.79,0,0,0-.63.45v2.82a3.89,3.89,0,0,0,0,.68.44.44,0,0,0,.16.31.9.9,0,0,0,.39.12l.21,0v.12h-2.39v-.12l.23,0a.76.76,0,0,0,.36-.12.41.41,0,0,0,.16-.32,3.76,3.76,0,0,0,0-.67v-2.52a.91.91,0,0,0-.09-.53.76.76,0,0,0-.4-.26l-.31-.12v-.08l1.5-.36.1.07v.76a4.47,4.47,0,0,1,.8-.61,1.71,1.71,0,0,1,.89-.23,1.49,1.49,0,0,1,.91.24,1.2,1.2,0,0,1,.46.65,4.68,4.68,0,0,1,.84-.64,2,2,0,0,1,.93-.25c1,0,1.45.52,1.45,1.59v2.29a5.24,5.24,0,0,0,0,.68.48.48,0,0,0,.16.31.8.8,0,0,0,.37.12l.22,0Zm-9.76,2.27h-2.74v-.12l.28,0a1.29,1.29,0,0,0,.49-.12.4.4,0,0,0,.21-.31,2.92,2.92,0,0,0,0-.68V481a3.85,3.85,0,0,1-.72.52,1.94,1.94,0,0,1-.91.21,1.89,1.89,0,0,1-1.09-.32,2,2,0,0,1-.72-.83,2.63,2.63,0,0,1-.25-1.16,3.2,3.2,0,0,1,.35-1.53,2.45,2.45,0,0,1,.92-1,2.5,2.5,0,0,1,1.3-.34,3.37,3.37,0,0,1,.82.09,3.65,3.65,0,0,1,.62.24l.41-.42h.07v6.17a4,4,0,0,0,0,.68.43.43,0,0,0,.18.31,1.05,1.05,0,0,0,.43.12l.26,0Zm-1.71-5.62a1.68,1.68,0,0,0-.36-1.15,1.19,1.19,0,0,0-.94-.39,1.51,1.51,0,0,0-1.19.53,2.44,2.44,0,0,0-.46,1.56,3.23,3.23,0,0,0,.22,1.24,2,2,0,0,0,.62.85,1.47,1.47,0,0,0,.94.32,1.72,1.72,0,0,0,.62-.1,2.11,2.11,0,0,0,.55-.35Zm-5.8,2a1.2,1.2,0,0,1-.29.8,1.54,1.54,0,0,1-.69.48,2.37,2.37,0,0,1-.88.16,4.16,4.16,0,0,1-.9-.09,4.45,4.45,0,0,1-.77-.28v-1h.31a1.76,1.76,0,0,0,.45.94,1.44,1.44,0,0,0,1,.3,1.2,1.2,0,0,0,.8-.25.93.93,0,0,0,.31-.71.82.82,0,0,0-.27-.65,3,3,0,0,0-1-.47,2.89,2.89,0,0,1-1.17-.6,1.21,1.21,0,0,1-.38-.94,1.31,1.31,0,0,1,.25-.77,1.53,1.53,0,0,1,.64-.5,2.05,2.05,0,0,1,.87-.18,3.26,3.26,0,0,1,.81.1,2.6,2.6,0,0,1,.61.25v1h-.31a1.79,1.79,0,0,0-.37-.9,1,1,0,0,0-.79-.31,1.15,1.15,0,0,0-.76.27,1,1,0,0,0-.29.71.81.81,0,0,0,.3.65,2.72,2.72,0,0,0,.95.44,3,3,0,0,1,1.23.62A1.23,1.23,0,0,1,1704.94,480.28Zm-8.72-.78h-1.17v2.16h-.77V479.5h-3.34l-.07-.1,3.8-5.15h.38v4.9h1.17Zm-1.94-.35v-4l-2.94,4Zm-4.75-1.19a5.83,5.83,0,0,1-.3,1.93,3.18,3.18,0,0,1-.86,1.35,2,2,0,0,1-1.34.5,2,2,0,0,1-1.4-.51,2.86,2.86,0,0,1-.82-1.35,6.32,6.32,0,0,1-.27-1.92,5.85,5.85,0,0,1,.3-1.94,3.21,3.21,0,0,1,.86-1.35,2,2,0,0,1,1.33-.5,2.1,2.1,0,0,1,1.41.51,2.94,2.94,0,0,1,.82,1.35A6.38,6.38,0,0,1,1689.53,478Zm-.94.21a7.56,7.56,0,0,0-.39-2.82,1.36,1.36,0,0,0-1.26-1,1.21,1.21,0,0,0-1.11.87,7.14,7.14,0,0,0-.35,2.53,7.65,7.65,0,0,0,.39,2.83,1.33,1.33,0,0,0,1.26,1,1.19,1.19,0,0,0,1.1-.87A6.89,6.89,0,0,0,1688.59,478.17Zm-5.72,3.45h-3.14v-.12l.41-.05a1.23,1.23,0,0,0,.5-.15.63.63,0,0,0,.24-.39,4.34,4.34,0,0,0,.06-.83V476a3.12,3.12,0,0,0-.07-.79.48.48,0,0,0-.27-.35,1.4,1.4,0,0,0-.59-.07h-.28v-.12a7.91,7.91,0,0,0,1-.22,9.44,9.44,0,0,0,.9-.3l.1.05v5.89a4.34,4.34,0,0,0,.06.83.62.62,0,0,0,.23.39,1,1,0,0,0,.46.15l.36.05Z"
              />
              <path
                d="M1722.21,497.5h-2.38v-.12l.21,0a.81.81,0,0,0,.38-.12.45.45,0,0,0,.17-.31,5.24,5.24,0,0,0,0-.68v-2.17c0-.85-.34-1.28-1-1.27a1.66,1.66,0,0,0-.75.18,2.33,2.33,0,0,0-.65.48c0,.07,0,.15,0,.25s0,.2,0,.3v2.23a5.24,5.24,0,0,0,0,.68.44.44,0,0,0,.16.31.9.9,0,0,0,.39.12l.21,0v.12h-2.4v-.12l.22,0a.81.81,0,0,0,.38-.12.45.45,0,0,0,.17-.31,5.66,5.66,0,0,0,0-.68v-2.17c0-.85-.33-1.28-1-1.27a1.69,1.69,0,0,0-.72.17,2.51,2.51,0,0,0-.63.45v2.82a3.89,3.89,0,0,0,0,.68.44.44,0,0,0,.16.31.9.9,0,0,0,.39.12l.21,0v.12h-2.39v-.12l.23,0a.76.76,0,0,0,.36-.12.41.41,0,0,0,.16-.32,3.76,3.76,0,0,0,0-.67v-2.52a1,1,0,0,0-.09-.54.81.81,0,0,0-.4-.25l-.31-.12v-.08l1.5-.36.1.07v.76a4.47,4.47,0,0,1,.8-.61,1.73,1.73,0,0,1,.89-.23,1.49,1.49,0,0,1,.91.24,1.2,1.2,0,0,1,.46.65,4.68,4.68,0,0,1,.84-.64,2,2,0,0,1,.93-.25c1,0,1.45.52,1.45,1.59v2.29a5.24,5.24,0,0,0,0,.68.48.48,0,0,0,.16.31.8.8,0,0,0,.37.12l.22,0Zm-9.76,2.27h-2.74v-.12l.28,0a1.29,1.29,0,0,0,.49-.12.4.4,0,0,0,.21-.31,2.92,2.92,0,0,0,0-.68v-1.64a3.85,3.85,0,0,1-.72.52,1.94,1.94,0,0,1-.91.21,1.89,1.89,0,0,1-1.09-.32,2,2,0,0,1-.72-.83,2.63,2.63,0,0,1-.25-1.16,3.2,3.2,0,0,1,.35-1.53,2.45,2.45,0,0,1,.92-1,2.5,2.5,0,0,1,1.3-.34,3.37,3.37,0,0,1,.82.09,3.65,3.65,0,0,1,.62.24l.41-.42h.07v6.17a4,4,0,0,0,0,.68.43.43,0,0,0,.18.31,1.05,1.05,0,0,0,.43.12l.26,0Zm-1.71-5.62a1.68,1.68,0,0,0-.36-1.15,1.19,1.19,0,0,0-.94-.39,1.51,1.51,0,0,0-1.19.53,2.44,2.44,0,0,0-.46,1.56,3.23,3.23,0,0,0,.22,1.24,2,2,0,0,0,.62.85,1.52,1.52,0,0,0,.94.32,1.72,1.72,0,0,0,.62-.1,2.11,2.11,0,0,0,.55-.35Zm-5.48,2a1.2,1.2,0,0,1-.29.8,1.54,1.54,0,0,1-.69.48,2.37,2.37,0,0,1-.88.16,4.16,4.16,0,0,1-.9-.09,4.45,4.45,0,0,1-.77-.28v-1h.31a1.76,1.76,0,0,0,.45.94,1.44,1.44,0,0,0,1,.3,1.2,1.2,0,0,0,.8-.25.93.93,0,0,0,.31-.71.79.79,0,0,0-.28-.65,2.88,2.88,0,0,0-1-.47,2.89,2.89,0,0,1-1.17-.6,1.21,1.21,0,0,1-.38-.94,1.31,1.31,0,0,1,.25-.77,1.53,1.53,0,0,1,.64-.5,2.05,2.05,0,0,1,.87-.18,3.12,3.12,0,0,1,.8.1,3,3,0,0,1,.62.24v1h-.31a1.88,1.88,0,0,0-.37-.9,1,1,0,0,0-.79-.31,1.15,1.15,0,0,0-.76.27,1,1,0,0,0-.29.71.81.81,0,0,0,.3.65,2.72,2.72,0,0,0,1,.44,3,3,0,0,1,1.23.62A1.27,1.27,0,0,1,1705.26,496.16Zm-9.25-1.3a2.45,2.45,0,0,1-.5,1.51,3.16,3.16,0,0,1-1.19.93,3.23,3.23,0,0,1-1.35.31,1.32,1.32,0,0,1-.76-.17.51.51,0,0,1-.26-.43.43.43,0,0,1,.45-.43,1,1,0,0,1,.54.17,2.65,2.65,0,0,1,.54.56,2.19,2.19,0,0,0,.93-.28,2,2,0,0,0,.7-.68,1.92,1.92,0,0,0,.27-1,1.34,1.34,0,0,0-.43-1.09,1.69,1.69,0,0,0-1.14-.36,2.1,2.1,0,0,0-.51.06l-.49.18-.11-.18a11.41,11.41,0,0,0,1.52-.94,2.65,2.65,0,0,0,.69-.73,1.3,1.3,0,0,0,.18-.67.89.89,0,0,0-.3-.7,1.27,1.27,0,0,0-.87-.28,2.06,2.06,0,0,0-1,.23,4,4,0,0,0-.84.63l-.1-.12a4,4,0,0,1,1.15-1,2.41,2.41,0,0,1,1.19-.29,1.67,1.67,0,0,1,1.09.33,1.16,1.16,0,0,1,.4.93,1.46,1.46,0,0,1-.39,1,5.08,5.08,0,0,1-1.24,1,2.25,2.25,0,0,1,1.31.45A1.47,1.47,0,0,1,1696,494.86Zm-5.74-1a5.83,5.83,0,0,1-.3,1.93,3.16,3.16,0,0,1-.85,1.35,2,2,0,0,1-1.34.5,2,2,0,0,1-1.41-.51,2.94,2.94,0,0,1-.82-1.35,6.65,6.65,0,0,1-.26-1.92,6.13,6.13,0,0,1,.29-1.94,3.31,3.31,0,0,1,.86-1.35,2,2,0,0,1,1.34-.5,2,2,0,0,1,1.4.51,2.86,2.86,0,0,1,.82,1.35A6.38,6.38,0,0,1,1690.27,493.84Zm-.94.21a7.56,7.56,0,0,0-.39-2.82,1.34,1.34,0,0,0-1.26-1,1.21,1.21,0,0,0-1.1.87,6.89,6.89,0,0,0-.36,2.53,8,8,0,0,0,.39,2.82,1.35,1.35,0,0,0,1.26,1,1.2,1.2,0,0,0,1.11-.87A7.14,7.14,0,0,0,1689.33,494.05Zm-5.72,3.45h-3.14v-.12l.42-.05a1.13,1.13,0,0,0,.49-.15.58.58,0,0,0,.24-.39,3.54,3.54,0,0,0,.07-.83v-4.09a3.67,3.67,0,0,0-.07-.79.5.5,0,0,0-.27-.35,1.4,1.4,0,0,0-.59-.07h-.29v-.12a8,8,0,0,0,1-.22q.51-.15.9-.3l.1.05V496a4.34,4.34,0,0,0,.06.83.6.6,0,0,0,.23.39,1,1,0,0,0,.45.15l.36.05Z"
              />
              <path
                d="M1722.21,513.14h-2.38V513l.21,0a.94.94,0,0,0,.38-.12.45.45,0,0,0,.17-.31,5.24,5.24,0,0,0,0-.68v-2.17c0-.85-.34-1.28-1-1.27a1.66,1.66,0,0,0-.75.18,2.33,2.33,0,0,0-.65.48c0,.07,0,.15,0,.25s0,.2,0,.3v2.23a5.24,5.24,0,0,0,0,.68.44.44,0,0,0,.16.31,1.06,1.06,0,0,0,.39.12l.21,0v.12h-2.4V513l.22,0a.94.94,0,0,0,.38-.12.45.45,0,0,0,.17-.31,5.66,5.66,0,0,0,0-.68v-2.17c0-.85-.33-1.28-1-1.27a1.69,1.69,0,0,0-.72.17,2.28,2.28,0,0,0-.63.45v2.82a3.89,3.89,0,0,0,0,.68.44.44,0,0,0,.16.31,1.06,1.06,0,0,0,.39.12l.21,0v.12h-2.39V513l.23,0a.89.89,0,0,0,.36-.12.41.41,0,0,0,.16-.32,3.76,3.76,0,0,0,0-.67v-2.52a1,1,0,0,0-.09-.54.81.81,0,0,0-.4-.25l-.31-.12v-.08l1.5-.36.1.07v.76a4.47,4.47,0,0,1,.8-.61,1.71,1.71,0,0,1,.89-.23,1.49,1.49,0,0,1,.91.24,1.2,1.2,0,0,1,.46.65,4.68,4.68,0,0,1,.84-.64,2,2,0,0,1,.93-.25c1,0,1.45.52,1.45,1.59v2.29a5.24,5.24,0,0,0,0,.68.48.48,0,0,0,.16.31.94.94,0,0,0,.37.12l.22,0Zm-9.76,2.27h-2.74v-.12l.28,0a1.29,1.29,0,0,0,.49-.12.42.42,0,0,0,.21-.31,2.92,2.92,0,0,0,0-.68v-1.64a3.85,3.85,0,0,1-.72.52,1.94,1.94,0,0,1-.91.21,1.89,1.89,0,0,1-1.09-.32,2,2,0,0,1-.72-.83,2.63,2.63,0,0,1-.25-1.16,3.2,3.2,0,0,1,.35-1.53,2.38,2.38,0,0,1,.92-1,2.5,2.5,0,0,1,1.3-.34,3.37,3.37,0,0,1,.82.09,3.65,3.65,0,0,1,.62.24l.41-.42h.07v6.17a4,4,0,0,0,0,.68.46.46,0,0,0,.18.31,1.05,1.05,0,0,0,.43.12l.26,0Zm-1.71-5.63a1.67,1.67,0,0,0-.36-1.14,1.19,1.19,0,0,0-.94-.39,1.51,1.51,0,0,0-1.19.53,2.44,2.44,0,0,0-.46,1.56,3.26,3.26,0,0,0,.22,1.24,2,2,0,0,0,.62.85,1.63,1.63,0,0,0,1.56.21,1.83,1.83,0,0,0,.55-.34Zm-5.48,2a1.2,1.2,0,0,1-.29.8,1.54,1.54,0,0,1-.69.48,2.37,2.37,0,0,1-.88.16,4.16,4.16,0,0,1-.9-.09,4.45,4.45,0,0,1-.77-.28v-1h.31a1.76,1.76,0,0,0,.45.94,1.44,1.44,0,0,0,1,.3,1.2,1.2,0,0,0,.8-.25.94.94,0,0,0,.31-.71.83.83,0,0,0-.28-.66,2.91,2.91,0,0,0-1-.46,2.89,2.89,0,0,1-1.17-.6,1.21,1.21,0,0,1-.38-.94,1.31,1.31,0,0,1,.25-.77,1.53,1.53,0,0,1,.64-.5,2.05,2.05,0,0,1,.87-.18,2.73,2.73,0,0,1,.8.1,2.5,2.5,0,0,1,.62.24v1h-.31a1.88,1.88,0,0,0-.37-.9,1,1,0,0,0-.79-.31,1.15,1.15,0,0,0-.76.27,1,1,0,0,0-.29.7.83.83,0,0,0,.3.66,2.72,2.72,0,0,0,1,.44,3,3,0,0,1,1.23.62A1.27,1.27,0,0,1,1705.26,511.8Zm-9,1.34h-3.14V513l.41-.06a1.06,1.06,0,0,0,.5-.14.66.66,0,0,0,.24-.39,4.34,4.34,0,0,0,.06-.83v-4.09a3.12,3.12,0,0,0-.07-.79.48.48,0,0,0-.27-.35,1.37,1.37,0,0,0-.59-.07h-.28v-.12a7.91,7.91,0,0,0,1-.22c.35-.1.65-.2.91-.3l.09,0v5.89a4.34,4.34,0,0,0,.06.83.65.65,0,0,0,.23.39.93.93,0,0,0,.46.14l.36.06Zm-4.37-2-.64,1.95h-4l-.08-.1,2-2.2a11.16,11.16,0,0,0,1-1.16,3.76,3.76,0,0,0,.51-1,2.92,2.92,0,0,0,.15-.93,1.42,1.42,0,0,0-.39-1,1.44,1.44,0,0,0-1.09-.41,1.58,1.58,0,0,0-1,.33,3.91,3.91,0,0,0-.85,1l-.13-.08a4.06,4.06,0,0,1,1-1.35,2.14,2.14,0,0,1,1.37-.48,1.86,1.86,0,0,1,1.31.47,1.78,1.78,0,0,1,.51,1.33,2.53,2.53,0,0,1-.2,1,4.27,4.27,0,0,1-.59.94c-.26.32-.57.68-1,1.08l-1.8,2h1.7a4.47,4.47,0,0,0,.91-.07,1.09,1.09,0,0,0,.56-.27,2.75,2.75,0,0,0,.44-.61l.21-.35Zm-6.07,2h-3.14V513l.41-.06a1.06,1.06,0,0,0,.5-.14.58.58,0,0,0,.24-.39,4.34,4.34,0,0,0,.06-.83v-4.09a3.12,3.12,0,0,0-.07-.79.45.45,0,0,0-.27-.35,1.35,1.35,0,0,0-.58-.07h-.29v-.12a7.91,7.91,0,0,0,1-.22c.35-.1.65-.2.91-.3l.09,0v5.89a3.54,3.54,0,0,0,.07.83.6.6,0,0,0,.23.39.92.92,0,0,0,.45.14l.36.06Z"
              />
              <path
                d="M1789.29,333.47a3.21,3.21,0,0,1-.59.42,1.41,1.41,0,0,1-.69.16c-.71,0-1.07-.37-1.07-1.12v-3.57h-.75v-.08l.76-.27.65-1.6h.14V329h1.46v.36h-1.46v3.44c0,.56.24.84.71.84a.94.94,0,0,0,.39-.07,1.51,1.51,0,0,0,.37-.2Zm-3.23-6.85a.6.6,0,0,1-.13.37.46.46,0,0,1-.33.18.7.7,0,0,1-.45-.2,3.5,3.5,0,0,1-.45-.55,1.18,1.18,0,0,0-.74.57,2.84,2.84,0,0,0-.25,1.36V329h1.21v.36h-1.21v3.34a3.74,3.74,0,0,0,0,.69.42.42,0,0,0,.21.31,1.62,1.62,0,0,0,.5.11l.27,0V334h-2.62v-.11l.23,0a.9.9,0,0,0,.36-.11.41.41,0,0,0,.16-.32,3.89,3.89,0,0,0,0-.68v-3.34h-.84v-.08l.84-.27v-.14a3.06,3.06,0,0,1,.32-1.33,2.69,2.69,0,0,1,.83-1,2.07,2.07,0,0,1,1.23-.41,1.14,1.14,0,0,1,.57.15A.42.42,0,0,1,1786.06,326.62Zm-5.08,9.62h-2.73v-.12l.27,0a1.35,1.35,0,0,0,.5-.12.42.42,0,0,0,.21-.31,3.7,3.7,0,0,0,0-.68v-1.65a3.5,3.5,0,0,1-.72.53,2.07,2.07,0,0,1-.91.21,2,2,0,0,1-1.09-.32,2.07,2.07,0,0,1-.72-.83,2.63,2.63,0,0,1-.26-1.16,3.29,3.29,0,0,1,.36-1.53,2.38,2.38,0,0,1,.92-1,2.47,2.47,0,0,1,1.3-.34,3.37,3.37,0,0,1,.82.09,3.2,3.2,0,0,1,.62.24l.4-.42h.08V335a4,4,0,0,0,0,.68.46.46,0,0,0,.18.31,1,1,0,0,0,.43.12l.25,0Zm-1.7-5.63a1.73,1.73,0,0,0-.36-1.14,1.19,1.19,0,0,0-.94-.39,1.47,1.47,0,0,0-1.19.53,2.44,2.44,0,0,0-.46,1.56,3.26,3.26,0,0,0,.22,1.24,1.94,1.94,0,0,0,.62.85,1.52,1.52,0,0,0,.94.32,1.71,1.71,0,0,0,.62-.11,1.83,1.83,0,0,0,.55-.34Zm-5.59,2a1.25,1.25,0,0,1-.28.8,1.83,1.83,0,0,1-.7.48,2.37,2.37,0,0,1-.88.16,3.59,3.59,0,0,1-.9-.1,3.71,3.71,0,0,1-.77-.27v-1h.31a1.76,1.76,0,0,0,.45.94,1.44,1.44,0,0,0,1,.3,1.2,1.2,0,0,0,.8-.26.9.9,0,0,0,.31-.7.84.84,0,0,0-.27-.66,3.07,3.07,0,0,0-1-.46,2.89,2.89,0,0,1-1.17-.6,1.23,1.23,0,0,1-.38-.94,1.45,1.45,0,0,1,.25-.78,1.57,1.57,0,0,1,.64-.49,2.05,2.05,0,0,1,.87-.18,2.8,2.8,0,0,1,.81.1,2.59,2.59,0,0,1,.61.24v1h-.31a1.79,1.79,0,0,0-.37-.9,1,1,0,0,0-.79-.31,1.15,1.15,0,0,0-.76.27.92.92,0,0,0-.28.7.78.78,0,0,0,.29.65,2.54,2.54,0,0,0,.95.45,2.91,2.91,0,0,1,1.23.62A1.18,1.18,0,0,1,1773.69,332.63Zm-8.88-5.88-1.52,3c-.51,1-.92,1.86-1.23,2.53s-.55,1.19-.71,1.57q-.07.17-.18.18a.4.4,0,0,1-.22-.06.19.19,0,0,1-.1-.14.42.42,0,0,1,.09-.23q.35-.54.87-1.5c.35-.64.77-1.46,1.27-2.47l1.17-2.35h-2.37a4.06,4.06,0,0,0-.67,0,1.11,1.11,0,0,0-.41.18,1.5,1.5,0,0,0-.31.4l-.2.36h-.11l.61-1.85h.06a.7.7,0,0,0,.23.15,1.71,1.71,0,0,0,.49.05h3.17Zm-6.16,5.25L1758,334h-4l-.08-.1,2-2.2a12,12,0,0,0,.94-1.16,4.17,4.17,0,0,0,.52-1,2.92,2.92,0,0,0,.15-.93,1.42,1.42,0,0,0-.39-1.05,1.48,1.48,0,0,0-1.09-.42,1.58,1.58,0,0,0-1,.34,3.89,3.89,0,0,0-.84,1l-.13-.08a4.06,4.06,0,0,1,1-1.35,2.06,2.06,0,0,1,1.36-.48,1.84,1.84,0,0,1,1.31.47,1.74,1.74,0,0,1,.52,1.33,2.37,2.37,0,0,1-.21,1,4.21,4.21,0,0,1-.58.94c-.26.32-.57.68-1,1.08l-1.8,1.95h1.69a4.35,4.35,0,0,0,.91-.07,1.13,1.13,0,0,0,.56-.27,2.47,2.47,0,0,0,.45-.61l.2-.35Zm-5.82-5.61-.33,1h-2.69l-.6,1.31a5.23,5.23,0,0,1,2.4.74,2,2,0,0,1,.82,1.74,2.84,2.84,0,0,1-.47,1.55,3.27,3.27,0,0,1-1.13,1,3,3,0,0,1-1.37.35,1.2,1.2,0,0,1-.7-.18.48.48,0,0,1-.21-.38c0-.28.18-.43.52-.44a.94.94,0,0,1,.53.16,3.75,3.75,0,0,1,.56.49,2.47,2.47,0,0,0,1.28-.77,2.15,2.15,0,0,0,.51-1.41,1.59,1.59,0,0,0-.78-1.45,5.62,5.62,0,0,0-2.42-.64l-.08-.1,1.23-2.71h1.86a2.44,2.44,0,0,0,.59,0,.81.81,0,0,0,.4-.21Z"
              />
              <path
                d="M1789.29,349.35a2.73,2.73,0,0,1-.59.41,1.41,1.41,0,0,1-.69.16c-.71,0-1.07-.37-1.07-1.12v-3.56h-.75v-.09l.76-.26.65-1.6h.14v1.59h1.46v.36h-1.46v3.43c0,.56.24.84.71.85a1.13,1.13,0,0,0,.39-.07,2,2,0,0,0,.37-.21Zm-3.23-6.85a.59.59,0,0,1-.13.36.46.46,0,0,1-.33.18.7.7,0,0,1-.45-.2,3.08,3.08,0,0,1-.45-.55,1.18,1.18,0,0,0-.74.57,2.84,2.84,0,0,0-.25,1.36v.66h1.21v.36h-1.21v3.34a3.7,3.7,0,0,0,0,.68.42.42,0,0,0,.21.31,1.35,1.35,0,0,0,.5.12l.27,0v.12h-2.62v-.12l.23,0a.76.76,0,0,0,.36-.12.41.41,0,0,0,.16-.31,4,4,0,0,0,0-.68v-3.34h-.84v-.09l.84-.26v-.14a3.11,3.11,0,0,1,.32-1.34,2.69,2.69,0,0,1,.83-1,2.13,2.13,0,0,1,1.23-.41,1,1,0,0,1,.57.16A.4.4,0,0,1,1786.06,342.5Zm-5.08,9.61h-2.73V352l.27,0a1.35,1.35,0,0,0,.5-.12.4.4,0,0,0,.21-.31,3.62,3.62,0,0,0,0-.68v-1.64a3.45,3.45,0,0,1-.72.52,1.83,1.83,0,0,1-.91.21,1.89,1.89,0,0,1-1.09-.32,2,2,0,0,1-.72-.83,2.63,2.63,0,0,1-.26-1.16,3.32,3.32,0,0,1,.36-1.53,2.42,2.42,0,0,1,.92-1,2.39,2.39,0,0,1,1.3-.35,3.37,3.37,0,0,1,.82.09,4,4,0,0,1,.62.24l.4-.42h.08v6.17a3.89,3.89,0,0,0,0,.68.43.43,0,0,0,.18.31,1,1,0,0,0,.43.12l.25,0Zm-1.7-5.62a1.74,1.74,0,0,0-.36-1.15,1.19,1.19,0,0,0-.94-.39,1.5,1.5,0,0,0-1.19.53,2.44,2.44,0,0,0-.46,1.56,3.23,3.23,0,0,0,.22,1.24,1.89,1.89,0,0,0,.62.85,1.47,1.47,0,0,0,.94.32,1.72,1.72,0,0,0,.62-.1,1.87,1.87,0,0,0,.55-.35Zm-5.59,2a1.25,1.25,0,0,1-.28.8,1.63,1.63,0,0,1-.7.48,2.37,2.37,0,0,1-.88.16,4.16,4.16,0,0,1-.9-.09,4.45,4.45,0,0,1-.77-.28v-1h.31a1.73,1.73,0,0,0,.45.93,1.44,1.44,0,0,0,1,.3,1.2,1.2,0,0,0,.8-.25.93.93,0,0,0,.31-.71.83.83,0,0,0-.27-.65,3,3,0,0,0-1-.47,2.89,2.89,0,0,1-1.17-.6,1.21,1.21,0,0,1-.38-.93,1.39,1.39,0,0,1,.25-.78,1.59,1.59,0,0,1,.64-.5,2.05,2.05,0,0,1,.87-.18,3.2,3.2,0,0,1,.81.1,2.6,2.6,0,0,1,.61.25v1h-.31a1.79,1.79,0,0,0-.37-.9,1,1,0,0,0-.79-.3,1.09,1.09,0,0,0-.76.26.94.94,0,0,0-.28.71.8.8,0,0,0,.29.65,2.9,2.9,0,0,0,.95.45,2.92,2.92,0,0,1,1.23.61A1.19,1.19,0,0,1,1773.69,348.5Zm-8.88-5.88-1.52,3c-.51,1-.92,1.86-1.23,2.53s-.55,1.19-.71,1.57q-.07.17-.18.18a.4.4,0,0,1-.22-.06.16.16,0,0,1-.1-.14.4.4,0,0,1,.09-.22c.23-.37.52-.87.87-1.51s.77-1.46,1.27-2.46l1.17-2.36h-2.37a3.09,3.09,0,0,0-.67.05.86.86,0,0,0-.41.18,1.35,1.35,0,0,0-.31.4l-.2.35h-.11l.61-1.85h.06a.57.57,0,0,0,.23.15,2,2,0,0,0,.49.06h3.17Zm-6.16,5.25-.64,2h-4l-.08-.11,2-2.2a10.92,10.92,0,0,0,.94-1.16,3.8,3.8,0,0,0,.52-1,2.92,2.92,0,0,0,.15-.93A1.38,1.38,0,0,0,1756,343a1.63,1.63,0,0,0-1,.33,3.89,3.89,0,0,0-.84,1l-.13-.08a4.06,4.06,0,0,1,1-1.35,2.17,2.17,0,0,1,1.36-.48,1.89,1.89,0,0,1,1.31.47,1.76,1.76,0,0,1,.52,1.33,2.45,2.45,0,0,1-.21,1,4.39,4.39,0,0,1-.58.93c-.26.33-.57.68-1,1.08l-1.8,2h1.69a5.16,5.16,0,0,0,.91-.07,1.14,1.14,0,0,0,.56-.28,2.59,2.59,0,0,0,.45-.6l.2-.36Zm-5.82-5.61-.33,1h-2.69l-.6,1.32a5.11,5.11,0,0,1,2.4.74,2,2,0,0,1,.82,1.73,2.81,2.81,0,0,1-.47,1.55,3.17,3.17,0,0,1-1.13,1,2.88,2.88,0,0,1-1.37.35,1.07,1.07,0,0,1-.7-.18.48.48,0,0,1-.21-.38c0-.28.18-.42.52-.44a1,1,0,0,1,.53.17,3.61,3.61,0,0,1,.56.48,2.4,2.4,0,0,0,1.28-.77,2.13,2.13,0,0,0,.51-1.4,1.6,1.6,0,0,0-.78-1.46,5.77,5.77,0,0,0-2.42-.64l-.08-.09,1.23-2.71h1.86a2.38,2.38,0,0,0,.59-.06.74.74,0,0,0,.4-.21Z"
              />
              <path
                d="M1789.36,375.65a3.27,3.27,0,0,1-.6.42,1.51,1.51,0,0,1-.68.16c-.71,0-1.07-.38-1.08-1.12v-3.57h-.74v-.08l.75-.27.65-1.6h.14v1.59h1.46v.36h-1.46V375c0,.55.25.83.71.84a1,1,0,0,0,.4-.07,1.38,1.38,0,0,0,.36-.21ZM1786,368.8a.55.55,0,0,1-.13.36.41.41,0,0,1-.34.18.66.66,0,0,1-.44-.19,3.41,3.41,0,0,1-.45-.55,1.12,1.12,0,0,0-.74.57,2.81,2.81,0,0,0-.25,1.36v.65h1.21v.36h-1.21v3.34a2.87,2.87,0,0,0,0,.68.4.4,0,0,0,.21.31,1.29,1.29,0,0,0,.49.12l.28,0v.12h-2.62V376l.22,0a.76.76,0,0,0,.37-.12.42.42,0,0,0,.16-.31,3.89,3.89,0,0,0,0-.68v-3.34H1782v-.08l.84-.27v-.14a3.2,3.2,0,0,1,.31-1.33,2.83,2.83,0,0,1,.84-1,2,2,0,0,1,1.22-.4,1,1,0,0,1,.57.15A.44.44,0,0,1,1786,368.8Zm-5.08,9.61h-2.74v-.11l.28,0a1.62,1.62,0,0,0,.5-.11.42.42,0,0,0,.21-.31,3.74,3.74,0,0,0,0-.69v-1.64a3.45,3.45,0,0,1-.72.52,2,2,0,0,1-.91.22,2,2,0,0,1-1.09-.32,2.14,2.14,0,0,1-.72-.83,2.64,2.64,0,0,1-.26-1.17,3.38,3.38,0,0,1,.35-1.52,2.45,2.45,0,0,1,2.23-1.34,2.85,2.85,0,0,1,.81.1,3.08,3.08,0,0,1,.63.23l.4-.41h.08v6.16a3.89,3.89,0,0,0,0,.68.46.46,0,0,0,.18.32,1.14,1.14,0,0,0,.43.11l.25,0Zm-1.7-5.62a1.75,1.75,0,0,0-.36-1.15,1.19,1.19,0,0,0-.94-.39,1.48,1.48,0,0,0-1.19.54,2.34,2.34,0,0,0-.46,1.56,3.17,3.17,0,0,0,.22,1.23,2,2,0,0,0,.61.86,1.62,1.62,0,0,0,1,.32,1.71,1.71,0,0,0,.62-.11,2,2,0,0,0,.55-.34Zm-5.49,2a1.22,1.22,0,0,1-.28.8,1.72,1.72,0,0,1-.69.48,2.63,2.63,0,0,1-.88.16,3.59,3.59,0,0,1-.9-.1,3.09,3.09,0,0,1-.77-.28v-1h.31a1.63,1.63,0,0,0,.45.94,1.41,1.41,0,0,0,1,.3,1.18,1.18,0,0,0,.8-.26.9.9,0,0,0,.31-.7.78.78,0,0,0-.27-.66,3.07,3.07,0,0,0-1-.46,3.19,3.19,0,0,1-1.16-.6,1.21,1.21,0,0,1-.38-.94,1.32,1.32,0,0,1,.25-.78,1.65,1.65,0,0,1,.63-.5,2.3,2.3,0,0,1,.88-.17,3.2,3.2,0,0,1,.8.09,2.87,2.87,0,0,1,.61.25v1h-.31a2,2,0,0,0-.36-.9,1,1,0,0,0-.8-.3,1.06,1.06,0,0,0-.75.27.92.92,0,0,0-.29.7.81.81,0,0,0,.29.65,3,3,0,0,0,1,.45,3,3,0,0,1,1.23.61A1.24,1.24,0,0,1,1773.75,374.81Zm-9-5.88-1.51,3c-.51,1-.92,1.86-1.24,2.53s-.54,1.19-.7,1.57a.31.31,0,0,1-.18.18.4.4,0,0,1-.22-.06.17.17,0,0,1-.1-.15.42.42,0,0,1,.09-.22q.35-.54.87-1.5c.35-.64.77-1.47,1.27-2.47l1.17-2.36h-2.38a3.77,3.77,0,0,0-.66,0,.82.82,0,0,0-.41.18,1.35,1.35,0,0,0-.31.4l-.2.35h-.11l.61-1.84h.06a.68.68,0,0,0,.23.14,2,2,0,0,0,.49.06h3.17Zm-5.68-.37-.33,1h-2.7l-.6,1.31a5.2,5.2,0,0,1,2.41.74,2,2,0,0,1,.81,1.74,2.72,2.72,0,0,1-.47,1.54,3.2,3.2,0,0,1-1.13,1,3,3,0,0,1-1.37.35,1.2,1.2,0,0,1-.7-.18.5.5,0,0,1-.21-.39c0-.27.18-.42.53-.43a.91.91,0,0,1,.52.16,2.91,2.91,0,0,1,.56.49,2.51,2.51,0,0,0,1.29-.78,2.12,2.12,0,0,0,.5-1.4,1.61,1.61,0,0,0-.78-1.46,5.78,5.78,0,0,0-2.41-.63l-.09-.1,1.24-2.71H1758a3.28,3.28,0,0,0,.6-.05.84.84,0,0,0,.39-.22Zm-5.84,5.28a2.52,2.52,0,0,1-.33,1.24,2.31,2.31,0,0,1-.84.86,2.34,2.34,0,0,1-1.17.33,2.29,2.29,0,0,1-1.21-.33,2.22,2.22,0,0,1-.86-.95,3.45,3.45,0,0,1-.33-1.52,4.28,4.28,0,0,1,.91-2.73,7.42,7.42,0,0,1,3.09-2.12l.08.16a6.54,6.54,0,0,0-2,1.33,3.72,3.72,0,0,0-.91,1.5,5.48,5.48,0,0,0-.2,1.69,4.17,4.17,0,0,0,.43,2.1,1.29,1.29,0,0,0,1.16.7,1.11,1.11,0,0,0,1-.56,3,3,0,0,0,.31-1.49,3.68,3.68,0,0,0-.13-1,1.51,1.51,0,0,0-.45-.73,1.29,1.29,0,0,0-.86-.29,2.17,2.17,0,0,0-.62.08l0-.14a2.92,2.92,0,0,1,.94-.17,2,2,0,0,1,1.5.56A2.1,2.1,0,0,1,1753.24,373.84Z"
              />
              <path
                d="M1789.36,391.54a3.27,3.27,0,0,1-.6.42,1.39,1.39,0,0,1-.68.16c-.71,0-1.07-.37-1.08-1.12v-3.57h-.74v-.08l.75-.27.65-1.6h.14v1.59h1.46v.36h-1.46v3.44c0,.56.25.84.71.84a1,1,0,0,0,.4-.07,1.66,1.66,0,0,0,.36-.2Zm-3.34-6.85a.6.6,0,0,1-.13.37.46.46,0,0,1-.34.18.68.68,0,0,1-.44-.2,3,3,0,0,1-.45-.55,1.15,1.15,0,0,0-.74.57,2.84,2.84,0,0,0-.25,1.36v.65h1.21v.36h-1.21v3.34a3,3,0,0,0,0,.69.42.42,0,0,0,.21.31,1.55,1.55,0,0,0,.49.11l.28,0V392h-2.62v-.11l.22,0a.9.9,0,0,0,.37-.11.45.45,0,0,0,.16-.32,3.89,3.89,0,0,0,0-.68v-3.34H1782v-.08l.84-.27v-.14a3.2,3.2,0,0,1,.31-1.33,2.72,2.72,0,0,1,.84-1,2,2,0,0,1,1.22-.41,1.08,1.08,0,0,1,.57.15A.44.44,0,0,1,1786,384.69Zm-5.08,9.62h-2.74v-.12l.28,0a1.35,1.35,0,0,0,.5-.12.42.42,0,0,0,.21-.31,3.7,3.7,0,0,0,0-.68V391.4a3.5,3.5,0,0,1-.72.53,2.11,2.11,0,0,1-.91.21,2,2,0,0,1-1.09-.32,2.07,2.07,0,0,1-.72-.83,2.64,2.64,0,0,1-.26-1.17,3.41,3.41,0,0,1,.35-1.52,2.41,2.41,0,0,1,2.23-1.33,3.29,3.29,0,0,1,.81.09,3.07,3.07,0,0,1,.63.24l.4-.42h.08v6.17a4,4,0,0,0,0,.68.46.46,0,0,0,.18.31,1,1,0,0,0,.43.12l.25,0Zm-1.7-5.63a1.73,1.73,0,0,0-.36-1.14,1.19,1.19,0,0,0-.94-.39,1.47,1.47,0,0,0-1.19.53,2.38,2.38,0,0,0-.46,1.56,3.26,3.26,0,0,0,.22,1.24,2,2,0,0,0,.61.85,1.55,1.55,0,0,0,1,.32,1.71,1.71,0,0,0,.62-.11,2,2,0,0,0,.55-.34Zm-5.49,2a1.2,1.2,0,0,1-.28.8,1.72,1.72,0,0,1-.69.48,2.41,2.41,0,0,1-.88.16,3.59,3.59,0,0,1-.9-.1,3.52,3.52,0,0,1-.77-.27v-1h.31a1.63,1.63,0,0,0,.45.94,1.41,1.41,0,0,0,1,.3,1.18,1.18,0,0,0,.8-.26.9.9,0,0,0,.31-.7.78.78,0,0,0-.27-.66,3.07,3.07,0,0,0-1-.46,2.91,2.91,0,0,1-1.16-.6,1.19,1.19,0,0,1-.38-.94,1.37,1.37,0,0,1,.25-.78,1.54,1.54,0,0,1,.63-.49,2.13,2.13,0,0,1,.88-.18,2.78,2.78,0,0,1,.8.1,2.43,2.43,0,0,1,.61.24v1h-.31a1.88,1.88,0,0,0-.36-.9,1,1,0,0,0-.8-.31,1.1,1.1,0,0,0-.75.27.92.92,0,0,0-.29.7.81.81,0,0,0,.29.65,2.6,2.6,0,0,0,1,.45,3,3,0,0,1,1.23.62A1.21,1.21,0,0,1,1773.75,390.7Zm-9.22-3.32a4.29,4.29,0,0,1-.92,2.73,7.3,7.3,0,0,1-3.09,2.13l-.07-.16a6.85,6.85,0,0,0,2-1.33,3.6,3.6,0,0,0,.91-1.51,5.2,5.2,0,0,0,.21-1.69,4.21,4.21,0,0,0-.43-2.09,1.3,1.3,0,0,0-1.17-.7,1.1,1.1,0,0,0-1,.55,3,3,0,0,0-.32,1.5,3.64,3.64,0,0,0,.14,1,1.47,1.47,0,0,0,.45.74,1.29,1.29,0,0,0,.86.28,2.72,2.72,0,0,0,.62-.07l0,.14a3.23,3.23,0,0,1-1,.17,2.05,2.05,0,0,1-1.49-.56,2.12,2.12,0,0,1-.55-1.51,2.55,2.55,0,0,1,.32-1.25,2.34,2.34,0,0,1,.85-.86,2.23,2.23,0,0,1,1.17-.32,2.31,2.31,0,0,1,1.21.32,2.27,2.27,0,0,1,.86.95A3.48,3.48,0,0,1,1764.53,387.38Zm-6.51,2.81a1.84,1.84,0,0,1-.33,1,2.16,2.16,0,0,1-.85.69,2.78,2.78,0,0,1-1.17.24,2.74,2.74,0,0,1-1.08-.21,1.91,1.91,0,0,1-.82-.59,1.51,1.51,0,0,1-.33-.94,1.82,1.82,0,0,1,.41-1.2,3.68,3.68,0,0,1,1.26-.9,2.6,2.6,0,0,1-1.06-.77,1.9,1.9,0,0,1-.4-1.19,1.62,1.62,0,0,1,.6-1.25,2.35,2.35,0,0,1,1.56-.52,2.27,2.27,0,0,1,1.43.47,1.48,1.48,0,0,1,.57,1.13,1.61,1.61,0,0,1-.41,1.05,3.32,3.32,0,0,1-1.09.78,3.51,3.51,0,0,1,1.31.91A1.94,1.94,0,0,1,1758,390.19Zm-1-3.87a1.74,1.74,0,0,0-.35-1.14,1.35,1.35,0,0,0-1.07-.42,1.21,1.21,0,0,0-1,.39,1.42,1.42,0,0,0-.36,1,1.31,1.31,0,0,0,.41,1,4.84,4.84,0,0,0,1.41.84,1.89,1.89,0,0,0,.68-.63A1.81,1.81,0,0,0,1757,386.32Zm.32,4.1a1.44,1.44,0,0,0-.43-1.09,5.34,5.34,0,0,0-1.62-.93,2,2,0,0,0-.8.8,2.15,2.15,0,0,0-.23,1.09,1.81,1.81,0,0,0,.43,1.26,1.54,1.54,0,0,0,1.15.44,1.48,1.48,0,0,0,1.08-.43A1.59,1.59,0,0,0,1757.35,390.42Zm-5.6-.69a2.58,2.58,0,0,1-.33,1.25,2.39,2.39,0,0,1-.84.86,2.28,2.28,0,0,1-3.24-.95,3.51,3.51,0,0,1-.33-1.52,4.29,4.29,0,0,1,.91-2.74,7.51,7.51,0,0,1,3.09-2.12l.08.16a6.72,6.72,0,0,0-2,1.33,3.72,3.72,0,0,0-.91,1.5,5.55,5.55,0,0,0-.2,1.7,4.1,4.1,0,0,0,.43,2.09,1.29,1.29,0,0,0,1.16.7,1.1,1.1,0,0,0,1-.55,2.91,2.91,0,0,0,.32-1.5,3.6,3.6,0,0,0-.13-1,1.55,1.55,0,0,0-.45-.74,1.38,1.38,0,0,0-.87-.29,2.15,2.15,0,0,0-.61.08l0-.14a3,3,0,0,1,1-.17,2,2,0,0,1,1.5.56A2.12,2.12,0,0,1,1751.75,389.73Z"
              />
              <path
                d="M1789.36,407.42a3.27,3.27,0,0,1-.6.42,1.39,1.39,0,0,1-.68.16c-.71,0-1.07-.37-1.08-1.12v-3.57h-.74v-.08l.75-.27.65-1.6h.14V403h1.46v.36h-1.46v3.44c0,.56.25.84.71.84a1,1,0,0,0,.4-.07,1.66,1.66,0,0,0,.36-.2Zm-3.55-6.85a.61.61,0,0,1-.13.36.44.44,0,0,1-.34.19.66.66,0,0,1-.44-.2,2.65,2.65,0,0,1-.45-.55,1.1,1.1,0,0,0-.74.57,2.84,2.84,0,0,0-.25,1.36V403h1.21v.36h-1.21v3.34a4,4,0,0,0,0,.69.43.43,0,0,0,.22.31,1.55,1.55,0,0,0,.49.11l.28,0v.11h-2.62v-.11l.22,0a.9.9,0,0,0,.37-.11.51.51,0,0,0,.16-.32,5.24,5.24,0,0,0,0-.68v-3.34h-.85v-.08l.85-.27v-.14a3.05,3.05,0,0,1,.31-1.33,2.63,2.63,0,0,1,.84-1,2,2,0,0,1,1.22-.41,1.14,1.14,0,0,1,.57.15A.44.44,0,0,1,1785.81,400.57Zm-5.08,9.62H1778v-.12l.28,0a1.29,1.29,0,0,0,.49-.12.46.46,0,0,0,.22-.31,3.89,3.89,0,0,0,0-.68v-1.65a3.2,3.2,0,0,1-.71.53,2.15,2.15,0,0,1-.92.21,2,2,0,0,1-1.09-.32,2.07,2.07,0,0,1-.72-.83,2.64,2.64,0,0,1-.25-1.17,3.28,3.28,0,0,1,.35-1.52,2.45,2.45,0,0,1,.92-1,2.52,2.52,0,0,1,1.31-.35,3.32,3.32,0,0,1,.81.1,2.36,2.36,0,0,1,.62.24l.41-.42h.07v6.17a3.57,3.57,0,0,0,0,.67.4.4,0,0,0,.18.32,1,1,0,0,0,.42.12l.26,0Zm-1.71-5.63a1.67,1.67,0,0,0-.35-1.14,1.21,1.21,0,0,0-1-.39,1.45,1.45,0,0,0-1.18.53,2.42,2.42,0,0,0-.47,1.56,3.47,3.47,0,0,0,.22,1.24,2,2,0,0,0,.62.85,1.55,1.55,0,0,0,.94.32,1.77,1.77,0,0,0,.63-.11,1.79,1.79,0,0,0,.54-.34Zm-5.59,2a1.2,1.2,0,0,1-.28.8,1.72,1.72,0,0,1-.69.48,2.41,2.41,0,0,1-.88.16,3.59,3.59,0,0,1-.9-.1,3.52,3.52,0,0,1-.77-.27v-1h.31a1.63,1.63,0,0,0,.45.94,1.43,1.43,0,0,0,1,.3,1.18,1.18,0,0,0,.8-.26.87.87,0,0,0,.31-.7.78.78,0,0,0-.27-.66,3.07,3.07,0,0,0-1-.46,2.91,2.91,0,0,1-1.16-.6,1.23,1.23,0,0,1-.38-.94,1.37,1.37,0,0,1,.25-.78,1.54,1.54,0,0,1,.63-.49,2.13,2.13,0,0,1,.88-.18,2.78,2.78,0,0,1,.8.1,2.43,2.43,0,0,1,.61.24v1h-.31a1.88,1.88,0,0,0-.36-.9,1,1,0,0,0-.8-.31,1.1,1.1,0,0,0-.75.27.92.92,0,0,0-.29.7.81.81,0,0,0,.29.65,2.69,2.69,0,0,0,1,.45,3,3,0,0,1,1.23.62A1.21,1.21,0,0,1,1773.43,406.58Zm-8.65,1.33h-3.14v-.11l.42-.06a1.14,1.14,0,0,0,.49-.14.6.6,0,0,0,.24-.4,3.39,3.39,0,0,0,.07-.82v-4.09a3.78,3.78,0,0,0-.07-.8.5.5,0,0,0-.27-.34,1.55,1.55,0,0,0-.59-.08h-.29V401a10.17,10.17,0,0,0,1-.22,8.49,8.49,0,0,0,.9-.31l.1.06v5.89a4.15,4.15,0,0,0,.06.82.63.63,0,0,0,.23.4,1,1,0,0,0,.45.14l.36.06Zm-4.58-2-.63,1.95h-4l-.07-.1,2-2.2a13.77,13.77,0,0,0,.94-1.16,3.76,3.76,0,0,0,.51-1,2.93,2.93,0,0,0,.16-.93,1.46,1.46,0,0,0-.39-1.06,1.54,1.54,0,0,0-1.1-.41,1.6,1.6,0,0,0-1,.33,4.18,4.18,0,0,0-.85,1l-.13-.08a4.06,4.06,0,0,1,1-1.35,2.08,2.08,0,0,1,1.37-.48,1.84,1.84,0,0,1,1.31.47,1.78,1.78,0,0,1,.51,1.33,2.53,2.53,0,0,1-.2,1,4.27,4.27,0,0,1-.59.94c-.25.32-.57.68-1,1.08l-1.8,1.95h1.7a4.41,4.41,0,0,0,.91-.07,1.18,1.18,0,0,0,.56-.27,2.47,2.47,0,0,0,.45-.61l.2-.35Zm-5.87-5.25-1.52,3c-.51,1-.92,1.86-1.23,2.53s-.55,1.19-.71,1.57c0,.1-.11.17-.18.18a.4.4,0,0,1-.22-.06.19.19,0,0,1-.1-.14.42.42,0,0,1,.09-.23q.35-.54.87-1.5c.35-.64.77-1.46,1.27-2.47l1.17-2.36h-2.37a3.9,3.9,0,0,0-.67.05,1,1,0,0,0-.41.18,1.5,1.5,0,0,0-.31.4l-.2.36h-.11l.61-1.85h.06a.68.68,0,0,0,.23.14,1.35,1.35,0,0,0,.49.06h3.17Z"
              />
              <path
                d="M1789.36,423.06a2.78,2.78,0,0,1-.6.41,1.39,1.39,0,0,1-.68.16c-.71,0-1.07-.37-1.08-1.12V419h-.74v-.09l.75-.26.65-1.61h.14v1.59h1.46V419h-1.46v3.43c0,.56.25.84.71.85a1.24,1.24,0,0,0,.4-.07,2.36,2.36,0,0,0,.36-.21ZM1786,416.2a.6.6,0,0,1-.13.37.46.46,0,0,1-.34.18.68.68,0,0,1-.44-.2,2.71,2.71,0,0,1-.45-.55,1.18,1.18,0,0,0-.74.57,2.84,2.84,0,0,0-.25,1.36v.65h1.21V419h-1.21v3.34a3,3,0,0,0,0,.68.42.42,0,0,0,.21.31,1.29,1.29,0,0,0,.49.12l.28,0v.12h-2.62v-.12l.22,0a.76.76,0,0,0,.37-.12.45.45,0,0,0,.16-.32,3.76,3.76,0,0,0,0-.67V419H1782v-.09l.84-.26v-.14a3.25,3.25,0,0,1,.31-1.34,2.72,2.72,0,0,1,.84-1,2,2,0,0,1,1.22-.41,1,1,0,0,1,.57.16A.41.41,0,0,1,1786,416.2Zm-5.08,9.62h-2.74v-.12l.28,0a1.35,1.35,0,0,0,.5-.12.4.4,0,0,0,.21-.31,3.62,3.62,0,0,0,0-.68v-1.64a3.85,3.85,0,0,1-.72.52,2,2,0,0,1-.91.21,1.87,1.87,0,0,1-1.09-.32,2,2,0,0,1-.72-.83,2.63,2.63,0,0,1-.26-1.16,3.45,3.45,0,0,1,.35-1.53,2.59,2.59,0,0,1,.92-1,2.54,2.54,0,0,1,1.31-.34,3.29,3.29,0,0,1,.81.09,3.78,3.78,0,0,1,.63.24l.4-.42h.08v6.17a4,4,0,0,0,0,.68.43.43,0,0,0,.18.31,1,1,0,0,0,.43.12l.25,0Zm-1.7-5.62a1.74,1.74,0,0,0-.36-1.15,1.19,1.19,0,0,0-.94-.39,1.5,1.5,0,0,0-1.19.53,2.38,2.38,0,0,0-.46,1.56,3.23,3.23,0,0,0,.22,1.24,1.94,1.94,0,0,0,.61.85,1.49,1.49,0,0,0,1,.32,1.72,1.72,0,0,0,.62-.1,2.28,2.28,0,0,0,.55-.35Zm-5.81,2a1.2,1.2,0,0,1-.28.8,1.54,1.54,0,0,1-.69.48,2.41,2.41,0,0,1-.88.16,3.47,3.47,0,0,1-1.67-.37v-1h.31a1.63,1.63,0,0,0,.45.94,1.43,1.43,0,0,0,1,.3,1.18,1.18,0,0,0,.8-.25.89.89,0,0,0,.31-.71.76.76,0,0,0-.27-.65,3,3,0,0,0-1-.47,2.91,2.91,0,0,1-1.16-.6,1.21,1.21,0,0,1-.38-.93,1.32,1.32,0,0,1,.25-.78,1.56,1.56,0,0,1,.63-.5,2.13,2.13,0,0,1,.88-.18,3.18,3.18,0,0,1,.8.1,2.43,2.43,0,0,1,.61.25v1h-.31a1.88,1.88,0,0,0-.36-.9,1,1,0,0,0-.8-.31,1.1,1.1,0,0,0-.75.27,1,1,0,0,0-.29.71.83.83,0,0,0,.29.65,2.88,2.88,0,0,0,1,.44,3.18,3.18,0,0,1,1.23.62A1.22,1.22,0,0,1,1773.43,422.21Zm-8.75-.63-.64,2h-4l-.07-.11,2-2.2a10.92,10.92,0,0,0,.94-1.16,3.6,3.6,0,0,0,.51-1,2.68,2.68,0,0,0,.16-.93,1.42,1.42,0,0,0-.39-1.05,1.44,1.44,0,0,0-1.09-.41,1.61,1.61,0,0,0-1,.33,3.91,3.91,0,0,0-.85,1l-.12-.08a4.18,4.18,0,0,1,1-1.35,2.21,2.21,0,0,1,1.37-.48,1.89,1.89,0,0,1,1.31.47,1.72,1.72,0,0,1,.51,1.33,2.44,2.44,0,0,1-.2,1,4.39,4.39,0,0,1-.58.93c-.26.32-.58.68-1,1.08l-1.8,1.95h1.69a5.41,5.41,0,0,0,.91-.06,1.14,1.14,0,0,0,.56-.28,2.59,2.59,0,0,0,.45-.6l.2-.36Zm-6.35-.67a2.39,2.39,0,0,1-.51,1.51,3.06,3.06,0,0,1-1.18.93,3.27,3.27,0,0,1-1.36.31,1.3,1.3,0,0,1-.75-.17.51.51,0,0,1-.26-.43.43.43,0,0,1,.45-.43,1,1,0,0,1,.54.17,2.29,2.29,0,0,1,.53.57,2.35,2.35,0,0,0,.94-.29,2,2,0,0,0,.69-.68,1.93,1.93,0,0,0,.28-1,1.39,1.39,0,0,0-.43-1.09,1.7,1.7,0,0,0-1.15-.36,2.07,2.07,0,0,0-.5.06,3.9,3.9,0,0,0-.5.19l-.1-.19a12.11,12.11,0,0,0,1.52-.94,2.65,2.65,0,0,0,.69-.73,1.29,1.29,0,0,0,.17-.67.89.89,0,0,0-.29-.7,1.24,1.24,0,0,0-.87-.27,2.05,2.05,0,0,0-1,.22,4,4,0,0,0-.84.63l-.1-.12a4,4,0,0,1,1.15-1,2.41,2.41,0,0,1,1.19-.29,1.67,1.67,0,0,1,1.09.33,1.16,1.16,0,0,1,.4.93,1.51,1.51,0,0,1-.39,1,5.56,5.56,0,0,1-1.24,1,2.25,2.25,0,0,1,1.31.45A1.47,1.47,0,0,1,1758.33,420.91Zm-5.5-4.58-1.51,3c-.51,1-.92,1.86-1.23,2.53s-.55,1.19-.71,1.57q-.08.17-.18.18a.4.4,0,0,1-.22-.06c-.07,0-.1-.08-.1-.14a.4.4,0,0,1,.09-.22c.23-.37.52-.87.87-1.51s.77-1.46,1.27-2.46l1.17-2.36h-2.38a3.05,3.05,0,0,0-.66.05.86.86,0,0,0-.41.18,1.35,1.35,0,0,0-.31.4l-.2.35h-.11l.61-1.85h.06a.57.57,0,0,0,.23.15,2,2,0,0,0,.49.06h3.17Z"
              />
              <path
                d="M1789.29,438.94a3.21,3.21,0,0,1-.59.42,1.53,1.53,0,0,1-.69.16c-.71,0-1.07-.38-1.07-1.12v-3.57h-.75v-.08l.76-.27.65-1.6h.14v1.59h1.46v.36h-1.46v3.44c0,.55.24.84.71.84a.94.94,0,0,0,.39-.07,1.51,1.51,0,0,0,.37-.2Zm-3.23-6.85a.55.55,0,0,1-.13.36.44.44,0,0,1-.33.19.7.7,0,0,1-.45-.2,3.5,3.5,0,0,1-.45-.55,1.12,1.12,0,0,0-.74.57,2.81,2.81,0,0,0-.25,1.36v.65h1.21v.36h-1.21v3.34a3.74,3.74,0,0,0,0,.69.42.42,0,0,0,.21.31,1.62,1.62,0,0,0,.5.11l.27,0v.11h-2.62v-.11l.23,0a.9.9,0,0,0,.36-.11.43.43,0,0,0,.16-.32,3.89,3.89,0,0,0,0-.68v-3.34h-.84v-.08l.84-.27v-.14a3.06,3.06,0,0,1,.32-1.33,2.8,2.8,0,0,1,.83-1,2.13,2.13,0,0,1,1.23-.4,1.14,1.14,0,0,1,.57.15A.42.42,0,0,1,1786.06,432.09Zm-5.08,9.62h-2.73v-.12l.27,0a1.58,1.58,0,0,0,.5-.12.42.42,0,0,0,.21-.31,3.7,3.7,0,0,0,0-.68V438.8a3.5,3.5,0,0,1-.72.53,2.07,2.07,0,0,1-.91.21,2,2,0,0,1-1.09-.32,2.07,2.07,0,0,1-.72-.83,2.64,2.64,0,0,1-.26-1.17,3.25,3.25,0,0,1,.36-1.52,2.38,2.38,0,0,1,.92-1,2.48,2.48,0,0,1,1.3-.35,3.35,3.35,0,0,1,.82.1,2.67,2.67,0,0,1,.62.24l.4-.42h.08v6.17a3.76,3.76,0,0,0,0,.67.46.46,0,0,0,.18.32,1.18,1.18,0,0,0,.43.12l.25,0Zm-1.7-5.63a1.71,1.71,0,0,0-.36-1.14,1.19,1.19,0,0,0-.94-.39,1.47,1.47,0,0,0-1.19.53,2.4,2.4,0,0,0-.46,1.56,3.17,3.17,0,0,0,.22,1.23,1.92,1.92,0,0,0,.62.86,1.59,1.59,0,0,0,.94.32,1.71,1.71,0,0,0,.62-.11,1.83,1.83,0,0,0,.55-.34Zm-5.59,2a1.25,1.25,0,0,1-.28.8,1.83,1.83,0,0,1-.7.48,2.35,2.35,0,0,1-.87.16,3.62,3.62,0,0,1-.91-.1,3.71,3.71,0,0,1-.77-.27v-1h.31a1.76,1.76,0,0,0,.45.94,1.44,1.44,0,0,0,1,.3,1.2,1.2,0,0,0,.8-.26.9.9,0,0,0,.31-.7.81.81,0,0,0-.27-.66,3.07,3.07,0,0,0-1-.46,3,3,0,0,1-1.17-.6,1.23,1.23,0,0,1-.38-.94,1.38,1.38,0,0,1,.26-.78,1.48,1.48,0,0,1,.63-.49,2.05,2.05,0,0,1,.87-.18,2.8,2.8,0,0,1,.81.1,2.59,2.59,0,0,1,.61.24v1h-.31a1.79,1.79,0,0,0-.37-.9,1,1,0,0,0-.79-.31,1.15,1.15,0,0,0-.76.27.92.92,0,0,0-.28.7.78.78,0,0,0,.29.65,2.54,2.54,0,0,0,.95.45,3,3,0,0,1,1.23.61A1.22,1.22,0,0,1,1773.69,438.1Zm-9.14-1.3a2.41,2.41,0,0,1-.51,1.51,3.06,3.06,0,0,1-1.18.93,3.27,3.27,0,0,1-1.36.31,1.39,1.39,0,0,1-.75-.17.51.51,0,0,1-.26-.44.46.46,0,0,1,.14-.32.48.48,0,0,1,.31-.1.91.91,0,0,1,.54.17,2.41,2.41,0,0,1,.53.56,2.2,2.2,0,0,0,.94-.29,1.85,1.85,0,0,0,.69-.67,1.93,1.93,0,0,0,.28-1,1.41,1.41,0,0,0-.43-1.1,1.74,1.74,0,0,0-1.14-.35,2.1,2.1,0,0,0-.51.06,2.75,2.75,0,0,0-.5.18l-.1-.18a13.42,13.42,0,0,0,1.52-.94,2.53,2.53,0,0,0,.69-.74,1.26,1.26,0,0,0,.17-.67.88.88,0,0,0-.29-.69,1.27,1.27,0,0,0-.87-.28,2.06,2.06,0,0,0-1,.23,3.42,3.42,0,0,0-.84.63l-.1-.12a3.83,3.83,0,0,1,1.15-1,2.41,2.41,0,0,1,1.19-.29,1.67,1.67,0,0,1,1.09.32,1.2,1.2,0,0,1,.4.94,1.48,1.48,0,0,1-.39,1,5.29,5.29,0,0,1-1.24,1,2.12,2.12,0,0,1,1.31.45A1.45,1.45,0,0,1,1764.55,436.8Zm-5.85.79a1.7,1.7,0,0,1-.33,1,2.2,2.2,0,0,1-.84.69,2.86,2.86,0,0,1-1.18.24,2.77,2.77,0,0,1-1.08-.21,2.09,2.09,0,0,1-.82-.59,1.53,1.53,0,0,1-.33-.94,1.8,1.8,0,0,1,.41-1.2,3.78,3.78,0,0,1,1.26-.9,2.67,2.67,0,0,1-1.06-.77,1.83,1.83,0,0,1-.39-1.19,1.58,1.58,0,0,1,.59-1.25,2.4,2.4,0,0,1,1.56-.53,2.37,2.37,0,0,1,1.43.47,1.45,1.45,0,0,1,.57,1.14,1.61,1.61,0,0,1-.41,1.05,3.22,3.22,0,0,1-1.09.78,3.51,3.51,0,0,1,1.31.91A1.94,1.94,0,0,1,1758.7,437.59Zm-1-3.87a1.74,1.74,0,0,0-.35-1.14,1.3,1.3,0,0,0-1.06-.42,1.25,1.25,0,0,0-1,.38,1.46,1.46,0,0,0-.36,1,1.31,1.31,0,0,0,.41,1,4.92,4.92,0,0,0,1.42.84,2.14,2.14,0,0,0,.67-.63A1.81,1.81,0,0,0,1757.71,433.72Zm.32,4.1a1.39,1.39,0,0,0-.43-1.09,5.37,5.37,0,0,0-1.61-.94,2.14,2.14,0,0,0-.81.8,2.32,2.32,0,0,0-.23,1.1,1.83,1.83,0,0,0,.43,1.26,1.55,1.55,0,0,0,1.15.44,1.5,1.5,0,0,0,1.09-.43A1.59,1.59,0,0,0,1758,437.82Zm-5.5-.23a1.77,1.77,0,0,1-.34,1,2.2,2.2,0,0,1-.84.69,3,3,0,0,1-2.26,0,2.09,2.09,0,0,1-.82-.59,1.47,1.47,0,0,1-.32-.94,1.75,1.75,0,0,1,.41-1.2,3.59,3.59,0,0,1,1.26-.9,2.64,2.64,0,0,1-1.07-.77,2,2,0,0,1-.39-1.19,1.61,1.61,0,0,1,.59-1.25,2.42,2.42,0,0,1,1.56-.53,2.35,2.35,0,0,1,1.43.47,1.45,1.45,0,0,1,.57,1.14,1.65,1.65,0,0,1-.4,1.05,3.37,3.37,0,0,1-1.1.78,3.43,3.43,0,0,1,1.31.91A2,2,0,0,1,1752.53,437.59Zm-1-3.87a1.69,1.69,0,0,0-.35-1.14,1.3,1.3,0,0,0-1.06-.42,1.26,1.26,0,0,0-1,.38,1.41,1.41,0,0,0-.35,1,1.3,1.3,0,0,0,.4,1,4.92,4.92,0,0,0,1.42.84,2,2,0,0,0,.67-.63A1.81,1.81,0,0,0,1751.53,433.72Zm.32,4.1a1.39,1.39,0,0,0-.43-1.09,5.37,5.37,0,0,0-1.61-.94,2.29,2.29,0,0,0-.81.8,2.21,2.21,0,0,0-.22,1.1,1.78,1.78,0,0,0,.43,1.26,1.51,1.51,0,0,0,1.14.44,1.48,1.48,0,0,0,1.09-.43A1.54,1.54,0,0,0,1751.85,437.82Z"
              />
              <path
                d="M1789.32,465.25a2.73,2.73,0,0,1-.59.41,1.39,1.39,0,0,1-.68.16c-.71,0-1.07-.37-1.08-1.12v-3.56h-.75v-.09l.76-.26.65-1.61h.14v1.59h1.46v.37h-1.46v3.43c0,.56.24.84.71.85a1.24,1.24,0,0,0,.4-.07,2.36,2.36,0,0,0,.36-.21Zm-3.33-6.86a.6.6,0,0,1-.13.37.46.46,0,0,1-.34.18.66.66,0,0,1-.44-.2,2.41,2.41,0,0,1-.45-.55,1.16,1.16,0,0,0-.74.57,2.84,2.84,0,0,0-.25,1.36v.65h1.21v.37h-1.21v3.34a3.89,3.89,0,0,0,0,.68.46.46,0,0,0,.22.31,1.29,1.29,0,0,0,.49.12l.28,0v.12h-2.62v-.12l.22,0a.76.76,0,0,0,.37-.12.44.44,0,0,0,.16-.31,5.37,5.37,0,0,0,0-.68v-3.34H1782v-.09l.84-.26v-.14a3.1,3.1,0,0,1,.31-1.34,2.63,2.63,0,0,1,.84-1,2.08,2.08,0,0,1,1.22-.41,1,1,0,0,1,.57.16A.41.41,0,0,1,1786,458.39Zm-5.08,9.62h-2.74v-.12l.28,0a1.29,1.29,0,0,0,.49-.12.41.41,0,0,0,.22-.31,3.62,3.62,0,0,0,0-.68v-1.64a3.85,3.85,0,0,1-.72.52,1.88,1.88,0,0,1-.91.21,1.92,1.92,0,0,1-1.1-.32,2.06,2.06,0,0,1-.71-.83,2.5,2.5,0,0,1-.26-1.16,3.32,3.32,0,0,1,.35-1.53,2.59,2.59,0,0,1,.92-1,2.51,2.51,0,0,1,1.31-.34,2.87,2.87,0,0,1,1.43.33l.41-.42h.07v6.17a3.7,3.7,0,0,0,0,.68.43.43,0,0,0,.18.31,1,1,0,0,0,.42.12l.26,0Zm-1.7-5.62a1.74,1.74,0,0,0-.36-1.15,1.2,1.2,0,0,0-.94-.39,1.5,1.5,0,0,0-1.19.53,2.38,2.38,0,0,0-.46,1.56,3.43,3.43,0,0,0,.21,1.24,2,2,0,0,0,.62.85,1.49,1.49,0,0,0,.94.32,1.74,1.74,0,0,0,.63-.1,2.28,2.28,0,0,0,.55-.35Zm-5.7,2a1.2,1.2,0,0,1-.29.8,1.54,1.54,0,0,1-.69.48,2.37,2.37,0,0,1-.88.16,4.16,4.16,0,0,1-.9-.09,4.45,4.45,0,0,1-.77-.28v-1h.31a1.76,1.76,0,0,0,.45.94,1.44,1.44,0,0,0,1,.3,1.2,1.2,0,0,0,.8-.25.93.93,0,0,0,.31-.71.82.82,0,0,0-.27-.65,3,3,0,0,0-1-.47,2.89,2.89,0,0,1-1.17-.6,1.21,1.21,0,0,1-.38-.93,1.32,1.32,0,0,1,.25-.78,1.59,1.59,0,0,1,.64-.5,2.05,2.05,0,0,1,.87-.18,3.26,3.26,0,0,1,.81.1,2.6,2.6,0,0,1,.61.25v1h-.31a1.79,1.79,0,0,0-.37-.9,1,1,0,0,0-.79-.31,1.15,1.15,0,0,0-.76.27,1,1,0,0,0-.29.71.81.81,0,0,0,.3.65,2.72,2.72,0,0,0,1,.44,3,3,0,0,1,1.23.62A1.23,1.23,0,0,1,1773.51,464.4Zm-8.78-5.88-1.51,3c-.51,1-.92,1.86-1.24,2.53s-.54,1.19-.7,1.57q-.08.17-.18.18a.38.38,0,0,1-.22-.06c-.07,0-.1-.08-.1-.14a.46.46,0,0,1,.08-.22c.24-.37.53-.87.88-1.51s.77-1.46,1.27-2.46l1.17-2.36h-2.38a3,3,0,0,0-.66.05.82.82,0,0,0-.41.18,1.35,1.35,0,0,0-.31.4l-.21.35h-.1l.61-1.85h.06a.51.51,0,0,0,.23.15,2,2,0,0,0,.49.06h3.17Zm-6,5.1h-1.17v2.16h-.78v-2.16h-3.33l-.07-.1,3.8-5.15h.38v4.9h1.17Zm-2-.35v-4l-2.93,4Zm-4.63-2.19a4.29,4.29,0,0,1-.91,2.74,7.51,7.51,0,0,1-3.09,2.12l-.08-.16a6.72,6.72,0,0,0,2-1.33,3.72,3.72,0,0,0,.91-1.5,5.55,5.55,0,0,0,.2-1.7,4.1,4.1,0,0,0-.43-2.09,1.29,1.29,0,0,0-1.16-.7,1.1,1.1,0,0,0-1,.55,2.91,2.91,0,0,0-.32,1.5,3.6,3.6,0,0,0,.13,1,1.55,1.55,0,0,0,.45.74,1.35,1.35,0,0,0,.86.29,3.24,3.24,0,0,0,.62-.08l0,.14a2.87,2.87,0,0,1-.94.17,2,2,0,0,1-1.5-.56,2.12,2.12,0,0,1-.55-1.51,2.58,2.58,0,0,1,.33-1.25,2.39,2.39,0,0,1,.84-.86,2.28,2.28,0,0,1,3.24.95A3.51,3.51,0,0,1,1752.14,461.08Z"
              />
              <path
                d="M1789.32,481.13a2.73,2.73,0,0,1-.59.41,1.39,1.39,0,0,1-.68.16c-.71,0-1.07-.37-1.08-1.12V477h-.75v-.09l.76-.26.65-1.61h.14v1.59h1.46V477h-1.46v3.43c0,.56.24.84.71.85a1.24,1.24,0,0,0,.4-.07,2.36,2.36,0,0,0,.36-.21Zm-3.33-6.86a.6.6,0,0,1-.13.37.46.46,0,0,1-.34.18.66.66,0,0,1-.44-.2,2.41,2.41,0,0,1-.45-.55,1.16,1.16,0,0,0-.74.57,2.84,2.84,0,0,0-.25,1.36v.65h1.21V477h-1.21v3.34a3.89,3.89,0,0,0,0,.68.46.46,0,0,0,.22.31,1.29,1.29,0,0,0,.49.12l.28,0v.12h-2.62v-.12l.22,0a.76.76,0,0,0,.37-.12.45.45,0,0,0,.16-.32,5.06,5.06,0,0,0,0-.67V477H1782v-.09l.84-.26v-.14a3.1,3.1,0,0,1,.31-1.34,2.63,2.63,0,0,1,.84-1,2,2,0,0,1,1.22-.41,1,1,0,0,1,.57.16A.41.41,0,0,1,1786,474.27Zm-5.08,9.62h-2.74v-.12l.28,0a1.29,1.29,0,0,0,.49-.12.41.41,0,0,0,.22-.31,3.62,3.62,0,0,0,0-.68V481a3.85,3.85,0,0,1-.72.52,2,2,0,0,1-.91.21,1.92,1.92,0,0,1-1.1-.32,2.06,2.06,0,0,1-.71-.83,2.5,2.5,0,0,1-.26-1.16,3.32,3.32,0,0,1,.35-1.53,2.59,2.59,0,0,1,.92-1,2.51,2.51,0,0,1,1.31-.34,2.87,2.87,0,0,1,1.43.33l.41-.42h.07v6.17a3.78,3.78,0,0,0,0,.68.43.43,0,0,0,.18.31,1,1,0,0,0,.42.12l.26,0Zm-1.7-5.62a1.74,1.74,0,0,0-.36-1.15,1.2,1.2,0,0,0-.94-.39,1.5,1.5,0,0,0-1.19.53,2.38,2.38,0,0,0-.46,1.56,3.43,3.43,0,0,0,.21,1.24,2,2,0,0,0,.62.85,1.49,1.49,0,0,0,.94.32,1.74,1.74,0,0,0,.63-.1,2.28,2.28,0,0,0,.55-.35Zm-5.49,2a1.25,1.25,0,0,1-.28.8,1.54,1.54,0,0,1-.69.48,2.41,2.41,0,0,1-.88.16,4,4,0,0,1-.9-.09,4.26,4.26,0,0,1-.78-.28v-1h.31a1.7,1.7,0,0,0,.46.94,1.4,1.4,0,0,0,1,.3,1.18,1.18,0,0,0,.8-.25.93.93,0,0,0,.31-.71.76.76,0,0,0-.27-.65,3,3,0,0,0-1-.47,3,3,0,0,1-1.17-.6,1.21,1.21,0,0,1-.37-.94,1.25,1.25,0,0,1,.25-.77,1.56,1.56,0,0,1,.63-.5,2.05,2.05,0,0,1,.87-.18,3.2,3.2,0,0,1,.81.1,2.6,2.6,0,0,1,.61.25v1h-.31a1.79,1.79,0,0,0-.37-.9,1,1,0,0,0-.79-.31,1.15,1.15,0,0,0-.76.27.94.94,0,0,0-.28.71.8.8,0,0,0,.29.65,2.82,2.82,0,0,0,1,.44,3,3,0,0,1,1.23.62A1.19,1.19,0,0,1,1773.72,480.28Zm-9.23-2.32a5.83,5.83,0,0,1-.3,1.93,3.18,3.18,0,0,1-.86,1.35,2,2,0,0,1-1.34.5,2,2,0,0,1-1.4-.51,2.94,2.94,0,0,1-.82-1.35,6.32,6.32,0,0,1-.27-1.92,5.85,5.85,0,0,1,.3-1.94,3.21,3.21,0,0,1,.86-1.35,2,2,0,0,1,1.33-.5,2.1,2.1,0,0,1,1.41.51,2.94,2.94,0,0,1,.82,1.35A6.38,6.38,0,0,1,1764.49,478Zm-.94.21a7.56,7.56,0,0,0-.39-2.82,1.36,1.36,0,0,0-1.26-1,1.19,1.19,0,0,0-1.1.87,6.89,6.89,0,0,0-.36,2.53,7.65,7.65,0,0,0,.39,2.83,1.33,1.33,0,0,0,1.26,1,1.19,1.19,0,0,0,1.1-.87A6.89,6.89,0,0,0,1763.55,478.17Zm-5.83,1.48-.64,2h-4l-.08-.11,2-2.2a12.34,12.34,0,0,0,.94-1.16,3.6,3.6,0,0,0,.51-1,2.92,2.92,0,0,0,.15-.93,1.38,1.38,0,0,0-1.48-1.46,1.58,1.58,0,0,0-1,.33,3.91,3.91,0,0,0-.85,1l-.13-.08a4.06,4.06,0,0,1,1-1.35,2.19,2.19,0,0,1,1.37-.48,1.91,1.91,0,0,1,1.31.47,1.79,1.79,0,0,1,.51,1.33,2.61,2.61,0,0,1-.2,1,4.47,4.47,0,0,1-.59.93c-.25.32-.57.68-1,1.08l-1.8,1.95h1.7a5.5,5.5,0,0,0,.91-.06,1.19,1.19,0,0,0,.56-.28,2.59,2.59,0,0,0,.44-.6l.21-.36Zm-5.86,2h-3.14v-.12l.42-.05a1.13,1.13,0,0,0,.49-.15.55.55,0,0,0,.24-.39,3.54,3.54,0,0,0,.07-.83V476a3.67,3.67,0,0,0-.07-.79.5.5,0,0,0-.27-.35,1.4,1.4,0,0,0-.59-.07h-.29v-.12a8,8,0,0,0,1-.22c.34-.1.65-.2.9-.3l.1.05v5.89a4.34,4.34,0,0,0,.06.83.58.58,0,0,0,.23.39,1,1,0,0,0,.45.15l.36.05Zm-4.47,0h-3.14v-.12l.41-.05a1.18,1.18,0,0,0,.5-.15.55.55,0,0,0,.24-.39,4.34,4.34,0,0,0,.06-.83V476a3.12,3.12,0,0,0-.07-.79.45.45,0,0,0-.27-.35,1.35,1.35,0,0,0-.58-.07h-.29v-.12a7.91,7.91,0,0,0,1-.22c.35-.1.65-.2.91-.3l.09.05v5.89a4.19,4.19,0,0,0,.07.83.58.58,0,0,0,.23.39,1,1,0,0,0,.45.15l.36.05Z"
              />
              <path
                d="M1789.26,497a3.14,3.14,0,0,1-.59.41,1.41,1.41,0,0,1-.69.16c-.71,0-1.07-.37-1.07-1.12V492.9h-.75v-.09l.76-.27.65-1.6h.13v1.59h1.46v.37h-1.46v3.43c0,.56.25.84.72.85a1.13,1.13,0,0,0,.39-.07,1.68,1.68,0,0,0,.36-.21Zm-3.23-6.86a.6.6,0,0,1-.13.37.46.46,0,0,1-.34.18.68.68,0,0,1-.44-.2,3.08,3.08,0,0,1-.45-.55,1.18,1.18,0,0,0-.74.57,2.84,2.84,0,0,0-.25,1.36v.65h1.21v.37h-1.21v3.34a3,3,0,0,0,0,.68.42.42,0,0,0,.21.31,1.29,1.29,0,0,0,.49.12l.28,0v.12h-2.62v-.12l.23,0a.76.76,0,0,0,.36-.12.45.45,0,0,0,.16-.32,3.76,3.76,0,0,0,0-.67V492.9H1782v-.09l.84-.27v-.13a3.25,3.25,0,0,1,.31-1.34,2.81,2.81,0,0,1,.84-1,2,2,0,0,1,1.23-.41,1,1,0,0,1,.56.16A.41.41,0,0,1,1786,490.15Zm-5.08,9.62h-2.74v-.12l.28,0a1.35,1.35,0,0,0,.5-.12.4.4,0,0,0,.21-.31,3.62,3.62,0,0,0,0-.68v-1.64a3.85,3.85,0,0,1-.72.52,2,2,0,0,1-.91.21,1.89,1.89,0,0,1-1.09-.32,2,2,0,0,1-.72-.83,2.63,2.63,0,0,1-.26-1.16,3.45,3.45,0,0,1,.35-1.53,2.59,2.59,0,0,1,.92-1,2.54,2.54,0,0,1,1.31-.34,3.29,3.29,0,0,1,.81.09,3.78,3.78,0,0,1,.63.24l.4-.42h.08v6.17a4,4,0,0,0,0,.68.43.43,0,0,0,.18.31,1,1,0,0,0,.43.12l.25,0Zm-1.7-5.62a1.74,1.74,0,0,0-.36-1.15,1.19,1.19,0,0,0-.94-.39,1.5,1.5,0,0,0-1.19.53,2.38,2.38,0,0,0-.46,1.56,3.23,3.23,0,0,0,.22,1.24,1.94,1.94,0,0,0,.61.85,1.55,1.55,0,0,0,.95.32,1.72,1.72,0,0,0,.62-.1,2.28,2.28,0,0,0,.55-.35Zm-5.81,2a1.2,1.2,0,0,1-.28.8,1.54,1.54,0,0,1-.69.48,2.37,2.37,0,0,1-.88.16,3.47,3.47,0,0,1-1.67-.37v-1h.31a1.63,1.63,0,0,0,.45.94,1.44,1.44,0,0,0,1,.3,1.15,1.15,0,0,0,.79-.25.89.89,0,0,0,.31-.71.76.76,0,0,0-.27-.65,3,3,0,0,0-1-.47,2.91,2.91,0,0,1-1.16-.6,1.21,1.21,0,0,1-.38-.94,1.31,1.31,0,0,1,.25-.77,1.56,1.56,0,0,1,.63-.5,2.13,2.13,0,0,1,.88-.18,3.18,3.18,0,0,1,.8.1,2.87,2.87,0,0,1,.61.24v1h-.31a1.88,1.88,0,0,0-.36-.9,1,1,0,0,0-.8-.31,1.1,1.1,0,0,0-.75.27,1,1,0,0,0-.29.71.83.83,0,0,0,.29.65,2.88,2.88,0,0,0,1,.44,3,3,0,0,1,1.23.62A1.22,1.22,0,0,1,1773.44,496.16Zm-9.11-3.32a4.36,4.36,0,0,1-.92,2.74,7.38,7.38,0,0,1-3.09,2.12l-.07-.16a6.66,6.66,0,0,0,2-1.33,3.61,3.61,0,0,0,.91-1.5,5.87,5.87,0,0,0,.21-1.7,4.21,4.21,0,0,0-.43-2.09,1.3,1.3,0,0,0-1.17-.7,1.11,1.11,0,0,0-1,.55,3,3,0,0,0-.32,1.5,3.6,3.6,0,0,0,.13,1,1.49,1.49,0,0,0,.46.74,1.35,1.35,0,0,0,.86.29,3.35,3.35,0,0,0,.62-.08l0,.14a3,3,0,0,1-.95.17,2,2,0,0,1-1.5-.56,2.11,2.11,0,0,1-.54-1.51,2.47,2.47,0,0,1,.32-1.25,2.39,2.39,0,0,1,.84-.86,2.27,2.27,0,0,1,1.18-.32,2.25,2.25,0,0,1,2.07,1.27A3.51,3.51,0,0,1,1764.33,492.84Zm-6.51,1a5.83,5.83,0,0,1-.3,1.93,3.09,3.09,0,0,1-.86,1.35,2,2,0,0,1-1.33.5,2,2,0,0,1-1.41-.51,2.94,2.94,0,0,1-.82-1.35,6.32,6.32,0,0,1-.27-1.92,5.85,5.85,0,0,1,.3-1.94,3.31,3.31,0,0,1,.86-1.35,2,2,0,0,1,1.34-.5,2,2,0,0,1,1.4.51,2.94,2.94,0,0,1,.82,1.35A6.38,6.38,0,0,1,1757.82,493.84Zm-.94.21a7.56,7.56,0,0,0-.39-2.82,1.34,1.34,0,0,0-1.26-1,1.2,1.2,0,0,0-1.1.87,6.89,6.89,0,0,0-.36,2.53,7.56,7.56,0,0,0,.39,2.82,1.35,1.35,0,0,0,1.26,1,1.18,1.18,0,0,0,1.1-.87A6.89,6.89,0,0,0,1756.88,494.05Zm-5.51,3.45h-3.14v-.12l.42-.05a1.13,1.13,0,0,0,.49-.15.58.58,0,0,0,.24-.39,3.54,3.54,0,0,0,.07-.83v-4.09a3.67,3.67,0,0,0-.07-.79.5.5,0,0,0-.27-.35,1.4,1.4,0,0,0-.59-.07h-.29v-.12a8,8,0,0,0,1-.22c.34-.1.65-.2.9-.3l.1.05V496a4.34,4.34,0,0,0,.06.83.6.6,0,0,0,.23.39,1,1,0,0,0,.45.15l.36.05Zm-4.47,0h-3.14v-.12l.41-.05a1.18,1.18,0,0,0,.5-.15.58.58,0,0,0,.24-.39,4.34,4.34,0,0,0,.06-.83v-4.09a3.12,3.12,0,0,0-.07-.79.45.45,0,0,0-.27-.35,1.35,1.35,0,0,0-.58-.07h-.29v-.12a7.91,7.91,0,0,0,1-.22c.35-.1.65-.2.91-.3l.09.05V496a4.19,4.19,0,0,0,.07.83.6.6,0,0,0,.23.39,1,1,0,0,0,.45.15l.36.05Z"
              />
              <path
                d="M1789.26,512.64a2.79,2.79,0,0,1-.59.42,1.41,1.41,0,0,1-.69.16c-.71,0-1.07-.37-1.07-1.12v-3.56h-.75v-.09l.76-.27.65-1.6h.13v1.59h1.46v.37h-1.46V512c0,.56.25.84.72.85a1.13,1.13,0,0,0,.39-.07,1.68,1.68,0,0,0,.36-.21Zm-3.23-6.85a.6.6,0,0,1-.13.37.46.46,0,0,1-.34.18.68.68,0,0,1-.44-.2,3.08,3.08,0,0,1-.45-.55,1.18,1.18,0,0,0-.74.57,2.84,2.84,0,0,0-.25,1.36v.65h1.21v.37h-1.21v3.34a3,3,0,0,0,0,.68.42.42,0,0,0,.21.31,1.51,1.51,0,0,0,.49.12l.28,0v.12h-2.62V513l.23,0a.89.89,0,0,0,.36-.12.45.45,0,0,0,.16-.32,3.76,3.76,0,0,0,0-.67v-3.34H1782v-.09l.84-.27v-.13a3.25,3.25,0,0,1,.31-1.34,2.81,2.81,0,0,1,.84-1,2,2,0,0,1,1.23-.41,1,1,0,0,1,.56.16A.41.41,0,0,1,1786,505.79Zm-5.08,9.62h-2.74v-.12l.28,0a1.35,1.35,0,0,0,.5-.12.42.42,0,0,0,.21-.31,3.62,3.62,0,0,0,0-.68v-1.64a3.85,3.85,0,0,1-.72.52,2,2,0,0,1-.91.21,1.89,1.89,0,0,1-1.09-.32,2,2,0,0,1-.72-.83,2.63,2.63,0,0,1-.26-1.16,3.45,3.45,0,0,1,.35-1.53,2.41,2.41,0,0,1,2.23-1.33,3.29,3.29,0,0,1,.81.09,3.78,3.78,0,0,1,.63.24l.4-.42h.08v6.17a4,4,0,0,0,0,.68.46.46,0,0,0,.18.31,1,1,0,0,0,.43.12l.25,0Zm-1.7-5.63a1.73,1.73,0,0,0-.36-1.14,1.19,1.19,0,0,0-.94-.39,1.5,1.5,0,0,0-1.19.53,2.38,2.38,0,0,0-.46,1.56,3.26,3.26,0,0,0,.22,1.24,2,2,0,0,0,.61.85,1.55,1.55,0,0,0,.95.32,1.52,1.52,0,0,0,.62-.11,2,2,0,0,0,.55-.34Zm-5.49,2a1.2,1.2,0,0,1-.28.8,1.54,1.54,0,0,1-.69.48,2.41,2.41,0,0,1-.88.16,3.47,3.47,0,0,1-1.67-.37v-1h.31a1.63,1.63,0,0,0,.45.94,1.43,1.43,0,0,0,1,.3,1.18,1.18,0,0,0,.8-.25.91.91,0,0,0,.31-.71.79.79,0,0,0-.27-.66,3.07,3.07,0,0,0-1-.46,2.91,2.91,0,0,1-1.16-.6,1.21,1.21,0,0,1-.38-.94,1.31,1.31,0,0,1,.25-.77,1.56,1.56,0,0,1,.63-.5,2.13,2.13,0,0,1,.88-.18,2.78,2.78,0,0,1,.8.1,2.43,2.43,0,0,1,.61.24v1h-.31a1.88,1.88,0,0,0-.36-.9,1,1,0,0,0-.8-.31,1.1,1.1,0,0,0-.75.27.94.94,0,0,0-.29.7.85.85,0,0,0,.29.66,2.88,2.88,0,0,0,1,.44,3,3,0,0,1,1.23.62A1.22,1.22,0,0,1,1773.76,511.8Zm-9.18-.63-.64,1.95h-4l-.08-.1,2-2.2a11.16,11.16,0,0,0,1-1.16,4.1,4.1,0,0,0,.51-1,2.92,2.92,0,0,0,.15-.93,1.42,1.42,0,0,0-.39-1,1.44,1.44,0,0,0-1.09-.41,1.58,1.58,0,0,0-1,.33,3.91,3.91,0,0,0-.85,1l-.13-.08a4.06,4.06,0,0,1,1-1.35,2.14,2.14,0,0,1,1.37-.48,1.86,1.86,0,0,1,1.31.47,1.78,1.78,0,0,1,.51,1.33,2.53,2.53,0,0,1-.2,1,4.27,4.27,0,0,1-.59.94c-.26.32-.57.68-1,1.08l-1.8,2h1.7a4.47,4.47,0,0,0,.91-.07,1.09,1.09,0,0,0,.56-.27,2.75,2.75,0,0,0,.44-.61l.21-.35Zm-6-1.69a6.11,6.11,0,0,1-.29,1.93,3.18,3.18,0,0,1-.86,1.35,2.11,2.11,0,0,1-2.74,0,2.86,2.86,0,0,1-.82-1.35,6.32,6.32,0,0,1-.27-1.92,5.85,5.85,0,0,1,.3-1.94,3.23,3.23,0,0,1,.85-1.35,2,2,0,0,1,1.34-.5,2,2,0,0,1,1.41.51,2.94,2.94,0,0,1,.82,1.35A6.35,6.35,0,0,1,1758.56,509.48Zm-.93.21a8,8,0,0,0-.39-2.82,1.36,1.36,0,0,0-1.26-1,1.21,1.21,0,0,0-1.11.87,7.14,7.14,0,0,0-.35,2.53,7.56,7.56,0,0,0,.39,2.82,1.33,1.33,0,0,0,1.26,1,1.2,1.2,0,0,0,1.1-.87A6.89,6.89,0,0,0,1757.63,509.69Zm-6,.81a2.39,2.39,0,0,1-.51,1.51,3.06,3.06,0,0,1-1.18.93,3.27,3.27,0,0,1-1.36.31,1.3,1.3,0,0,1-.75-.17.51.51,0,0,1-.26-.44.41.41,0,0,1,.45-.42,1,1,0,0,1,.54.17,2.65,2.65,0,0,1,.54.56,2.19,2.19,0,0,0,.93-.28,2.07,2.07,0,0,0,.7-.68,2,2,0,0,0,.27-1,1.38,1.38,0,0,0-.43-1.09,1.69,1.69,0,0,0-1.14-.36,2.1,2.1,0,0,0-.51.06l-.5.18-.1-.18a11.41,11.41,0,0,0,1.52-.94,2.65,2.65,0,0,0,.69-.73,1.29,1.29,0,0,0,.17-.67.89.89,0,0,0-.29-.7,1.27,1.27,0,0,0-.87-.28,2.06,2.06,0,0,0-1,.23,3.69,3.69,0,0,0-.84.63l-.1-.12a4,4,0,0,1,1.15-1,2.41,2.41,0,0,1,1.19-.29,1.72,1.72,0,0,1,1.09.32,1.2,1.2,0,0,1,.4.94,1.48,1.48,0,0,1-.39,1,5.29,5.29,0,0,1-1.24,1,2.25,2.25,0,0,1,1.31.45A1.47,1.47,0,0,1,1751.63,510.5Zm-5.47,2.64H1743V513l.42-.06a1,1,0,0,0,.49-.14.58.58,0,0,0,.24-.39,3.54,3.54,0,0,0,.07-.83v-4.09a3.67,3.67,0,0,0-.07-.79.5.5,0,0,0-.27-.35,1.4,1.4,0,0,0-.59-.07H1743v-.12a8,8,0,0,0,1-.22c.34-.1.65-.2.9-.3l.1,0v5.89a4.34,4.34,0,0,0,.06.83.6.6,0,0,0,.23.39.92.92,0,0,0,.45.14l.37.06Z"
              />
              <path
                class="cls-5"
                d="M1705.78,307.77a2.35,2.35,0,0,1-.37.14,1.89,1.89,0,0,1-.44,0c-.46,0-.71-.27-.76-.8a3.51,3.51,0,0,1-.79.6,2,2,0,0,1-.93.25,1.26,1.26,0,0,1-.83-.27,1.09,1.09,0,0,1,0-1.59,4.18,4.18,0,0,1,1.26-.62l.62-.2.64-.18v-.72c0-1-.31-1.44-1-1.43a1.23,1.23,0,0,0-.35.05,1.43,1.43,0,0,0-.28.13,2.57,2.57,0,0,1-.18.89.44.44,0,0,1-.41.29.53.53,0,0,1-.32-.09.43.43,0,0,1-.15-.35.79.79,0,0,1,.31-.48,2.66,2.66,0,0,1,.76-.47,2.32,2.32,0,0,1,1-.21,1.31,1.31,0,0,1,1.09.4,1.92,1.92,0,0,1,.31,1.26V307a1.13,1.13,0,0,0,.1.57.36.36,0,0,0,.34.16l.29,0Zm-1.57-2.44c-.18,0-.39.09-.61.15a5.51,5.51,0,0,0-.62.22,1.12,1.12,0,0,0-.84,1,1,1,0,0,0,.21.66.78.78,0,0,0,.6.23,1.26,1.26,0,0,0,.61-.17,2.58,2.58,0,0,0,.65-.49Zm-8-.53v.13a3.14,3.14,0,0,0,.55,1.89,1.69,1.69,0,0,0,2.22.47,3,3,0,0,0,.68-.63l.13.06a2.81,2.81,0,0,1-.85.93,2,2,0,0,1-1.17.38,2.24,2.24,0,0,1-1.69-.68,2.72,2.72,0,0,1-.65-1.85,3,3,0,0,1,.37-1.46,2.58,2.58,0,0,1,.89-1,2.14,2.14,0,0,1,1.13-.33c1.28,0,1.94.66,2,2.05Zm2.66-.19a2.14,2.14,0,0,0-.35-1.23,1,1,0,0,0-.85-.43,1.29,1.29,0,0,0-1,.45,2,2,0,0,0-.46,1.21Zm-4.92-1.4a.74.74,0,0,1-.13.46.33.33,0,0,1-.27.16.7.7,0,0,1-.33-.11,3.09,3.09,0,0,1-.55-.37,3.21,3.21,0,0,0-.46.29,2.77,2.77,0,0,0-.39.37v2.63a3.62,3.62,0,0,0,0,.68.4.4,0,0,0,.21.31,1.35,1.35,0,0,0,.5.12l.28,0v.12h-2.62v-.12l.22,0a.8.8,0,0,0,.37-.12.46.46,0,0,0,.16-.31,5.24,5.24,0,0,0,0-.68v-2.52a1,1,0,0,0-.1-.53.74.74,0,0,0-.39-.26l-.31-.11v-.09l1.5-.35.09.06v.89a4.09,4.09,0,0,1,.85-.75,1.21,1.21,0,0,1,.72-.22.71.71,0,0,1,.41.1A.4.4,0,0,1,1693.92,303.21Zm-4.69,4.69h-2.93v-.12l.39,0c.36,0,.54-.2.53-.48a1.86,1.86,0,0,0-.13-.64l-.63-1.65h-2.78l-.47,1.2a2.09,2.09,0,0,0-.14.48,2,2,0,0,0-.06.45.59.59,0,0,0,.56.64l.37,0v.12h-2.47v-.12l.22,0a1,1,0,0,0,.56-.29,2.44,2.44,0,0,0,.44-.77L1685,301l.54-.55h.1l2.48,6.44a1.63,1.63,0,0,0,.36.65.74.74,0,0,0,.47.24l.31,0Zm-2.87-3.19-1.28-3.37-1.31,3.37Zm-39.6.09v.13a3.14,3.14,0,0,0,.55,1.89,1.69,1.69,0,0,0,2.22.47,3,3,0,0,0,.68-.63l.13.06a2.81,2.81,0,0,1-.85.93,2,2,0,0,1-1.17.38,2.24,2.24,0,0,1-1.69-.68,2.72,2.72,0,0,1-.65-1.85,3,3,0,0,1,.37-1.46,2.58,2.58,0,0,1,.89-1,2.14,2.14,0,0,1,1.13-.33c1.28,0,1.94.66,2,2.05Zm2.66-.19a2.14,2.14,0,0,0-.35-1.23,1,1,0,0,0-.85-.43,1.29,1.29,0,0,0-1,.45,2,2,0,0,0-.46,1.21Zm-5.16.47a3.32,3.32,0,0,1-.35,1.53,2.59,2.59,0,0,1-.92,1,2.54,2.54,0,0,1-1.31.34,5.65,5.65,0,0,1-1.12-.1v1.07a3.74,3.74,0,0,0,0,.69.42.42,0,0,0,.21.31,1.62,1.62,0,0,0,.5.11l.28,0v.11h-2.74v-.11l.25,0a1.14,1.14,0,0,0,.43-.11.48.48,0,0,0,.18-.32,3.89,3.89,0,0,0,0-.68v-4.79a.93.93,0,0,0-.09-.53.73.73,0,0,0-.4-.26l-.3-.11v-.09l1.5-.35.09.06v.66a3.85,3.85,0,0,1,.72-.52,2,2,0,0,1,.91-.21,1.87,1.87,0,0,1,1.09.32,2,2,0,0,1,.72.83A2.63,2.63,0,0,1,1644.26,305.08Zm-.75.59a3.47,3.47,0,0,0-.21-1.24,2,2,0,0,0-.62-.85,1.65,1.65,0,0,0-1.57-.21,2,2,0,0,0-.55.34v2.51a1.74,1.74,0,0,0,.36,1.15,1.2,1.2,0,0,0,.94.39,1.5,1.5,0,0,0,1.19-.53A2.38,2.38,0,0,0,1643.51,305.67Zm-5.45-2.68-.2,0a.72.72,0,0,0-.47.26,3.84,3.84,0,0,0-.43.82l-2,4.91a2.93,2.93,0,0,1-.56.92.82.82,0,0,1-.61.26.45.45,0,0,1-.34-.12.48.48,0,0,1-.11-.32.47.47,0,0,1,.32-.43,1.79,1.79,0,0,1,.91-.09,11.73,11.73,0,0,0,.64-1.35l-1.64-3.85a3,3,0,0,0-.39-.78.66.66,0,0,0-.45-.23l-.22,0v-.12h2.38V303l-.27,0a.68.68,0,0,0-.33.11.25.25,0,0,0-.08.21,1.55,1.55,0,0,0,0,.29,3,3,0,0,0,.11.32l1.23,3.08,1-2.61a3.29,3.29,0,0,0,.28-1c0-.22-.14-.34-.39-.38l-.29,0v-.12h1.9Zm-5.61-2.62-.3,1.77H1632l0-.42a.83.83,0,0,0-.34-.69,2.16,2.16,0,0,0-1.06-.18l-1.36,0v5.53a4.27,4.27,0,0,0,.06.83.69.69,0,0,0,.24.4,1.24,1.24,0,0,0,.5.14l.42,0v.12h-3.29v-.12l.42,0a1.24,1.24,0,0,0,.5-.14.69.69,0,0,0,.24-.4,4.27,4.27,0,0,0,.06-.83v-5.53l-1.25,0a3.59,3.59,0,0,0-.82.08,1,1,0,0,0-.51.25,1.4,1.4,0,0,0-.35.54l-.18.42h-.11l.31-1.77h.07a.82.82,0,0,0,.2.12,1.08,1.08,0,0,0,.41.08c.2,0,.51,0,.93,0h3.58c.44,0,.77,0,1,0a1.41,1.41,0,0,0,.46-.08,1.11,1.11,0,0,0,.27-.12Z"
              />
              <line
                class="cls-3"
                x1="1499.17"
                y1="317.07"
                x2="1788.53"
                y2="317.07"
              />
              <line
                class="cls-3"
                x1="1499.17"
                y1="359.51"
                x2="1788.53"
                y2="359.51"
              />
              <line
                class="cls-6"
                x1="1733.19"
                y1="326.26"
                x2="1733.19"
                y2="333.95"
              />
              <line
                class="cls-6"
                x1="1733.19"
                y1="458.03"
                x2="1733.19"
                y2="465.97"
              />
              <line
                class="cls-6"
                x1="1733.19"
                y1="473.91"
                x2="1733.19"
                y2="481.6"
              />
              <line
                class="cls-6"
                x1="1733.19"
                y1="489.55"
                x2="1733.19"
                y2="497.24"
              />
              <line
                class="cls-6"
                x1="1733.19"
                y1="505.43"
                x2="1733.19"
                y2="513.12"
              />
              <line
                class="cls-6"
                x1="1733.19"
                y1="341.89"
                x2="1733.19"
                y2="349.83"
              />
              <line
                class="cls-6"
                x1="1733.19"
                y1="368.19"
                x2="1733.19"
                y2="376.14"
              />
              <line
                class="cls-6"
                x1="1733.19"
                y1="384.08"
                x2="1733.19"
                y2="392.02"
              />
              <line
                class="cls-6"
                x1="1733.19"
                y1="399.96"
                x2="1733.19"
                y2="407.65"
              />
              <line
                class="cls-6"
                x1="1733.19"
                y1="415.59"
                x2="1733.19"
                y2="423.53"
              />
              <line
                class="cls-6"
                x1="1733.19"
                y1="432.22"
                x2="1733.19"
                y2="439.91"
              />
              <path
                d="M1645.11,541.91H1642v-.11l.41-.06a1.19,1.19,0,0,0,.5-.14.6.6,0,0,0,.24-.4,4.15,4.15,0,0,0,.06-.82v-4.09a3.21,3.21,0,0,0-.07-.8.46.46,0,0,0-.27-.34,1.49,1.49,0,0,0-.58-.08H1642V535a10,10,0,0,0,1-.22,8,8,0,0,0,.91-.31l.09.06v5.89a4,4,0,0,0,.07.82.63.63,0,0,0,.23.4,1,1,0,0,0,.45.14l.36.06Zm-4.79-5.26a1.9,1.9,0,0,1-.77,1.56,3.69,3.69,0,0,1-2,.65l0-.13a2.28,2.28,0,0,0,1.33-.58,2.37,2.37,0,0,0-.07-2.9,1.9,1.9,0,0,0-1.36-.48,3.62,3.62,0,0,0-.5,0l-.38.08v5.49a4.15,4.15,0,0,0,.06.82.69.69,0,0,0,.24.4,1.24,1.24,0,0,0,.5.14l.41.06v.11h-3.08v-.11l.39-.06a.56.56,0,0,0,.51-.31,2.85,2.85,0,0,0,.12-1v-4.25a2.85,2.85,0,0,0-.12-1,.59.59,0,0,0-.51-.32l-.39,0v-.12h3a3.84,3.84,0,0,1,1.36.23,2,2,0,0,1,.94.68A2,2,0,0,1,1640.32,536.65Zm-7.83,1.6a3.83,3.83,0,0,1-.54,2,3.28,3.28,0,0,1-1.41,1.22,4.66,4.66,0,0,1-2,.4h-3.13v-.11l.39-.06a.56.56,0,0,0,.51-.31,2.64,2.64,0,0,0,.12-1v-4.25a2.64,2.64,0,0,0-.12-1,.59.59,0,0,0-.51-.32l-.39,0v-.12h2.63a6,6,0,0,1,2.28.41,3.55,3.55,0,0,1,1.56,1.23A3.49,3.49,0,0,1,1632.49,538.25Zm-1,.12a4.2,4.2,0,0,0-.44-2,2.83,2.83,0,0,0-1.21-1.21,3.91,3.91,0,0,0-1.82-.41,2.21,2.21,0,0,0-.72.1v5.51a2.39,2.39,0,0,0,.11.85.67.67,0,0,0,.43.41,2.5,2.5,0,0,0,.91.1,2.68,2.68,0,0,0,1.41-.35,2.42,2.42,0,0,0,1-1.09A4.78,4.78,0,0,0,1631.5,538.37Zm-21.71,3.54h-2.38v-.11l.21,0a1,1,0,0,0,.38-.11.45.45,0,0,0,.17-.31,5.29,5.29,0,0,0,0-.69v-2.16c0-.86-.34-1.28-1-1.27a1.66,1.66,0,0,0-.75.18,2.33,2.33,0,0,0-.65.48,1.42,1.42,0,0,1,0,.25c0,.1,0,.2,0,.29v2.23a5.29,5.29,0,0,0,0,.69.45.45,0,0,0,.17.31,1,1,0,0,0,.38.11l.21,0v.11h-2.39v-.11l.21,0a1,1,0,0,0,.38-.11.45.45,0,0,0,.17-.31,5.73,5.73,0,0,0,0-.69v-2.16c0-.86-.33-1.28-1-1.27a1.72,1.72,0,0,0-.72.17,2.28,2.28,0,0,0-.63.45v2.81a4,4,0,0,0,0,.69.44.44,0,0,0,.16.31,1.07,1.07,0,0,0,.39.11l.21,0v.11h-2.39v-.11l.23,0a1,1,0,0,0,.37-.11.51.51,0,0,0,.16-.32,5.66,5.66,0,0,0,0-.68v-2.51a1,1,0,0,0-.09-.54.77.77,0,0,0-.4-.25l-.31-.12v-.09l1.51-.35.09.07v.75a4.38,4.38,0,0,1,.8-.6,1.73,1.73,0,0,1,.89-.23,1.53,1.53,0,0,1,.92.24,1.24,1.24,0,0,1,.45.65,4.26,4.26,0,0,1,.84-.64,2,2,0,0,1,.93-.25c1,0,1.46.52,1.46,1.59v2.28a5.73,5.73,0,0,0,0,.69.48.48,0,0,0,.16.31,1,1,0,0,0,.37.11l.22,0Zm-10.13,0c-.61,0-1.14,0-1.58,0v-.76a4.69,4.69,0,0,1-.82.61,1.77,1.77,0,0,1-.9.22c-1,0-1.47-.52-1.49-1.59v-2.29a1,1,0,0,0-.09-.54.81.81,0,0,0-.4-.25l-.31-.12v-.09l1.5-.35.1.07v3.45a1.45,1.45,0,0,0,.27,1,.93.93,0,0,0,.75.31,1.59,1.59,0,0,0,.75-.17,2.32,2.32,0,0,0,.64-.45v-2.82a1.05,1.05,0,0,0-.1-.54.73.73,0,0,0-.39-.25l-.31-.12v-.09l1.5-.35.1.07v3.79a5.73,5.73,0,0,0,0,.69.48.48,0,0,0,.16.31,1,1,0,0,0,.37.11l.22,0Zm-7.74-6.83a.51.51,0,0,1-.16.4.54.54,0,0,1-.4.16.51.51,0,0,1-.4-.16.55.55,0,0,1-.17-.4.59.59,0,0,1,.17-.4.51.51,0,0,1,.4-.16.55.55,0,0,1,.56.56Zm.74,6.83h-2.39v-.11l.22,0a.9.9,0,0,0,.37-.11.47.47,0,0,0,.16-.32,3.89,3.89,0,0,0,0-.68v-2.51a1,1,0,0,0-.1-.54.73.73,0,0,0-.39-.25l-.31-.12v-.09l1.5-.35.1.07v3.79a5.73,5.73,0,0,0,0,.69.45.45,0,0,0,.17.31,1,1,0,0,0,.38.11l.22,0Zm-3.74,0h-2.39v-.11l.21,0a1,1,0,0,0,.39-.11.44.44,0,0,0,.16-.31,4,4,0,0,0,0-.69v-2.16c0-.86-.34-1.28-1-1.27a1.69,1.69,0,0,0-.75.18,2.49,2.49,0,0,0-.65.48,1.31,1.31,0,0,1,0,.25c0,.1,0,.2,0,.29v2.23a5.73,5.73,0,0,0,0,.69.45.45,0,0,0,.17.31,1,1,0,0,0,.38.11l.22,0v.11h-2.4v-.11l.21,0a1.07,1.07,0,0,0,.39-.11.44.44,0,0,0,.16-.31,4,4,0,0,0,0-.69v-2.16c0-.86-.34-1.28-1-1.27a1.65,1.65,0,0,0-.72.17,2.28,2.28,0,0,0-.63.45v2.81a5.73,5.73,0,0,0,0,.69.45.45,0,0,0,.17.31,1,1,0,0,0,.38.11l.21,0v.11h-2.38v-.11l.22,0a.9.9,0,0,0,.37-.11.51.51,0,0,0,.16-.32,5.24,5.24,0,0,0,0-.68v-2.51a1.05,1.05,0,0,0-.1-.54.73.73,0,0,0-.39-.25l-.31-.12v-.09l1.5-.35.1.07v.75a4.34,4.34,0,0,1,.79-.6,1.77,1.77,0,0,1,.9-.23,1.51,1.51,0,0,1,.91.24,1.14,1.14,0,0,1,.45.65,4.61,4.61,0,0,1,.85-.64,2,2,0,0,1,.92-.25c1,0,1.46.52,1.46,1.59v2.28a4,4,0,0,0,0,.69.41.41,0,0,0,.16.31.9.9,0,0,0,.36.11l.23,0Zm-13.66-3.1V539a3.19,3.19,0,0,0,.55,1.89,1.65,1.65,0,0,0,1.34.69,1.71,1.71,0,0,0,.88-.22,2.83,2.83,0,0,0,.68-.63l.13.05a2.93,2.93,0,0,1-.84.94,2.11,2.11,0,0,1-1.18.37,2.21,2.21,0,0,1-1.68-.68,2.63,2.63,0,0,1-.65-1.85,2.85,2.85,0,0,1,.36-1.46,2.55,2.55,0,0,1,.89-.95,2.07,2.07,0,0,1,1.13-.34c1.28,0,1.94.67,2,2Zm2.67-.18a2.23,2.23,0,0,0-.36-1.24,1,1,0,0,0-.85-.43,1.29,1.29,0,0,0-1,.45,2.08,2.08,0,0,0-.46,1.22Zm-4.82-1.41a.87.87,0,0,1-.13.47.36.36,0,0,1-.27.16.84.84,0,0,1-.33-.11,4.77,4.77,0,0,1-.56-.37,2.45,2.45,0,0,0-.45.29,2.25,2.25,0,0,0-.39.36v2.63a3.74,3.74,0,0,0,0,.69.42.42,0,0,0,.21.31,1.62,1.62,0,0,0,.5.11l.27,0v.11h-2.62v-.11l.23,0a1,1,0,0,0,.37-.11.51.51,0,0,0,.16-.32,5.66,5.66,0,0,0,0-.68v-2.51a1,1,0,0,0-.09-.54.77.77,0,0,0-.4-.25l-.31-.12v-.09l1.51-.35.09.07v.88a3.84,3.84,0,0,1,.84-.75,1.31,1.31,0,0,1,.73-.22.73.73,0,0,1,.41.11A.38.38,0,0,1,1573.11,537.22Zm-5.32-.57a1.9,1.9,0,0,1-.77,1.56,3.69,3.69,0,0,1-2,.65l0-.13a2.31,2.31,0,0,0,1.33-.58,2,2,0,0,0,.46-1.43,2,2,0,0,0-.53-1.47,1.91,1.91,0,0,0-1.36-.48,3.49,3.49,0,0,0-.5,0l-.38.08v5.49a4.15,4.15,0,0,0,.06.82.6.6,0,0,0,.24.4,1.19,1.19,0,0,0,.5.14l.41.06v.11h-3.09v-.11l.4-.06a.55.55,0,0,0,.5-.31,2.79,2.79,0,0,0,.13-1v-4.25a2.79,2.79,0,0,0-.13-1,.57.57,0,0,0-.5-.32l-.4,0v-.12h3a3.86,3.86,0,0,1,1.37.23,2,2,0,0,1,.94.68A2,2,0,0,1,1567.79,536.65Zm-10.4,5.26H1555v-.11l.21,0a1,1,0,0,0,.38-.11.45.45,0,0,0,.17-.31,5.73,5.73,0,0,0,0-.69v-2.16c0-.86-.33-1.28-1-1.27a1.65,1.65,0,0,0-.74.18,2.33,2.33,0,0,0-.65.48c0,.06,0,.15,0,.25s0,.2,0,.29v2.23a4,4,0,0,0,0,.69.44.44,0,0,0,.16.31,1.07,1.07,0,0,0,.39.11l.21,0v.11h-2.4v-.11l.22,0a1,1,0,0,0,.38-.11.41.41,0,0,0,.16-.31,4,4,0,0,0,0-.69v-2.16c0-.86-.33-1.28-1-1.27a1.65,1.65,0,0,0-.72.17,2.28,2.28,0,0,0-.63.45v2.81a4,4,0,0,0,0,.69.44.44,0,0,0,.16.31,1,1,0,0,0,.38.11l.22,0v.11h-2.39v-.11l.23,0a.9.9,0,0,0,.36-.11.47.47,0,0,0,.16-.32,3.89,3.89,0,0,0,0-.68v-2.51a.88.88,0,0,0-.1-.54.73.73,0,0,0-.39-.25l-.31-.12v-.09l1.5-.35.1.07v.75a4.38,4.38,0,0,1,.8-.6,1.71,1.71,0,0,1,.89-.23,1.49,1.49,0,0,1,.91.24,1.2,1.2,0,0,1,.46.65,4.26,4.26,0,0,1,.84-.64,2,2,0,0,1,.92-.25c1,0,1.46.52,1.46,1.59v2.28a5.29,5.29,0,0,0,0,.69.48.48,0,0,0,.16.31.9.9,0,0,0,.37.11l.22,0Zm-10.32-2.46a2.92,2.92,0,0,1-.33,1.34,2.31,2.31,0,0,1-.87.91,2.41,2.41,0,0,1-1.23.34,2.49,2.49,0,0,1-1.21-.3,2.28,2.28,0,0,1-.88-.89,3.2,3.2,0,0,1-.34-1.5,2.8,2.8,0,0,1,.34-1.34,2.53,2.53,0,0,1,.87-.91,2.4,2.4,0,0,1,1.22-.34,2.47,2.47,0,0,1,1.21.3,2.22,2.22,0,0,1,.88.89A3.2,3.2,0,0,1,1547.07,539.45Zm-.9.2a3.81,3.81,0,0,0-.47-2,1.48,1.48,0,0,0-1.23-.75,1.08,1.08,0,0,0-1,.52,3.13,3.13,0,0,0-.37,1.69,3.71,3.71,0,0,0,.47,2,1.41,1.41,0,0,0,1.22.75,1.11,1.11,0,0,0,1-.52A3.13,3.13,0,0,0,1546.17,539.65Zm-5.7-.2a2.92,2.92,0,0,1-.33,1.34A2.38,2.38,0,0,1,1538,542a2.49,2.49,0,0,1-1.21-.3,2.22,2.22,0,0,1-.88-.89,3.2,3.2,0,0,1-.34-1.5A2.8,2.8,0,0,1,1536,538a2.35,2.35,0,0,1,2.09-1.25,2.49,2.49,0,0,1,1.21.3,2.28,2.28,0,0,1,.88.89A3.2,3.2,0,0,1,1540.47,539.45Zm-.91.2a3.71,3.71,0,0,0-.47-2,1.46,1.46,0,0,0-1.22-.75,1.11,1.11,0,0,0-1,.52,3.14,3.14,0,0,0-.36,1.69,3.71,3.71,0,0,0,.46,2,1.44,1.44,0,0,0,1.23.75,1.08,1.08,0,0,0,1-.52A3.13,3.13,0,0,0,1539.56,539.65Zm-5.43-2.43a.87.87,0,0,1-.13.47.37.37,0,0,1-.27.16.92.92,0,0,1-.34-.11,5.88,5.88,0,0,1-.55-.37,2.52,2.52,0,0,0-.46.29,2.18,2.18,0,0,0-.38.36v2.63a3.74,3.74,0,0,0,0,.69.42.42,0,0,0,.21.31,1.62,1.62,0,0,0,.5.11l.27,0v.11h-2.62v-.11l.23,0a.9.9,0,0,0,.36-.11.43.43,0,0,0,.16-.32,3.89,3.89,0,0,0,0-.68v-2.51a.88.88,0,0,0-.1-.54.73.73,0,0,0-.39-.25l-.31-.12v-.09l1.5-.35.1.07v.88a3.84,3.84,0,0,1,.84-.75,1.31,1.31,0,0,1,.73-.22.73.73,0,0,1,.41.11A.38.38,0,0,1,1534.13,537.22Zm-4.94,4.69c-.61,0-1.14,0-1.59,0v-.67a3.5,3.5,0,0,1-.72.53,2.07,2.07,0,0,1-.91.21,2,2,0,0,1-1.09-.32,2.07,2.07,0,0,1-.72-.83,2.64,2.64,0,0,1-.25-1.17,3.16,3.16,0,0,1,.35-1.52,2.38,2.38,0,0,1,.92-1,2.47,2.47,0,0,1,1.3-.34,4.93,4.93,0,0,1,1.12.1V535.4a1,1,0,0,0-.09-.53.82.82,0,0,0-.4-.26l-.31-.11v-.09l1.5-.35.1.06v6.53a4,4,0,0,0,0,.69.44.44,0,0,0,.16.31.9.9,0,0,0,.36.11l.23,0Zm-1.59-3.35a1.73,1.73,0,0,0-.36-1.14,1.19,1.19,0,0,0-.94-.39,1.48,1.48,0,0,0-1.19.53,2.44,2.44,0,0,0-.46,1.56,3.26,3.26,0,0,0,.22,1.24,1.94,1.94,0,0,0,.62.85,1.52,1.52,0,0,0,.94.32,1.71,1.71,0,0,0,.62-.11,1.83,1.83,0,0,0,.55-.34Zm-9.11.25V539a3.19,3.19,0,0,0,.55,1.89,1.66,1.66,0,0,0,1.34.69,1.71,1.71,0,0,0,.88-.22,2.86,2.86,0,0,0,.69-.63l.12.05a2.93,2.93,0,0,1-.84.94,2.11,2.11,0,0,1-1.18.37,2.23,2.23,0,0,1-1.68-.68,2.63,2.63,0,0,1-.65-1.85,2.85,2.85,0,0,1,.36-1.46,2.55,2.55,0,0,1,.89-.95,2.09,2.09,0,0,1,1.13-.34c1.28,0,1.94.67,2,2Zm2.67-.18a2.23,2.23,0,0,0-.35-1.24,1,1,0,0,0-.86-.43,1.29,1.29,0,0,0-1,.45,2.08,2.08,0,0,0-.45,1.22Zm-5.28,1.18a1.85,1.85,0,0,1-.78,1.52,3.37,3.37,0,0,1-2,.58h-3v-.11l.39-.06a.56.56,0,0,0,.51-.31,2.64,2.64,0,0,0,.12-1v-4.25a2.64,2.64,0,0,0-.12-1,.59.59,0,0,0-.51-.32l-.39,0v-.12h3.06a3.07,3.07,0,0,1,1.74.43,1.36,1.36,0,0,1,.65,1.22,1.34,1.34,0,0,1-.37,1,3.13,3.13,0,0,1-1,.64,2.6,2.6,0,0,1,1.25.67A1.7,1.7,0,0,1,1515.88,539.81Zm-1.28-3.38a1.66,1.66,0,0,0-.42-1.2,1.61,1.61,0,0,0-1.21-.46,4,4,0,0,0-1,.11V538h.73a2.39,2.39,0,0,0,1.41-.38A1.43,1.43,0,0,0,1514.6,536.43Zm.35,3.65a1.7,1.7,0,0,0-.59-1.4,2.34,2.34,0,0,0-1.52-.46H1512v2.16a1.61,1.61,0,0,0,.26,1.11,1.31,1.31,0,0,0,1,.26,1.67,1.67,0,0,0,1.24-.45A1.61,1.61,0,0,0,1515,540.08Zm-6.66-1h-2.73v-.36h2.73Zm-4.15.67H1503V542h-.78V539.8h-3.34l-.07-.11,3.8-5.14h.39v4.9h1.17Zm-2-.35v-4l-2.94,4Z"
              />
              <path
                d="M1667.5,557.81h-3v-.12l.49-.06a.62.62,0,0,0,.54-.31,2.43,2.43,0,0,0,.13-1.05v-2h-4v2a2.6,2.6,0,0,0,.13,1.05.65.65,0,0,0,.54.31l.49.06v.12h-3v-.12l.39-.05a.59.59,0,0,0,.51-.32,2.64,2.64,0,0,0,.12-1.05V552a2.64,2.64,0,0,0-.12-1,.56.56,0,0,0-.51-.31l-.39-.06v-.11h3v.11l-.49.07a.61.61,0,0,0-.54.31,2.51,2.51,0,0,0-.13,1v2h4v-2a2.35,2.35,0,0,0-.13-1,.59.59,0,0,0-.54-.31l-.49-.07v-.11h3v.11l-.39.06a.56.56,0,0,0-.51.31,2.64,2.64,0,0,0-.12,1v4.25a2.64,2.64,0,0,0,.12,1.05.59.59,0,0,0,.51.32l.39.05Zm-9.9-5.26a1.88,1.88,0,0,1-.76,1.55,3.72,3.72,0,0,1-2,.65l0-.12a2.32,2.32,0,0,0,1.33-.59,2,2,0,0,0-1.43-3.37,3.63,3.63,0,0,0-.5,0,1.93,1.93,0,0,0-.38.09v5.48a4.34,4.34,0,0,0,.06.83.55.55,0,0,0,.24.39,1.18,1.18,0,0,0,.5.15l.41.05v.12H1652v-.12l.4-.05a.58.58,0,0,0,.5-.32,2.64,2.64,0,0,0,.12-1.05V552a2.64,2.64,0,0,0-.12-1,.56.56,0,0,0-.5-.31l-.4-.06v-.11h3a3.9,3.9,0,0,1,1.37.22,2,2,0,0,1,.93.68A1.83,1.83,0,0,1,1657.6,552.55ZM1650,555h-2.73v-.36H1650Zm-4.84,2.79H1642v-.12l.42-.05a1.18,1.18,0,0,0,.49-.15.55.55,0,0,0,.24-.39,4.19,4.19,0,0,0,.07-.83v-4.09a3.67,3.67,0,0,0-.07-.79.49.49,0,0,0-.28-.35,1.35,1.35,0,0,0-.58-.07H1642v-.12a7.57,7.57,0,0,0,1-.22c.35-.1.65-.2.91-.3l.1,0v5.89a4.34,4.34,0,0,0,.06.83.58.58,0,0,0,.23.39,1,1,0,0,0,.45.15l.36.05Zm-4.9-5.26a1.88,1.88,0,0,1-.76,1.55,3.72,3.72,0,0,1-2,.65l0-.12a2.32,2.32,0,0,0,1.33-.59,2,2,0,0,0,.45-1.43,1.93,1.93,0,0,0-.52-1.47,2,2,0,0,0-1.36-.47,3.63,3.63,0,0,0-.5,0,1.93,1.93,0,0,0-.38.09v5.48a4.34,4.34,0,0,0,.06.83.55.55,0,0,0,.24.39,1.18,1.18,0,0,0,.49.15l.42.05v.12h-3.09v-.12l.4-.05a.58.58,0,0,0,.5-.32,2.64,2.64,0,0,0,.12-1.05V552a2.64,2.64,0,0,0-.12-1,.56.56,0,0,0-.5-.31l-.4-.06v-.11h3a3.9,3.9,0,0,1,1.37.22,2,2,0,0,1,.93.68A1.83,1.83,0,0,1,1640.24,552.55Zm-7.72,1.6a3.62,3.62,0,0,1-.54,2,3.28,3.28,0,0,1-1.41,1.22,4.66,4.66,0,0,1-2,.41h-.79l-.44,0h-1.9v-.12l.4-.05a.58.58,0,0,0,.5-.32,2.64,2.64,0,0,0,.12-1.05V552a2.64,2.64,0,0,0-.12-1,.56.56,0,0,0-.5-.31l-.4-.06v-.11h2.63a5.8,5.8,0,0,1,2.28.41,3.31,3.31,0,0,1,2.14,3.25Zm-1,.11a4.2,4.2,0,0,0-.44-2,2.88,2.88,0,0,0-1.21-1.21,3.88,3.88,0,0,0-1.82-.4,2.19,2.19,0,0,0-.71.09v5.51a2.21,2.21,0,0,0,.1.85.67.67,0,0,0,.43.41,3.25,3.25,0,0,0,2.33-.25,2.4,2.4,0,0,0,1-1.09A4.74,4.74,0,0,0,1631.53,554.26Z"
              />
              <path
                d="M1722.18,541.91h-2.38v-.11l.21,0a1,1,0,0,0,.38-.11.45.45,0,0,0,.17-.31,5.73,5.73,0,0,0,0-.69v-2.16c0-.86-.33-1.28-1-1.27a1.65,1.65,0,0,0-.74.18,2.33,2.33,0,0,0-.65.48c0,.06,0,.15,0,.25s0,.2,0,.29v2.23a4,4,0,0,0,0,.69.44.44,0,0,0,.16.31,1.07,1.07,0,0,0,.39.11l.21,0v.11h-2.4v-.11l.22,0a1,1,0,0,0,.38-.11.44.44,0,0,0,.16-.31,4,4,0,0,0,0-.69v-2.16c0-.86-.34-1.28-1-1.27a1.65,1.65,0,0,0-.72.17,2.28,2.28,0,0,0-.63.45v2.81a4,4,0,0,0,0,.69.44.44,0,0,0,.16.31,1,1,0,0,0,.38.11l.22,0v.11h-2.39v-.11l.23,0a.9.9,0,0,0,.36-.11.47.47,0,0,0,.16-.32,3.89,3.89,0,0,0,0-.68v-2.51a1,1,0,0,0-.1-.54.73.73,0,0,0-.39-.25l-.31-.12v-.09l1.5-.35.1.07v.75a4.38,4.38,0,0,1,.8-.6,1.71,1.71,0,0,1,.89-.23,1.49,1.49,0,0,1,.91.24,1.2,1.2,0,0,1,.46.65,4.26,4.26,0,0,1,.84-.64,2,2,0,0,1,.92-.25c1,0,1.46.52,1.46,1.59v2.28a5.29,5.29,0,0,0,0,.69.44.44,0,0,0,.16.31.9.9,0,0,0,.37.11l.22,0Zm-9.77,2.28h-2.73v-.12l.27,0a1.35,1.35,0,0,0,.5-.12.42.42,0,0,0,.21-.31,3.7,3.7,0,0,0,0-.68v-1.65a3.5,3.5,0,0,1-.72.53,2.07,2.07,0,0,1-.91.21,2,2,0,0,1-1.09-.32,2.07,2.07,0,0,1-.72-.83,2.64,2.64,0,0,1-.26-1.17,3.28,3.28,0,0,1,.36-1.52,2.38,2.38,0,0,1,.92-1,2.47,2.47,0,0,1,1.3-.34,3.37,3.37,0,0,1,.82.09,3.2,3.2,0,0,1,.62.24l.4-.42h.08v6.17a4,4,0,0,0,0,.68.46.46,0,0,0,.18.31,1,1,0,0,0,.43.12l.25,0Zm-1.7-5.63a1.73,1.73,0,0,0-.36-1.14,1.19,1.19,0,0,0-.94-.39,1.47,1.47,0,0,0-1.19.53,2.44,2.44,0,0,0-.46,1.56,3.26,3.26,0,0,0,.22,1.24,1.94,1.94,0,0,0,.62.85,1.52,1.52,0,0,0,.94.32,1.71,1.71,0,0,0,.62-.11,1.83,1.83,0,0,0,.55-.34Zm-5.49,2a1.2,1.2,0,0,1-.28.8,1.72,1.72,0,0,1-.69.48,2.37,2.37,0,0,1-.88.16,3.59,3.59,0,0,1-.9-.1,3.71,3.71,0,0,1-.77-.27v-1h.31a1.63,1.63,0,0,0,.45.94,1.44,1.44,0,0,0,1,.3,1.2,1.2,0,0,0,.8-.26.9.9,0,0,0,.3-.7.78.78,0,0,0-.27-.66,3,3,0,0,0-1-.46,2.89,2.89,0,0,1-1.17-.6,1.23,1.23,0,0,1-.38-.94,1.37,1.37,0,0,1,.25-.78,1.51,1.51,0,0,1,.64-.49,2.05,2.05,0,0,1,.87-.18,2.78,2.78,0,0,1,.8.1,2.67,2.67,0,0,1,.62.24v1h-.31a1.88,1.88,0,0,0-.37-.9,1,1,0,0,0-.79-.31,1.13,1.13,0,0,0-.76.27.92.92,0,0,0-.29.7.81.81,0,0,0,.29.65,2.69,2.69,0,0,0,1,.45,3,3,0,0,1,1.23.62A1.21,1.21,0,0,1,1705.22,540.58Zm-9.11-3.32a4.29,4.29,0,0,1-.92,2.73,7.3,7.3,0,0,1-3.09,2.13L1692,542a6.85,6.85,0,0,0,2-1.33,3.6,3.6,0,0,0,.91-1.51,5.48,5.48,0,0,0,.21-1.69,4.21,4.21,0,0,0-.43-2.09,1.3,1.3,0,0,0-1.17-.7,1.09,1.09,0,0,0-1,.55,3,3,0,0,0-.32,1.49,3.66,3.66,0,0,0,.14,1,1.41,1.41,0,0,0,.45.74,1.29,1.29,0,0,0,.86.28,2.72,2.72,0,0,0,.62-.07l0,.14a3.23,3.23,0,0,1-.95.17,2.05,2.05,0,0,1-1.49-.56,2.12,2.12,0,0,1-.55-1.51,2.55,2.55,0,0,1,.32-1.25,2.39,2.39,0,0,1,.84-.86,2.3,2.3,0,0,1,1.18-.32,2.25,2.25,0,0,1,1.2.32,2.3,2.3,0,0,1,.87,1A3.48,3.48,0,0,1,1696.11,537.26Zm-6.52,2a2.39,2.39,0,0,1-.51,1.51,3.06,3.06,0,0,1-1.18.93,3.27,3.27,0,0,1-1.36.31,1.39,1.39,0,0,1-.75-.17.51.51,0,0,1-.26-.44.42.42,0,0,1,.14-.32.46.46,0,0,1,.31-.1.91.91,0,0,1,.54.17,2.41,2.41,0,0,1,.53.56,2.2,2.2,0,0,0,.94-.29,1.85,1.85,0,0,0,.69-.67,1.93,1.93,0,0,0,.28-1,1.41,1.41,0,0,0-.43-1.1,1.75,1.75,0,0,0-1.15-.35,2.07,2.07,0,0,0-.5.06,2.75,2.75,0,0,0-.5.18l-.1-.18a12.3,12.3,0,0,0,1.51-.94,2.57,2.57,0,0,0,.7-.73,1.32,1.32,0,0,0,.17-.68.91.91,0,0,0-.29-.69,1.29,1.29,0,0,0-.87-.28,2.06,2.06,0,0,0-1,.23,3.42,3.42,0,0,0-.84.63l-.1-.12a3.83,3.83,0,0,1,1.15-1,2.41,2.41,0,0,1,1.19-.29,1.67,1.67,0,0,1,1.08.32,1.17,1.17,0,0,1,.41.94,1.48,1.48,0,0,1-.39,1,5.29,5.29,0,0,1-1.24,1,2.18,2.18,0,0,1,1.31.45A1.45,1.45,0,0,1,1689.59,539.28Zm-5.48,2.63H1681v-.11l.42-.06a1.14,1.14,0,0,0,.49-.14.6.6,0,0,0,.24-.4,3.39,3.39,0,0,0,.07-.82v-4.09a3.78,3.78,0,0,0-.07-.8.5.5,0,0,0-.27-.34,1.55,1.55,0,0,0-.59-.08H1681V535a10.17,10.17,0,0,0,1-.22,7.77,7.77,0,0,0,.9-.31l.1.06v5.89a4.15,4.15,0,0,0,.06.82.63.63,0,0,0,.23.4,1,1,0,0,0,.45.14l.36.06Z"
              />
              <path
                d="M1722.21,557.81h-2.38v-.12l.21,0a.81.81,0,0,0,.38-.12.45.45,0,0,0,.17-.31,5.24,5.24,0,0,0,0-.68v-2.17c0-.85-.34-1.28-1-1.27a1.66,1.66,0,0,0-.75.18,2.33,2.33,0,0,0-.65.48c0,.07,0,.15,0,.25s0,.2,0,.3v2.23a5.24,5.24,0,0,0,0,.68.44.44,0,0,0,.16.31.9.9,0,0,0,.39.12l.21,0v.12h-2.39v-.12l.21,0a.81.81,0,0,0,.38-.12.45.45,0,0,0,.17-.31,5.66,5.66,0,0,0,0-.68v-2.17c0-.85-.33-1.28-1-1.27a1.69,1.69,0,0,0-.72.17,2.79,2.79,0,0,0-.63.45v2.82a3.89,3.89,0,0,0,0,.68.44.44,0,0,0,.16.31.9.9,0,0,0,.39.12l.21,0v.12h-2.39v-.12l.23,0a.76.76,0,0,0,.36-.12.41.41,0,0,0,.16-.31,4,4,0,0,0,0-.68V554a.91.91,0,0,0-.09-.53.72.72,0,0,0-.4-.26l-.31-.12V553l1.5-.36.1.07v.76a4.47,4.47,0,0,1,.8-.61,1.73,1.73,0,0,1,.89-.23,1.49,1.49,0,0,1,.91.24,1.24,1.24,0,0,1,.46.65,4.68,4.68,0,0,1,.84-.64,2,2,0,0,1,.93-.25c1,0,1.45.52,1.45,1.59v2.29a5.24,5.24,0,0,0,0,.68.48.48,0,0,0,.16.31.8.8,0,0,0,.37.12l.22,0Zm-9.76,2.27h-2.74V560l.28,0a1.29,1.29,0,0,0,.49-.12.4.4,0,0,0,.21-.31,2.92,2.92,0,0,0,0-.68v-1.64a3.55,3.55,0,0,1-.72.52,1.83,1.83,0,0,1-.91.21,1.89,1.89,0,0,1-1.09-.32,2,2,0,0,1-.72-.83,2.63,2.63,0,0,1-.25-1.16,3.2,3.2,0,0,1,.35-1.53,2.41,2.41,0,0,1,2.22-1.33,3.37,3.37,0,0,1,.82.09,3.65,3.65,0,0,1,.62.24l.41-.42h.07v6.17a3.89,3.89,0,0,0,0,.68.43.43,0,0,0,.18.31,1.05,1.05,0,0,0,.43.12l.26,0Zm-1.71-5.62a1.73,1.73,0,0,0-.35-1.15,1.22,1.22,0,0,0-1-.39,1.51,1.51,0,0,0-1.19.53,2.44,2.44,0,0,0-.46,1.56,3.23,3.23,0,0,0,.22,1.24,2,2,0,0,0,.62.85,1.47,1.47,0,0,0,.94.32,1.72,1.72,0,0,0,.62-.1,2.11,2.11,0,0,0,.55-.35Zm-5.48,2a1.2,1.2,0,0,1-.29.8,1.54,1.54,0,0,1-.69.48,2.37,2.37,0,0,1-.88.16,4.16,4.16,0,0,1-.9-.09,4.45,4.45,0,0,1-.77-.28v-1h.31a1.76,1.76,0,0,0,.45.94,1.44,1.44,0,0,0,1,.3,1.2,1.2,0,0,0,.8-.25.93.93,0,0,0,.31-.71.79.79,0,0,0-.28-.65,2.88,2.88,0,0,0-1-.47,2.89,2.89,0,0,1-1.17-.6,1.21,1.21,0,0,1-.38-.93,1.32,1.32,0,0,1,.25-.78,1.53,1.53,0,0,1,.64-.5,2.05,2.05,0,0,1,.87-.18,3.12,3.12,0,0,1,.8.1,2.51,2.51,0,0,1,.62.25v1h-.31a1.88,1.88,0,0,0-.37-.9,1,1,0,0,0-.79-.31,1.15,1.15,0,0,0-.76.27,1,1,0,0,0-.29.71.81.81,0,0,0,.3.65,2.72,2.72,0,0,0,1,.44,3.18,3.18,0,0,1,1.23.62A1.27,1.27,0,0,1,1705.26,556.47Zm-8.72-6.24-.33,1h-2.69l-.6,1.32a5.11,5.11,0,0,1,2.4.74,2,2,0,0,1,.82,1.73,2.76,2.76,0,0,1-.47,1.55,3.17,3.17,0,0,1-1.13,1,2.88,2.88,0,0,1-1.37.35,1.07,1.07,0,0,1-.7-.18.48.48,0,0,1-.21-.38c0-.28.18-.42.52-.44a1,1,0,0,1,.53.17,3.2,3.2,0,0,1,.56.48,2.4,2.4,0,0,0,1.28-.77,2.13,2.13,0,0,0,.51-1.4,1.6,1.6,0,0,0-.78-1.46,5.61,5.61,0,0,0-2.41-.64l-.09-.09,1.24-2.71h1.85a2.52,2.52,0,0,0,.6-.06.75.75,0,0,0,.39-.21Zm-5.53,0-.33,1H1688l-.6,1.32a5.2,5.2,0,0,1,2.41.74,2,2,0,0,1,.81,1.73,2.76,2.76,0,0,1-.47,1.55,3.09,3.09,0,0,1-1.13,1,2.88,2.88,0,0,1-1.37.35,1.07,1.07,0,0,1-.7-.18.48.48,0,0,1-.21-.38c0-.28.19-.42.53-.44a.92.92,0,0,1,.52.17,3.2,3.2,0,0,1,.56.48,2.43,2.43,0,0,0,1.29-.77,2.12,2.12,0,0,0,.5-1.4,1.6,1.6,0,0,0-.78-1.46,5.61,5.61,0,0,0-2.41-.64l-.09-.09,1.24-2.71h1.85a2.52,2.52,0,0,0,.6-.06.75.75,0,0,0,.39-.21Zm-5.9,7.58H1682v-.12l.42-.05a1.13,1.13,0,0,0,.49-.15.55.55,0,0,0,.24-.39,3.54,3.54,0,0,0,.07-.83v-4.09a3.67,3.67,0,0,0-.07-.79.5.5,0,0,0-.27-.35,1.4,1.4,0,0,0-.59-.07H1682v-.12a8,8,0,0,0,1-.22c.34-.1.65-.2.9-.3l.1,0v5.89a4.34,4.34,0,0,0,.06.83.58.58,0,0,0,.23.39,1,1,0,0,0,.45.15l.37.05Z"
              />
              <path
                d="M1789.29,541.42a3.21,3.21,0,0,1-.59.42,1.41,1.41,0,0,1-.69.16c-.71,0-1.07-.37-1.07-1.12v-3.57h-.75v-.08l.76-.27.65-1.6h.14V537h1.46v.36h-1.46v3.44c0,.56.24.84.71.84a.94.94,0,0,0,.39-.07,1.51,1.51,0,0,0,.37-.2Zm-3.23-6.85a.55.55,0,0,1-.13.36.44.44,0,0,1-.33.19.7.7,0,0,1-.45-.2,3.5,3.5,0,0,1-.45-.55,1.12,1.12,0,0,0-.74.57,2.84,2.84,0,0,0-.25,1.36V537h1.21v.36h-1.21v3.34a3.74,3.74,0,0,0,0,.69.42.42,0,0,0,.21.31,1.62,1.62,0,0,0,.5.11l.27,0v.11h-2.62v-.11l.23,0a.9.9,0,0,0,.36-.11.43.43,0,0,0,.16-.32,3.89,3.89,0,0,0,0-.68v-3.34h-.84v-.08l.84-.27v-.14a3.06,3.06,0,0,1,.32-1.33,2.69,2.69,0,0,1,.83-1,2.07,2.07,0,0,1,1.23-.41,1.14,1.14,0,0,1,.57.15A.42.42,0,0,1,1786.06,534.57Zm-5.08,9.62h-2.73v-.12l.27,0a1.35,1.35,0,0,0,.5-.12.42.42,0,0,0,.21-.31,3.7,3.7,0,0,0,0-.68v-1.65a3.5,3.5,0,0,1-.72.53,2.07,2.07,0,0,1-.91.21,2,2,0,0,1-1.09-.32,2.07,2.07,0,0,1-.72-.83,2.64,2.64,0,0,1-.26-1.17,3.28,3.28,0,0,1,.36-1.52,2.38,2.38,0,0,1,.92-1,2.47,2.47,0,0,1,1.3-.34,3.37,3.37,0,0,1,.82.09,3.2,3.2,0,0,1,.62.24l.4-.42h.08v6.17a4,4,0,0,0,0,.68.46.46,0,0,0,.18.31,1,1,0,0,0,.43.12l.25,0Zm-1.7-5.63a1.73,1.73,0,0,0-.36-1.14,1.19,1.19,0,0,0-.94-.39,1.47,1.47,0,0,0-1.19.53,2.44,2.44,0,0,0-.46,1.56,3.26,3.26,0,0,0,.22,1.24,1.94,1.94,0,0,0,.62.85,1.52,1.52,0,0,0,.94.32,1.71,1.71,0,0,0,.62-.11,1.83,1.83,0,0,0,.55-.34Zm-5.59,2a1.25,1.25,0,0,1-.28.8,1.83,1.83,0,0,1-.7.48,2.37,2.37,0,0,1-.88.16,3.59,3.59,0,0,1-.9-.1,3.71,3.71,0,0,1-.77-.27v-1h.31a1.76,1.76,0,0,0,.45.94,1.44,1.44,0,0,0,1,.3,1.2,1.2,0,0,0,.8-.26.9.9,0,0,0,.31-.7.84.84,0,0,0-.27-.66,3.07,3.07,0,0,0-1-.46,2.89,2.89,0,0,1-1.17-.6,1.23,1.23,0,0,1-.38-.94,1.45,1.45,0,0,1,.25-.78,1.57,1.57,0,0,1,.64-.49,2.05,2.05,0,0,1,.87-.18,2.8,2.8,0,0,1,.81.1,2.59,2.59,0,0,1,.61.24v1h-.31a1.79,1.79,0,0,0-.37-.9,1,1,0,0,0-.79-.31,1.15,1.15,0,0,0-.76.27.92.92,0,0,0-.28.7.78.78,0,0,0,.29.65,2.54,2.54,0,0,0,.95.45,2.91,2.91,0,0,1,1.23.62A1.18,1.18,0,0,1,1773.69,540.58Zm-9-1a2.58,2.58,0,0,1-.33,1.25,2.39,2.39,0,0,1-.84.86,2.28,2.28,0,0,1-3.24-1,3.51,3.51,0,0,1-.33-1.52,4.29,4.29,0,0,1,.91-2.74,7.51,7.51,0,0,1,3.09-2.12l.08.16a6.72,6.72,0,0,0-2,1.33,3.72,3.72,0,0,0-.91,1.5,5.55,5.55,0,0,0-.2,1.7,4.1,4.1,0,0,0,.43,2.09,1.29,1.29,0,0,0,1.16.7,1.1,1.1,0,0,0,1-.55,2.91,2.91,0,0,0,.32-1.5,3.6,3.6,0,0,0-.13-1,1.55,1.55,0,0,0-.45-.74,1.38,1.38,0,0,0-.87-.29,2.15,2.15,0,0,0-.61.08l0-.14a3,3,0,0,1,1-.17,2,2,0,0,1,1.5.56A2.12,2.12,0,0,1,1764.68,539.61Zm-6.82-2.35A4.28,4.28,0,0,1,1757,540a7.43,7.43,0,0,1-3.09,2.13l-.08-.16a6.92,6.92,0,0,0,2-1.33,3.82,3.82,0,0,0,.91-1.51,5.48,5.48,0,0,0,.2-1.69,4.1,4.1,0,0,0-.43-2.09,1.29,1.29,0,0,0-1.16-.7,1.08,1.08,0,0,0-1,.55,2.87,2.87,0,0,0-.32,1.49,3.68,3.68,0,0,0,.13,1,1.55,1.55,0,0,0,.45.74,1.29,1.29,0,0,0,.86.28,2.65,2.65,0,0,0,.62-.07l0,.14a3.22,3.22,0,0,1-.94.17,2.08,2.08,0,0,1-1.5-.56,2.12,2.12,0,0,1-.55-1.51,2.55,2.55,0,0,1,.33-1.25,2.39,2.39,0,0,1,.84-.86,2.23,2.23,0,0,1,1.17-.32,2.23,2.23,0,0,1,2.07,1.27A3.48,3.48,0,0,1,1757.86,537.26Zm-6.09,2.54h-1.17V542h-.78V539.8h-3.33l-.08-.11,3.8-5.14h.39v4.9h1.17Zm-2-.35v-4l-2.94,4Zm-4.16,2.46h-3.15v-.11l.42-.06a1.14,1.14,0,0,0,.49-.14.6.6,0,0,0,.24-.4,3.39,3.39,0,0,0,.07-.82v-4.09a3.78,3.78,0,0,0-.07-.8.5.5,0,0,0-.27-.34,1.55,1.55,0,0,0-.59-.08h-.29V535a10.17,10.17,0,0,0,1-.22,7.77,7.77,0,0,0,.9-.31l.1.06v5.89a4.15,4.15,0,0,0,.06.82.63.63,0,0,0,.23.4,1,1,0,0,0,.45.14l.37.06Z"
              />
              <path
                d="M1789.26,557.32a2.73,2.73,0,0,1-.59.41,1.41,1.41,0,0,1-.69.16c-.71,0-1.07-.37-1.07-1.12v-3.56h-.75v-.09l.76-.26.65-1.61h.13v1.59h1.46v.37h-1.46v3.43c0,.56.25.84.72.85a1.13,1.13,0,0,0,.39-.07,1.68,1.68,0,0,0,.36-.21Zm-3.23-6.85a.59.59,0,0,1-.13.36.46.46,0,0,1-.34.18.68.68,0,0,1-.44-.2,3.08,3.08,0,0,1-.45-.55,1.18,1.18,0,0,0-.74.57,2.84,2.84,0,0,0-.25,1.36v.65h1.21v.37h-1.21v3.34a3,3,0,0,0,0,.68.42.42,0,0,0,.21.31,1.29,1.29,0,0,0,.49.12l.28,0v.12h-2.62v-.12l.23,0a.76.76,0,0,0,.36-.12.44.44,0,0,0,.16-.31,4,4,0,0,0,0-.68v-3.34H1782v-.09l.84-.26v-.14a3.25,3.25,0,0,1,.31-1.34,2.81,2.81,0,0,1,.84-1,2.11,2.11,0,0,1,1.23-.41,1,1,0,0,1,.56.16A.41.41,0,0,1,1786,550.47Zm-5.08,9.61h-2.74V560l.28,0a1.35,1.35,0,0,0,.5-.12.4.4,0,0,0,.21-.31,3.62,3.62,0,0,0,0-.68v-1.64a3.85,3.85,0,0,1-.72.52,1.85,1.85,0,0,1-.91.21,1.89,1.89,0,0,1-1.09-.32,2,2,0,0,1-.72-.83,2.63,2.63,0,0,1-.26-1.16,3.45,3.45,0,0,1,.35-1.53,2.66,2.66,0,0,1,.92-1,2.54,2.54,0,0,1,1.31-.34,3.23,3.23,0,0,1,.81.09,3.78,3.78,0,0,1,.63.24l.4-.42h.08v6.17a3.89,3.89,0,0,0,0,.68.43.43,0,0,0,.18.31,1,1,0,0,0,.43.12l.25,0Zm-1.7-5.62a1.74,1.74,0,0,0-.36-1.15,1.19,1.19,0,0,0-.94-.39,1.5,1.5,0,0,0-1.19.53,2.38,2.38,0,0,0-.46,1.56,3.23,3.23,0,0,0,.22,1.24,1.94,1.94,0,0,0,.61.85,1.49,1.49,0,0,0,.95.32,1.72,1.72,0,0,0,.62-.1,2.28,2.28,0,0,0,.55-.35Zm-5.81,2a1.2,1.2,0,0,1-.28.8,1.54,1.54,0,0,1-.69.48,2.37,2.37,0,0,1-.88.16,3.47,3.47,0,0,1-1.67-.37v-1h.31a1.63,1.63,0,0,0,.45.94,1.44,1.44,0,0,0,1,.3,1.15,1.15,0,0,0,.79-.25.89.89,0,0,0,.31-.71.76.76,0,0,0-.27-.65,3,3,0,0,0-1-.47,2.91,2.91,0,0,1-1.16-.6,1.21,1.21,0,0,1-.38-.93,1.32,1.32,0,0,1,.25-.78,1.56,1.56,0,0,1,.63-.5,2.13,2.13,0,0,1,.88-.18,3.18,3.18,0,0,1,.8.1,2.43,2.43,0,0,1,.61.25v1h-.31a1.88,1.88,0,0,0-.36-.9,1,1,0,0,0-.8-.31,1.1,1.1,0,0,0-.75.27,1,1,0,0,0-.29.71.83.83,0,0,0,.29.65,2.88,2.88,0,0,0,1,.44,3.18,3.18,0,0,1,1.23.62A1.22,1.22,0,0,1,1773.44,556.47Zm-9-.51a1.74,1.74,0,0,1-.33,1,2,2,0,0,1-.84.69,2.86,2.86,0,0,1-1.18.24,2.73,2.73,0,0,1-1.08-.2,2,2,0,0,1-.82-.6,1.5,1.5,0,0,1-.33-.93,1.85,1.85,0,0,1,.41-1.21,3.78,3.78,0,0,1,1.26-.9,2.52,2.52,0,0,1-1.06-.77,1.81,1.81,0,0,1-.39-1.19,1.59,1.59,0,0,1,.59-1.25,2.4,2.4,0,0,1,1.56-.52,2.25,2.25,0,0,1,1.43.47,1.49,1.49,0,0,1,.57,1.13,1.57,1.57,0,0,1-.41,1,3.22,3.22,0,0,1-1.09.78,3.52,3.52,0,0,1,1.31.92A1.89,1.89,0,0,1,1764.42,556Zm-1-3.86a1.71,1.71,0,0,0-.35-1.14,1.35,1.35,0,0,0-1.07-.43,1.28,1.28,0,0,0-1,.39,1.42,1.42,0,0,0-.36,1,1.32,1.32,0,0,0,.41,1,4.93,4.93,0,0,0,1.42.83,1.94,1.94,0,0,0,.67-.63A1.8,1.8,0,0,0,1763.43,552.1Zm.32,4.1a1.39,1.39,0,0,0-.43-1.09,5.37,5.37,0,0,0-1.61-.94,2,2,0,0,0-.81.8,2.3,2.3,0,0,0-.23,1.1,1.78,1.78,0,0,0,.43,1.25,1.67,1.67,0,0,0,2.24,0A1.62,1.62,0,0,0,1763.75,556.2Zm-5.49-.7a2.55,2.55,0,0,1-.33,1.25,2.39,2.39,0,0,1-.84.86,2.37,2.37,0,0,1-2.38,0,2.27,2.27,0,0,1-.86-1,3.22,3.22,0,0,1-.33-1.52,4.28,4.28,0,0,1,.91-2.73,7.43,7.43,0,0,1,3.09-2.13l.07.16a7,7,0,0,0-2,1.33,3.71,3.71,0,0,0-.91,1.51,5.8,5.8,0,0,0-.21,1.69,4.28,4.28,0,0,0,.43,2.1,1.31,1.31,0,0,0,1.17.69,1.09,1.09,0,0,0,1-.55,3,3,0,0,0,.32-1.49,3.68,3.68,0,0,0-.13-1,1.55,1.55,0,0,0-.45-.74,1.33,1.33,0,0,0-.87-.28,2.3,2.3,0,0,0-.62.07l0-.14a3.29,3.29,0,0,1,1-.17,2.08,2.08,0,0,1,1.5.56A2.12,2.12,0,0,1,1758.26,555.5Zm-6.5,0a2.55,2.55,0,0,1-.33,1.25,2.39,2.39,0,0,1-.84.86,2.37,2.37,0,0,1-2.38,0,2.27,2.27,0,0,1-.86-1,3.48,3.48,0,0,1-.33-1.52,4.28,4.28,0,0,1,.91-2.73,7.43,7.43,0,0,1,3.09-2.13l.08.16a6.92,6.92,0,0,0-2,1.33,3.82,3.82,0,0,0-.91,1.51,5.48,5.48,0,0,0-.2,1.69,4.17,4.17,0,0,0,.43,2.1,1.3,1.3,0,0,0,1.16.69,1.08,1.08,0,0,0,1-.55,2.87,2.87,0,0,0,.32-1.49,3.68,3.68,0,0,0-.13-1,1.55,1.55,0,0,0-.45-.74,1.29,1.29,0,0,0-.86-.28,2.21,2.21,0,0,0-.62.07l0-.14a3.22,3.22,0,0,1,.94-.17,2.08,2.08,0,0,1,1.5.56A2.12,2.12,0,0,1,1751.76,555.5Zm-6.35,2.31h-3.14v-.12l.41-.05a1.18,1.18,0,0,0,.5-.15.55.55,0,0,0,.24-.39,4.34,4.34,0,0,0,.06-.83v-4.09a3.12,3.12,0,0,0-.07-.79.45.45,0,0,0-.27-.35,1.35,1.35,0,0,0-.58-.07h-.29v-.12a7.91,7.91,0,0,0,1-.22c.35-.1.65-.2.91-.3l.09,0v5.89a3.54,3.54,0,0,0,.07.83.58.58,0,0,0,.23.39,1,1,0,0,0,.45.15l.36.05Z"
              />
              <path
                class="cls-7"
                d="M1483.29,546.87a8.48,8.48,0,0,0,8.19-8.44,8.32,8.32,0,1,0-16.63,0A8.53,8.53,0,0,0,1483.29,546.87Z"
              />
              <line
                class="cls-6"
                x1="1733.19"
                y1="534.21"
                x2="1733.19"
                y2="542.16"
              />
              <line
                class="cls-6"
                x1="1733.19"
                y1="549.85"
                x2="1733.19"
                y2="557.79"
              />
              <path
                class="cls-8"
                d="M1483.29,338.66a8.44,8.44,0,1,0-8.44-8.43A8.31,8.31,0,0,0,1483.29,338.66Z"
              />
              <path
                class="cls-9"
                d="M1483.29,380.85a8.44,8.44,0,1,0-8.44-8.44A8.31,8.31,0,0,0,1483.29,380.85Z"
              />
            </g>
            <g id="Unit">
              <g id="BP3" @click="setimgpop('BP3')">
                <path
                  class="cls-9"
                  d="M400.38,576.44H454v20.47h-53.6Zm0-20.47H454v20.47h-53.6Zm0-20.47H454V556h-53.6Zm0-20.2H454v20.2h-53.6Zm0-20.47H454V515.3h-53.6Zm0-20.47H454v20.47h-53.6Zm0-20.2H454v20.2h-53.6Zm0-20.47H454v20.47h-53.6Zm0-20.47H454v20.47h-53.6Zm0-20.2H454v20.2h-53.6Zm0-20.47H454V393h-53.6Zm0-20.47H454v20.47h-53.6Zm0-20.47H454v20.47h-53.6Zm0-20.2H454v20.2h-53.6Zm0-20.47H454v20.47h-53.6Zm0-20.47H454v20.47h-53.6Zm0-20.2H454v20.2h-53.6Zm0-20.47H454v20.47h-53.6Zm0-20.47H454V229.8h-53.6Z"
                />
                <text class="cls-10" transform="translate(416.5 223.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(416.5 243.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(416.5 263.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(416.5 284.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(416.5 304.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(416.5 325.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(416.5 345.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(416.5 366.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(416.5 387.16)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(416.5 406.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(416.5 427.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(416.5 447.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(416.5 468.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(416.5 488.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(416.5 508.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(416.5 528.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(416.5 549.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(416.5 570.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(416.5 590.66)">
                  BP3
                </text>
                <path
                  class="cls-9"
                  d="M1363.66,576.44h53.6v20.47h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6V556h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6V515.3h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6V393h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6V229.8h-53.6Z"
                />
                <text class="cls-10" transform="translate(1379.5 223.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(1379.5 243.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(1379.5 263.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(1379.5 284.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(1379.5 304.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(1379.5 325.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(1379.5 345.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(1379.5 366.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(1379.5 387.16)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(1379.5 406.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(1379.5 427.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(1379.5 447.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(1379.5 468.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(1379.5 488.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(1379.5 508.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(1379.5 528.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(1379.5 549.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(1379.5 570.66)">
                  BP3
                </text>
                <text class="cls-10" transform="translate(1379.5 590.66)">
                  BP3
                </text>
              </g>
              <g id="BP3-PH" @click="setimgpop('BP3-PH')">
                <rect
                  class="cls-9"
                  x="400.38"
                  y="177.01"
                  width="53.6"
                  height="32.32"
                />
                <text class="cls-10" transform="translate(405.99 197.19)">
                  BP3-PH
                </text>
                <rect
                  class="cls-9"
                  x="1363.66"
                  y="177.01"
                  width="53.6"
                  height="32.32"
                />
                <text class="cls-10" transform="translate(1368.99 197.19)">
                  BP3-PH
                </text>
              </g>
              <g id="BP1" @click="setimgpop('BP1')">
                <rect
                  class="cls-9"
                  x="577.34"
                  y="576.44"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="577.34"
                  y="555.97"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="577.34"
                  y="535.5"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="577.34"
                  y="515.3"
                  width="53.6"
                  height="20.2"
                />
                <rect
                  class="cls-9"
                  x="577.34"
                  y="494.83"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="577.34"
                  y="474.36"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="577.34"
                  y="454.16"
                  width="53.6"
                  height="20.2"
                />
                <rect
                  class="cls-9"
                  x="577.34"
                  y="433.69"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="577.34"
                  y="413.22"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="577.34"
                  y="393.02"
                  width="53.6"
                  height="20.2"
                />
                <rect
                  class="cls-9"
                  x="577.34"
                  y="372.55"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="577.34"
                  y="352.08"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="577.34"
                  y="270.47"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="577.34"
                  y="250.27"
                  width="53.6"
                  height="20.2"
                />
                <rect
                  class="cls-9"
                  x="577.34"
                  y="229.8"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="577.34"
                  y="209.33"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="577.34"
                  y="177.01"
                  width="53.6"
                  height="32.32"
                />
                <text class="cls-10" transform="translate(593.5 223.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(593.5 197.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(593.5 243.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(593.5 263.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(593.5 284.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(593.5 366.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(593.5 387.16)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(593.5 406.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(593.5 427.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(593.5 447.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(593.5 468.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(593.5 488.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(593.5 508.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(593.5 528.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(593.5 549.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(593.5 570.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(593.5 590.66)">
                  BP1
                </text>
                <rect
                  class="cls-9"
                  x="1186.7"
                  y="576.44"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="1186.7"
                  y="555.97"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="1186.7"
                  y="535.5"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="1186.7"
                  y="515.3"
                  width="53.6"
                  height="20.2"
                />
                <rect
                  class="cls-9"
                  x="1186.7"
                  y="494.83"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="1186.7"
                  y="474.36"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="1186.7"
                  y="454.16"
                  width="53.6"
                  height="20.2"
                />
                <rect
                  class="cls-9"
                  x="1186.7"
                  y="433.69"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="1186.7"
                  y="413.22"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="1186.7"
                  y="393.02"
                  width="53.6"
                  height="20.2"
                />
                <rect
                  class="cls-9"
                  x="1186.7"
                  y="372.55"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="1186.7"
                  y="352.08"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="1186.7"
                  y="270.47"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="1186.7"
                  y="250.27"
                  width="53.6"
                  height="20.2"
                />
                <rect
                  class="cls-9"
                  x="1186.7"
                  y="229.8"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="1186.7"
                  y="209.33"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="1186.7"
                  y="177.01"
                  width="53.6"
                  height="32.32"
                />
                <text class="cls-10" transform="translate(1204.5 223.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(1204.5 197.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(1204.5 243.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(1204.5 263.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(1204.5 284.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(1204.5 366.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(1204.5 387.16)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(1204.5 406.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(1204.5 427.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(1204.5 447.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(1204.5 468.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(1204.5 488.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(1204.5 508.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(1204.5 528.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(1204.5 549.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(1204.5 570.66)">
                  BP1
                </text>
                <text class="cls-10" transform="translate(1204.5 590.66)">
                  BP1
                </text>
              </g>
              <g id="A1" @click="setimgpop('A1')">
                <path
                  class="cls-8"
                  d="M507.58,576.44h53.33v20.47H507.58Zm0-20.47h53.33v20.47H507.58Zm0-20.47h53.33V556H507.58Zm0-20.2h53.33v20.2H507.58Zm0-20.47h53.33V515.3H507.58Zm0-20.47h53.33v20.47H507.58Zm0-20.2h53.33v20.2H507.58Zm0-20.47h53.33v20.47H507.58Zm0-20.47h53.33v20.47H507.58Zm0-20.2h53.33v20.2H507.58Zm0-20.47h53.33V393H507.58Zm0-20.47h53.33v20.47H507.58Zm0-20.47h53.33v20.47H507.58Zm0-20.2h53.33v20.2H507.58Zm0-20.47h53.33v20.47H507.58Zm0-20.47h53.33v20.47H507.58Zm0-20.2h53.33v20.2H507.58Zm0-20.47h53.33v20.47H507.58Zm0-20.47h53.33V229.8H507.58Zm0-32.32h53.33v32.32H507.58Z"
                />
                <text class="cls-10" transform="translate(526.69 223.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(526.69 197.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(526.69 243.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(526.69 263.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(526.69 284.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(526.69 304.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(526.69 325.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(526.69 345.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(526.69 366.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(526.69 387.16)">
                  A1
                </text>
                <text class="cls-10" transform="translate(526.69 406.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(526.69 427.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(526.69 447.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(526.69 468.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(526.69 488.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(526.69 508.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(526.69 528.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(526.69 549.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(526.69 570.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(526.69 590.66)">
                  A1
                </text>
                <path
                  class="cls-8"
                  d="M1256.73,576.44h53.33v20.47h-53.33Zm0-20.47h53.33v20.47h-53.33Zm0-20.47h53.33V556h-53.33Zm0-20.2h53.33v20.2h-53.33Zm0-20.47h53.33V515.3h-53.33Zm0-20.47h53.33v20.47h-53.33Zm0-20.2h53.33v20.2h-53.33Zm0-20.47h53.33v20.47h-53.33Zm0-20.47h53.33v20.47h-53.33Zm0-20.2h53.33v20.2h-53.33Zm0-20.47h53.33V393h-53.33Zm0-20.47h53.33v20.47h-53.33Zm0-20.47h53.33v20.47h-53.33Zm0-20.2h53.33v20.2h-53.33Zm0-20.47h53.33v20.47h-53.33Zm0-20.47h53.33v20.47h-53.33Zm0-20.2h53.33v20.2h-53.33Zm0-20.47h53.33v20.47h-53.33Zm0-20.47h53.33V229.8h-53.33Zm0-32.32h53.33v32.32h-53.33Z"
                />
                <text class="cls-10" transform="translate(1276.69 223.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(1276.69 197.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(1276.69 243.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(1276.69 263.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(1276.69 284.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(1276.69 304.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(1276.69 325.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(1276.69 345.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(1276.69 366.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(1276.69 387.16)">
                  A1
                </text>
                <text class="cls-10" transform="translate(1276.69 406.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(1276.69 427.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(1276.69 447.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(1276.69 468.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(1276.69 488.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(1276.69 508.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(1276.69 528.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(1276.69 549.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(1276.69 570.66)">
                  A1
                </text>
                <text class="cls-10" transform="translate(1276.69 590.66)">
                  A1
                </text>
              </g>
              <g id="BP2" @click="setimgpop('BP2')">
                <path
                  class="cls-9"
                  d="M206.88,576.44h53.6v20.47h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6V556h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6V515.3h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-81.61h53.6V393h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-81.61h53.6V229.8h-53.6Z"
                />
                <text class="cls-10" transform="translate(223.5 223.66)">
                  BP2
                </text>
                <text class="cls-10" transform="translate(223.5 304.66)">
                  BP2
                </text>
                <text class="cls-10" transform="translate(223.5 325.66)">
                  BP2
                </text>
                <text class="cls-10" transform="translate(223.5 345.66)">
                  BP2
                </text>
                <text class="cls-10" transform="translate(223.5 366.66)">
                  BP2
                </text>
                <text class="cls-10" transform="translate(223.5 387.16)">
                  BP2
                </text>
                <text class="cls-10" transform="translate(223.5 468.66)">
                  BP2
                </text>
                <text class="cls-10" transform="translate(223.5 488.66)">
                  BP2
                </text>
                <text class="cls-10" transform="translate(223.5 508.66)">
                  BP2
                </text>
                <text class="cls-10" transform="translate(223.5 528.66)">
                  BP2
                </text>
                <text class="cls-10" transform="translate(223.5 549.66)">
                  BP2
                </text>
                <text class="cls-10" transform="translate(223.5 570.66)">
                  BP2
                </text>
                <text class="cls-10" transform="translate(223.5 590.66)">
                  BP2
                </text>
                <path
                  class="cls-9"
                  d="M849.64,576.44h53.6v20.47h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6V556h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6V515.3h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-81.61h53.6V393h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-81.61h53.6V229.8h-53.6Z"
                />
                <text class="cls-10" transform="translate(866.5 223.66)">
                  BP2
                </text>
                <text class="cls-10" transform="translate(866.5 304.66)">
                  BP2
                </text>
                <text class="cls-10" transform="translate(866.5 325.66)">
                  BP2
                </text>
                <text class="cls-10" transform="translate(866.5 345.66)">
                  BP2
                </text>
                <text class="cls-10" transform="translate(866.5 366.66)">
                  BP2
                </text>
                <text class="cls-10" transform="translate(866.5 387.16)">
                  BP2
                </text>
                <text class="cls-10" transform="translate(866.5 468.66)">
                  BP2
                </text>
                <text class="cls-10" transform="translate(866.5 488.66)">
                  BP2
                </text>
                <text class="cls-10" transform="translate(866.5 508.66)">
                  BP2
                </text>
                <text class="cls-10" transform="translate(866.5 528.66)">
                  BP2
                </text>
                <text class="cls-10" transform="translate(866.5 549.66)">
                  BP2
                </text>
                <text class="cls-10" transform="translate(866.5 570.66)">
                  BP2
                </text>
                <text class="cls-10" transform="translate(866.5 590.66)">
                  BP2
                </text>
              </g>
              <g id="DP1-PH" @click="setimgpop('DP1-PH')">
                <rect
                  class="cls-7"
                  x="260.48"
                  y="177.01"
                  width="70.3"
                  height="32.32"
                />
                <text class="cls-10" transform="translate(273.66 197.19)">
                  DP1-PH
                </text>
                <rect
                  class="cls-7"
                  x="779.34"
                  y="177.01"
                  width="70.3"
                  height="32.32"
                />
                <text class="cls-10" transform="translate(793.66 197.19)">
                  DP1-PH
                </text>
              </g>
              <g id="DP1" @click="setimgpop('DP1')">
                <path
                  class="cls-7"
                  d="M260.48,576.44h70.3v20.47h-70.3Zm0-20.47h70.3v20.47h-70.3Zm0-20.47h70.3V556h-70.3Zm0-20.2h70.3v20.2h-70.3Zm0-20.47h70.3V515.3h-70.3Zm0-20.47h70.3v20.47h-70.3Zm0-20.2h70.3v20.2h-70.3Zm0-20.47h70.3v20.47h-70.3Zm0-20.47h70.3v20.47h-70.3Zm0-20.2h70.3v20.2h-70.3Zm0-20.47h70.3V393h-70.3Zm0-20.47h70.3v20.47h-70.3Zm0-20.47h70.3v20.47h-70.3Zm0-20.2h70.3v20.2h-70.3Zm0-20.47h70.3v20.47h-70.3Zm0-20.47h70.3v20.47h-70.3Zm0-20.2h70.3v20.2h-70.3Zm0-20.47h70.3v20.47h-70.3Zm0-20.47h70.3V229.8h-70.3Z"
                />
                <text class="cls-10" transform="translate(285.17 223.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(285.17 243.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(285.17 263.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(285.17 284.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(285.17 304.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(285.17 325.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(285.17 345.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(285.17 366.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(285.17 387.16)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(285.17 406.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(285.17 427.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(285.17 447.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(285.17 468.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(285.17 488.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(285.17 508.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(285.17 528.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(285.17 549.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(285.17 570.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(285.17 590.66)">
                  DP1
                </text>
                <path
                  class="cls-7"
                  d="M779.34,576.44h70.3v20.47h-70.3Zm0-20.47h70.3v20.47h-70.3Zm0-20.47h70.3V556h-70.3Zm0-20.2h70.3v20.2h-70.3Zm0-20.47h70.3V515.3h-70.3Zm0-20.47h70.3v20.47h-70.3Zm0-20.2h70.3v20.2h-70.3Zm0-20.47h70.3v20.47h-70.3Zm0-20.47h70.3v20.47h-70.3Zm0-20.2h70.3v20.2h-70.3Zm0-20.47h70.3V393h-70.3Zm0-20.47h70.3v20.47h-70.3Zm0-20.47h70.3v20.47h-70.3Zm0-20.2h70.3v20.2h-70.3Zm0-20.47h70.3v20.47h-70.3Zm0-20.47h70.3v20.47h-70.3Zm0-20.2h70.3v20.2h-70.3Zm0-20.47h70.3v20.47h-70.3Zm0-20.47h70.3V229.8h-70.3Z"
                />
                <text class="cls-10" transform="translate(804.17 223.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(804.17 243.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(804.17 263.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(804.17 284.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(804.17 304.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(804.17 325.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(804.17 345.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(804.17 366.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(804.17 387.16)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(804.17 406.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(804.17 427.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(804.17 447.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(804.17 468.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(804.17 488.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(804.17 508.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(804.17 528.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(804.17 549.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(804.17 570.66)">
                  DP1
                </text>
                <text class="cls-10" transform="translate(804.17 590.66)">
                  DP1
                </text>
              </g>
              <g id="A2" @click="setimgpop('A2')">
                <path
                  class="cls-8"
                  d="M153.28,576.44h53.6v20.47h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6V556h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6V515.3h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6V393h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6V229.8h-53.6Z"
                />
                <text class="cls-10" transform="translate(172.69 223.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(172.69 243.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(172.69 263.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(172.69 284.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(172.69 304.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(172.69 325.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(172.69 345.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(172.69 366.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(172.69 387.16)">
                  A2
                </text>
                <text class="cls-10" transform="translate(172.69 406.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(172.69 427.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(172.69 447.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(172.69 468.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(172.69 488.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(172.69 508.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(172.69 528.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(172.69 549.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(172.69 570.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(172.69 590.66)">
                  A2
                </text>
                <path
                  class="cls-8"
                  d="M903.24,576.44h53.33v20.47H903.24Zm0-20.47h53.33v20.47H903.24Zm0-20.47h53.33V556H903.24Zm0-20.2h53.33v20.2H903.24Zm0-20.47h53.33V515.3H903.24Zm0-20.47h53.33v20.47H903.24Zm0-20.2h53.33v20.2H903.24Zm0-20.47h53.33v20.47H903.24Zm0-20.47h53.33v20.47H903.24Zm0-20.2h53.33v20.2H903.24Zm0-20.47h53.33V393H903.24Zm0-20.47h53.33v20.47H903.24Zm0-20.47h53.33v20.47H903.24Zm0-20.2h53.33v20.2H903.24Zm0-20.47h53.33v20.47H903.24Zm0-20.47h53.33v20.47H903.24Zm0-20.2h53.33v20.2H903.24Zm0-20.47h53.33v20.47H903.24Zm0-20.47h53.33V229.8H903.24Z"
                />
                <text class="cls-10" transform="translate(922.69 223.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(922.69 243.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(922.69 263.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(922.69 284.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(922.69 304.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(922.69 325.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(922.69 345.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(922.69 366.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(922.69 387.16)">
                  A2
                </text>
                <text class="cls-10" transform="translate(922.69 406.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(922.69 427.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(922.69 447.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(922.69 468.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(922.69 488.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(922.69 508.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(922.69 528.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(922.69 549.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(922.69 570.66)">
                  A2
                </text>
                <text class="cls-10" transform="translate(922.69 590.66)">
                  A2
                </text>
              </g>
              <g id="B1" @click="setimgpop('B1')">
                <rect
                  class="cls-9"
                  x="99.68"
                  y="576.44"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="99.68"
                  y="555.97"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="99.68"
                  y="535.5"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="99.68"
                  y="515.3"
                  width="53.6"
                  height="20.2"
                />
                <rect
                  class="cls-9"
                  x="99.68"
                  y="494.83"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="99.68"
                  y="474.36"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="99.68"
                  y="454.16"
                  width="53.6"
                  height="20.2"
                />
                <rect
                  class="cls-9"
                  x="99.68"
                  y="433.69"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="99.68"
                  y="413.22"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="99.68"
                  y="393.02"
                  width="53.6"
                  height="20.2"
                />
                <rect
                  class="cls-9"
                  x="99.68"
                  y="372.55"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="99.68"
                  y="352.08"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="99.68"
                  y="331.61"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="99.68"
                  y="311.41"
                  width="53.6"
                  height="20.2"
                />
                <rect
                  class="cls-9"
                  x="99.68"
                  y="290.94"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="99.68"
                  y="270.47"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="99.68"
                  y="250.27"
                  width="53.6"
                  height="20.2"
                />
                <rect
                  class="cls-9"
                  x="99.68"
                  y="229.8"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="99.68"
                  y="209.33"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="99.68"
                  y="177.01"
                  width="53.6"
                  height="32.32"
                />
                <text class="cls-10" transform="translate(119.02 223.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(119.02 197.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(119.02 243.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(119.02 263.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(119.02 284.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(119.02 304.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(119.02 325.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(119.02 345.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(119.02 366.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(119.02 387.16)">
                  B1
                </text>
                <text class="cls-10" transform="translate(119.02 406.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(119.02 427.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(119.02 447.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(119.02 468.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(119.02 488.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(119.02 508.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(119.02 528.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(119.02 549.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(119.02 570.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(119.02 590.66)">
                  B1
                </text>
                <rect
                  class="cls-9"
                  x="453.98"
                  y="576.44"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="453.98"
                  y="555.97"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="453.98"
                  y="535.5"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="453.98"
                  y="515.3"
                  width="53.6"
                  height="20.2"
                />
                <rect
                  class="cls-9"
                  x="453.98"
                  y="494.83"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="453.98"
                  y="474.36"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="453.98"
                  y="454.16"
                  width="53.6"
                  height="20.2"
                />
                <rect
                  class="cls-9"
                  x="453.98"
                  y="433.69"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="453.98"
                  y="413.22"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="453.98"
                  y="393.02"
                  width="53.6"
                  height="20.2"
                />
                <rect
                  class="cls-9"
                  x="453.98"
                  y="372.55"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="453.98"
                  y="352.08"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="453.98"
                  y="331.61"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="453.98"
                  y="311.41"
                  width="53.6"
                  height="20.2"
                />
                <rect
                  class="cls-9"
                  x="453.98"
                  y="290.94"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="453.98"
                  y="270.47"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="453.98"
                  y="250.27"
                  width="53.6"
                  height="20.2"
                />
                <rect
                  class="cls-9"
                  x="453.98"
                  y="229.8"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="453.98"
                  y="209.33"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="453.98"
                  y="177.01"
                  width="53.6"
                  height="32.32"
                />
                <text class="cls-10" transform="translate(473.02 223.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(473.02 197.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(473.02 243.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(473.02 263.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(473.02 284.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(473.02 304.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(473.02 325.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(473.02 345.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(473.02 366.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(473.02 387.16)">
                  B1
                </text>
                <text class="cls-10" transform="translate(473.02 406.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(473.02 427.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(473.02 447.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(473.02 468.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(473.02 488.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(473.02 508.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(473.02 528.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(473.02 549.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(473.02 570.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(473.02 590.66)">
                  B1
                </text>
                <rect
                  class="cls-9"
                  x="956.57"
                  y="576.44"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="956.57"
                  y="555.97"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="956.57"
                  y="535.5"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="956.57"
                  y="515.3"
                  width="53.6"
                  height="20.2"
                />
                <rect
                  class="cls-9"
                  x="956.57"
                  y="494.83"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="956.57"
                  y="474.36"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="956.57"
                  y="454.16"
                  width="53.6"
                  height="20.2"
                />
                <rect
                  class="cls-9"
                  x="956.57"
                  y="433.69"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="956.57"
                  y="413.22"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="956.57"
                  y="393.02"
                  width="53.6"
                  height="20.2"
                />
                <rect
                  class="cls-9"
                  x="956.57"
                  y="372.55"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="956.57"
                  y="352.08"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="956.57"
                  y="331.61"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="956.57"
                  y="311.41"
                  width="53.6"
                  height="20.2"
                />
                <rect
                  class="cls-9"
                  x="956.57"
                  y="290.94"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="956.57"
                  y="270.47"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="956.57"
                  y="250.27"
                  width="53.6"
                  height="20.2"
                />
                <rect
                  class="cls-9"
                  x="956.57"
                  y="229.8"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="956.57"
                  y="209.33"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="956.57"
                  y="177.01"
                  width="53.6"
                  height="32.32"
                />
                <text class="cls-10" transform="translate(977.02 223.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(977.02 197.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(977.02 243.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(977.02 263.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(977.02 284.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(977.02 304.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(977.02 325.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(977.02 345.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(977.02 366.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(977.02 387.16)">
                  B1
                </text>
                <text class="cls-10" transform="translate(977.02 406.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(977.02 427.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(977.02 447.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(977.02 468.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(977.02 488.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(977.02 508.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(977.02 528.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(977.02 549.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(977.02 570.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(977.02 590.66)">
                  B1
                </text>
                <rect
                  class="cls-9"
                  x="1310.06"
                  y="576.44"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="1310.06"
                  y="555.97"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="1310.06"
                  y="535.5"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="1310.06"
                  y="515.3"
                  width="53.6"
                  height="20.2"
                />
                <rect
                  class="cls-9"
                  x="1310.06"
                  y="494.83"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="1310.06"
                  y="474.36"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="1310.06"
                  y="454.16"
                  width="53.6"
                  height="20.2"
                />
                <rect
                  class="cls-9"
                  x="1310.06"
                  y="433.69"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="1310.06"
                  y="413.22"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="1310.06"
                  y="393.02"
                  width="53.6"
                  height="20.2"
                />
                <rect
                  class="cls-9"
                  x="1310.06"
                  y="372.55"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="1310.06"
                  y="352.08"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="1310.06"
                  y="331.61"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="1310.06"
                  y="311.41"
                  width="53.6"
                  height="20.2"
                />
                <rect
                  class="cls-9"
                  x="1310.06"
                  y="290.94"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="1310.06"
                  y="270.47"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="1310.06"
                  y="250.27"
                  width="53.6"
                  height="20.2"
                />
                <rect
                  class="cls-9"
                  x="1310.06"
                  y="229.8"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="1310.06"
                  y="209.33"
                  width="53.6"
                  height="20.47"
                />
                <rect
                  class="cls-9"
                  x="1310.06"
                  y="177.01"
                  width="53.6"
                  height="32.32"
                />
                <text class="cls-10" transform="translate(1331.02 223.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(1331.02 197.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(1331.02 243.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(1331.02 263.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(1331.02 284.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(1331.02 304.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(1331.02 325.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(1331.02 345.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(1331.02 366.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(1331.02 387.16)">
                  B1
                </text>
                <text class="cls-10" transform="translate(1331.02 406.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(1331.02 427.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(1331.02 447.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(1331.02 468.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(1331.02 488.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(1331.02 508.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(1331.02 528.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(1331.02 549.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(1331.02 570.66)">
                  B1
                </text>
                <text class="cls-10" transform="translate(1331.02 590.66)">
                  B1
                </text>
              </g>
              <g id="C1" @click="setimgpop('C1')">
                <path
                  class="cls-11"
                  d="M1133.1,576.44h53.6v20.47h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6V556h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6V515.3h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6V393h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6V229.8h-53.6Z"
                />
                <text class="cls-10" transform="translate(1154.02 223.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(1154.02 243.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(1154.02 263.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(1154.02 284.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(1154.02 304.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(1154.02 325.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(1154.02 345.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(1154.02 366.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(1154.02 387.16)">
                  C1
                </text>
                <text class="cls-10" transform="translate(1154.02 406.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(1154.02 427.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(1154.02 447.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(1154.02 468.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(1154.02 488.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(1154.02 508.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(1154.02 528.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(1154.02 549.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(1154.02 570.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(1154.02 590.66)">
                  C1
                </text>
                <path
                  class="cls-11"
                  d="M630.94,576.44h53.6v20.47h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6V556h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6V515.3h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6V393h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6V229.8h-53.6Z"
                />
                <text class="cls-10" transform="translate(651.02 223.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(651.02 243.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(651.02 263.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(651.02 284.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(651.02 304.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(651.02 325.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(651.02 345.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(651.02 366.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(651.02 387.16)">
                  C1
                </text>
                <text class="cls-10" transform="translate(651.02 406.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(651.02 427.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(651.02 447.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(651.02 468.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(651.02 488.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(651.02 508.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(651.02 528.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(651.02 549.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(651.02 570.66)">
                  C1
                </text>
                <text class="cls-10" transform="translate(651.02 590.66)">
                  C1
                </text>
              </g>
              <g id="CP1" @click="setimgpop('CP1')">
                <path
                  class="cls-11"
                  d="M46.35,576.44H99.68v20.47H46.35Zm0-20.47H99.68v20.47H46.35Zm0-20.47H99.68V556H46.35Zm0-20.2H99.68v20.2H46.35Zm0-20.47H99.68V515.3H46.35Zm0-20.47H99.68v20.47H46.35Zm0-20.2H99.68v20.2H46.35Zm0-20.47H99.68v20.47H46.35Zm0-20.47H99.68v20.47H46.35Zm0-20.2H99.68v20.2H46.35Zm0-20.47H99.68V393H46.35Zm0-20.47H99.68v20.47H46.35Zm0-20.47H99.68v20.47H46.35Zm0-20.2H99.68v20.2H46.35Zm0-20.47H99.68v20.47H46.35Zm0-20.47H99.68v20.47H46.35Zm0-20.2H99.68v20.2H46.35Zm0-20.47H99.68v20.47H46.35Zm0-20.47H99.68V229.8H46.35Z"
                />
                <text class="cls-10" transform="translate(62.5 223.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(62.5 243.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(62.5 263.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(62.5 284.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(62.5 304.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(62.5 325.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(62.5 345.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(62.5 366.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(62.5 387.16)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(62.5 406.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(62.5 427.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(62.5 447.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(62.5 468.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(62.5 488.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(62.5 508.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(62.5 528.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(62.5 549.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(62.5 570.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(62.5 590.66)">
                  CP1
                </text>
                <path
                  class="cls-11"
                  d="M1010.17,576.44h53.6v20.47h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6V556h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6V515.3h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6V393h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.2h53.6v20.2h-53.6Zm0-20.47h53.6v20.47h-53.6Zm0-20.47h53.6V229.8h-53.6Z"
                />
                <text class="cls-10" transform="translate(1026.5 223.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(1026.5 243.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(1026.5 263.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(1026.5 284.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(1026.5 304.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(1026.5 325.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(1026.5 345.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(1026.5 366.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(1026.5 387.16)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(1026.5 406.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(1026.5 427.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(1026.5 447.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(1026.5 468.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(1026.5 488.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(1026.5 508.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(1026.5 528.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(1026.5 549.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(1026.5 570.66)">
                  CP1
                </text>
                <text class="cls-10" transform="translate(1026.5 590.66)">
                  CP1
                </text>
              </g>
              <g id="C1-PH" @click="setimgpop('C1-PH')">
                <rect
                  class="cls-11"
                  x="1133.1"
                  y="177.01"
                  width="53.6"
                  height="32.32"
                />
                <text class="cls-10" transform="translate(1142.5 197.19)">
                  C1-PH
                </text>
                <rect
                  class="cls-11"
                  x="630.94"
                  y="177.01"
                  width="53.6"
                  height="32.32"
                />
                <text class="cls-10" transform="translate(639.81 197.19)">
                  C1-PH
                </text>
              </g>
              <g id="CP1-PH" @click="setimgpop('CP1-PH')">
                <rect
                  class="cls-11"
                  x="46.35"
                  y="177.01"
                  width="53.33"
                  height="32.32"
                />
                <text class="cls-10" transform="translate(51.99 197.19)">
                  CP1-PH
                </text>
                <rect
                  class="cls-11"
                  x="1010.17"
                  y="177.01"
                  width="53.6"
                  height="32.32"
                />
                <text class="cls-10" transform="translate(1015.99 197.19)">
                  CP1-PH
                </text>
              </g>
            </g>
            <g id="Overall">
              <path
                class="cls-12"
                d="M260.48,596.91h70.3v32.33h-70.3Zm-214.67,0H260.48v32.33H45.81Z"
              />
              <path class="cls-12" d="M779.34,596.91h284.43v32.33H779.34Z" />
              <path class="cls-12" d="M399.42,596.91H683.84v32.33H399.42Z" />
              <path class="cls-13" d="M399.42,144.76H683.84v32.32H399.42Z" />
              <path class="cls-13" d="M45.26,144.76H329.69v32.32H45.26Z" />
              <path class="cls-13" d="M779.34,144.76h284.43v32.32H779.34Z" />
              <path class="cls-13" d="M1132.36,144.76h284.42v32.32H1132.36Z" />
              <path class="cls-12" d="M1133.49,596.91h284.43v32.33H1133.49Z" />
              <rect
                class="cls-12"
                x="399.58"
                y="629.24"
                width="284.97"
                height="65.18"
              />
              <rect
                class="cls-13"
                x="354.27"
                y="176.55"
                width="45.4"
                height="517.87"
              />
              <rect
                class="cls-13"
                x="0.12"
                y="176.55"
                width="45.4"
                height="517.87"
              />
              <rect
                class="cls-13"
                x="733.63"
                y="176.55"
                width="45.4"
                height="517.87"
              />
              <rect
                class="cls-13"
                x="1087.21"
                y="176.55"
                width="45.4"
                height="517.87"
              />
              <rect
                class="cls-12"
                x="45.81"
                y="629.24"
                width="284.97"
                height="65.18"
              />
              <rect
                class="cls-12"
                x="779.07"
                y="629.24"
                width="284.97"
                height="65.18"
              />
              <rect
                class="cls-12"
                x="1133.1"
                y="629.24"
                width="284.43"
                height="65.18"
              />
              <rect
                class="cls-14"
                x="0.12"
                y="144.76"
                width="330.32"
                height="549.65"
              />
              <rect
                class="cls-14"
                x="354.23"
                y="144.76"
                width="330.32"
                height="549.65"
              />
              <rect
                class="cls-14"
                x="733.72"
                y="144.76"
                width="330.32"
                height="549.65"
              />
              <rect
                class="cls-14"
                x="1087.21"
                y="144.76"
                width="330.32"
                height="549.65"
              />
              <g id="Function_Room" data-name="Function Room">
                <rect
                  class="cls-12"
                  x="206.88"
                  y="177.01"
                  width="53.6"
                  height="32.32"
                />
                <rect
                  class="cls-12"
                  x="153.28"
                  y="177.01"
                  width="53.6"
                  height="32.32"
                />
                <rect
                  class="cls-12"
                  x="903.24"
                  y="177.01"
                  width="53.33"
                  height="32.32"
                />
                <rect
                  class="cls-12"
                  x="849.64"
                  y="177.01"
                  width="53.6"
                  height="32.32"
                />
                <path
                  class="cls-5"
                  d="M199.68,190.76h-2.23v-.11l.2,0a.9.9,0,0,0,.36-.11.41.41,0,0,0,.15-.29,4.92,4.92,0,0,0,0-.64v-2a1.36,1.36,0,0,0-.25-.9.89.89,0,0,0-.7-.29,1.5,1.5,0,0,0-.7.16,2.44,2.44,0,0,0-.59.42v2.63a4.92,4.92,0,0,0,0,.64.41.41,0,0,0,.16.29.8.8,0,0,0,.35.11l.2,0v.11h-2.23v-.11l.21,0a.85.85,0,0,0,.35-.11.5.5,0,0,0,.15-.3,4.85,4.85,0,0,0,0-.63v-2.35a.82.82,0,0,0-.09-.5.7.7,0,0,0-.37-.24l-.29-.11v-.08l1.41-.33.09.06v.71a4.42,4.42,0,0,1,.76-.57,1.69,1.69,0,0,1,.84-.21c.91,0,1.38.48,1.39,1.49v2.13a3.39,3.39,0,0,0,0,.64.44.44,0,0,0,.14.29.9.9,0,0,0,.35.11l.21,0Zm-6-2.31a2.63,2.63,0,0,1-.31,1.25,2.24,2.24,0,0,1-.81.86,2.36,2.36,0,0,1-1.15.32,2.39,2.39,0,0,1-1.13-.28,2.14,2.14,0,0,1-.82-.84,3,3,0,0,1-.32-1.4,2.58,2.58,0,0,1,.32-1.25,2.28,2.28,0,0,1,.81-.85,2.19,2.19,0,0,1,1.14-.32,2.39,2.39,0,0,1,1.13.28,2.14,2.14,0,0,1,.82.84A2.91,2.91,0,0,1,193.71,188.45Zm-.85.19a3.49,3.49,0,0,0-.43-1.83,1.36,1.36,0,0,0-1.15-.7,1,1,0,0,0-.92.48,2.92,2.92,0,0,0-.34,1.58,3.35,3.35,0,0,0,.44,1.83,1.34,1.34,0,0,0,1.14.71,1,1,0,0,0,.92-.49A2.89,2.89,0,0,0,192.86,188.64ZM188,184.38a.5.5,0,0,1-.15.37.52.52,0,0,1-.38.15.5.5,0,0,1-.37-.15.52.52,0,0,1,0-.75.5.5,0,0,1,.37-.15.52.52,0,0,1,.38.15A.5.5,0,0,1,188,184.38Zm.69,6.38h-2.23v-.11l.21,0a.85.85,0,0,0,.34-.11.41.41,0,0,0,.15-.3,4.85,4.85,0,0,0,0-.63v-2.35a.82.82,0,0,0-.09-.5.67.67,0,0,0-.36-.24l-.29-.11v-.08l1.4-.33.09.06v3.55a4.92,4.92,0,0,0,0,.64.45.45,0,0,0,.16.29.9.9,0,0,0,.36.11l.2,0Zm-3-.46a2.78,2.78,0,0,1-.55.39,1.34,1.34,0,0,1-.64.15c-.67,0-1-.35-1-1.05v-3.33h-.69v-.08l.7-.25.61-1.49h.13v1.48h1.36v.34h-1.36v3.21c0,.52.23.78.67.79a1,1,0,0,0,.36-.07,1.68,1.68,0,0,0,.34-.19ZM182,190a3.56,3.56,0,0,1-.79.66,2.26,2.26,0,0,1-1.07.27,2.34,2.34,0,0,1-1.15-.3,2,2,0,0,1-.76-.8,2.34,2.34,0,0,1-.27-1.14,2.93,2.93,0,0,1,.34-1.38,2.49,2.49,0,0,1,.85-1,2.23,2.23,0,0,1,1.17-.36,2.45,2.45,0,0,1,1.19.28c.28.17.42.35.42.56a.58.58,0,0,1-.16.4.52.52,0,0,1-.36.14c-.32,0-.5-.34-.54-1.06a1.07,1.07,0,0,0-.27-.09,1.83,1.83,0,0,0-.37,0,1.36,1.36,0,0,0-1.1.54,2.42,2.42,0,0,0-.41,1.47,2.5,2.5,0,0,0,.5,1.61,1.61,1.61,0,0,0,1.29.62,2,2,0,0,0,.71-.12,2.94,2.94,0,0,0,.7-.39Zm-4.67.81h-2.23v-.11l.2,0a.8.8,0,0,0,.35-.11.41.41,0,0,0,.16-.29,4.92,4.92,0,0,0,0-.64v-2a1.36,1.36,0,0,0-.25-.9.89.89,0,0,0-.7-.29,1.5,1.5,0,0,0-.7.16,2.26,2.26,0,0,0-.59.42v2.63a4.92,4.92,0,0,0,0,.64.45.45,0,0,0,.15.29.9.9,0,0,0,.36.11l.2,0v.11h-2.23v-.11l.21,0a.85.85,0,0,0,.35-.11.5.5,0,0,0,.15-.3,4.85,4.85,0,0,0,0-.63v-2.35a.82.82,0,0,0-.09-.5.7.7,0,0,0-.37-.24l-.29-.11v-.08l1.41-.33.09.06v.71a4.42,4.42,0,0,1,.76-.57,1.69,1.69,0,0,1,.84-.21c.91,0,1.38.48,1.39,1.49v2.13a4.92,4.92,0,0,0,0,.64.5.5,0,0,0,.15.29.85.85,0,0,0,.35.11l.21,0Zm-6.09,0c-.57,0-1.07,0-1.48,0v-.71a4.42,4.42,0,0,1-.76.57,1.69,1.69,0,0,1-.84.21c-.92,0-1.38-.49-1.4-1.49v-2.14a.82.82,0,0,0-.09-.5.66.66,0,0,0-.37-.24l-.28-.11v-.08l1.4-.33.09.06v3.23a1.31,1.31,0,0,0,.25.89.87.87,0,0,0,.7.3,1.6,1.6,0,0,0,.7-.16,2.49,2.49,0,0,0,.6-.42v-2.64a1,1,0,0,0-.09-.5.7.7,0,0,0-.37-.24l-.29-.11v-.08l1.4-.33.09.06v3.55a3.39,3.39,0,0,0,0,.64.41.41,0,0,0,.15.29.8.8,0,0,0,.34.11l.21,0Zm-5.48-5.58h-.12l-.18-.29a2,2,0,0,0-.38-.5,1,1,0,0,0-.49-.23,3.73,3.73,0,0,0-.74-.06h-.19a6.13,6.13,0,0,0-.68,0,2.64,2.64,0,0,0-.43.09v2.92l.81,0a2.25,2.25,0,0,0,1-.15.64.64,0,0,0,.3-.56l0-.41h.14v.33c0,.14,0,.29,0,.45s0,.31,0,.45,0,.41,0,.65,0,.4,0,.52h-.14l0-.28a1,1,0,0,0-.16-.47.6.6,0,0,0-.38-.22,3.56,3.56,0,0,0-.76-.07l-.81,0v2a3.8,3.8,0,0,0,0,.77.56.56,0,0,0,.23.37,1,1,0,0,0,.46.14l.39.05v.11h-2.89v-.11l.37-.05a.52.52,0,0,0,.47-.3,2.28,2.28,0,0,0,.12-1v-4a2.34,2.34,0,0,0-.12-1,.53.53,0,0,0-.47-.29l-.37-.05v-.11h4.68Z"
                />
                <path
                  class="cls-5"
                  d="M193.1,202.34h-2.23v-.11l.2,0a.9.9,0,0,0,.36-.11.41.41,0,0,0,.15-.29,3.39,3.39,0,0,0,0-.64v-2c0-.8-.32-1.2-.93-1.19a1.56,1.56,0,0,0-.69.17,2.05,2.05,0,0,0-.61.45c0,.06,0,.14,0,.23a2.72,2.72,0,0,1,0,.28v2.08a3.39,3.39,0,0,0,0,.64.41.41,0,0,0,.15.29.9.9,0,0,0,.36.11l.2,0v.11h-2.24v-.11l.2,0a.9.9,0,0,0,.36-.11.41.41,0,0,0,.15-.29,4.54,4.54,0,0,0,0-.64v-2c0-.8-.32-1.2-.93-1.19a1.44,1.44,0,0,0-.67.16,2.44,2.44,0,0,0-.59.42v2.63a4.92,4.92,0,0,0,0,.64.41.41,0,0,0,.16.29.85.85,0,0,0,.35.11l.2,0v.11H185v-.11l.21,0a.85.85,0,0,0,.35-.11.5.5,0,0,0,.15-.3,4.85,4.85,0,0,0,0-.63v-2.35a.84.84,0,0,0-.09-.5.66.66,0,0,0-.37-.24L185,198v-.08l1.41-.33.09.06v.71a4.34,4.34,0,0,1,.74-.57,1.64,1.64,0,0,1,.84-.21,1.48,1.48,0,0,1,.85.22,1.16,1.16,0,0,1,.42.61,4.37,4.37,0,0,1,.79-.59,1.82,1.82,0,0,1,.86-.24c.91,0,1.37.48,1.37,1.49v2.13a4.92,4.92,0,0,0,0,.64.41.41,0,0,0,.15.29.85.85,0,0,0,.34.11l.21,0ZM184.36,200a2.63,2.63,0,0,1-.31,1.25,2.24,2.24,0,0,1-.81.86,2.36,2.36,0,0,1-1.15.32,2.39,2.39,0,0,1-1.13-.28,2.14,2.14,0,0,1-.82-.84,3,3,0,0,1-.32-1.4,2.58,2.58,0,0,1,.32-1.25,2.23,2.23,0,0,1,2-1.17,2.39,2.39,0,0,1,1.13.28,2.14,2.14,0,0,1,.82.84A2.91,2.91,0,0,1,184.36,200Zm-.85.19a3.49,3.49,0,0,0-.43-1.83,1.36,1.36,0,0,0-1.15-.7,1,1,0,0,0-.92.48,2.92,2.92,0,0,0-.34,1.58,3.35,3.35,0,0,0,.44,1.83,1.34,1.34,0,0,0,1.14.71,1,1,0,0,0,.92-.49A2.89,2.89,0,0,0,183.51,200.22Zm-4.82-.19a2.63,2.63,0,0,1-.31,1.25,2.24,2.24,0,0,1-.81.86,2.33,2.33,0,0,1-1.15.32,2.39,2.39,0,0,1-1.13-.28,2.14,2.14,0,0,1-.82-.84,3,3,0,0,1-.32-1.4,2.58,2.58,0,0,1,.32-1.25,2.28,2.28,0,0,1,.81-.85,2.32,2.32,0,0,1,1.14-.32,2.39,2.39,0,0,1,1.13.28,2.14,2.14,0,0,1,.82.84A2.91,2.91,0,0,1,178.69,200Zm-.85.19a3.49,3.49,0,0,0-.43-1.83,1.36,1.36,0,0,0-1.15-.7,1,1,0,0,0-.92.48,2.92,2.92,0,0,0-.34,1.58,3.35,3.35,0,0,0,.44,1.83,1.34,1.34,0,0,0,1.14.71,1,1,0,0,0,.92-.49A2.89,2.89,0,0,0,177.84,200.22Zm-4,2.1-.31,0-.34,0a2,2,0,0,1-1.08-.31,2.8,2.8,0,0,1-.78-.82l-1.41-2.08h-.51l-.39,0v1.76a2.49,2.49,0,0,0,.12,1,.58.58,0,0,0,.51.29l.45.06v.11h-2.83v-.11l.37,0a.52.52,0,0,0,.47-.3,2.51,2.51,0,0,0,.11-1v-4a2.57,2.57,0,0,0-.11-1,.53.53,0,0,0-.47-.29l-.37,0v-.11h2.91a2.85,2.85,0,0,1,1.69.47,1.5,1.5,0,0,1,.63,1.27,1.41,1.41,0,0,1-.24.78,2.22,2.22,0,0,1-.62.6,4,4,0,0,1-.86.39l1.46,2.13a4.33,4.33,0,0,0,.53.67,1.23,1.23,0,0,0,.47.32,1.35,1.35,0,0,0,.58.06Zm-2.24-5a1.67,1.67,0,0,0-.4-1.24,1.52,1.52,0,0,0-1.15-.4,3.47,3.47,0,0,0-.6,0,2.5,2.5,0,0,0-.43.09V199a8,8,0,0,0,.81,0,2,2,0,0,0,1.3-.38A1.68,1.68,0,0,0,171.56,197.31Z"
                />
                <path
                  class="cls-5"
                  d="M253.28,190.76h-2.23v-.11l.2,0a.9.9,0,0,0,.36-.11.41.41,0,0,0,.15-.29,4.54,4.54,0,0,0,0-.64v-2a1.36,1.36,0,0,0-.26-.9.89.89,0,0,0-.7-.29,1.53,1.53,0,0,0-.7.16,2.44,2.44,0,0,0-.59.42v2.63a4.92,4.92,0,0,0,0,.64.45.45,0,0,0,.16.29.9.9,0,0,0,.35.11l.2,0v.11h-2.22v-.11l.2,0a.85.85,0,0,0,.35-.11.5.5,0,0,0,.15-.3,4.85,4.85,0,0,0,0-.63v-2.35a.82.82,0,0,0-.09-.5.66.66,0,0,0-.37-.24l-.28-.11v-.08l1.4-.33.09.06v.71a4.42,4.42,0,0,1,.76-.57,1.69,1.69,0,0,1,.84-.21c.91,0,1.38.48,1.39,1.49v2.13a3.39,3.39,0,0,0,0,.64.41.41,0,0,0,.15.29.8.8,0,0,0,.34.11l.21,0Zm-6-2.31a2.63,2.63,0,0,1-.31,1.25,2.24,2.24,0,0,1-.81.86,2.33,2.33,0,0,1-1.15.32,2.39,2.39,0,0,1-1.13-.28,2.14,2.14,0,0,1-.82-.84,3,3,0,0,1-.32-1.4,2.69,2.69,0,0,1,.32-1.25,2.28,2.28,0,0,1,.81-.85,2.22,2.22,0,0,1,1.14-.32,2.39,2.39,0,0,1,1.13.28,2.07,2.07,0,0,1,.82.84A2.91,2.91,0,0,1,247.31,188.45Zm-.85.19a3.49,3.49,0,0,0-.43-1.83,1.36,1.36,0,0,0-1.15-.7,1,1,0,0,0-.92.48,3,3,0,0,0-.34,1.58,3.44,3.44,0,0,0,.44,1.83,1.34,1.34,0,0,0,1.14.71,1,1,0,0,0,.92-.49A2.89,2.89,0,0,0,246.46,188.64Zm-4.91-4.26a.5.5,0,0,1-.15.37.5.5,0,0,1-.38.15.51.51,0,0,1-.52-.52.5.5,0,0,1,.15-.38.5.5,0,0,1,.37-.15.51.51,0,0,1,.53.53Zm.69,6.38H240v-.11l.21,0a.85.85,0,0,0,.34-.11.41.41,0,0,0,.15-.3,4.85,4.85,0,0,0,0-.63v-2.35a.92.92,0,0,0-.08-.5.7.7,0,0,0-.37-.24l-.29-.11v-.08l1.4-.33.09.06v3.55a3.39,3.39,0,0,0,0,.64.41.41,0,0,0,.15.29.9.9,0,0,0,.36.11l.2,0Zm-3-.46a2.78,2.78,0,0,1-.55.39,1.34,1.34,0,0,1-.64.15c-.66,0-1-.35-1-1.05v-3.33h-.69v-.08l.7-.25.61-1.49h.13v1.48h1.36v.34h-1.36v3.21c0,.52.23.78.67.79a1,1,0,0,0,.36-.07,1.68,1.68,0,0,0,.34-.19Zm-3.7-.35a3.34,3.34,0,0,1-.79.66,2.26,2.26,0,0,1-1.07.27,2.34,2.34,0,0,1-1.15-.3,2,2,0,0,1-.76-.8,2.34,2.34,0,0,1-.27-1.14,2.93,2.93,0,0,1,.34-1.38,2.49,2.49,0,0,1,.85-1,2.23,2.23,0,0,1,1.17-.36,2.52,2.52,0,0,1,1.2.28c.27.17.41.35.41.56a.54.54,0,0,1-.16.4.52.52,0,0,1-.35.14c-.33,0-.51-.34-.55-1.06a1.07,1.07,0,0,0-.27-.09,1.83,1.83,0,0,0-.37,0,1.36,1.36,0,0,0-1.1.54,2.42,2.42,0,0,0-.41,1.47,2.5,2.5,0,0,0,.5,1.61,1.61,1.61,0,0,0,1.29.62,2,2,0,0,0,.71-.12,2.94,2.94,0,0,0,.7-.39Zm-4.67.81h-2.23v-.11l.2,0a.9.9,0,0,0,.36-.11.41.41,0,0,0,.15-.29,4.54,4.54,0,0,0,0-.64v-2a1.36,1.36,0,0,0-.26-.9.89.89,0,0,0-.7-.29,1.5,1.5,0,0,0-.7.16,2.44,2.44,0,0,0-.59.42v2.63a4.92,4.92,0,0,0,0,.64.45.45,0,0,0,.16.29.9.9,0,0,0,.35.11l.2,0v.11h-2.22v-.11l.2,0a.85.85,0,0,0,.35-.11.5.5,0,0,0,.15-.3,4.85,4.85,0,0,0,0-.63v-2.35a.82.82,0,0,0-.09-.5.66.66,0,0,0-.37-.24l-.28-.11v-.08l1.4-.33.09.06v.71a4.42,4.42,0,0,1,.76-.57,1.69,1.69,0,0,1,.84-.21c.91,0,1.38.48,1.39,1.49v2.13a3.39,3.39,0,0,0,0,.64.41.41,0,0,0,.15.29.8.8,0,0,0,.34.11l.21,0Zm-6.09,0c-.57,0-1.06,0-1.48,0v-.71a4.07,4.07,0,0,1-.76.57,1.69,1.69,0,0,1-.84.21c-.92,0-1.38-.49-1.4-1.49v-2.14a.82.82,0,0,0-.09-.5.63.63,0,0,0-.36-.24l-.29-.11v-.08L221,186l.09.06v3.23a1.31,1.31,0,0,0,.25.89.88.88,0,0,0,.7.3,1.68,1.68,0,0,0,.71-.16,2.65,2.65,0,0,0,.59-.42v-2.64a1,1,0,0,0-.09-.5.7.7,0,0,0-.37-.24l-.29-.11v-.08L224,186l.09.06v3.55a4.54,4.54,0,0,0,0,.64.41.41,0,0,0,.15.29.8.8,0,0,0,.34.11l.21,0Zm-5.48-5.58h-.12l-.18-.29a2,2,0,0,0-.38-.5,1,1,0,0,0-.48-.23,3.92,3.92,0,0,0-.75-.06h-.19a6.13,6.13,0,0,0-.68,0,2.64,2.64,0,0,0-.43.09v2.92l.81,0a2.25,2.25,0,0,0,1-.15.65.65,0,0,0,.31-.56l0-.41h.14v.33c0,.14,0,.29,0,.45s0,.31,0,.45,0,.41,0,.65,0,.4,0,.52h-.14l0-.28a1.08,1.08,0,0,0-.16-.47.62.62,0,0,0-.39-.22,3.56,3.56,0,0,0-.76-.07l-.81,0v2a3.66,3.66,0,0,0,.06.77.55.55,0,0,0,.22.37,1,1,0,0,0,.46.14l.39.05v.11h-2.88v-.11l.36-.05a.54.54,0,0,0,.48-.3,2.51,2.51,0,0,0,.11-1v-4a2.57,2.57,0,0,0-.11-1,.55.55,0,0,0-.48-.29l-.36-.05v-.11H219Z"
                />
                <path
                  class="cls-5"
                  d="M246.7,202.34h-2.23v-.11l.2,0a.9.9,0,0,0,.36-.11.45.45,0,0,0,.16-.29,4.92,4.92,0,0,0,0-.64v-2c0-.8-.31-1.2-.92-1.19a1.57,1.57,0,0,0-.7.17,2.05,2.05,0,0,0-.61.45.75.75,0,0,1,0,.23,2.72,2.72,0,0,1,0,.28v2.08a3.39,3.39,0,0,0,0,.64.41.41,0,0,0,.15.29.9.9,0,0,0,.36.11l.2,0v.11h-2.24v-.11l.2,0a.9.9,0,0,0,.36-.11.41.41,0,0,0,.15-.29,4.54,4.54,0,0,0,0-.64v-2c0-.8-.32-1.2-.93-1.19a1.47,1.47,0,0,0-.67.16,2.44,2.44,0,0,0-.59.42v2.63a4.92,4.92,0,0,0,0,.64.45.45,0,0,0,.16.29.9.9,0,0,0,.36.11l.19,0v.11h-2.22v-.11l.21,0a.85.85,0,0,0,.34-.11.5.5,0,0,0,.15-.3,4.85,4.85,0,0,0,0-.63v-2.35a.84.84,0,0,0-.09-.5.66.66,0,0,0-.37-.24l-.28-.11v-.08l1.4-.33.09.06v.71a4.76,4.76,0,0,1,.74-.57,1.64,1.64,0,0,1,.84-.21,1.48,1.48,0,0,1,.85.22,1.16,1.16,0,0,1,.42.61,4.37,4.37,0,0,1,.79-.59,1.85,1.85,0,0,1,.86-.24c.91,0,1.37.48,1.37,1.49v2.13a4.92,4.92,0,0,0,0,.64.41.41,0,0,0,.15.29.85.85,0,0,0,.34.11l.21,0ZM238,200a2.63,2.63,0,0,1-.31,1.25,2.24,2.24,0,0,1-.81.86,2.33,2.33,0,0,1-1.15.32,2.39,2.39,0,0,1-1.13-.28,2.14,2.14,0,0,1-.82-.84,3,3,0,0,1-.32-1.4,2.69,2.69,0,0,1,.32-1.25,2.28,2.28,0,0,1,.81-.85,2.32,2.32,0,0,1,1.14-.32,2.39,2.39,0,0,1,1.13.28,2.07,2.07,0,0,1,.82.84A2.91,2.91,0,0,1,238,200Zm-.85.19a3.49,3.49,0,0,0-.43-1.83,1.36,1.36,0,0,0-1.15-.7,1,1,0,0,0-.92.48,3,3,0,0,0-.34,1.58,3.44,3.44,0,0,0,.44,1.83,1.34,1.34,0,0,0,1.14.71,1,1,0,0,0,.92-.49A2.89,2.89,0,0,0,237.11,200.22Zm-4.82-.19a2.63,2.63,0,0,1-.31,1.25,2.24,2.24,0,0,1-.81.86,2.33,2.33,0,0,1-1.15.32,2.39,2.39,0,0,1-1.13-.28,2.14,2.14,0,0,1-.82-.84,3,3,0,0,1-.32-1.4,2.69,2.69,0,0,1,.32-1.25,2.28,2.28,0,0,1,.81-.85,2.32,2.32,0,0,1,1.14-.32,2.39,2.39,0,0,1,1.13.28,2.07,2.07,0,0,1,.82.84A2.91,2.91,0,0,1,232.29,200Zm-.85.19a3.49,3.49,0,0,0-.43-1.83,1.36,1.36,0,0,0-1.15-.7,1,1,0,0,0-.92.48,3,3,0,0,0-.34,1.58,3.44,3.44,0,0,0,.44,1.83,1.34,1.34,0,0,0,1.14.71,1,1,0,0,0,.92-.49A2.89,2.89,0,0,0,231.44,200.22Zm-4,2.1-.32,0-.34,0a1.93,1.93,0,0,1-1.07-.31,2.7,2.7,0,0,1-.79-.82l-1.41-2.08H223l-.39,0v1.76a2.44,2.44,0,0,0,.13,1,.57.57,0,0,0,.5.29l.46.06v.11h-2.84v-.11l.37,0a.52.52,0,0,0,.47-.3,2.66,2.66,0,0,0,.12-1v-4a2.73,2.73,0,0,0-.12-1,.53.53,0,0,0-.47-.29l-.37,0v-.11h2.92a2.84,2.84,0,0,1,1.68.47,1.5,1.5,0,0,1,.63,1.27,1.33,1.33,0,0,1-.24.78,2.22,2.22,0,0,1-.62.6,4,4,0,0,1-.86.39l1.46,2.13a4.33,4.33,0,0,0,.53.67,1.23,1.23,0,0,0,.47.32,1.38,1.38,0,0,0,.59.06Zm-2.25-5a1.71,1.71,0,0,0-.39-1.24,1.56,1.56,0,0,0-1.16-.4,3.47,3.47,0,0,0-.6,0,2.5,2.5,0,0,0-.43.09V199a8,8,0,0,0,.81,0,1.94,1.94,0,0,0,1.3-.38A1.64,1.64,0,0,0,225.16,197.31Z"
                />
                <path
                  class="cls-5"
                  d="M895.77,190.76h-2.23v-.11l.2,0a.9.9,0,0,0,.36-.11.45.45,0,0,0,.15-.29,4.92,4.92,0,0,0,0-.64v-2a1.36,1.36,0,0,0-.25-.9.89.89,0,0,0-.7-.29,1.5,1.5,0,0,0-.7.16,2.44,2.44,0,0,0-.59.42v2.63a4.92,4.92,0,0,0,0,.64.41.41,0,0,0,.16.29.8.8,0,0,0,.35.11l.2,0v.11h-2.23v-.11l.21,0a.85.85,0,0,0,.35-.11.5.5,0,0,0,.15-.3,4.85,4.85,0,0,0,0-.63v-2.35a.82.82,0,0,0-.09-.5.7.7,0,0,0-.37-.24l-.29-.11v-.08L892,186l.09.06v.71a4.42,4.42,0,0,1,.76-.57,1.69,1.69,0,0,1,.84-.21c.91,0,1.38.48,1.39,1.49v2.13a4.92,4.92,0,0,0,0,.64.5.5,0,0,0,.15.29.85.85,0,0,0,.35.11l.21,0Zm-6-2.31a2.63,2.63,0,0,1-.31,1.25,2.24,2.24,0,0,1-.81.86,2.36,2.36,0,0,1-1.15.32,2.39,2.39,0,0,1-1.13-.28,2.14,2.14,0,0,1-.82-.84,2.93,2.93,0,0,1-.32-1.4,2.58,2.58,0,0,1,.32-1.25,2.28,2.28,0,0,1,.81-.85,2.19,2.19,0,0,1,1.14-.32,2.39,2.39,0,0,1,1.13.28,2.14,2.14,0,0,1,.82.84A2.91,2.91,0,0,1,889.8,188.45Zm-.85.19a3.39,3.39,0,0,0-.44-1.83,1.33,1.33,0,0,0-1.14-.7,1,1,0,0,0-.92.48,2.92,2.92,0,0,0-.34,1.58,3.35,3.35,0,0,0,.44,1.83,1.34,1.34,0,0,0,1.14.71,1,1,0,0,0,.92-.49A2.89,2.89,0,0,0,889,188.64ZM884,184.38a.5.5,0,0,1-.15.37.52.52,0,0,1-.38.15.48.48,0,0,1-.37-.15.52.52,0,0,1,0-.75.48.48,0,0,1,.37-.15.52.52,0,0,1,.38.15A.5.5,0,0,1,884,184.38Zm.69,6.38H882.5v-.11l.21,0a.85.85,0,0,0,.34-.11.45.45,0,0,0,.15-.3,4.85,4.85,0,0,0,0-.63v-2.35a.82.82,0,0,0-.09-.5.67.67,0,0,0-.36-.24l-.29-.11v-.08l1.4-.33.09.06v3.55a4.92,4.92,0,0,0,0,.64.45.45,0,0,0,.16.29.9.9,0,0,0,.36.11l.2,0Zm-3-.46a2.78,2.78,0,0,1-.55.39,1.34,1.34,0,0,1-.64.15c-.67,0-1-.35-1-1.05v-3.33h-.69v-.08l.7-.25.61-1.49h.13v1.48h1.36v.34h-1.36v3.21c0,.52.23.78.67.79a1,1,0,0,0,.36-.07,1.68,1.68,0,0,0,.34-.19Zm-3.7-.35a3.39,3.39,0,0,1-.8.66,2.19,2.19,0,0,1-1.06.27,2.34,2.34,0,0,1-1.15-.3,2,2,0,0,1-.76-.8,2.34,2.34,0,0,1-.27-1.14,2.93,2.93,0,0,1,.34-1.38,2.49,2.49,0,0,1,.85-1,2.23,2.23,0,0,1,1.17-.36,2.48,2.48,0,0,1,1.19.28c.28.17.42.35.42.56a.58.58,0,0,1-.16.4.52.52,0,0,1-.36.14c-.32,0-.5-.34-.54-1.06a1.07,1.07,0,0,0-.27-.09,1.83,1.83,0,0,0-.37,0,1.36,1.36,0,0,0-1.1.54,2.36,2.36,0,0,0-.41,1.47,2.44,2.44,0,0,0,.5,1.61,1.61,1.61,0,0,0,1.29.62,2,2,0,0,0,.71-.12,2.94,2.94,0,0,0,.7-.39Zm-4.67.81h-2.23v-.11l.2,0a.85.85,0,0,0,.35-.11.41.41,0,0,0,.16-.29,4.92,4.92,0,0,0,0-.64v-2a1.36,1.36,0,0,0-.25-.9.89.89,0,0,0-.7-.29,1.5,1.5,0,0,0-.7.16,2.26,2.26,0,0,0-.59.42v2.63a4.92,4.92,0,0,0,0,.64.41.41,0,0,0,.15.29.9.9,0,0,0,.36.11l.2,0v.11h-2.23v-.11l.21,0a.9.9,0,0,0,.35-.11.45.45,0,0,0,.14-.3,3.34,3.34,0,0,0,0-.63v-2.35a.82.82,0,0,0-.09-.5.7.7,0,0,0-.37-.24l-.29-.11v-.08l1.41-.33.09.06v.71a4.42,4.42,0,0,1,.76-.57,1.69,1.69,0,0,1,.84-.21c.91,0,1.38.48,1.39,1.49v2.13a4.92,4.92,0,0,0,0,.64.5.5,0,0,0,.15.29.85.85,0,0,0,.35.11l.21,0Zm-6.09,0c-.57,0-1.07,0-1.48,0v-.71a4.42,4.42,0,0,1-.76.57,1.7,1.7,0,0,1-.85.21c-.91,0-1.37-.49-1.39-1.49v-2.14a.82.82,0,0,0-.09-.5.66.66,0,0,0-.37-.24l-.28-.11v-.08l1.4-.33.09.06v3.23a1.31,1.31,0,0,0,.25.89.87.87,0,0,0,.7.3,1.63,1.63,0,0,0,.7-.16,2.49,2.49,0,0,0,.6-.42v-2.64a1,1,0,0,0-.09-.5.7.7,0,0,0-.37-.24l-.29-.11v-.08l1.4-.33.09.06v3.55a3.39,3.39,0,0,0,0,.64.41.41,0,0,0,.15.29.8.8,0,0,0,.34.11l.21,0Zm-5.48-5.58h-.12l-.18-.29a2,2,0,0,0-.38-.5,1,1,0,0,0-.49-.23,3.73,3.73,0,0,0-.74-.06h-.19a6.13,6.13,0,0,0-.68,0,3.06,3.06,0,0,0-.44.09v2.92l.82,0a2.25,2.25,0,0,0,1-.15.64.64,0,0,0,.3-.56l0-.41h.14v.33c0,.14,0,.29,0,.45s0,.31,0,.45,0,.41,0,.65,0,.4,0,.52h-.14l0-.28a1,1,0,0,0-.16-.47.6.6,0,0,0-.38-.22,3.56,3.56,0,0,0-.76-.07l-.82,0v2a3.66,3.66,0,0,0,.06.77.56.56,0,0,0,.23.37,1,1,0,0,0,.46.14l.39.05v.11h-2.89v-.11l.37-.05a.52.52,0,0,0,.47-.3,2.28,2.28,0,0,0,.12-1v-4a2.34,2.34,0,0,0-.12-1,.53.53,0,0,0-.47-.29l-.37-.05v-.11h4.68Z"
                />
                <path
                  class="cls-5"
                  d="M889.46,202.34h-2.22v-.11l.2,0a.9.9,0,0,0,.35-.11.45.45,0,0,0,.16-.29,4.92,4.92,0,0,0,0-.64v-2c0-.8-.31-1.2-.92-1.19a1.6,1.6,0,0,0-.7.17,2.19,2.19,0,0,0-.61.45.75.75,0,0,1,0,.23,2.72,2.72,0,0,1,0,.28v2.08a4.54,4.54,0,0,0,0,.64.41.41,0,0,0,.15.29.9.9,0,0,0,.36.11l.2,0v.11H884.3v-.11l.2,0a.9.9,0,0,0,.36-.11.41.41,0,0,0,.15-.29,3.39,3.39,0,0,0,0-.64v-2c0-.8-.32-1.2-.93-1.19a1.47,1.47,0,0,0-.67.16,2.65,2.65,0,0,0-.59.42v2.63a4.92,4.92,0,0,0,0,.64.45.45,0,0,0,.16.29.9.9,0,0,0,.36.11l.2,0v.11h-2.23v-.11l.21,0a.85.85,0,0,0,.34-.11.41.41,0,0,0,.15-.3,4.85,4.85,0,0,0,0-.63v-2.35a.84.84,0,0,0-.09-.5.63.63,0,0,0-.36-.24l-.29-.11v-.08l1.4-.33.09.06v.71a4.38,4.38,0,0,1,.75-.57,1.57,1.57,0,0,1,.83-.21,1.46,1.46,0,0,1,.85.22,1.11,1.11,0,0,1,.42.61,4.1,4.1,0,0,1,.8-.59,1.79,1.79,0,0,1,.86-.24c.9,0,1.36.48,1.36,1.49v2.13a4.92,4.92,0,0,0,0,.64.5.5,0,0,0,.15.29.85.85,0,0,0,.35.11l.2,0ZM880.72,200a2.63,2.63,0,0,1-.31,1.25,2.24,2.24,0,0,1-.81.86,2.33,2.33,0,0,1-1.15.32,2.42,2.42,0,0,1-1.13-.28,2.14,2.14,0,0,1-.82-.84,2.93,2.93,0,0,1-.31-1.4,2.57,2.57,0,0,1,.31-1.25,2.28,2.28,0,0,1,.81-.85,2.32,2.32,0,0,1,1.14-.32,2.39,2.39,0,0,1,1.13.28,2.07,2.07,0,0,1,.82.84A2.91,2.91,0,0,1,880.72,200Zm-.84.19a3.58,3.58,0,0,0-.44-1.83,1.36,1.36,0,0,0-1.15-.7,1,1,0,0,0-.92.48,3,3,0,0,0-.34,1.58,3.44,3.44,0,0,0,.44,1.83,1.36,1.36,0,0,0,1.14.71,1,1,0,0,0,.92-.49A2.88,2.88,0,0,0,879.88,200.22Zm-4.83-.19a2.52,2.52,0,0,1-.31,1.25,2.24,2.24,0,0,1-.81.86,2.33,2.33,0,0,1-1.15.32,2.35,2.35,0,0,1-1.12-.28,2.1,2.1,0,0,1-.83-.84,2.93,2.93,0,0,1-.31-1.4,2.57,2.57,0,0,1,.31-1.25,2.28,2.28,0,0,1,.81-.85,2.32,2.32,0,0,1,1.14-.32,2.36,2.36,0,0,1,1.13.28,2.07,2.07,0,0,1,.82.84A2.8,2.8,0,0,1,875.05,200Zm-.84.19a3.58,3.58,0,0,0-.44-1.83,1.36,1.36,0,0,0-1.15-.7,1,1,0,0,0-.92.48,3,3,0,0,0-.34,1.58,3.44,3.44,0,0,0,.44,1.83,1.36,1.36,0,0,0,1.14.71,1,1,0,0,0,.92-.49A2.88,2.88,0,0,0,874.21,200.22Zm-4,2.1-.32,0-.34,0a1.93,1.93,0,0,1-1.07-.31,2.82,2.82,0,0,1-.79-.82l-1.41-2.08h-.5l-.4,0v1.76a2.44,2.44,0,0,0,.13,1,.58.58,0,0,0,.5.29l.46.06v.11h-2.84v-.11l.37,0a.52.52,0,0,0,.47-.3,2.45,2.45,0,0,0,.12-1v-4a2.52,2.52,0,0,0-.12-1,.53.53,0,0,0-.47-.29l-.37,0v-.11h2.92a2.84,2.84,0,0,1,1.68.47,1.51,1.51,0,0,1,.64,1.27,1.42,1.42,0,0,1-.25.78,2.09,2.09,0,0,1-.62.6,3.76,3.76,0,0,1-.86.39l1.47,2.13a3.82,3.82,0,0,0,.52.67,1.19,1.19,0,0,0,.48.32,1.31,1.31,0,0,0,.58.06Zm-2.25-5a1.71,1.71,0,0,0-.39-1.24,1.54,1.54,0,0,0-1.16-.4,3.34,3.34,0,0,0-.59,0,2.43,2.43,0,0,0-.44.09V199a8,8,0,0,0,.81,0,1.94,1.94,0,0,0,1.3-.38A1.64,1.64,0,0,0,867.92,197.31Z"
                />
                <path
                  class="cls-5"
                  d="M949.27,190.76h-2.22v-.11l.19,0a.9.9,0,0,0,.36-.11.45.45,0,0,0,.16-.29,4.92,4.92,0,0,0,0-.64v-2a1.36,1.36,0,0,0-.25-.9.89.89,0,0,0-.7-.29,1.5,1.5,0,0,0-.7.16,2.49,2.49,0,0,0-.6.42v2.63a4.54,4.54,0,0,0,0,.64.41.41,0,0,0,.15.29.9.9,0,0,0,.36.11l.2,0v.11h-2.23v-.11l.21,0a.8.8,0,0,0,.34-.11.41.41,0,0,0,.15-.3,3.34,3.34,0,0,0,0-.63v-2.35a1,1,0,0,0-.09-.5.7.7,0,0,0-.37-.24l-.29-.11v-.08l1.4-.33.09.06v.71a4.47,4.47,0,0,1,.77-.57,1.66,1.66,0,0,1,.84-.21c.91,0,1.37.48,1.39,1.49v2.13a4.92,4.92,0,0,0,0,.64.5.5,0,0,0,.15.29.85.85,0,0,0,.35.11l.2,0Zm-5.86-2.31a2.63,2.63,0,0,1-.31,1.25,2.24,2.24,0,0,1-.81.86,2.32,2.32,0,0,1-2.28,0,2.07,2.07,0,0,1-.82-.84,2.93,2.93,0,0,1-.32-1.4,2.69,2.69,0,0,1,.31-1.25,2.45,2.45,0,0,1,.81-.85,2.23,2.23,0,0,1,1.15-.32,2.42,2.42,0,0,1,1.13.28,2.14,2.14,0,0,1,.82.84A3,3,0,0,1,943.41,188.45Zm-.85.19a3.49,3.49,0,0,0-.44-1.83,1.33,1.33,0,0,0-1.14-.7,1,1,0,0,0-.92.48,2.92,2.92,0,0,0-.34,1.58,3.44,3.44,0,0,0,.43,1.83,1.37,1.37,0,0,0,1.15.71,1.06,1.06,0,0,0,.92-.49A3,3,0,0,0,942.56,188.64Zm-4.91-4.26a.5.5,0,0,1-.15.37.52.52,0,0,1-.38.15.48.48,0,0,1-.37-.15.52.52,0,0,1,0-.75.48.48,0,0,1,.37-.15.52.52,0,0,1,.38.15A.5.5,0,0,1,937.65,184.38Zm.68,6.38H936.1v-.11l.21,0a.85.85,0,0,0,.35-.11.5.5,0,0,0,.15-.3,4.85,4.85,0,0,0,0-.63v-2.35a.82.82,0,0,0-.09-.5.7.7,0,0,0-.37-.24l-.29-.11v-.08l1.41-.33.09.06v3.55a4.92,4.92,0,0,0,0,.64.41.41,0,0,0,.16.29.85.85,0,0,0,.35.11l.2,0Zm-3-.46a2.78,2.78,0,0,1-.55.39,1.38,1.38,0,0,1-.65.15c-.66,0-1-.35-1-1.05v-3.33h-.7v-.08l.71-.25.61-1.49h.13v1.48h1.36v.34h-1.36v3.21c0,.52.22.78.66.79a1.06,1.06,0,0,0,.37-.07,1.68,1.68,0,0,0,.34-.19Zm-3.7-.35a3.39,3.39,0,0,1-.8.66,2.22,2.22,0,0,1-1.06.27,2.38,2.38,0,0,1-1.16-.3,2.06,2.06,0,0,1-.75-.8,2.34,2.34,0,0,1-.27-1.14,3.05,3.05,0,0,1,.33-1.38,2.51,2.51,0,0,1,.86-1,2.18,2.18,0,0,1,1.17-.36,2.51,2.51,0,0,1,1.19.28c.28.17.42.35.42.56a.58.58,0,0,1-.16.4.52.52,0,0,1-.36.14c-.32,0-.51-.34-.55-1.06a1,1,0,0,0-.26-.09,1.9,1.9,0,0,0-.37,0,1.35,1.35,0,0,0-1.1.54,2.36,2.36,0,0,0-.41,1.47,2.44,2.44,0,0,0,.5,1.61,1.61,1.61,0,0,0,1.29.62,2.08,2.08,0,0,0,.71-.12,3.15,3.15,0,0,0,.7-.39Zm-4.68.81h-2.22v-.11l.19,0a.9.9,0,0,0,.36-.11.45.45,0,0,0,.16-.29,4.92,4.92,0,0,0,0-.64v-2a1.36,1.36,0,0,0-.25-.9.9.9,0,0,0-.7-.29,1.54,1.54,0,0,0-.71.16,2.65,2.65,0,0,0-.59.42v2.63a3.39,3.39,0,0,0,0,.64.41.41,0,0,0,.15.29.9.9,0,0,0,.36.11l.2,0v.11h-2.23v-.11l.21,0a.8.8,0,0,0,.34-.11.41.41,0,0,0,.15-.3,3.34,3.34,0,0,0,0-.63v-2.35a1,1,0,0,0-.09-.5.7.7,0,0,0-.37-.24l-.29-.11v-.08l1.4-.33.09.06v.71a4.47,4.47,0,0,1,.77-.57,1.63,1.63,0,0,1,.83-.21c.92,0,1.38.48,1.4,1.49v2.13a4.92,4.92,0,0,0,0,.64.45.45,0,0,0,.15.29.85.85,0,0,0,.34.11l.21,0Zm-6.08,0c-.57,0-1.07,0-1.49,0v-.71a4.07,4.07,0,0,1-.76.57,1.69,1.69,0,0,1-.84.21c-.91,0-1.38-.49-1.39-1.49v-2.14a.82.82,0,0,0-.09-.5.7.7,0,0,0-.37-.24l-.29-.11v-.08l1.41-.33.09.06v3.23a1.31,1.31,0,0,0,.25.89.87.87,0,0,0,.7.3,1.63,1.63,0,0,0,.7-.16,2.44,2.44,0,0,0,.59-.42v-2.64a.82.82,0,0,0-.09-.5.67.67,0,0,0-.36-.24l-.29-.11v-.08l1.4-.33.09.06v3.55a4.92,4.92,0,0,0,0,.64.5.5,0,0,0,.15.29.85.85,0,0,0,.35.11l.21,0Zm-5.49-5.58h-.11l-.18-.29a2,2,0,0,0-.39-.5,1,1,0,0,0-.48-.23,3.73,3.73,0,0,0-.74-.06h-.19a6.47,6.47,0,0,0-.69,0,2.89,2.89,0,0,0-.43.09v2.92l.82,0a2.2,2.2,0,0,0,1-.15.65.65,0,0,0,.31-.56l0-.41h.14c0,.07,0,.18,0,.33s0,.29,0,.45v.45c0,.2,0,.41,0,.65s0,.4,0,.52h-.14l0-.28a1.08,1.08,0,0,0-.16-.47.62.62,0,0,0-.39-.22,3.52,3.52,0,0,0-.75-.07l-.82,0v2a3.66,3.66,0,0,0,.06.77.56.56,0,0,0,.23.37,1,1,0,0,0,.46.14l.39.05v.11h-2.89v-.11l.37-.05a.52.52,0,0,0,.47-.3,2.66,2.66,0,0,0,.12-1v-4a2.73,2.73,0,0,0-.12-1,.53.53,0,0,0-.47-.29l-.37-.05v-.11h4.68Z"
                />
                <path
                  class="cls-5"
                  d="M943.07,202.34h-2.23v-.11l.2,0a.8.8,0,0,0,.35-.11.41.41,0,0,0,.16-.29,4.92,4.92,0,0,0,0-.64v-2c0-.8-.31-1.2-.92-1.19a1.6,1.6,0,0,0-.7.17,2,2,0,0,0-.6.45c0,.06,0,.14,0,.23s0,.19,0,.28v2.08a4.92,4.92,0,0,0,0,.64.41.41,0,0,0,.15.29.9.9,0,0,0,.36.11l.2,0v.11H937.9v-.11l.2,0a.9.9,0,0,0,.36-.11.41.41,0,0,0,.15-.29,3.39,3.39,0,0,0,0-.64v-2c0-.8-.32-1.2-.93-1.19a1.47,1.47,0,0,0-.67.16,2.65,2.65,0,0,0-.59.42v2.63a3.39,3.39,0,0,0,0,.64.41.41,0,0,0,.15.29.9.9,0,0,0,.36.11l.2,0v.11H935v-.11l.21,0a.85.85,0,0,0,.34-.11.41.41,0,0,0,.15-.3,4.49,4.49,0,0,0,0-.63v-2.35a1,1,0,0,0-.09-.5.7.7,0,0,0-.37-.24L935,198v-.08l1.4-.33.09.06v.71a4.38,4.38,0,0,1,.75-.57,1.6,1.6,0,0,1,.83-.21,1.46,1.46,0,0,1,.85.22,1.13,1.13,0,0,1,.43.61,3.77,3.77,0,0,1,.79-.59,1.82,1.82,0,0,1,.86-.24c.91,0,1.36.48,1.36,1.49v2.13a4.92,4.92,0,0,0,0,.64.5.5,0,0,0,.15.29.85.85,0,0,0,.35.11l.21,0ZM934.32,200a2.52,2.52,0,0,1-.31,1.25,2.1,2.1,0,0,1-.81.86,2.33,2.33,0,0,1-1.15.32,2.35,2.35,0,0,1-1.12-.28,2,2,0,0,1-.82-.84,2.81,2.81,0,0,1-.32-1.4,2.57,2.57,0,0,1,.31-1.25,2.28,2.28,0,0,1,.81-.85,2.32,2.32,0,0,1,1.14-.32,2.36,2.36,0,0,1,1.13.28,2,2,0,0,1,.82.84A2.8,2.8,0,0,1,934.32,200Zm-.84.19a3.58,3.58,0,0,0-.44-1.83,1.36,1.36,0,0,0-1.14-.7,1,1,0,0,0-.92.48,2.91,2.91,0,0,0-.35,1.58,3.44,3.44,0,0,0,.44,1.83,1.36,1.36,0,0,0,1.14.71,1,1,0,0,0,.92-.49A2.88,2.88,0,0,0,933.48,200.22Zm-4.83-.19a2.52,2.52,0,0,1-.31,1.25,2.1,2.1,0,0,1-.81.86,2.32,2.32,0,0,1-1.14.32,2.36,2.36,0,0,1-1.13-.28,2,2,0,0,1-.82-.84,2.81,2.81,0,0,1-.32-1.4,2.57,2.57,0,0,1,.31-1.25,2.28,2.28,0,0,1,.81-.85,2.33,2.33,0,0,1,1.15-.32,2.35,2.35,0,0,1,1.12.28,2,2,0,0,1,.82.84A2.8,2.8,0,0,1,928.65,200Zm-.84.19a3.58,3.58,0,0,0-.44-1.83,1.36,1.36,0,0,0-1.14-.7,1,1,0,0,0-.92.48,2.91,2.91,0,0,0-.35,1.58,3.53,3.53,0,0,0,.44,1.83,1.37,1.37,0,0,0,1.14.71,1,1,0,0,0,.92-.49A2.88,2.88,0,0,0,927.81,200.22Zm-4,2.1-.31,0-.35,0a1.93,1.93,0,0,1-1.07-.31,2.82,2.82,0,0,1-.79-.82l-1.41-2.08h-.5l-.4,0v1.76a2.44,2.44,0,0,0,.13,1,.58.58,0,0,0,.5.29l.46.06v.11h-2.84v-.11l.37,0a.52.52,0,0,0,.47-.3,2.28,2.28,0,0,0,.12-1v-4a2.34,2.34,0,0,0-.12-1,.53.53,0,0,0-.47-.29l-.37,0v-.11h2.92a2.84,2.84,0,0,1,1.68.47,1.51,1.51,0,0,1,.64,1.27,1.42,1.42,0,0,1-.25.78,2.09,2.09,0,0,1-.62.6,3.88,3.88,0,0,1-.85.39l1.46,2.13a3.82,3.82,0,0,0,.52.67,1.26,1.26,0,0,0,.48.32,1.31,1.31,0,0,0,.58.06Zm-2.25-5a1.71,1.71,0,0,0-.39-1.24,1.54,1.54,0,0,0-1.16-.4,3.34,3.34,0,0,0-.59,0,2.43,2.43,0,0,0-.44.09V199a8,8,0,0,0,.81,0,1.94,1.94,0,0,0,1.3-.38A1.64,1.64,0,0,0,921.52,197.31Z"
                />
              </g>
              <line
                class="cls-14"
                x1="400.38"
                y1="629.24"
                x2="453.98"
                y2="629.24"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="629.24"
                x2="507.58"
                y2="629.24"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="629.24"
                x2="560.91"
                y2="629.24"
              />
              <line
                class="cls-14"
                x1="560.91"
                y1="629.24"
                x2="577.34"
                y2="629.24"
              />
              <line
                class="cls-14"
                x1="577.34"
                y1="629.24"
                x2="630.94"
                y2="629.24"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="629.24"
                x2="684.54"
                y2="629.24"
              />
              <line
                class="cls-14"
                x1="400.38"
                y1="694.15"
                x2="453.98"
                y2="694.15"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="694.15"
                x2="507.58"
                y2="694.15"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="694.15"
                x2="560.91"
                y2="694.15"
              />
              <line
                class="cls-14"
                x1="560.91"
                y1="694.15"
                x2="577.34"
                y2="694.15"
              />
              <line
                class="cls-14"
                x1="577.34"
                y1="694.15"
                x2="630.94"
                y2="694.15"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="694.15"
                x2="684.54"
                y2="694.15"
              />
              <line
                class="cls-14"
                x1="400.38"
                y1="144.42"
                x2="453.98"
                y2="144.42"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="144.42"
                x2="507.58"
                y2="144.42"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="144.42"
                x2="560.91"
                y2="144.42"
              />
              <line
                class="cls-14"
                x1="560.91"
                y1="144.42"
                x2="577.34"
                y2="144.42"
              />
              <line
                class="cls-14"
                x1="577.34"
                y1="144.42"
                x2="630.94"
                y2="144.42"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="144.42"
                x2="684.54"
                y2="144.42"
              />
              <line
                class="cls-14"
                x1="400.11"
                y1="177.01"
                x2="453.98"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="400.38"
                y1="209.33"
                x2="400.38"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="177.01"
                x2="507.58"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="209.33"
                x2="453.98"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="177.01"
                x2="561.18"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="209.33"
                x2="507.58"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="560.91"
                y1="209.33"
                x2="560.91"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="400.11"
                y1="209.33"
                x2="453.98"
                y2="209.33"
              />
              <line
                class="cls-14"
                x1="400.38"
                y1="229.53"
                x2="400.38"
                y2="209.6"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="209.33"
                x2="507.58"
                y2="209.33"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="229.53"
                x2="453.98"
                y2="209.6"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="209.33"
                x2="561.18"
                y2="209.33"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="229.53"
                x2="507.58"
                y2="209.6"
              />
              <line
                class="cls-14"
                x1="560.91"
                y1="229.53"
                x2="560.91"
                y2="209.6"
              />
              <line
                class="cls-14"
                x1="400.11"
                y1="229.8"
                x2="453.98"
                y2="229.8"
              />
              <line
                class="cls-14"
                x1="400.38"
                y1="250"
                x2="400.38"
                y2="230.07"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="229.8"
                x2="507.58"
                y2="229.8"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="250"
                x2="453.98"
                y2="230.07"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="229.8"
                x2="561.18"
                y2="229.8"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="250"
                x2="507.58"
                y2="230.07"
              />
              <line
                class="cls-14"
                x1="560.91"
                y1="250"
                x2="560.91"
                y2="230.07"
              />
              <line
                class="cls-14"
                x1="400.11"
                y1="250.27"
                x2="453.98"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="400.38"
                y1="270.47"
                x2="400.38"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="250.27"
                x2="507.58"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="270.47"
                x2="453.98"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="250.27"
                x2="561.18"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="270.47"
                x2="507.58"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="560.91"
                y1="270.47"
                x2="560.91"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="400.11"
                y1="270.47"
                x2="453.98"
                y2="270.47"
              />
              <line
                class="cls-14"
                x1="400.38"
                y1="290.67"
                x2="400.38"
                y2="270.74"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="270.47"
                x2="507.58"
                y2="270.47"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="290.67"
                x2="453.98"
                y2="270.74"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="270.47"
                x2="561.18"
                y2="270.47"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="290.67"
                x2="507.58"
                y2="270.74"
              />
              <line
                class="cls-14"
                x1="560.91"
                y1="290.67"
                x2="560.91"
                y2="270.74"
              />
              <line
                class="cls-14"
                x1="400.11"
                y1="290.94"
                x2="453.98"
                y2="290.94"
              />
              <line
                class="cls-14"
                x1="400.38"
                y1="311.14"
                x2="400.38"
                y2="291.21"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="290.94"
                x2="507.58"
                y2="290.94"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="311.14"
                x2="453.98"
                y2="291.21"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="290.94"
                x2="561.18"
                y2="290.94"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="311.14"
                x2="507.58"
                y2="291.21"
              />
              <line
                class="cls-14"
                x1="560.91"
                y1="311.14"
                x2="560.91"
                y2="291.21"
              />
              <line
                class="cls-14"
                x1="400.11"
                y1="311.41"
                x2="453.98"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="400.38"
                y1="331.61"
                x2="400.38"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="311.41"
                x2="507.58"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="331.61"
                x2="453.98"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="311.41"
                x2="561.18"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="331.61"
                x2="507.58"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="560.91"
                y1="331.61"
                x2="560.91"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="400.11"
                y1="331.61"
                x2="453.98"
                y2="331.61"
              />
              <line
                class="cls-14"
                x1="400.38"
                y1="351.81"
                x2="400.38"
                y2="331.88"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="331.61"
                x2="507.58"
                y2="331.61"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="351.81"
                x2="453.98"
                y2="331.88"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="331.61"
                x2="561.18"
                y2="331.61"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="351.81"
                x2="507.58"
                y2="331.88"
              />
              <line
                class="cls-14"
                x1="560.91"
                y1="351.81"
                x2="560.91"
                y2="331.88"
              />
              <line
                class="cls-14"
                x1="400.11"
                y1="352.08"
                x2="453.98"
                y2="352.08"
              />
              <line
                class="cls-14"
                x1="400.38"
                y1="372.28"
                x2="400.38"
                y2="352.35"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="352.08"
                x2="507.58"
                y2="352.08"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="372.28"
                x2="453.98"
                y2="352.35"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="352.08"
                x2="561.18"
                y2="352.08"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="372.28"
                x2="507.58"
                y2="352.35"
              />
              <line
                class="cls-14"
                x1="560.91"
                y1="372.28"
                x2="560.91"
                y2="352.35"
              />
              <line
                class="cls-14"
                x1="400.11"
                y1="372.55"
                x2="453.98"
                y2="372.55"
              />
              <line
                class="cls-14"
                x1="400.38"
                y1="392.75"
                x2="400.38"
                y2="372.82"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="372.55"
                x2="507.58"
                y2="372.55"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="392.75"
                x2="453.98"
                y2="372.82"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="372.55"
                x2="561.18"
                y2="372.55"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="392.75"
                x2="507.58"
                y2="372.82"
              />
              <line
                class="cls-14"
                x1="560.91"
                y1="392.75"
                x2="560.91"
                y2="372.82"
              />
              <line
                class="cls-14"
                x1="400.11"
                y1="393.02"
                x2="453.98"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="400.38"
                y1="413.22"
                x2="400.38"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="393.02"
                x2="507.58"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="413.22"
                x2="453.98"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="393.02"
                x2="561.18"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="413.22"
                x2="507.58"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="560.91"
                y1="413.22"
                x2="560.91"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="400.11"
                y1="413.22"
                x2="453.98"
                y2="413.22"
              />
              <line
                class="cls-14"
                x1="400.38"
                y1="433.42"
                x2="400.38"
                y2="413.49"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="413.22"
                x2="507.58"
                y2="413.22"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="433.42"
                x2="453.98"
                y2="413.49"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="413.22"
                x2="561.18"
                y2="413.22"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="433.42"
                x2="507.58"
                y2="413.49"
              />
              <line
                class="cls-14"
                x1="560.91"
                y1="433.42"
                x2="560.91"
                y2="413.49"
              />
              <line
                class="cls-14"
                x1="400.11"
                y1="433.69"
                x2="453.98"
                y2="433.69"
              />
              <line
                class="cls-14"
                x1="400.38"
                y1="453.89"
                x2="400.38"
                y2="433.96"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="433.69"
                x2="507.58"
                y2="433.69"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="453.89"
                x2="453.98"
                y2="433.96"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="433.69"
                x2="561.18"
                y2="433.69"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="453.89"
                x2="507.58"
                y2="433.96"
              />
              <line
                class="cls-14"
                x1="560.91"
                y1="453.89"
                x2="560.91"
                y2="433.96"
              />
              <line
                class="cls-14"
                x1="400.11"
                y1="454.16"
                x2="453.98"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="400.38"
                y1="474.36"
                x2="400.38"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="454.16"
                x2="507.58"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="474.36"
                x2="453.98"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="454.16"
                x2="561.18"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="474.36"
                x2="507.58"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="560.91"
                y1="474.36"
                x2="560.91"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="400.11"
                y1="474.36"
                x2="453.98"
                y2="474.36"
              />
              <line
                class="cls-14"
                x1="400.38"
                y1="494.56"
                x2="400.38"
                y2="474.63"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="474.36"
                x2="507.58"
                y2="474.36"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="494.56"
                x2="453.98"
                y2="474.63"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="474.36"
                x2="561.18"
                y2="474.36"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="494.56"
                x2="507.58"
                y2="474.63"
              />
              <line
                class="cls-14"
                x1="560.91"
                y1="494.56"
                x2="560.91"
                y2="474.63"
              />
              <line
                class="cls-14"
                x1="400.11"
                y1="494.83"
                x2="453.98"
                y2="494.83"
              />
              <line
                class="cls-14"
                x1="400.38"
                y1="515.03"
                x2="400.38"
                y2="495.1"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="494.83"
                x2="507.58"
                y2="494.83"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="515.03"
                x2="453.98"
                y2="495.1"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="494.83"
                x2="561.18"
                y2="494.83"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="515.03"
                x2="507.58"
                y2="495.1"
              />
              <line
                class="cls-14"
                x1="560.91"
                y1="515.03"
                x2="560.91"
                y2="495.1"
              />
              <line
                class="cls-14"
                x1="400.11"
                y1="515.3"
                x2="453.98"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="400.38"
                y1="535.5"
                x2="400.38"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="515.3"
                x2="507.58"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="535.5"
                x2="453.98"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="515.3"
                x2="561.18"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="535.5"
                x2="507.58"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="560.91"
                y1="535.5"
                x2="560.91"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="400.11"
                y1="535.5"
                x2="453.98"
                y2="535.5"
              />
              <line
                class="cls-14"
                x1="400.38"
                y1="555.97"
                x2="400.38"
                y2="535.77"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="535.5"
                x2="507.58"
                y2="535.5"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="555.97"
                x2="453.98"
                y2="535.77"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="535.5"
                x2="561.18"
                y2="535.5"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="555.97"
                x2="507.58"
                y2="535.77"
              />
              <line
                class="cls-14"
                x1="560.91"
                y1="555.97"
                x2="560.91"
                y2="535.77"
              />
              <line
                class="cls-14"
                x1="400.11"
                y1="555.97"
                x2="453.98"
                y2="555.97"
              />
              <line
                class="cls-14"
                x1="400.38"
                y1="576.17"
                x2="400.38"
                y2="556.24"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="555.97"
                x2="507.58"
                y2="555.97"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="576.17"
                x2="453.98"
                y2="556.24"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="555.97"
                x2="561.18"
                y2="555.97"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="576.17"
                x2="507.58"
                y2="556.24"
              />
              <line
                class="cls-14"
                x1="560.91"
                y1="576.17"
                x2="560.91"
                y2="556.24"
              />
              <line
                class="cls-14"
                x1="400.11"
                y1="576.44"
                x2="453.98"
                y2="576.44"
              />
              <line
                class="cls-14"
                x1="400.38"
                y1="596.64"
                x2="400.38"
                y2="576.71"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="576.44"
                x2="507.58"
                y2="576.44"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="596.64"
                x2="453.98"
                y2="576.71"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="576.44"
                x2="561.18"
                y2="576.44"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="596.64"
                x2="507.58"
                y2="576.71"
              />
              <line
                class="cls-14"
                x1="560.91"
                y1="596.64"
                x2="560.91"
                y2="576.71"
              />
              <line
                class="cls-14"
                x1="400.11"
                y1="596.91"
                x2="453.98"
                y2="596.91"
              />
              <line
                class="cls-14"
                x1="453.98"
                y1="596.91"
                x2="507.58"
                y2="596.91"
              />
              <line
                class="cls-14"
                x1="507.58"
                y1="596.91"
                x2="561.18"
                y2="596.91"
              />
              <line
                class="cls-14"
                x1="577.07"
                y1="177.01"
                x2="630.94"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="577.34"
                y1="209.33"
                x2="577.34"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="177.01"
                x2="684.54"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="209.33"
                x2="630.94"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="684.54"
                y1="209.33"
                x2="684.54"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="577.07"
                y1="209.33"
                x2="630.94"
                y2="209.33"
              />
              <line
                class="cls-14"
                x1="577.34"
                y1="229.53"
                x2="577.34"
                y2="209.6"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="209.33"
                x2="684.54"
                y2="209.33"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="229.53"
                x2="630.94"
                y2="209.6"
              />
              <line
                class="cls-14"
                x1="684.54"
                y1="229.53"
                x2="684.54"
                y2="209.6"
              />
              <line
                class="cls-14"
                x1="577.07"
                y1="229.8"
                x2="630.94"
                y2="229.8"
              />
              <line
                class="cls-14"
                x1="577.34"
                y1="250"
                x2="577.34"
                y2="230.07"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="229.8"
                x2="684.54"
                y2="229.8"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="250"
                x2="630.94"
                y2="230.07"
              />
              <line
                class="cls-14"
                x1="684.54"
                y1="250"
                x2="684.54"
                y2="230.07"
              />
              <line
                class="cls-14"
                x1="577.07"
                y1="250.27"
                x2="630.94"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="577.34"
                y1="270.47"
                x2="577.34"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="250.27"
                x2="684.54"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="270.47"
                x2="630.94"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="684.54"
                y1="270.47"
                x2="684.54"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="577.07"
                y1="270.47"
                x2="630.94"
                y2="270.47"
              />
              <line
                class="cls-14"
                x1="577.34"
                y1="290.67"
                x2="577.34"
                y2="270.74"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="270.47"
                x2="684.54"
                y2="270.47"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="290.67"
                x2="630.94"
                y2="270.74"
              />
              <line
                class="cls-14"
                x1="684.54"
                y1="290.67"
                x2="684.54"
                y2="270.74"
              />
              <line
                class="cls-14"
                x1="577.07"
                y1="290.94"
                x2="630.94"
                y2="290.94"
              />
              <line
                class="cls-14"
                x1="577.07"
                y1="352.08"
                x2="630.94"
                y2="352.08"
              />
              <line
                class="cls-14"
                x1="577.34"
                y1="372.28"
                x2="577.34"
                y2="352.35"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="372.28"
                x2="630.94"
                y2="352.35"
              />
              <line
                class="cls-14"
                x1="684.54"
                y1="372.28"
                x2="684.54"
                y2="352.35"
              />
              <line
                class="cls-14"
                x1="577.07"
                y1="372.55"
                x2="630.94"
                y2="372.55"
              />
              <line
                class="cls-14"
                x1="577.34"
                y1="392.75"
                x2="577.34"
                y2="372.82"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="372.55"
                x2="684.54"
                y2="372.55"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="392.75"
                x2="630.94"
                y2="372.82"
              />
              <line
                class="cls-14"
                x1="684.54"
                y1="392.75"
                x2="684.54"
                y2="372.82"
              />
              <line
                class="cls-14"
                x1="577.07"
                y1="393.02"
                x2="630.94"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="577.34"
                y1="413.22"
                x2="577.34"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="393.02"
                x2="684.54"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="413.22"
                x2="630.94"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="684.54"
                y1="413.22"
                x2="684.54"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="577.07"
                y1="413.22"
                x2="630.94"
                y2="413.22"
              />
              <line
                class="cls-14"
                x1="577.34"
                y1="433.42"
                x2="577.34"
                y2="413.49"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="413.22"
                x2="684.54"
                y2="413.22"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="433.42"
                x2="630.94"
                y2="413.49"
              />
              <line
                class="cls-14"
                x1="684.54"
                y1="433.42"
                x2="684.54"
                y2="413.49"
              />
              <line
                class="cls-14"
                x1="577.07"
                y1="433.69"
                x2="630.94"
                y2="433.69"
              />
              <line
                class="cls-14"
                x1="577.34"
                y1="453.89"
                x2="577.34"
                y2="433.96"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="433.69"
                x2="684.54"
                y2="433.69"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="453.89"
                x2="630.94"
                y2="433.96"
              />
              <line
                class="cls-14"
                x1="684.54"
                y1="453.89"
                x2="684.54"
                y2="433.96"
              />
              <line
                class="cls-14"
                x1="577.07"
                y1="454.16"
                x2="630.94"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="577.34"
                y1="474.36"
                x2="577.34"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="454.16"
                x2="684.54"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="474.36"
                x2="630.94"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="684.54"
                y1="474.36"
                x2="684.54"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="577.07"
                y1="474.36"
                x2="630.94"
                y2="474.36"
              />
              <line
                class="cls-14"
                x1="577.34"
                y1="494.56"
                x2="577.34"
                y2="474.63"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="474.36"
                x2="684.54"
                y2="474.36"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="494.56"
                x2="630.94"
                y2="474.63"
              />
              <line
                class="cls-14"
                x1="684.54"
                y1="494.56"
                x2="684.54"
                y2="474.63"
              />
              <line
                class="cls-14"
                x1="577.07"
                y1="494.83"
                x2="630.94"
                y2="494.83"
              />
              <line
                class="cls-14"
                x1="577.34"
                y1="515.03"
                x2="577.34"
                y2="495.1"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="494.83"
                x2="684.54"
                y2="494.83"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="515.03"
                x2="630.94"
                y2="495.1"
              />
              <line
                class="cls-14"
                x1="684.54"
                y1="515.03"
                x2="684.54"
                y2="495.1"
              />
              <line
                class="cls-14"
                x1="577.07"
                y1="515.3"
                x2="630.94"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="577.34"
                y1="535.5"
                x2="577.34"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="515.3"
                x2="684.54"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="535.5"
                x2="630.94"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="684.54"
                y1="535.5"
                x2="684.54"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="577.07"
                y1="535.5"
                x2="630.94"
                y2="535.5"
              />
              <line
                class="cls-14"
                x1="577.34"
                y1="555.97"
                x2="577.34"
                y2="535.77"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="535.5"
                x2="684.54"
                y2="535.5"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="555.97"
                x2="630.94"
                y2="535.77"
              />
              <line
                class="cls-14"
                x1="684.54"
                y1="555.97"
                x2="684.54"
                y2="535.77"
              />
              <line
                class="cls-14"
                x1="577.07"
                y1="555.97"
                x2="630.94"
                y2="555.97"
              />
              <line
                class="cls-14"
                x1="577.34"
                y1="576.17"
                x2="577.34"
                y2="556.24"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="555.97"
                x2="684.54"
                y2="555.97"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="576.17"
                x2="630.94"
                y2="556.24"
              />
              <line
                class="cls-14"
                x1="684.54"
                y1="576.17"
                x2="684.54"
                y2="556.24"
              />
              <line
                class="cls-14"
                x1="577.07"
                y1="576.44"
                x2="630.94"
                y2="576.44"
              />
              <line
                class="cls-14"
                x1="577.34"
                y1="596.64"
                x2="577.34"
                y2="576.71"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="576.44"
                x2="684.54"
                y2="576.44"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="596.64"
                x2="630.94"
                y2="576.71"
              />
              <line
                class="cls-14"
                x1="684.54"
                y1="596.64"
                x2="684.54"
                y2="576.71"
              />
              <line
                class="cls-14"
                x1="577.07"
                y1="596.91"
                x2="630.94"
                y2="596.91"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="596.91"
                x2="684.54"
                y2="596.91"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="290.94"
                x2="684.54"
                y2="290.94"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="311.14"
                x2="630.94"
                y2="291.21"
              />
              <line
                class="cls-14"
                x1="684.54"
                y1="311.14"
                x2="684.54"
                y2="291.21"
              />
              <line
                class="cls-14"
                x1="630.67"
                y1="311.41"
                x2="684.54"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="331.61"
                x2="630.94"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="684.54"
                y1="331.61"
                x2="684.54"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="630.67"
                y1="331.61"
                x2="684.54"
                y2="331.61"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="351.81"
                x2="630.94"
                y2="331.88"
              />
              <line
                class="cls-14"
                x1="684.54"
                y1="351.81"
                x2="684.54"
                y2="331.88"
              />
              <line
                class="cls-14"
                x1="630.94"
                y1="352.08"
                x2="684.54"
                y2="352.08"
              />
              <path
                class="cls-5"
                d="M390.89,152.65l-3.63,7-.19-.09,3.63-7Zm-4.74,6.4a2.78,2.78,0,0,1-.55.39,1.34,1.34,0,0,1-.64.15.91.91,0,0,1-1-1v-3.33h-.7v-.08l.71-.25.6-1.5h.13v1.49h1.36v.34H384.7v3.21c0,.51.23.78.67.78a1.06,1.06,0,0,0,.37-.06,1.53,1.53,0,0,0,.33-.2Zm-4.38-5.92a.5.5,0,0,1-.15.38.56.56,0,0,1-.38.14.51.51,0,0,1-.37-.14.52.52,0,0,1,0-.75.48.48,0,0,1,.37-.15.52.52,0,0,1,.38.15A.5.5,0,0,1,381.77,153.13Zm.68,6.38h-2.22v-.11l.2,0a.72.72,0,0,0,.35-.11.47.47,0,0,0,.15-.29,4.85,4.85,0,0,0,0-.63V156a.82.82,0,0,0-.09-.5.66.66,0,0,0-.37-.24l-.28-.11v-.08l1.4-.33.09.06v3.55a4.74,4.74,0,0,0,0,.63.43.43,0,0,0,.16.29.76.76,0,0,0,.35.11l.2,0Zm-3.28,0h-2.23v-.11l.2,0a.77.77,0,0,0,.36-.11.39.39,0,0,0,.15-.29,3.27,3.27,0,0,0,0-.63v-2a1.41,1.41,0,0,0-.25-.89.91.91,0,0,0-.71-.29,1.53,1.53,0,0,0-.7.16,2.13,2.13,0,0,0-.59.42v2.63a3.27,3.27,0,0,0,0,.63.39.39,0,0,0,.15.29.77.77,0,0,0,.36.11l.2,0v.11H374v-.11l.21,0a.72.72,0,0,0,.34-.11.39.39,0,0,0,.15-.29,4.85,4.85,0,0,0,0-.63V156a.92.92,0,0,0-.08-.5.7.7,0,0,0-.37-.24l-.29-.11v-.08l1.4-.33.09.06v.71a4.47,4.47,0,0,1,.77-.57,1.63,1.63,0,0,1,.83-.21c.92,0,1.38.48,1.39,1.48v2.14a4.37,4.37,0,0,0,0,.63.39.39,0,0,0,.15.29.72.72,0,0,0,.34.11l.21,0Zm-5.83-6.72-.14,0a1,1,0,0,0-.46.14.71.71,0,0,0-.27.37,2.47,2.47,0,0,0-.09.75l0,3a2.62,2.62,0,0,1-.7,1.9,2.76,2.76,0,0,1-2,.67,2.86,2.86,0,0,1-2-.63,2.3,2.3,0,0,1-.66-1.75v-3.12a2.69,2.69,0,0,0-.12-1,.51.51,0,0,0-.47-.29l-.37-.05v-.11h2.84v.11l-.46.06a.56.56,0,0,0-.5.28,2.44,2.44,0,0,0-.13,1v3a2.27,2.27,0,0,0,.56,1.69,2.12,2.12,0,0,0,1.54.5,2.29,2.29,0,0,0,1.63-.56,2.18,2.18,0,0,0,.61-1.68l0-3a1.83,1.83,0,0,0-.2-.95.84.84,0,0,0-.62-.28l-.28,0v-.11h2.36Z"
              />
              <path
                class="cls-5"
                d="M390.36,166.44a.85.85,0,0,1-.12.44.33.33,0,0,1-.26.15.82.82,0,0,1-.31-.11,4,4,0,0,1-.51-.34,2.2,2.2,0,0,0-.43.27,2,2,0,0,0-.36.34v2.46a3.29,3.29,0,0,0,.05.64.36.36,0,0,0,.2.28,1.14,1.14,0,0,0,.46.11l.26,0v.11h-2.45v-.11l.21,0a.68.68,0,0,0,.34-.11.39.39,0,0,0,.15-.29,4.49,4.49,0,0,0,0-.63V167.3a1,1,0,0,0-.09-.5.7.7,0,0,0-.37-.24l-.29-.11v-.08l1.4-.33.09.06v.83a4,4,0,0,1,.79-.71,1.2,1.2,0,0,1,.67-.2.67.67,0,0,1,.39.1A.37.37,0,0,1,390.36,166.44Zm-4.72,2.08a2.66,2.66,0,0,1-.31,1.25,2.21,2.21,0,0,1-.81.85,2.16,2.16,0,0,1-1.15.32,2.28,2.28,0,0,1-1.13-.28,2,2,0,0,1-.82-.83,2.93,2.93,0,0,1-.32-1.4,2.66,2.66,0,0,1,.31-1.25,2.45,2.45,0,0,1,.81-.85,2.23,2.23,0,0,1,1.15-.32,2.28,2.28,0,0,1,1.13.28,2.08,2.08,0,0,1,.82.84A3,3,0,0,1,385.64,168.52Zm-.85.19a3.49,3.49,0,0,0-.44-1.83,1.33,1.33,0,0,0-1.14-.7,1,1,0,0,0-.92.48,2.92,2.92,0,0,0-.34,1.58,3.44,3.44,0,0,0,.43,1.83,1.34,1.34,0,0,0,1.15.7,1,1,0,0,0,.92-.48A3,3,0,0,0,384.79,168.71Zm-5.12-.19a2.66,2.66,0,0,1-.31,1.25,2.21,2.21,0,0,1-.81.85,2.16,2.16,0,0,1-1.15.32,2.28,2.28,0,0,1-1.13-.28,2,2,0,0,1-.82-.83,3,3,0,0,1-.32-1.4,2.55,2.55,0,0,1,.32-1.25,2.28,2.28,0,0,1,.81-.85,2.19,2.19,0,0,1,1.14-.32,2.28,2.28,0,0,1,1.13.28,2.08,2.08,0,0,1,.82.84A2.88,2.88,0,0,1,379.67,168.52Zm-.85.19a3.49,3.49,0,0,0-.43-1.83,1.36,1.36,0,0,0-1.15-.7,1,1,0,0,0-.92.48,2.92,2.92,0,0,0-.34,1.58,3.35,3.35,0,0,0,.44,1.83,1.31,1.31,0,0,0,1.14.7,1,1,0,0,0,.92-.48A2.89,2.89,0,0,0,378.82,168.71Zm-4.52,2.11h-2.23v-.11l.21,0a.72.72,0,0,0,.34-.11.39.39,0,0,0,.15-.29,4.49,4.49,0,0,0,0-.63v-4.91a1,1,0,0,0-.09-.49.7.7,0,0,0-.37-.24l-.29-.11v-.08l1.4-.33.09.06v6.1a3.46,3.46,0,0,0,0,.64.37.37,0,0,0,.15.28.77.77,0,0,0,.36.11l.2,0Zm-3.22-5.57H371l-.17-.3a1.9,1.9,0,0,0-.39-.49,1,1,0,0,0-.48-.23,3.77,3.77,0,0,0-.75-.06H369a6.47,6.47,0,0,0-.69,0,2,2,0,0,0-.43.09v2.92l.82,0a2.23,2.23,0,0,0,1-.15.65.65,0,0,0,.31-.56l0-.41h.14c0,.07,0,.18,0,.32s0,.3,0,.46v.45c0,.2,0,.41,0,.64s0,.41,0,.53H370l0-.28a1.08,1.08,0,0,0-.16-.47.62.62,0,0,0-.39-.22,3.52,3.52,0,0,0-.75-.07l-.82,0v2a3.66,3.66,0,0,0,.06.77.59.59,0,0,0,.22.37,1.1,1.1,0,0,0,.47.13l.39.05v.11h-2.89v-.11l.37-.05a.51.51,0,0,0,.47-.29,2.69,2.69,0,0,0,.12-1v-4a2.69,2.69,0,0,0-.12-1,.51.51,0,0,0-.47-.29l-.37-.05V164h4.68Z"
              />
              <path
                class="cls-5"
                d="M663.43,162.66a2.86,2.86,0,0,1-.35,1.36,2.64,2.64,0,0,1-.92.93,2.4,2.4,0,0,1-1.27.35,2.45,2.45,0,0,1-1.31-.35,2.48,2.48,0,0,1-.94-1,3.72,3.72,0,0,1-.36-1.65,4.65,4.65,0,0,1,1-3,8,8,0,0,1,3.35-2.31l.08.17a7.1,7.1,0,0,0-2.19,1.45,3.76,3.76,0,0,0-1,1.63,6.09,6.09,0,0,0-.23,1.83,4.65,4.65,0,0,0,.47,2.28,1.41,1.41,0,0,0,1.27.76,1.2,1.2,0,0,0,1.08-.6,3.25,3.25,0,0,0,.35-1.62,3.94,3.94,0,0,0-.15-1.12,1.64,1.64,0,0,0-.49-.8,1.42,1.42,0,0,0-.93-.31,2.51,2.51,0,0,0-.67.08l-.05-.15a3.16,3.16,0,0,1,1-.18,2.16,2.16,0,0,1,1.62.61A2.26,2.26,0,0,1,663.43,162.66Zm-7.65-.36a2.69,2.69,0,0,1-.55,1.64,3.34,3.34,0,0,1-1.29,1,3.49,3.49,0,0,1-1.47.34,1.51,1.51,0,0,1-.82-.18.55.55,0,0,1-.28-.48.45.45,0,0,1,.15-.34.5.5,0,0,1,.34-.12,1,1,0,0,1,.59.19,2.63,2.63,0,0,1,.57.61,2.58,2.58,0,0,0,1-.31,2.1,2.1,0,0,0,.75-.73,2,2,0,0,0,.3-1.1,1.49,1.49,0,0,0-.46-1.19,1.87,1.87,0,0,0-1.25-.39,2,2,0,0,0-.55.07,3.16,3.16,0,0,0-.53.2l-.12-.2a12.46,12.46,0,0,0,1.65-1,3,3,0,0,0,.76-.8,1.39,1.39,0,0,0,.18-.73,1,1,0,0,0-.32-.75,1.41,1.41,0,0,0-.94-.3,2.17,2.17,0,0,0-1,.25,3.68,3.68,0,0,0-.9.68l-.12-.13a4.35,4.35,0,0,1,1.25-1.09,2.61,2.61,0,0,1,1.29-.31,1.75,1.75,0,0,1,1.18.35,1.26,1.26,0,0,1,.44,1,1.56,1.56,0,0,1-.43,1.05,5.33,5.33,0,0,1-1.34,1.06,2.39,2.39,0,0,1,1.43.49A1.59,1.59,0,0,1,655.78,162.3Zm-46.13-5.36-.36,1.09h-2.92l-.65,1.43a5.63,5.63,0,0,1,2.61.8,2.13,2.13,0,0,1,.88,1.88,2.93,2.93,0,0,1-.51,1.68,3.38,3.38,0,0,1-1.23,1.09,3.11,3.11,0,0,1-1.48.38,1.22,1.22,0,0,1-.76-.19.56.56,0,0,1-.23-.42q0-.45.57-.48a1,1,0,0,1,.57.18,3.81,3.81,0,0,1,.61.53,2.72,2.72,0,0,0,1.39-.84,2.28,2.28,0,0,0,.55-1.52,1.73,1.73,0,0,0-.85-1.58,6.21,6.21,0,0,0-2.62-.69l-.09-.11,1.34-2.94h2a2.87,2.87,0,0,0,.65-.06.79.79,0,0,0,.43-.23Zm-6.93,5.36a2.69,2.69,0,0,1-.55,1.64,3.34,3.34,0,0,1-1.29,1,3.49,3.49,0,0,1-1.47.34,1.51,1.51,0,0,1-.82-.18.55.55,0,0,1-.28-.48.45.45,0,0,1,.15-.34.5.5,0,0,1,.34-.12,1,1,0,0,1,.59.19,2.63,2.63,0,0,1,.57.61,2.58,2.58,0,0,0,1-.31,2.1,2.1,0,0,0,.75-.73,2,2,0,0,0,.3-1.1,1.49,1.49,0,0,0-.46-1.19,1.87,1.87,0,0,0-1.25-.39,2,2,0,0,0-.55.07,3.16,3.16,0,0,0-.53.2l-.12-.2a13.17,13.17,0,0,0,1.65-1,2.82,2.82,0,0,0,.75-.8,1.31,1.31,0,0,0,.19-.73,1,1,0,0,0-.32-.75,1.41,1.41,0,0,0-.94-.3,2.17,2.17,0,0,0-1.05.25,3.68,3.68,0,0,0-.9.68l-.12-.13a4.35,4.35,0,0,1,1.25-1.09,2.61,2.61,0,0,1,1.29-.31,1.77,1.77,0,0,1,1.18.35,1.26,1.26,0,0,1,.44,1,1.56,1.56,0,0,1-.43,1.05,5.33,5.33,0,0,1-1.34,1.06,2.39,2.39,0,0,1,1.43.49A1.59,1.59,0,0,1,602.72,162.3Zm-62.31.57h-1.27v2.34h-.85v-2.34h-3.62l-.08-.11,4.13-5.59h.42v5.32h1.27Zm-2.12-.38v-4.31l-3.19,4.31Zm-5.86-.19a2.63,2.63,0,0,1-.55,1.64,3.39,3.39,0,0,1-1.28,1,3.57,3.57,0,0,1-1.48.34,1.53,1.53,0,0,1-.82-.18.56.56,0,0,1-.27-.48.39.39,0,0,1,.15-.34.48.48,0,0,1,.33-.12,1,1,0,0,1,.59.19,2.45,2.45,0,0,1,.58.61,2.53,2.53,0,0,0,1-.31,2.13,2.13,0,0,0,.76-.73,2.17,2.17,0,0,0,.3-1.1,1.49,1.49,0,0,0-.47-1.19,1.84,1.84,0,0,0-1.24-.39,2,2,0,0,0-.55.07,3.62,3.62,0,0,0-.54.2l-.11-.2a12.23,12.23,0,0,0,1.64-1,2.74,2.74,0,0,0,.76-.8,1.5,1.5,0,0,0,.19-.73,1,1,0,0,0-.32-.75,1.43,1.43,0,0,0-.94-.3,2.14,2.14,0,0,0-1,.25,3.72,3.72,0,0,0-.91.68l-.11-.13a4.33,4.33,0,0,1,1.24-1.09,2.62,2.62,0,0,1,1.3-.31,1.79,1.79,0,0,1,1.18.35,1.29,1.29,0,0,1,.44,1,1.56,1.56,0,0,1-.43,1.05,5.52,5.52,0,0,1-1.34,1.06,2.36,2.36,0,0,1,1.42.49A1.56,1.56,0,0,1,532.43,162.3Zm-46.35,0a2.69,2.69,0,0,1-.55,1.64,3.34,3.34,0,0,1-1.29,1,3.49,3.49,0,0,1-1.47.34,1.51,1.51,0,0,1-.82-.18.55.55,0,0,1-.28-.48.45.45,0,0,1,.15-.34.5.5,0,0,1,.34-.12,1,1,0,0,1,.59.19,2.63,2.63,0,0,1,.57.61,2.58,2.58,0,0,0,1-.31,2.1,2.1,0,0,0,.75-.73,2,2,0,0,0,.3-1.1,1.49,1.49,0,0,0-.46-1.19,1.87,1.87,0,0,0-1.25-.39,2,2,0,0,0-.55.07,3.16,3.16,0,0,0-.53.2l-.12-.2a13.17,13.17,0,0,0,1.65-1,2.82,2.82,0,0,0,.75-.8,1.31,1.31,0,0,0,.19-.73,1,1,0,0,0-.32-.75,1.41,1.41,0,0,0-.94-.3,2.17,2.17,0,0,0-1.05.25,3.68,3.68,0,0,0-.9.68l-.12-.13a4.35,4.35,0,0,1,1.25-1.09,2.61,2.61,0,0,1,1.29-.31,1.77,1.77,0,0,1,1.18.35,1.26,1.26,0,0,1,.44,1,1.56,1.56,0,0,1-.43,1.05,5.33,5.33,0,0,1-1.34,1.06,2.39,2.39,0,0,1,1.43.49A1.59,1.59,0,0,1,486.08,162.3Zm-6.71,0a2.63,2.63,0,0,1-.55,1.64,3.39,3.39,0,0,1-1.28,1,3.57,3.57,0,0,1-1.48.34,1.53,1.53,0,0,1-.82-.18.56.56,0,0,1-.27-.48.39.39,0,0,1,.15-.34.48.48,0,0,1,.33-.12,1,1,0,0,1,.59.19,2.45,2.45,0,0,1,.58.61,2.53,2.53,0,0,0,1-.31,2.13,2.13,0,0,0,.76-.73,2.17,2.17,0,0,0,.3-1.1,1.52,1.52,0,0,0-.47-1.19,1.84,1.84,0,0,0-1.24-.39,2,2,0,0,0-.55.07,3.62,3.62,0,0,0-.54.2l-.11-.2a12.23,12.23,0,0,0,1.64-1,2.74,2.74,0,0,0,.76-.8,1.5,1.5,0,0,0,.19-.73,1,1,0,0,0-.32-.75,1.43,1.43,0,0,0-.94-.3,2.14,2.14,0,0,0-1.05.25,3.72,3.72,0,0,0-.91.68l-.11-.13a4.33,4.33,0,0,1,1.24-1.09,2.62,2.62,0,0,1,1.3-.31,1.79,1.79,0,0,1,1.18.35,1.29,1.29,0,0,1,.44,1,1.61,1.61,0,0,1-.43,1.05,5.52,5.52,0,0,1-1.34,1.06,2.36,2.36,0,0,1,1.42.49A1.56,1.56,0,0,1,479.37,162.3Zm-46.52.73-.69,2.12h-4.34l-.08-.11,2.14-2.39a14.18,14.18,0,0,0,1-1.25,4.44,4.44,0,0,0,.55-1.05,3.1,3.1,0,0,0,.17-1,1.57,1.57,0,0,0-.42-1.14,1.65,1.65,0,0,0-1.19-.45,1.74,1.74,0,0,0-1.09.36,4.38,4.38,0,0,0-.92,1l-.14-.08a4.42,4.42,0,0,1,1.11-1.46,2.29,2.29,0,0,1,1.48-.53,2,2,0,0,1,1.42.52,1.9,1.9,0,0,1,.56,1.44,2.8,2.8,0,0,1-.22,1.1,4.86,4.86,0,0,1-.64,1c-.28.35-.62.74-1,1.17l-1.95,2.12h1.84a5.18,5.18,0,0,0,1-.08,1.22,1.22,0,0,0,.6-.3,2.81,2.81,0,0,0,.49-.65l.22-.39Zm-7.35-.73a2.63,2.63,0,0,1-.55,1.64,3.39,3.39,0,0,1-1.28,1,3.56,3.56,0,0,1-1.47.34,1.55,1.55,0,0,1-.83-.18.56.56,0,0,1-.27-.48.39.39,0,0,1,.15-.34.48.48,0,0,1,.33-.12,1,1,0,0,1,.59.19,2.45,2.45,0,0,1,.58.61,2.53,2.53,0,0,0,1-.31,2.13,2.13,0,0,0,.76-.73,2.17,2.17,0,0,0,.3-1.1,1.49,1.49,0,0,0-.47-1.19,1.84,1.84,0,0,0-1.24-.39,2,2,0,0,0-.55.07,3.62,3.62,0,0,0-.54.2l-.11-.2a12.23,12.23,0,0,0,1.64-1,2.74,2.74,0,0,0,.76-.8,1.5,1.5,0,0,0,.19-.73,1,1,0,0,0-.32-.75,1.43,1.43,0,0,0-.94-.3,2.14,2.14,0,0,0-1.05.25,3.72,3.72,0,0,0-.91.68l-.11-.13a4.33,4.33,0,0,1,1.24-1.09,2.62,2.62,0,0,1,1.3-.31,1.79,1.79,0,0,1,1.18.35,1.29,1.29,0,0,1,.44,1,1.56,1.56,0,0,1-.43,1.05,5.33,5.33,0,0,1-1.34,1.06,2.36,2.36,0,0,1,1.42.49A1.56,1.56,0,0,1,425.5,162.3Z"
              />
              <path
                class="cls-5"
                d="M382,194.44a2.86,2.86,0,0,1-.35,1.36,2.64,2.64,0,0,1-.92.93,2.5,2.5,0,0,1-1.27.36,2.48,2.48,0,0,1-2.25-1.39,3.72,3.72,0,0,1-.36-1.65,4.65,4.65,0,0,1,1-3,8,8,0,0,1,3.35-2.31l.08.17a7.1,7.1,0,0,0-2.19,1.45,3.76,3.76,0,0,0-1,1.63,6.11,6.11,0,0,0-.23,1.84,4.61,4.61,0,0,0,.47,2.27,1.41,1.41,0,0,0,1.27.76,1.2,1.2,0,0,0,1.08-.6,3.25,3.25,0,0,0,.35-1.62,3.94,3.94,0,0,0-.15-1.12,1.57,1.57,0,0,0-.49-.79,1.38,1.38,0,0,0-.93-.32,2.51,2.51,0,0,0-.67.08l-.05-.15a3.16,3.16,0,0,1,1-.18,2.2,2.2,0,0,1,1.62.61A2.26,2.26,0,0,1,382,194.44Zm-7.19-5.72-.36,1.09h-2.92l-.65,1.43a5.58,5.58,0,0,1,2.6.8,2.14,2.14,0,0,1,.89,1.88,3,3,0,0,1-.52,1.68,3.27,3.27,0,0,1-1.22,1.09,3.14,3.14,0,0,1-1.49.38,1.21,1.21,0,0,1-.75-.19.56.56,0,0,1-.23-.42q0-.45.57-.48a1,1,0,0,1,.57.18,4.3,4.3,0,0,1,.61.53,2.72,2.72,0,0,0,1.39-.84,2.28,2.28,0,0,0,.55-1.52,1.73,1.73,0,0,0-.85-1.58,6.26,6.26,0,0,0-2.62-.69l-.09-.11,1.34-2.94h2a2.93,2.93,0,0,0,.65-.06.79.79,0,0,0,.43-.23Z"
              />
              <path
                class="cls-5"
                d="M381.84,215.4l-.36,1.08h-2.92l-.65,1.43a5.63,5.63,0,0,1,2.61.8,2.15,2.15,0,0,1,.88,1.89,3.06,3.06,0,0,1-.51,1.68,3.35,3.35,0,0,1-1.23,1.08,3.12,3.12,0,0,1-1.48.39,1.28,1.28,0,0,1-.76-.2.53.53,0,0,1-.23-.42c0-.3.2-.46.57-.47a1,1,0,0,1,.57.18,3.69,3.69,0,0,1,.61.52,2.59,2.59,0,0,0,1.39-.84,2.28,2.28,0,0,0,.55-1.52,1.73,1.73,0,0,0-.85-1.58,6.21,6.21,0,0,0-2.62-.69l-.09-.1,1.34-2.94h2a2.87,2.87,0,0,0,.65-.06.94.94,0,0,0,.43-.23Zm-6.47,0-.36,1.08h-2.93l-.64,1.43a5.58,5.58,0,0,1,2.6.8,2.16,2.16,0,0,1,.89,1.89,3.06,3.06,0,0,1-.52,1.68,3.24,3.24,0,0,1-1.22,1.08,3.16,3.16,0,0,1-1.49.39,1.27,1.27,0,0,1-.75-.2.53.53,0,0,1-.23-.42c0-.3.2-.46.57-.47a1,1,0,0,1,.57.18,4.14,4.14,0,0,1,.61.52,2.59,2.59,0,0,0,1.39-.84,2.28,2.28,0,0,0,.55-1.52,1.75,1.75,0,0,0-.85-1.58,6.26,6.26,0,0,0-2.62-.69l-.09-.1,1.34-2.94h2a2.93,2.93,0,0,0,.65-.06.86.86,0,0,0,.42-.23Z"
              />
              <path
                class="cls-5"
                d="M382.33,241.79h-1.27v2.34h-.84v-2.34H376.6l-.08-.11,4.12-5.59h.42v5.32h1.27Zm-2.11-.38V237.1L377,241.41Zm-5.4-5.55-.36,1.09h-2.92l-.65,1.42a5.69,5.69,0,0,1,2.6.81,2.14,2.14,0,0,1,.89,1.88,3,3,0,0,1-.52,1.68,3.36,3.36,0,0,1-1.22,1.09,3.26,3.26,0,0,1-1.49.38,1.2,1.2,0,0,1-.75-.2.53.53,0,0,1-.23-.41q0-.45.57-.48a1,1,0,0,1,.57.18,4.3,4.3,0,0,1,.61.53,2.72,2.72,0,0,0,1.39-.84,2.28,2.28,0,0,0,.55-1.52,1.72,1.72,0,0,0-.85-1.58,6,6,0,0,0-2.62-.69l-.09-.11,1.34-2.94h2a2.93,2.93,0,0,0,.65-.06.86.86,0,0,0,.43-.23Z"
              />
              <path
                class="cls-5"
                d="M381.34,261.42a2.63,2.63,0,0,1-.55,1.64,3.49,3.49,0,0,1-1.28,1,3.53,3.53,0,0,1-1.47.34,1.4,1.4,0,0,1-.82-.19.54.54,0,0,1-.28-.47.5.5,0,0,1,.15-.35.52.52,0,0,1,.33-.11,1,1,0,0,1,.59.19,2.45,2.45,0,0,1,.58.61,2.55,2.55,0,0,0,1-.32,2,2,0,0,0,.76-.73,2.15,2.15,0,0,0,.3-1.1,1.47,1.47,0,0,0-.47-1.18,1.84,1.84,0,0,0-1.24-.39,2,2,0,0,0-.55.07,3.51,3.51,0,0,0-.54.19l-.11-.19a13.21,13.21,0,0,0,1.64-1,2.72,2.72,0,0,0,.76-.79,1.5,1.5,0,0,0,.19-.73,1,1,0,0,0-.32-.75,1.33,1.33,0,0,0-.94-.3,2.26,2.26,0,0,0-1.05.24,4.58,4.58,0,0,0-.91.68l-.11-.13a4.18,4.18,0,0,1,1.25-1.08,2.68,2.68,0,0,1,1.29-.32,1.79,1.79,0,0,1,1.18.36,1.28,1.28,0,0,1,.44,1,1.6,1.6,0,0,1-.43,1,5.56,5.56,0,0,1-1.34,1.06,2.36,2.36,0,0,1,1.42.49A1.56,1.56,0,0,1,381.34,261.42Zm-6.24-5.36-.36,1.09h-2.92l-.65,1.42a5.62,5.62,0,0,1,2.61.81,2.13,2.13,0,0,1,.88,1.88,3,3,0,0,1-.51,1.68,3.47,3.47,0,0,1-1.23,1.09,3.23,3.23,0,0,1-1.48.38,1.22,1.22,0,0,1-.76-.2.53.53,0,0,1-.23-.41c0-.31.2-.46.57-.48a1,1,0,0,1,.57.18,4.3,4.3,0,0,1,.61.53,2.72,2.72,0,0,0,1.39-.84,2.28,2.28,0,0,0,.55-1.52,1.75,1.75,0,0,0-.85-1.59,6.12,6.12,0,0,0-2.62-.68l-.09-.11,1.34-2.94h2a2.93,2.93,0,0,0,.65-.06.86.86,0,0,0,.43-.23Z"
              />
              <path
                class="cls-5"
                d="M382,282.63l-.69,2.12H377l-.08-.12,2.14-2.38a15.78,15.78,0,0,0,1-1.26,4.67,4.67,0,0,0,.56-1,3.2,3.2,0,0,0,.16-1,1.48,1.48,0,0,0-1.6-1.58,1.72,1.72,0,0,0-1.09.36,4,4,0,0,0-.92,1l-.14-.08a4.32,4.32,0,0,1,1.1-1.47,2.31,2.31,0,0,1,1.49-.52,2,2,0,0,1,1.42.51,1.89,1.89,0,0,1,.55,1.44,2.64,2.64,0,0,1-.22,1.1,4.42,4.42,0,0,1-.63,1c-.28.35-.62.74-1,1.17L377.74,284h1.83a5.17,5.17,0,0,0,1-.07,1.19,1.19,0,0,0,.61-.31,2.6,2.6,0,0,0,.48-.65l.22-.38Zm-6.89-6.09-.36,1.08h-2.92l-.65,1.43a5.63,5.63,0,0,1,2.61.8,2.15,2.15,0,0,1,.88,1.89,3.06,3.06,0,0,1-.51,1.68,3.35,3.35,0,0,1-1.23,1.08,3.12,3.12,0,0,1-1.48.39,1.28,1.28,0,0,1-.76-.2.53.53,0,0,1-.23-.42c0-.3.2-.46.57-.47a1,1,0,0,1,.57.18,4.14,4.14,0,0,1,.61.52,2.59,2.59,0,0,0,1.39-.84,2.28,2.28,0,0,0,.55-1.52,1.73,1.73,0,0,0-.85-1.58,6.26,6.26,0,0,0-2.62-.69l-.09-.1,1.34-2.94h2a2.93,2.93,0,0,0,.65-.06.94.94,0,0,0,.43-.23Z"
              />
              <path
                class="cls-5"
                d="M381.36,305.22H378v-.12l.45-.06a1.23,1.23,0,0,0,.54-.16.64.64,0,0,0,.26-.43,4,4,0,0,0,.07-.89v-4.44a3.55,3.55,0,0,0-.08-.86.51.51,0,0,0-.29-.38,1.61,1.61,0,0,0-.64-.08H378v-.13a9.29,9.29,0,0,0,1.12-.23,10.1,10.1,0,0,0,1-.33l.11.05v6.4a4,4,0,0,0,.07.89.63.63,0,0,0,.25.43,1,1,0,0,0,.49.16l.39.06ZM375.63,297l-.36,1.09h-2.93l-.64,1.42a5.69,5.69,0,0,1,2.6.81,2.14,2.14,0,0,1,.89,1.88,3,3,0,0,1-.52,1.68,3.36,3.36,0,0,1-1.22,1.09,3.26,3.26,0,0,1-1.49.38,1.2,1.2,0,0,1-.75-.2.53.53,0,0,1-.23-.41q0-.45.57-.48a1,1,0,0,1,.57.18,4.3,4.3,0,0,1,.61.53,2.72,2.72,0,0,0,1.39-.84,2.28,2.28,0,0,0,.55-1.52,1.74,1.74,0,0,0-.85-1.58,6,6,0,0,0-2.62-.69l-.09-.11,1.34-2.94h2a2.93,2.93,0,0,0,.65-.06.79.79,0,0,0,.42-.23Z"
              />
              <path
                class="cls-5"
                d="M382.08,321.45a6.26,6.26,0,0,1-.32,2.1,3.54,3.54,0,0,1-.93,1.46,2.18,2.18,0,0,1-1.45.55,2.25,2.25,0,0,1-1.53-.55,3.38,3.38,0,0,1-.89-1.47,7,7,0,0,1-.29-2.09,6.25,6.25,0,0,1,.33-2.1,3.35,3.35,0,0,1,.93-1.46,2.16,2.16,0,0,1,1.45-.55,2.23,2.23,0,0,1,1.52.55,3.2,3.2,0,0,1,.89,1.47A6.73,6.73,0,0,1,382.08,321.45Zm-1,.23a8.5,8.5,0,0,0-.43-3.06,1.47,1.47,0,0,0-1.37-1.1,1.31,1.31,0,0,0-1.19,1,7.49,7.49,0,0,0-.39,2.75,8.32,8.32,0,0,0,.42,3.06,1.49,1.49,0,0,0,1.37,1.1,1.31,1.31,0,0,0,1.2-.95A7.49,7.49,0,0,0,381.07,321.68Zm-6.51-4.48-.36,1.09h-2.92l-.65,1.42a5.58,5.58,0,0,1,2.6.81,2.14,2.14,0,0,1,.89,1.88,3,3,0,0,1-.52,1.68,3.36,3.36,0,0,1-1.22,1.09,3.26,3.26,0,0,1-1.49.38,1.2,1.2,0,0,1-.75-.2.53.53,0,0,1-.23-.41q0-.45.57-.48a1,1,0,0,1,.57.18,4.3,4.3,0,0,1,.61.53,2.72,2.72,0,0,0,1.39-.84,2.28,2.28,0,0,0,.55-1.52,1.75,1.75,0,0,0-.85-1.59,6.12,6.12,0,0,0-2.62-.68l-.09-.11,1.34-2.94h2a2.93,2.93,0,0,0,.65-.06.86.86,0,0,0,.43-.23Z"
              />
              <path
                class="cls-5"
                d="M382.41,340.85a4.65,4.65,0,0,1-1,3,8,8,0,0,1-3.35,2.31L378,346a7.1,7.1,0,0,0,2.19-1.45,3.76,3.76,0,0,0,1-1.63,6.11,6.11,0,0,0,.23-1.84,4.61,4.61,0,0,0-.47-2.27,1.41,1.41,0,0,0-1.27-.76,1.2,1.2,0,0,0-1.08.6,3.25,3.25,0,0,0-.35,1.62,3.94,3.94,0,0,0,.15,1.12,1.64,1.64,0,0,0,.49.8,1.42,1.42,0,0,0,.93.31,3.72,3.72,0,0,0,.67-.08l.05.15a3.16,3.16,0,0,1-1,.18,2.16,2.16,0,0,1-1.62-.61,2.26,2.26,0,0,1-.6-1.63,2.86,2.86,0,0,1,.35-1.36,2.64,2.64,0,0,1,.92-.93,2.4,2.4,0,0,1,1.27-.35,2.45,2.45,0,0,1,1.31.35,2.48,2.48,0,0,1,.94,1A3.72,3.72,0,0,1,382.41,340.85Zm-7.08,2.76h-1.27V346h-.84v-2.34H369.6l-.08-.12,4.12-5.58h.42v5.31h1.27Zm-2.11-.39v-4.3l-3.19,4.3Z"
              />
              <path
                class="cls-5"
                d="M382.28,364.36a2,2,0,0,1-.36,1.13,2.35,2.35,0,0,1-.92.75,3.11,3.11,0,0,1-1.28.26,3.08,3.08,0,0,1-1.17-.22,2.19,2.19,0,0,1-.89-.65,1.61,1.61,0,0,1-.35-1,2,2,0,0,1,.44-1.31,4.13,4.13,0,0,1,1.37-1,2.72,2.72,0,0,1-1.15-.83,2.07,2.07,0,0,1-.43-1.3,1.72,1.72,0,0,1,.65-1.35,2.7,2.7,0,0,1,3.24-.06,1.58,1.58,0,0,1,.62,1.23,1.78,1.78,0,0,1-.44,1.14,3.57,3.57,0,0,1-1.19.85,3.85,3.85,0,0,1,1.42,1A2,2,0,0,1,382.28,364.36Zm-1.08-4.19a1.82,1.82,0,0,0-.38-1.24,1.43,1.43,0,0,0-1.15-.46,1.33,1.33,0,0,0-1.05.42,1.54,1.54,0,0,0-.39,1.05,1.39,1.39,0,0,0,.44,1.07,5,5,0,0,0,1.54.91,2.11,2.11,0,0,0,.73-.69A1.87,1.87,0,0,0,381.2,360.17Zm.35,4.45a1.52,1.52,0,0,0-.47-1.19,6,6,0,0,0-1.75-1,2.36,2.36,0,0,0-.88.87,2.48,2.48,0,0,0-.24,1.2,1.93,1.93,0,0,0,.47,1.36,1.63,1.63,0,0,0,1.24.48,1.59,1.59,0,0,0,1.18-.47A1.75,1.75,0,0,0,381.55,364.62Zm-6.22-.55h-1.27v2.34h-.84v-2.34H369.6l-.08-.11,4.12-5.59h.42v5.32h1.27Zm-2.11-.38v-4.31L370,363.69Z"
              />
              <path
                class="cls-5"
                d="M382.35,379l-1.64,3.29c-.56,1.11-1,2-1.34,2.75s-.6,1.29-.77,1.7a.34.34,0,0,1-.19.2.52.52,0,0,1-.25-.07.19.19,0,0,1-.1-.15.48.48,0,0,1,.09-.25c.26-.39.57-.94,1-1.63s.84-1.59,1.38-2.68l1.27-2.56h-2.58a3.45,3.45,0,0,0-.72.06,1,1,0,0,0-.45.19,1.67,1.67,0,0,0-.33.44l-.22.38h-.12l.66-2h.07a.58.58,0,0,0,.25.15,1.8,1.8,0,0,0,.53.07h3.44Zm-6.75,5.54h-1.27v2.34h-.85v-2.34h-3.62l-.08-.12,4.13-5.58h.42v5.32h1.27Zm-2.12-.38v-4.31l-3.19,4.31Z"
              />
              <path
                class="cls-5"
                d="M382.52,404.54a2.71,2.71,0,0,1-.35,1.35,2.57,2.57,0,0,1-.91.94,2.67,2.67,0,0,1-1.28.35,2.54,2.54,0,0,1-1.31-.35,2.49,2.49,0,0,1-.93-1,3.47,3.47,0,0,1-.36-1.65,4.62,4.62,0,0,1,1-3,8,8,0,0,1,3.35-2.31l.08.18a7.28,7.28,0,0,0-2.19,1.44,3.92,3.92,0,0,0-1,1.63,6.15,6.15,0,0,0-.23,1.84,4.61,4.61,0,0,0,.47,2.27,1.42,1.42,0,0,0,1.27.76,1.2,1.2,0,0,0,1.09-.6,3.2,3.2,0,0,0,.34-1.62,4.21,4.21,0,0,0-.14-1.11,1.67,1.67,0,0,0-.49-.8,1.42,1.42,0,0,0-.94-.31,2.2,2.2,0,0,0-.67.08l-.05-.15a3.5,3.5,0,0,1,1-.19,2.21,2.21,0,0,1,1.63.61A2.28,2.28,0,0,1,382.52,404.54Zm-7.19.21h-1.27v2.34h-.84v-2.34H369.6l-.08-.12,4.12-5.58h.42v5.31h1.27Zm-2.11-.39v-4.3l-3.19,4.3Z"
              />
              <path
                class="cls-5"
                d="M382.33,419.28l-.36,1.09h-2.92l-.65,1.42a5.74,5.74,0,0,1,2.61.81,2.13,2.13,0,0,1,.88,1.88,2.93,2.93,0,0,1-.51,1.68,3.38,3.38,0,0,1-1.23,1.09,3.23,3.23,0,0,1-1.48.38,1.29,1.29,0,0,1-.76-.19.56.56,0,0,1-.23-.42q0-.45.57-.48a1,1,0,0,1,.57.18,3.81,3.81,0,0,1,.61.53,2.68,2.68,0,0,0,1.39-.84,2.28,2.28,0,0,0,.55-1.52,1.72,1.72,0,0,0-.85-1.58,6.07,6.07,0,0,0-2.62-.69l-.09-.11,1.34-2.94h2a2.87,2.87,0,0,0,.65-.06.86.86,0,0,0,.43-.23Zm-6.47,5.93h-1.27v2.34h-.85v-2.34h-3.62l-.08-.11,4.13-5.59h.42v5.32h1.27Zm-2.12-.38v-4.31l-3.19,4.31Z"
              />
              <path
                class="cls-5"
                d="M383.19,445.69h-1.27V448h-.84v-2.34h-3.62l-.08-.12L381.5,440h.42v5.32h1.27Zm-2.11-.38V441l-3.19,4.31Zm-5.75.38h-1.27V448h-.84v-2.34H369.6l-.08-.12,4.12-5.58h.42v5.32h1.27Zm-2.11-.38V441L370,445.31Z"
              />
              <path
                class="cls-5"
                d="M381.84,465.32a2.65,2.65,0,0,1-.55,1.64,3.49,3.49,0,0,1-1.28,1,3.73,3.73,0,0,1-1.48.34,1.44,1.44,0,0,1-.82-.19.55.55,0,0,1-.27-.47.41.41,0,0,1,.15-.35.48.48,0,0,1,.33-.12,1.06,1.06,0,0,1,.59.19,2.45,2.45,0,0,1,.58.61,2.38,2.38,0,0,0,1-.31,2.06,2.06,0,0,0,1.06-1.83,1.5,1.5,0,0,0-.47-1.19,1.84,1.84,0,0,0-1.24-.38,2.44,2.44,0,0,0-.55.06,5.21,5.21,0,0,0-.54.2l-.11-.2a12.23,12.23,0,0,0,1.64-1,2.72,2.72,0,0,0,.76-.79,1.53,1.53,0,0,0,.19-.73,1,1,0,0,0-.32-.76,1.43,1.43,0,0,0-.94-.3,2.26,2.26,0,0,0-1.05.25,4,4,0,0,0-.91.68l-.11-.13a4.28,4.28,0,0,1,1.24-1.08,2.63,2.63,0,0,1,1.3-.32,1.84,1.84,0,0,1,1.18.35,1.32,1.32,0,0,1,.44,1,1.65,1.65,0,0,1-.43,1.05,6,6,0,0,1-1.34,1.06,2.3,2.3,0,0,1,1.42.49A1.55,1.55,0,0,1,381.84,465.32Zm-6.24.57h-1.27v2.34h-.85v-2.34h-3.62l-.08-.12,4.13-5.58h.42v5.31h1.27Zm-2.12-.39v-4.3l-3.19,4.3Z"
              />
              <path
                class="cls-5"
                d="M382.57,486.51l-.7,2.12h-4.33l-.08-.11,2.14-2.39a14.17,14.17,0,0,0,1-1.26,3.9,3.9,0,0,0,.55-1,2.9,2.9,0,0,0,.17-1,1.57,1.57,0,0,0-.42-1.14,1.62,1.62,0,0,0-1.18-.45,1.77,1.77,0,0,0-1.1.36,4.38,4.38,0,0,0-.92,1l-.13-.08a4.28,4.28,0,0,1,1.1-1.46,2.29,2.29,0,0,1,1.48-.53,2.07,2.07,0,0,1,1.43.52,1.9,1.9,0,0,1,.55,1.44,2.64,2.64,0,0,1-.22,1.1,4.79,4.79,0,0,1-.63,1c-.28.34-.62.73-1,1.17l-2,2.12h1.84a5,5,0,0,0,1-.08,1.3,1.3,0,0,0,.61-.3,2.81,2.81,0,0,0,.48-.65l.22-.39Zm-7.24-.16h-1.27v2.34h-.84v-2.34H369.6l-.08-.11,4.12-5.59h.42V486h1.27Zm-2.11-.38v-4.31L370,486Z"
              />
              <path
                class="cls-5"
                d="M381.56,509.12h-.42l-.65,0h-1.17l-.7,0h-.47V509l.45-.05a1.33,1.33,0,0,0,.54-.16.61.61,0,0,0,.26-.43,4.06,4.06,0,0,0,.07-.9V503a3.76,3.76,0,0,0-.07-.87.52.52,0,0,0-.3-.37,1.58,1.58,0,0,0-.63-.08h-.32v-.13a7.46,7.46,0,0,0,1.12-.24,7.15,7.15,0,0,0,1-.33l.1.06v6.39a4.06,4.06,0,0,0,.07.9.67.67,0,0,0,.25.43,1.18,1.18,0,0,0,.49.16l.39.05Zm-5.15-2.29h-1.27v2.34h-.85v-2.34h-3.62l-.08-.12,4.13-5.58h.42v5.32h1.27Zm-2.12-.38v-4.31l-3.19,4.31Z"
              />
              <path
                class="cls-5"
                d="M382.57,525.35a6.16,6.16,0,0,1-.32,2.09,3.32,3.32,0,0,1-.93,1.47,2.16,2.16,0,0,1-1.45.55,2.21,2.21,0,0,1-1.53-.56,3.29,3.29,0,0,1-.89-1.46,7.08,7.08,0,0,1-.29-2.09,6.25,6.25,0,0,1,.33-2.1,3.29,3.29,0,0,1,.93-1.46,2.11,2.11,0,0,1,1.45-.55,2.22,2.22,0,0,1,1.53.55,3.27,3.27,0,0,1,.89,1.47A7,7,0,0,1,382.57,525.35Zm-1,.23a8.54,8.54,0,0,0-.42-3.06,1.48,1.48,0,0,0-1.37-1.1,1.31,1.31,0,0,0-1.2,1,7.49,7.49,0,0,0-.39,2.75,8.32,8.32,0,0,0,.42,3.06,1.47,1.47,0,0,0,1.37,1.09,1.29,1.29,0,0,0,1.2-.95A7.44,7.44,0,0,0,381.56,525.58ZM375.05,527h-1.27v2.34h-.85V527h-3.61l-.09-.12,4.13-5.58h.42v5.31h1.27Zm-2.12-.39v-4.3l-3.19,4.3Z"
              />
              <path
                class="cls-5"
                d="M382.12,544.74a4.62,4.62,0,0,1-1,3,8,8,0,0,1-3.35,2.31l-.08-.18a7.28,7.28,0,0,0,2.19-1.44,3.82,3.82,0,0,0,1-1.63,6.15,6.15,0,0,0,.23-1.84,4.68,4.68,0,0,0-.47-2.28,1.43,1.43,0,0,0-1.27-.75,1.16,1.16,0,0,0-1.08.6,3.09,3.09,0,0,0-.35,1.62,4.21,4.21,0,0,0,.14,1.11,1.62,1.62,0,0,0,.5.8,1.37,1.37,0,0,0,.93.31,2.56,2.56,0,0,0,.67-.08l.05.15a3.44,3.44,0,0,1-1,.19,2.19,2.19,0,0,1-1.62-.61,2.29,2.29,0,0,1-.6-1.64,2.82,2.82,0,0,1,.35-1.35,2.52,2.52,0,0,1,.92-.94,2.6,2.6,0,0,1,1.27-.35,2.54,2.54,0,0,1,1.31.35,2.58,2.58,0,0,1,.94,1A3.59,3.59,0,0,1,382.12,544.74Zm-7.53,2.18a2.69,2.69,0,0,1-.55,1.64,3.34,3.34,0,0,1-1.29,1,3.49,3.49,0,0,1-1.47.34,1.51,1.51,0,0,1-.82-.18.57.57,0,0,1-.28-.48.5.5,0,0,1,.15-.35.58.58,0,0,1,.34-.11,1,1,0,0,1,.59.19,2.64,2.64,0,0,1,.58.61,2.53,2.53,0,0,0,1-.31,2.18,2.18,0,0,0,.75-.73,2,2,0,0,0,.3-1.1,1.49,1.49,0,0,0-.46-1.19,1.87,1.87,0,0,0-1.25-.39,2,2,0,0,0-.55.07,3.16,3.16,0,0,0-.53.2l-.12-.2a11.71,11.71,0,0,0,1.65-1,2.74,2.74,0,0,0,.76-.79,1.39,1.39,0,0,0,.18-.73.93.93,0,0,0-.32-.75,1.41,1.41,0,0,0-.94-.3,2.13,2.13,0,0,0-1,.25,3.74,3.74,0,0,0-.91.67l-.12-.12a4.35,4.35,0,0,1,1.25-1.09,2.62,2.62,0,0,1,1.3-.31,1.74,1.74,0,0,1,1.17.35,1.22,1.22,0,0,1,.44,1,1.62,1.62,0,0,1-.42,1,5.6,5.6,0,0,1-1.35,1.06,2.39,2.39,0,0,1,1.43.49A1.56,1.56,0,0,1,374.59,546.92Z"
              />
              <path
                class="cls-5"
                d="M382,568.26a2,2,0,0,1-.36,1.13,2.24,2.24,0,0,1-.92.74,3,3,0,0,1-1.28.27,2.87,2.87,0,0,1-1.17-.23,2.17,2.17,0,0,1-.89-.64,1.58,1.58,0,0,1-.35-1,2,2,0,0,1,.44-1.31,4,4,0,0,1,1.37-1,3,3,0,0,1-1.16-.83,2.07,2.07,0,0,1-.42-1.3,1.71,1.71,0,0,1,.64-1.35,2.55,2.55,0,0,1,1.69-.57,2.43,2.43,0,0,1,1.56.51,1.61,1.61,0,0,1,.62,1.22,1.79,1.79,0,0,1-.44,1.15,3.83,3.83,0,0,1-1.19.85,3.63,3.63,0,0,1,1.42,1A2.1,2.1,0,0,1,382,568.26Zm-1.08-4.19a1.87,1.87,0,0,0-.38-1.24,1.47,1.47,0,0,0-1.16-.47,1.37,1.37,0,0,0-1,.43,1.53,1.53,0,0,0-.39,1,1.4,1.4,0,0,0,.44,1.08,5,5,0,0,0,1.54.9,2.09,2.09,0,0,0,.73-.68A1.87,1.87,0,0,0,380.92,564.07Zm.35,4.44a1.55,1.55,0,0,0-.47-1.18,6,6,0,0,0-1.75-1,2.36,2.36,0,0,0-.88.87,2.44,2.44,0,0,0-.24,1.19,1.91,1.91,0,0,0,.47,1.36,1.58,1.58,0,0,0,1.24.49,1.64,1.64,0,0,0,1.18-.47A1.75,1.75,0,0,0,381.27,568.51Zm-6.68-1.11A2.69,2.69,0,0,1,374,569a3.44,3.44,0,0,1-1.29,1,3.49,3.49,0,0,1-1.47.34,1.42,1.42,0,0,1-.82-.19.56.56,0,0,1-.28-.47.48.48,0,0,1,.15-.35.51.51,0,0,1,.34-.11,1,1,0,0,1,.59.19,2.57,2.57,0,0,1,.58.6,2.38,2.38,0,0,0,1-.31,2.1,2.1,0,0,0,.75-.73,2,2,0,0,0,.3-1.1,1.5,1.5,0,0,0-.46-1.19,1.92,1.92,0,0,0-1.25-.38,2,2,0,0,0-.55.07,3.09,3.09,0,0,0-.53.19l-.12-.19a12.72,12.72,0,0,0,1.65-1,2.87,2.87,0,0,0,.76-.79,1.39,1.39,0,0,0,.18-.73.93.93,0,0,0-.32-.75,1.36,1.36,0,0,0-.94-.31,2.25,2.25,0,0,0-1,.25,4.07,4.07,0,0,0-.91.68l-.12-.13a4.3,4.3,0,0,1,1.25-1.08,2.63,2.63,0,0,1,1.3-.32,1.74,1.74,0,0,1,1.17.36,1.22,1.22,0,0,1,.44,1,1.64,1.64,0,0,1-.42,1,5.86,5.86,0,0,1-1.35,1.06,2.39,2.39,0,0,1,1.43.49A1.56,1.56,0,0,1,374.59,567.4Z"
              />
              <path
                class="cls-5"
                d="M382.08,582.9l-1.64,3.29c-.55,1.1-1,2-1.34,2.74s-.59,1.29-.76,1.7c-.06.12-.12.19-.2.2a.48.48,0,0,1-.24-.06.21.21,0,0,1-.11-.16.4.4,0,0,1,.1-.24c.25-.4.57-.94.94-1.64s.84-1.58,1.38-2.67l1.27-2.56H378.9a4.48,4.48,0,0,0-.72,0,.94.94,0,0,0-.44.2,1.57,1.57,0,0,0-.34.43l-.22.39h-.11l.65-2h.07a.82.82,0,0,0,.25.16,2.48,2.48,0,0,0,.53.06H382Zm-7.21,5a2.69,2.69,0,0,1-.55,1.63,3.39,3.39,0,0,1-1.28,1,3.57,3.57,0,0,1-1.48.34,1.53,1.53,0,0,1-.82-.18.56.56,0,0,1-.28-.48.45.45,0,0,1,.15-.34.52.52,0,0,1,.34-.12,1,1,0,0,1,.59.19,2.64,2.64,0,0,1,.58.61,2.53,2.53,0,0,0,1-.31,2.21,2.21,0,0,0,.76-.73,2.17,2.17,0,0,0,.3-1.1,1.52,1.52,0,0,0-.47-1.19,1.86,1.86,0,0,0-1.24-.39,2.36,2.36,0,0,0-.55.07,3,3,0,0,0-.54.2l-.12-.2a11.82,11.82,0,0,0,1.65-1,2.88,2.88,0,0,0,.76-.8,1.39,1.39,0,0,0,.18-.73,1,1,0,0,0-.31-.75,1.46,1.46,0,0,0-.95-.3,2.13,2.13,0,0,0-1,.25,3.54,3.54,0,0,0-.91.68l-.12-.13a4.44,4.44,0,0,1,1.25-1.08,2.63,2.63,0,0,1,1.3-.32,1.84,1.84,0,0,1,1.18.35,1.29,1.29,0,0,1,.44,1,1.61,1.61,0,0,1-.43,1.05,5.52,5.52,0,0,1-1.34,1.06,2.36,2.36,0,0,1,1.42.49A1.57,1.57,0,0,1,374.87,587.87Z"
              />
              <path
                class="cls-5"
                d="M382.24,614.35a2.89,2.89,0,0,1-.35,1.36,2.56,2.56,0,0,1-.92.93,2.4,2.4,0,0,1-1.27.35,2.45,2.45,0,0,1-1.31-.35,2.48,2.48,0,0,1-.94-1,3.59,3.59,0,0,1-.35-1.65,4.63,4.63,0,0,1,1-3,8.11,8.11,0,0,1,3.35-2.3l.08.17a7.1,7.1,0,0,0-2.19,1.45,3.76,3.76,0,0,0-1,1.63,6.09,6.09,0,0,0-.23,1.83,4.65,4.65,0,0,0,.47,2.28,1.42,1.42,0,0,0,1.27.76,1.2,1.2,0,0,0,1.08-.6,3.25,3.25,0,0,0,.35-1.62,4.35,4.35,0,0,0-.14-1.12,1.62,1.62,0,0,0-.5-.8,1.42,1.42,0,0,0-.93-.31,2.56,2.56,0,0,0-.67.08l-.05-.15a3.16,3.16,0,0,1,1-.18,2.18,2.18,0,0,1,1.62.6A2.3,2.3,0,0,1,382.24,614.35Zm-7.65-.36a2.69,2.69,0,0,1-.55,1.64,3.34,3.34,0,0,1-1.29,1,3.49,3.49,0,0,1-1.47.34,1.51,1.51,0,0,1-.82-.18.57.57,0,0,1-.28-.48.5.5,0,0,1,.15-.35.58.58,0,0,1,.34-.11,1,1,0,0,1,.59.19,2.64,2.64,0,0,1,.58.61,2.53,2.53,0,0,0,1-.31,2.18,2.18,0,0,0,.75-.73,2,2,0,0,0,.3-1.1,1.49,1.49,0,0,0-.46-1.19,1.87,1.87,0,0,0-1.25-.39,2,2,0,0,0-.55.07,3.16,3.16,0,0,0-.53.2L371,613a12.86,12.86,0,0,0,1.65-1,2.88,2.88,0,0,0,.76-.8,1.39,1.39,0,0,0,.18-.73.93.93,0,0,0-.32-.75,1.41,1.41,0,0,0-.94-.3,2.13,2.13,0,0,0-1,.25,3.74,3.74,0,0,0-.91.67l-.12-.12a4.35,4.35,0,0,1,1.25-1.09,2.62,2.62,0,0,1,1.3-.31,1.74,1.74,0,0,1,1.17.35,1.22,1.22,0,0,1,.44,1,1.62,1.62,0,0,1-.42,1.05,5.6,5.6,0,0,1-1.35,1.06,2.39,2.39,0,0,1,1.43.49A1.56,1.56,0,0,1,374.59,614Z"
              />
              <path
                class="cls-5"
                d="M564.19,616.4a2.78,2.78,0,0,1-.55.39,1.34,1.34,0,0,1-.64.15c-.67,0-1-.35-1-1v-3.33h-.69v-.08l.7-.25.61-1.5h.13v1.49h1.36v.34h-1.36v3.21c0,.51.23.78.66.78a1,1,0,0,0,.37-.06,1.37,1.37,0,0,0,.34-.2Zm-3.65-3.92a.85.85,0,0,1-.12.44.34.34,0,0,1-.26.15.82.82,0,0,1-.31-.11,4,4,0,0,1-.51-.34,2.2,2.2,0,0,0-.43.27,2.31,2.31,0,0,0-.36.33v2.47a3.17,3.17,0,0,0,.05.63.37.37,0,0,0,.19.29,1.25,1.25,0,0,0,.47.11l.26,0v.11h-2.45v-.11l.21,0a.72.72,0,0,0,.34-.11.39.39,0,0,0,.15-.29,4.85,4.85,0,0,0,0-.63v-2.36a.81.81,0,0,0-.09-.49.63.63,0,0,0-.36-.24l-.29-.11v-.08l1.4-.33.09.06V613a3.72,3.72,0,0,1,.79-.71,1.18,1.18,0,0,1,.67-.2.67.67,0,0,1,.39.1A.36.36,0,0,1,560.54,612.48Zm-4,4.38c-.57,0-1.06,0-1.48,0v-.71a4.07,4.07,0,0,1-.76.57,1.69,1.69,0,0,1-.84.21c-.92,0-1.38-.48-1.39-1.48v-2.15a1,1,0,0,0-.09-.49.7.7,0,0,0-.37-.24l-.29-.11v-.08l1.4-.33.09.06v3.23a1.39,1.39,0,0,0,.25.89.88.88,0,0,0,.71.29,1.53,1.53,0,0,0,.7-.16A2.32,2.32,0,0,0,555,616v-2.65a.81.81,0,0,0-.09-.49.7.7,0,0,0-.37-.24l-.29-.11v-.08l1.41-.33.09.06v3.55a4.85,4.85,0,0,0,0,.63.39.39,0,0,0,.15.29.72.72,0,0,0,.34.11l.21,0Zm-5.75-2.3a2.54,2.54,0,0,1-.31,1.25,2.21,2.21,0,0,1-.81.85,2.14,2.14,0,0,1-1.15.32,2.24,2.24,0,0,1-1.12-.28,2,2,0,0,1-.83-.83,3,3,0,0,1-.31-1.4,2.54,2.54,0,0,1,.31-1.25,2.23,2.23,0,0,1,2-1.17,2.26,2.26,0,0,1,1.13.28,2,2,0,0,1,.82.83A2.84,2.84,0,0,1,550.74,614.56Zm-.84.19a3.58,3.58,0,0,0-.44-1.83,1.36,1.36,0,0,0-1.14-.7,1,1,0,0,0-.93.48,3,3,0,0,0-.34,1.58,3.46,3.46,0,0,0,.44,1.83,1.34,1.34,0,0,0,1.14.7,1,1,0,0,0,.92-.48A2.91,2.91,0,0,0,549.9,614.75Zm-4.79.33-.24,1.39a3.49,3.49,0,0,1-1,.37,5.11,5.11,0,0,1-1.31.14,3.93,3.93,0,0,1-1.84-.42,3.13,3.13,0,0,1-1.28-1.22,3.8,3.8,0,0,1-.48-1.9,3.55,3.55,0,0,1,.54-1.88,3.69,3.69,0,0,1,1.32-1.23,3.65,3.65,0,0,1,1.7-.42,5.18,5.18,0,0,1,1.29.13,4.35,4.35,0,0,1,.89.34l.24,1.43h-.12l-.13-.28a2.58,2.58,0,0,0-.8-1,2.54,2.54,0,0,0-3.29.45,3.82,3.82,0,0,0-.71,2.41,4,4,0,0,0,.77,2.54,2.46,2.46,0,0,0,2,.92,2.26,2.26,0,0,0,1.34-.36,2.57,2.57,0,0,0,.83-1.09l.13-.28Zm-9.19-2.8-.19,0a.65.65,0,0,0-.44.24,3.38,3.38,0,0,0-.39.76L533,617.9a2.78,2.78,0,0,1-.53.86.74.74,0,0,1-.57.24.38.38,0,0,1-.31-.11.44.44,0,0,1-.1-.3.43.43,0,0,1,.3-.4,1.57,1.57,0,0,1,.85-.08c.18-.33.38-.75.6-1.27l-1.54-3.6a2.89,2.89,0,0,0-.36-.72.61.61,0,0,0-.42-.21l-.21,0v-.11h2.23v.11l-.26,0a.59.59,0,0,0-.31.1.22.22,0,0,0-.07.2.93.93,0,0,0,0,.27c0,.1.06.2.1.3l1.14,2.87,1-2.44a3.34,3.34,0,0,0,.26-1,.36.36,0,0,0-.36-.35l-.27,0v-.11h1.77Zm-5.65,4.58H529a8.51,8.51,0,0,0-.65-1l-1-1.47-.34.32v1a4.85,4.85,0,0,0,0,.63.43.43,0,0,0,.16.29.77.77,0,0,0,.36.11l.2,0v.11h-2.23v-.11l.21,0a.72.72,0,0,0,.34-.11.39.39,0,0,0,.15-.29,4.85,4.85,0,0,0,0-.63v-4.91a.84.84,0,0,0-.09-.5.72.72,0,0,0-.36-.23l-.29-.11v-.08l1.4-.33.09.06v4.87l1.18-1.11a5.68,5.68,0,0,0,.42-.41.48.48,0,0,0,.13-.29c0-.18-.13-.28-.41-.32l-.21,0v-.12h2v.11h-.11a.87.87,0,0,0-.47.15,3.82,3.82,0,0,0-.62.5l-1.09,1,1.53,2.1a4.33,4.33,0,0,0,.45.53.65.65,0,0,0,.35.16l.19,0ZM524.74,615a1.77,1.77,0,0,1-.33,1,2.28,2.28,0,0,1-.89.67,3.31,3.31,0,0,1-1.3.24,4.56,4.56,0,0,1-1.05-.1,2.6,2.6,0,0,1-.7-.23l-.23-1.31h.12l.14.29a2.18,2.18,0,0,0,.76.92,1.85,1.85,0,0,0,1,.26,2.07,2.07,0,0,0,1.33-.37,1.3,1.3,0,0,0,.46-1.08,1.22,1.22,0,0,0-.35-1,3,3,0,0,0-1.26-.59,3.73,3.73,0,0,1-1.51-.72,1.62,1.62,0,0,1-.52-1.3,1.67,1.67,0,0,1,.31-1,2,2,0,0,1,.79-.64,2.6,2.6,0,0,1,1.13-.23,4.57,4.57,0,0,1,1,.08,2.65,2.65,0,0,1,.67.21l.22,1.35h-.12l-.13-.29a2.2,2.2,0,0,0-.69-.92,2,2,0,0,0-2.11.1,1.27,1.27,0,0,0-.39,1,1.17,1.17,0,0,0,.33.92,3.21,3.21,0,0,0,1.27.58,3.37,3.37,0,0,1,1.57.79A1.73,1.73,0,0,1,524.74,615Z"
              />
              <path
                class="cls-15"
                d="M625,666.66V657h.82l5.28,5.73V657h1.95v9.62h-.83L627,660.93v5.73Zm-10.74-7.22a3.71,3.71,0,0,0,0,4.82,3.27,3.27,0,0,0,4.55,0,3.71,3.71,0,0,0,0-4.82,3.3,3.3,0,0,0-4.55,0Zm-2.44,4.4a5.15,5.15,0,0,1,0-4,5,5,0,0,1,1.08-1.59,5.17,5.17,0,0,1,1.63-1,5.48,5.48,0,0,1,4,0,5.06,5.06,0,0,1,1.63,1,4.67,4.67,0,0,1,1.08,1.59,5.15,5.15,0,0,1,0,4,4.67,4.67,0,0,1-1.08,1.59,4.9,4.9,0,0,1-1.63,1,5.48,5.48,0,0,1-4,0,4.78,4.78,0,0,1-2.71-2.63Zm-5.33,2.82V657h2v9.62Zm-9.87-8V657h6.55v1.65h-2.3v8h-1.94v-8Zm-11.11,3.16a5,5,0,0,1,.67-2.57,4.72,4.72,0,0,1,1.84-1.79,5.42,5.42,0,0,1,2.61-.64,5.82,5.82,0,0,1,1.49.17,4.93,4.93,0,0,1,1.26.56l.16,2h-.26a4.26,4.26,0,0,0-2.57-1,3.1,3.1,0,0,0-2.38.91,3.22,3.22,0,0,0-.87,2.33,3.26,3.26,0,0,0,.87,2.34,3.14,3.14,0,0,0,2.38.91,4.23,4.23,0,0,0,2.57-1h.26l-.16,2a5,5,0,0,1-1.27.56,5.33,5.33,0,0,1-1.48.17,5.46,5.46,0,0,1-2-.37,5.14,5.14,0,0,1-1.63-1,4.79,4.79,0,0,1-1.07-1.59A5.18,5.18,0,0,1,585.52,661.85Zm-8.91,4.81V657h6.1v1.65h-4.15v2.2h4v1.65h-4V665h4.2v1.65Zm-10,0V657h1.95v8h4.69v1.65Zm-10,0V657h1.94v8h4.69v1.65Zm-10.74-7.22a3.71,3.71,0,0,0,0,4.82,3.27,3.27,0,0,0,4.55,0,3.71,3.71,0,0,0,0-4.82,3.3,3.3,0,0,0-4.55,0Zm-2.44,4.4a5.15,5.15,0,0,1,0-4,4.67,4.67,0,0,1,1.08-1.59,5.06,5.06,0,0,1,1.63-1,5.48,5.48,0,0,1,4,0,5.17,5.17,0,0,1,1.63,1,5,5,0,0,1,1.08,1.59,5.15,5.15,0,0,1,0,4,4.78,4.78,0,0,1-2.71,2.63,5.48,5.48,0,0,1-4,0,4.9,4.9,0,0,1-1.63-1A4.67,4.67,0,0,1,543.42,663.84Zm-11-2a5,5,0,0,1,.67-2.57,4.72,4.72,0,0,1,1.84-1.79,5.42,5.42,0,0,1,2.61-.64,5.82,5.82,0,0,1,1.49.17,4.93,4.93,0,0,1,1.26.56l.16,2h-.26a4.26,4.26,0,0,0-2.57-1,3.1,3.1,0,0,0-2.38.91,3.22,3.22,0,0,0-.87,2.33,3.26,3.26,0,0,0,.87,2.34,3.14,3.14,0,0,0,2.38.91,4.23,4.23,0,0,0,2.57-1h.26l-.16,2a5,5,0,0,1-1.27.56,5.33,5.33,0,0,1-1.48.17,5.46,5.46,0,0,1-2-.37,5.14,5.14,0,0,1-1.63-1,4.79,4.79,0,0,1-1.07-1.59A5.18,5.18,0,0,1,532.46,661.85Zm-17.54,4.81V657h.82l5.27,5.73V657h2v9.62h-.82l-5.28-5.73v5.73Zm-10.6-7.22a3.68,3.68,0,0,0,0,4.82,3.26,3.26,0,0,0,4.54,0,3.68,3.68,0,0,0,0-4.82,3.29,3.29,0,0,0-4.54,0Zm-2.45,4.4a5.27,5.27,0,0,1,0-4,4.84,4.84,0,0,1,1.09-1.59,5,5,0,0,1,1.63-1,5.48,5.48,0,0,1,4,0,5.17,5.17,0,0,1,1.63,1,5,5,0,0,1,1.08,1.59,5.27,5.27,0,0,1,0,4,4.78,4.78,0,0,1-2.71,2.63,5.48,5.48,0,0,1-4,0,4.84,4.84,0,0,1-2.72-2.63Zm-10.4,2.82v-.27l4.51-7.7h-4.1V657h7v.28L494.36,665H499v1.65Zm-4.94,0V657h2v9.62Zm-8.19-5.74h.91c1,0,1.44-.37,1.44-1.1s-.48-1.1-1.44-1.1h-.91Zm-1.95,5.74V657h3a3.53,3.53,0,0,1,2.32.74,2.52,2.52,0,0,1,.9,2,2.63,2.63,0,0,1-.48,1.59,2.78,2.78,0,0,1-1.33,1l2.56,4.29h-2.15l-2.44-4.06h-.46v4.06Zm-10.6-7.22a3.71,3.71,0,0,0,0,4.82,3.27,3.27,0,0,0,4.55,0,3.71,3.71,0,0,0,0-4.82,3.3,3.3,0,0,0-4.55,0Zm-2.44,4.4a5.15,5.15,0,0,1,0-4,4.67,4.67,0,0,1,1.08-1.59,5.06,5.06,0,0,1,1.63-1,5.48,5.48,0,0,1,4,0,5.17,5.17,0,0,1,1.63,1,5,5,0,0,1,1.08,1.59,5.15,5.15,0,0,1,0,4,4.78,4.78,0,0,1-2.71,2.63,5.48,5.48,0,0,1-4,0,4.9,4.9,0,0,1-1.63-1A4.67,4.67,0,0,1,463.35,663.84Zm-11.23,2.82V657h1.95v3.72h3.81V657h1.95v9.62h-1.95v-4.25h-3.81v4.25Z"
              />
              <line
                class="cls-14"
                x1="46.35"
                y1="144.42"
                x2="99.68"
                y2="144.42"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="144.42"
                x2="153.28"
                y2="144.42"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="144.42"
                x2="206.88"
                y2="144.42"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="144.42"
                x2="260.48"
                y2="144.42"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="144.42"
                x2="330.78"
                y2="144.42"
              />
              <line
                class="cls-14"
                x1="46.08"
                y1="177.01"
                x2="99.68"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="46.35"
                y1="209.33"
                x2="46.35"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="46.08"
                y1="209.33"
                x2="99.68"
                y2="209.33"
              />
              <line
                class="cls-14"
                x1="46.35"
                y1="229.53"
                x2="46.35"
                y2="209.6"
              />
              <line
                class="cls-14"
                x1="46.08"
                y1="229.8"
                x2="99.68"
                y2="229.8"
              />
              <line class="cls-14" x1="46.35" y1="250" x2="46.35" y2="230.07" />
              <line
                class="cls-14"
                x1="46.08"
                y1="250.27"
                x2="99.68"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="46.35"
                y1="270.47"
                x2="46.35"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="46.08"
                y1="270.47"
                x2="99.68"
                y2="270.47"
              />
              <line
                class="cls-14"
                x1="46.35"
                y1="290.67"
                x2="46.35"
                y2="270.74"
              />
              <line
                class="cls-14"
                x1="46.08"
                y1="290.94"
                x2="99.68"
                y2="290.94"
              />
              <line
                class="cls-14"
                x1="46.35"
                y1="311.14"
                x2="46.35"
                y2="291.21"
              />
              <line
                class="cls-14"
                x1="46.08"
                y1="311.41"
                x2="99.68"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="46.35"
                y1="331.61"
                x2="46.35"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="46.08"
                y1="331.61"
                x2="99.68"
                y2="331.61"
              />
              <line
                class="cls-14"
                x1="46.35"
                y1="351.81"
                x2="46.35"
                y2="331.88"
              />
              <line
                class="cls-14"
                x1="46.08"
                y1="352.08"
                x2="99.68"
                y2="352.08"
              />
              <line
                class="cls-14"
                x1="46.35"
                y1="372.28"
                x2="46.35"
                y2="352.35"
              />
              <line
                class="cls-14"
                x1="46.08"
                y1="372.55"
                x2="99.68"
                y2="372.55"
              />
              <line
                class="cls-14"
                x1="46.35"
                y1="392.75"
                x2="46.35"
                y2="372.82"
              />
              <line
                class="cls-14"
                x1="46.08"
                y1="393.02"
                x2="99.68"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="46.35"
                y1="413.22"
                x2="46.35"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="46.08"
                y1="413.22"
                x2="99.68"
                y2="413.22"
              />
              <line
                class="cls-14"
                x1="46.35"
                y1="433.42"
                x2="46.35"
                y2="413.49"
              />
              <line
                class="cls-14"
                x1="46.08"
                y1="433.69"
                x2="99.68"
                y2="433.69"
              />
              <line
                class="cls-14"
                x1="46.35"
                y1="453.89"
                x2="46.35"
                y2="433.96"
              />
              <line
                class="cls-14"
                x1="46.08"
                y1="454.16"
                x2="99.68"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="46.35"
                y1="474.36"
                x2="46.35"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="46.08"
                y1="474.36"
                x2="99.68"
                y2="474.36"
              />
              <line
                class="cls-14"
                x1="46.35"
                y1="494.56"
                x2="46.35"
                y2="474.63"
              />
              <line
                class="cls-14"
                x1="46.08"
                y1="494.83"
                x2="99.68"
                y2="494.83"
              />
              <line
                class="cls-14"
                x1="46.35"
                y1="515.03"
                x2="46.35"
                y2="495.1"
              />
              <line
                class="cls-14"
                x1="46.08"
                y1="515.3"
                x2="99.68"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="46.35"
                y1="535.5"
                x2="46.35"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="46.08"
                y1="535.5"
                x2="99.68"
                y2="535.5"
              />
              <line
                class="cls-14"
                x1="46.35"
                y1="555.97"
                x2="46.35"
                y2="535.77"
              />
              <line
                class="cls-14"
                x1="46.08"
                y1="555.97"
                x2="99.68"
                y2="555.97"
              />
              <line
                class="cls-14"
                x1="46.35"
                y1="576.17"
                x2="46.35"
                y2="556.24"
              />
              <line
                class="cls-14"
                x1="46.08"
                y1="576.44"
                x2="99.68"
                y2="576.44"
              />
              <line
                class="cls-14"
                x1="46.35"
                y1="596.64"
                x2="46.35"
                y2="576.71"
              />
              <line
                class="cls-14"
                x1="46.08"
                y1="596.91"
                x2="99.68"
                y2="596.91"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="177.01"
                x2="153.28"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="209.33"
                x2="99.68"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="209.33"
                x2="153.28"
                y2="209.33"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="229.53"
                x2="99.68"
                y2="209.6"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="229.8"
                x2="153.28"
                y2="229.8"
              />
              <line class="cls-14" x1="99.68" y1="250" x2="99.68" y2="230.07" />
              <line
                class="cls-14"
                x1="99.68"
                y1="250.27"
                x2="153.28"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="270.47"
                x2="99.68"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="270.47"
                x2="153.28"
                y2="270.47"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="290.67"
                x2="99.68"
                y2="270.74"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="290.94"
                x2="153.28"
                y2="290.94"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="311.14"
                x2="99.68"
                y2="291.21"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="311.41"
                x2="153.28"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="331.61"
                x2="99.68"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="331.61"
                x2="153.28"
                y2="331.61"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="351.81"
                x2="99.68"
                y2="331.88"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="352.08"
                x2="153.28"
                y2="352.08"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="372.28"
                x2="99.68"
                y2="352.35"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="372.55"
                x2="153.28"
                y2="372.55"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="392.75"
                x2="99.68"
                y2="372.82"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="393.02"
                x2="153.28"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="413.22"
                x2="99.68"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="413.22"
                x2="153.28"
                y2="413.22"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="433.42"
                x2="99.68"
                y2="413.49"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="433.69"
                x2="153.28"
                y2="433.69"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="453.89"
                x2="99.68"
                y2="433.96"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="454.16"
                x2="153.28"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="474.36"
                x2="99.68"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="474.36"
                x2="153.28"
                y2="474.36"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="494.56"
                x2="99.68"
                y2="474.63"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="494.83"
                x2="153.28"
                y2="494.83"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="515.03"
                x2="99.68"
                y2="495.1"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="515.3"
                x2="153.28"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="535.5"
                x2="99.68"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="535.5"
                x2="153.28"
                y2="535.5"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="555.97"
                x2="99.68"
                y2="535.77"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="555.97"
                x2="153.28"
                y2="555.97"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="576.17"
                x2="99.68"
                y2="556.24"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="576.44"
                x2="153.28"
                y2="576.44"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="596.64"
                x2="99.68"
                y2="576.71"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="596.91"
                x2="153.28"
                y2="596.91"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="177.01"
                x2="206.88"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="209.33"
                x2="153.28"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="177.01"
                x2="260.48"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="209.33"
                x2="206.88"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="177.01"
                x2="331.05"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="209.33"
                x2="260.48"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="330.78"
                y1="209.33"
                x2="330.78"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="209.33"
                x2="206.88"
                y2="209.33"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="229.53"
                x2="153.28"
                y2="209.6"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="209.33"
                x2="260.48"
                y2="209.33"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="229.53"
                x2="206.88"
                y2="209.6"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="209.33"
                x2="331.05"
                y2="209.33"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="229.53"
                x2="260.48"
                y2="209.6"
              />
              <line
                class="cls-14"
                x1="330.78"
                y1="229.53"
                x2="330.78"
                y2="209.6"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="229.8"
                x2="206.88"
                y2="229.8"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="250"
                x2="153.28"
                y2="230.07"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="229.8"
                x2="260.48"
                y2="229.8"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="250"
                x2="206.88"
                y2="230.07"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="229.8"
                x2="331.05"
                y2="229.8"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="250"
                x2="260.48"
                y2="230.07"
              />
              <line
                class="cls-14"
                x1="330.78"
                y1="250"
                x2="330.78"
                y2="230.07"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="250.27"
                x2="207.15"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="270.47"
                x2="153.28"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="270.47"
                x2="206.88"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="250.27"
                x2="331.05"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="270.47"
                x2="260.48"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="330.78"
                y1="270.47"
                x2="330.78"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="270.47"
                x2="207.15"
                y2="270.47"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="290.67"
                x2="153.28"
                y2="270.74"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="290.67"
                x2="206.88"
                y2="270.74"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="270.47"
                x2="331.05"
                y2="270.47"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="290.67"
                x2="260.48"
                y2="270.74"
              />
              <line
                class="cls-14"
                x1="330.78"
                y1="290.67"
                x2="330.78"
                y2="270.74"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="290.94"
                x2="206.88"
                y2="290.94"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="311.14"
                x2="153.28"
                y2="291.21"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="290.94"
                x2="260.48"
                y2="290.94"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="311.14"
                x2="206.88"
                y2="291.21"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="290.94"
                x2="331.05"
                y2="290.94"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="311.14"
                x2="260.48"
                y2="291.21"
              />
              <line
                class="cls-14"
                x1="330.78"
                y1="311.14"
                x2="330.78"
                y2="291.21"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="311.41"
                x2="206.88"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="331.61"
                x2="153.28"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="311.41"
                x2="260.48"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="331.61"
                x2="206.88"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="311.41"
                x2="331.05"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="331.61"
                x2="260.48"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="330.78"
                y1="331.61"
                x2="330.78"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="331.61"
                x2="206.88"
                y2="331.61"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="351.81"
                x2="153.28"
                y2="331.88"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="331.61"
                x2="260.48"
                y2="331.61"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="351.81"
                x2="206.88"
                y2="331.88"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="331.61"
                x2="331.05"
                y2="331.61"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="351.81"
                x2="260.48"
                y2="331.88"
              />
              <line
                class="cls-14"
                x1="330.78"
                y1="351.81"
                x2="330.78"
                y2="331.88"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="352.08"
                x2="206.88"
                y2="352.08"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="372.28"
                x2="153.28"
                y2="352.35"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="352.08"
                x2="260.48"
                y2="352.08"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="372.28"
                x2="206.88"
                y2="352.35"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="352.08"
                x2="331.05"
                y2="352.08"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="372.28"
                x2="260.48"
                y2="352.35"
              />
              <line
                class="cls-14"
                x1="330.78"
                y1="372.28"
                x2="330.78"
                y2="352.35"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="372.55"
                x2="206.88"
                y2="372.55"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="392.75"
                x2="153.28"
                y2="372.82"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="372.55"
                x2="260.48"
                y2="372.55"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="392.75"
                x2="206.88"
                y2="372.82"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="372.55"
                x2="331.05"
                y2="372.55"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="392.75"
                x2="260.48"
                y2="372.82"
              />
              <line
                class="cls-14"
                x1="330.78"
                y1="392.75"
                x2="330.78"
                y2="372.82"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="393.02"
                x2="206.88"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="413.22"
                x2="153.28"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="393.02"
                x2="260.48"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="413.22"
                x2="206.88"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="393.02"
                x2="331.05"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="413.22"
                x2="260.48"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="330.78"
                y1="413.22"
                x2="330.78"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="413.22"
                x2="207.15"
                y2="413.22"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="433.42"
                x2="153.28"
                y2="413.49"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="433.42"
                x2="206.88"
                y2="413.49"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="413.22"
                x2="331.05"
                y2="413.22"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="433.42"
                x2="260.48"
                y2="413.49"
              />
              <line
                class="cls-14"
                x1="330.78"
                y1="433.42"
                x2="330.78"
                y2="413.49"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="433.69"
                x2="207.15"
                y2="433.69"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="453.89"
                x2="153.28"
                y2="433.96"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="453.89"
                x2="206.88"
                y2="433.96"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="433.69"
                x2="331.05"
                y2="433.69"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="453.89"
                x2="260.48"
                y2="433.96"
              />
              <line
                class="cls-14"
                x1="330.78"
                y1="453.89"
                x2="330.78"
                y2="433.96"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="454.16"
                x2="206.88"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="474.36"
                x2="153.28"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="454.16"
                x2="260.48"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="474.36"
                x2="206.88"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="454.16"
                x2="331.05"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="474.36"
                x2="260.48"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="330.78"
                y1="474.36"
                x2="330.78"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="474.36"
                x2="206.88"
                y2="474.36"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="494.56"
                x2="153.28"
                y2="474.63"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="474.36"
                x2="260.48"
                y2="474.36"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="494.56"
                x2="206.88"
                y2="474.63"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="474.36"
                x2="331.05"
                y2="474.36"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="494.56"
                x2="260.48"
                y2="474.63"
              />
              <line
                class="cls-14"
                x1="330.78"
                y1="494.56"
                x2="330.78"
                y2="474.63"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="494.83"
                x2="206.88"
                y2="494.83"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="515.03"
                x2="153.28"
                y2="495.1"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="494.83"
                x2="260.48"
                y2="494.83"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="515.03"
                x2="206.88"
                y2="495.1"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="494.83"
                x2="331.05"
                y2="494.83"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="515.03"
                x2="260.48"
                y2="495.1"
              />
              <line
                class="cls-14"
                x1="330.78"
                y1="515.03"
                x2="330.78"
                y2="495.1"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="515.3"
                x2="206.88"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="535.5"
                x2="153.28"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="515.3"
                x2="260.48"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="535.5"
                x2="206.88"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="515.3"
                x2="331.05"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="535.5"
                x2="260.48"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="330.78"
                y1="535.5"
                x2="330.78"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="535.5"
                x2="206.88"
                y2="535.5"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="555.97"
                x2="153.28"
                y2="535.77"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="535.5"
                x2="260.48"
                y2="535.5"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="555.97"
                x2="206.88"
                y2="535.77"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="535.5"
                x2="331.05"
                y2="535.5"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="555.97"
                x2="260.48"
                y2="535.77"
              />
              <line
                class="cls-14"
                x1="330.78"
                y1="555.97"
                x2="330.78"
                y2="535.77"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="555.97"
                x2="206.88"
                y2="555.97"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="576.17"
                x2="153.28"
                y2="556.24"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="555.97"
                x2="260.48"
                y2="555.97"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="576.17"
                x2="206.88"
                y2="556.24"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="555.97"
                x2="331.05"
                y2="555.97"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="576.17"
                x2="260.48"
                y2="556.24"
              />
              <line
                class="cls-14"
                x1="330.78"
                y1="576.17"
                x2="330.78"
                y2="556.24"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="576.44"
                x2="206.88"
                y2="576.44"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="596.64"
                x2="153.28"
                y2="576.71"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="576.44"
                x2="260.48"
                y2="576.44"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="596.64"
                x2="206.88"
                y2="576.71"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="576.44"
                x2="331.05"
                y2="576.44"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="596.64"
                x2="260.48"
                y2="576.71"
              />
              <line
                class="cls-14"
                x1="330.78"
                y1="596.64"
                x2="330.78"
                y2="576.71"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="596.91"
                x2="206.88"
                y2="596.91"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="596.91"
                x2="260.48"
                y2="596.91"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="596.91"
                x2="331.05"
                y2="596.91"
              />
              <line
                class="cls-14"
                x1="46.35"
                y1="629.24"
                x2="99.68"
                y2="629.24"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="629.24"
                x2="153.28"
                y2="629.24"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="629.24"
                x2="206.88"
                y2="629.24"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="629.24"
                x2="260.48"
                y2="629.24"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="629.24"
                x2="330.78"
                y2="629.24"
              />
              <line
                class="cls-14"
                x1="46.35"
                y1="694.15"
                x2="99.68"
                y2="694.15"
              />
              <line
                class="cls-14"
                x1="99.68"
                y1="694.15"
                x2="153.28"
                y2="694.15"
              />
              <line
                class="cls-14"
                x1="153.28"
                y1="694.15"
                x2="206.88"
                y2="694.15"
              />
              <line
                class="cls-14"
                x1="206.88"
                y1="694.15"
                x2="260.48"
                y2="694.15"
              />
              <line
                class="cls-14"
                x1="260.48"
                y1="694.15"
                x2="330.78"
                y2="694.15"
              />
              <path
                class="cls-5"
                d="M36.86,152.65l-3.63,7-.19-.09,3.63-7Zm-4.74,6.4a2.78,2.78,0,0,1-.55.39,1.34,1.34,0,0,1-.64.15.92.92,0,0,1-1-1v-3.33h-.69v-.08l.7-.25.61-1.5h.13v1.49H32v.34H30.67v3.21c0,.51.23.78.67.78a1.06,1.06,0,0,0,.37-.06A1.53,1.53,0,0,0,32,159Zm-4.38-5.92a.5.5,0,0,1-.15.38.56.56,0,0,1-.38.14.51.51,0,0,1-.37-.14.52.52,0,0,1,0-.75.48.48,0,0,1,.37-.15.52.52,0,0,1,.38.15A.5.5,0,0,1,27.74,153.13Zm.68,6.38H26.19v-.11l.21,0a.72.72,0,0,0,.35-.11.47.47,0,0,0,.15-.29,4.85,4.85,0,0,0,0-.63V156a.82.82,0,0,0-.09-.5.7.7,0,0,0-.37-.24l-.29-.11v-.08l1.41-.33.09.06v3.55a4.74,4.74,0,0,0,0,.63.39.39,0,0,0,.16.29.72.72,0,0,0,.35.11l.2,0Zm-3.28,0H22.91v-.11l.2,0a.77.77,0,0,0,.36-.11.39.39,0,0,0,.15-.29,3.27,3.27,0,0,0,0-.63v-2a1.35,1.35,0,0,0-.26-.89.88.88,0,0,0-.7-.29,1.53,1.53,0,0,0-.7.16,2.13,2.13,0,0,0-.59.42v2.63a4.74,4.74,0,0,0,0,.63.43.43,0,0,0,.16.29.77.77,0,0,0,.36.11l.2,0v.11H19.93v-.11l.21,0a.72.72,0,0,0,.34-.11.39.39,0,0,0,.15-.29,4.85,4.85,0,0,0,0-.63V156a.82.82,0,0,0-.09-.5.63.63,0,0,0-.36-.24l-.29-.11v-.08l1.4-.33.09.06v.71a4.47,4.47,0,0,1,.77-.57,1.63,1.63,0,0,1,.83-.21c.92,0,1.38.48,1.39,1.48v2.14a4.37,4.37,0,0,0,0,.63.39.39,0,0,0,.15.29.68.68,0,0,0,.34.11l.21,0Zm-5.83-6.72-.14,0a1,1,0,0,0-.46.14.71.71,0,0,0-.27.37,2.47,2.47,0,0,0-.09.75l0,3a2.62,2.62,0,0,1-.7,1.9,2.76,2.76,0,0,1-2,.67,2.86,2.86,0,0,1-2-.63,2.3,2.3,0,0,1-.66-1.75v-3.12a2.69,2.69,0,0,0-.12-1,.51.51,0,0,0-.47-.29l-.37-.05v-.11h2.84v.11l-.46.06a.55.55,0,0,0-.5.28,2.27,2.27,0,0,0-.13,1v3a2.27,2.27,0,0,0,.56,1.69,2.12,2.12,0,0,0,1.54.5,2.29,2.29,0,0,0,1.63-.56,2.18,2.18,0,0,0,.61-1.68l0-3a1.72,1.72,0,0,0-.21-.95.82.82,0,0,0-.61-.28l-.28,0v-.11h2.36Z"
              />
              <path
                class="cls-5"
                d="M36.33,166.44a.85.85,0,0,1-.12.44A.33.33,0,0,1,36,167a.82.82,0,0,1-.31-.11,4,4,0,0,1-.51-.34,2.2,2.2,0,0,0-.43.27,2,2,0,0,0-.36.34v2.46a3.29,3.29,0,0,0,0,.64.37.37,0,0,0,.19.28,1.25,1.25,0,0,0,.47.11l.26,0v.11H32.86v-.11l.21,0a.72.72,0,0,0,.34-.11.39.39,0,0,0,.15-.29,4.85,4.85,0,0,0,0-.63V167.3a.92.92,0,0,0-.08-.5.7.7,0,0,0-.37-.24l-.29-.11v-.08l1.4-.33.09.06v.83a3.72,3.72,0,0,1,.79-.71,1.18,1.18,0,0,1,.67-.2.67.67,0,0,1,.39.1A.37.37,0,0,1,36.33,166.44Zm-4.72,2.08a2.66,2.66,0,0,1-.31,1.25,2.21,2.21,0,0,1-.81.85,2.16,2.16,0,0,1-1.15.32,2.28,2.28,0,0,1-1.13-.28,2,2,0,0,1-.82-.83,2.93,2.93,0,0,1-.32-1.4,2.66,2.66,0,0,1,.31-1.25,2.45,2.45,0,0,1,.81-.85,2.23,2.23,0,0,1,1.15-.32,2.28,2.28,0,0,1,1.13.28,2.08,2.08,0,0,1,.82.84A3,3,0,0,1,31.61,168.52Zm-.85.19a3.49,3.49,0,0,0-.44-1.83,1.33,1.33,0,0,0-1.14-.7,1,1,0,0,0-.92.48,2.92,2.92,0,0,0-.34,1.58,3.44,3.44,0,0,0,.43,1.83,1.34,1.34,0,0,0,1.15.7,1,1,0,0,0,.92-.48A3,3,0,0,0,30.76,168.71Zm-5.12-.19a2.66,2.66,0,0,1-.31,1.25,2.21,2.21,0,0,1-.81.85,2.16,2.16,0,0,1-1.15.32,2.28,2.28,0,0,1-1.13-.28,2,2,0,0,1-.82-.83,2.93,2.93,0,0,1-.32-1.4,2.55,2.55,0,0,1,.32-1.25,2.28,2.28,0,0,1,.81-.85,2.19,2.19,0,0,1,1.14-.32,2.28,2.28,0,0,1,1.13.28,2.08,2.08,0,0,1,.82.84A3,3,0,0,1,25.64,168.52Zm-.85.19a3.39,3.39,0,0,0-.44-1.83,1.33,1.33,0,0,0-1.14-.7,1,1,0,0,0-.92.48,2.92,2.92,0,0,0-.34,1.58,3.44,3.44,0,0,0,.43,1.83,1.34,1.34,0,0,0,1.15.7,1,1,0,0,0,.92-.48A2.89,2.89,0,0,0,24.79,168.71Zm-4.52,2.11H18v-.11l.21,0a.72.72,0,0,0,.34-.11.39.39,0,0,0,.15-.29,4.85,4.85,0,0,0,0-.63v-4.91a.81.81,0,0,0-.09-.49.63.63,0,0,0-.36-.24L18,163.9v-.08l1.4-.33.09.06v6.1a5,5,0,0,0,0,.64.4.4,0,0,0,.16.28.77.77,0,0,0,.36.11l.2,0Zm-3.22-5.57h-.12l-.18-.3a1.7,1.7,0,0,0-.38-.49,1,1,0,0,0-.48-.23,3.77,3.77,0,0,0-.75-.06H15a6.39,6.39,0,0,0-.68,0,2,2,0,0,0-.43.09v2.92l.82,0a2.23,2.23,0,0,0,1-.15.65.65,0,0,0,.31-.56l.05-.41h.14c0,.07,0,.18,0,.32s0,.3,0,.46v.45c0,.2,0,.41,0,.64s0,.41,0,.53H16l0-.28a1.08,1.08,0,0,0-.16-.47.62.62,0,0,0-.39-.22,3.52,3.52,0,0,0-.75-.07l-.82,0v2a3.66,3.66,0,0,0,.06.77.55.55,0,0,0,.22.37,1.1,1.1,0,0,0,.47.13l.38.05v.11H12.09v-.11l.37-.05a.51.51,0,0,0,.47-.29,2.54,2.54,0,0,0,.11-1v-4a2.54,2.54,0,0,0-.11-1,.51.51,0,0,0-.47-.29l-.37-.05V164h4.67Z"
              />
              <path
                class="cls-5"
                d="M300.65,165.17h-3.41V165l.45-.06a1,1,0,0,0,.53-.16.6.6,0,0,0,.26-.42,4.18,4.18,0,0,0,.07-.9v-4.44a3.72,3.72,0,0,0-.07-.86.52.52,0,0,0-.3-.38,1.52,1.52,0,0,0-.63-.08h-.31v-.13a9.29,9.29,0,0,0,1.12-.23c.37-.11.7-.22,1-.33l.1,0v6.4a5,5,0,0,0,.07.9.67.67,0,0,0,.25.42,1,1,0,0,0,.49.16l.4.06ZM295,162.3a2.69,2.69,0,0,1-.55,1.64,3.39,3.39,0,0,1-1.28,1,3.57,3.57,0,0,1-1.48.34,1.53,1.53,0,0,1-.82-.18.57.57,0,0,1-.28-.48.45.45,0,0,1,.15-.34.52.52,0,0,1,.34-.12,1,1,0,0,1,.59.19,2.64,2.64,0,0,1,.58.61,2.53,2.53,0,0,0,1-.31,2.21,2.21,0,0,0,.76-.73,2.17,2.17,0,0,0,.3-1.1,1.52,1.52,0,0,0-.47-1.19,1.87,1.87,0,0,0-1.25-.39,1.9,1.9,0,0,0-.54.07,3,3,0,0,0-.54.2l-.12-.2a11.82,11.82,0,0,0,1.65-1,2.88,2.88,0,0,0,.76-.8,1.39,1.39,0,0,0,.18-.73.93.93,0,0,0-.32-.75,1.41,1.41,0,0,0-.94-.3,2.13,2.13,0,0,0-1,.25,3.54,3.54,0,0,0-.91.68l-.12-.13a4.49,4.49,0,0,1,1.25-1.09,2.62,2.62,0,0,1,1.3-.31,1.79,1.79,0,0,1,1.18.35,1.26,1.26,0,0,1,.43,1,1.6,1.6,0,0,1-.42,1.05,5.72,5.72,0,0,1-1.34,1.06,2.39,2.39,0,0,1,1.42.49A1.56,1.56,0,0,1,295,162.3Zm-55.25-1.11a6.52,6.52,0,0,1-.32,2.1,3.41,3.41,0,0,1-.93,1.46,2.13,2.13,0,0,1-1.45.55,2.21,2.21,0,0,1-1.53-.55,3.18,3.18,0,0,1-.89-1.47,7,7,0,0,1-.29-2.09,6.15,6.15,0,0,1,.33-2.09,3.32,3.32,0,0,1,.93-1.47,2.16,2.16,0,0,1,1.45-.55,2.21,2.21,0,0,1,1.52.56,3.2,3.2,0,0,1,.89,1.46A6.77,6.77,0,0,1,239.78,161.19Zm-1,.23a8.5,8.5,0,0,0-.43-3.06,1.46,1.46,0,0,0-1.37-1.09,1.28,1.28,0,0,0-1.19.95,7.44,7.44,0,0,0-.39,2.74,8.32,8.32,0,0,0,.42,3.06,1.48,1.48,0,0,0,1.37,1.1,1.3,1.3,0,0,0,1.2-1A7.49,7.49,0,0,0,238.77,161.42Zm-7.09.88a2.69,2.69,0,0,1-.55,1.64,3.39,3.39,0,0,1-1.28,1,3.57,3.57,0,0,1-1.48.34,1.53,1.53,0,0,1-.82-.18.57.57,0,0,1-.28-.48.43.43,0,0,1,.16-.34.48.48,0,0,1,.33-.12,1,1,0,0,1,.59.19,2.64,2.64,0,0,1,.58.61,2.53,2.53,0,0,0,1-.31,2.21,2.21,0,0,0,.76-.73,2.17,2.17,0,0,0,.3-1.1,1.52,1.52,0,0,0-.47-1.19,1.86,1.86,0,0,0-1.24-.39,1.93,1.93,0,0,0-.55.07,3,3,0,0,0-.54.2l-.12-.2a11.82,11.82,0,0,0,1.65-1,2.74,2.74,0,0,0,.76-.8,1.39,1.39,0,0,0,.18-.73,1,1,0,0,0-.31-.75,1.46,1.46,0,0,0-1-.3,2.13,2.13,0,0,0-1,.25,3.72,3.72,0,0,0-.91.68l-.12-.13a4.49,4.49,0,0,1,1.25-1.09,2.62,2.62,0,0,1,1.3-.31,1.79,1.79,0,0,1,1.18.35,1.29,1.29,0,0,1,.44,1,1.61,1.61,0,0,1-.43,1.05,5.52,5.52,0,0,1-1.34,1.06,2.36,2.36,0,0,1,1.42.49A1.56,1.56,0,0,1,231.68,162.3Zm-45.41-2.18a4.62,4.62,0,0,1-1,3,8,8,0,0,1-3.35,2.31l-.09-.18a7.21,7.21,0,0,0,2.2-1.44,4,4,0,0,0,1-1.63,6.15,6.15,0,0,0,.22-1.84,4.51,4.51,0,0,0-.46-2.27,1.42,1.42,0,0,0-1.27-.76,1.2,1.2,0,0,0-1.09.6,3.2,3.2,0,0,0-.34,1.62,4.21,4.21,0,0,0,.14,1.11,1.67,1.67,0,0,0,.49.8,1.4,1.4,0,0,0,.94.31,2.62,2.62,0,0,0,.67-.08l0,.15a3.5,3.5,0,0,1-1,.19,2.21,2.21,0,0,1-1.63-.61,2.28,2.28,0,0,1-.59-1.64,2.71,2.71,0,0,1,.35-1.35,2.57,2.57,0,0,1,.91-.94,2.64,2.64,0,0,1,1.28-.35,2.57,2.57,0,0,1,1.31.35,2.49,2.49,0,0,1,.93,1A3.72,3.72,0,0,1,186.27,160.12ZM179,163l-.7,2.12H174l-.08-.11,2.13-2.39a14.18,14.18,0,0,0,1-1.25,4.1,4.1,0,0,0,.55-1.05,3.1,3.1,0,0,0,.17-1,1.57,1.57,0,0,0-.42-1.14,1.63,1.63,0,0,0-1.19-.45,1.74,1.74,0,0,0-1.09.36,4.38,4.38,0,0,0-.92,1l-.14-.08a4.42,4.42,0,0,1,1.11-1.46,2.29,2.29,0,0,1,1.48-.53,2,2,0,0,1,1.42.52,1.87,1.87,0,0,1,.56,1.44,2.64,2.64,0,0,1-.22,1.1,4.86,4.86,0,0,1-.64,1,15.44,15.44,0,0,1-1,1.17l-1.95,2.12h1.84a5.11,5.11,0,0,0,1-.08,1.22,1.22,0,0,0,.6-.3,2.56,2.56,0,0,0,.49-.65l.22-.39Zm-46.3.13a2,2,0,0,1-.36,1.13,2.35,2.35,0,0,1-.92.75,3,3,0,0,1-1.28.26,3.08,3.08,0,0,1-1.17-.22,2.19,2.19,0,0,1-.89-.65,1.55,1.55,0,0,1-.35-1,2,2,0,0,1,.44-1.31,4,4,0,0,1,1.37-1,2.82,2.82,0,0,1-1.15-.84A2.07,2.07,0,0,1,128,159a1.72,1.72,0,0,1,.65-1.35,2.61,2.61,0,0,1,1.68-.57,2.55,2.55,0,0,1,1.56.51,1.63,1.63,0,0,1,.62,1.23,1.78,1.78,0,0,1-.44,1.14,3.67,3.67,0,0,1-1.19.85,3.85,3.85,0,0,1,1.42,1A2.06,2.06,0,0,1,132.74,163.16ZM131.66,159a1.82,1.82,0,0,0-.38-1.24,1.43,1.43,0,0,0-1.16-.46,1.36,1.36,0,0,0-1,.42,1.54,1.54,0,0,0-.39,1.05,1.39,1.39,0,0,0,.44,1.07,5,5,0,0,0,1.54.91,2.11,2.11,0,0,0,.73-.69A1.87,1.87,0,0,0,131.66,159Zm.35,4.45a1.52,1.52,0,0,0-.47-1.18,5.6,5.6,0,0,0-1.75-1,2.27,2.27,0,0,0-.88.86,2.48,2.48,0,0,0-.24,1.2,1.93,1.93,0,0,0,.47,1.36,1.79,1.79,0,0,0,2.42,0A1.79,1.79,0,0,0,132,163.42ZM125.4,163l-.7,2.12h-4.33l-.08-.11,2.14-2.39a15.83,15.83,0,0,0,1-1.25,4.1,4.1,0,0,0,.55-1.05,2.86,2.86,0,0,0,.17-1,1.57,1.57,0,0,0-.42-1.14,1.63,1.63,0,0,0-1.19-.45,1.74,1.74,0,0,0-1.09.36,4.38,4.38,0,0,0-.92,1l-.14-.08a4.42,4.42,0,0,1,1.11-1.46,2.29,2.29,0,0,1,1.48-.53,2.07,2.07,0,0,1,1.43.52A1.9,1.9,0,0,1,125,159a2.64,2.64,0,0,1-.22,1.1,5.24,5.24,0,0,1-.63,1c-.28.35-.63.74-1,1.17l-2,2.12H123a5,5,0,0,0,1-.08,1.3,1.3,0,0,0,.61-.3,2.81,2.81,0,0,0,.48-.65l.22-.39Zm-46.15-5.69-1.64,3.29c-.56,1.1-1,2-1.34,2.74s-.6,1.29-.77,1.7a.31.31,0,0,1-.19.2.51.51,0,0,1-.25-.06.22.22,0,0,1-.1-.16.45.45,0,0,1,.09-.24c.26-.4.57-.94,1-1.64s.84-1.58,1.38-2.67l1.27-2.56H76.07a4.48,4.48,0,0,0-.72.05,1,1,0,0,0-.45.2,1.6,1.6,0,0,0-.33.43l-.22.38h-.12l.66-2H75a.72.72,0,0,0,.25.16,2.39,2.39,0,0,0,.53.06h3.44ZM72.11,163l-.7,2.12H67.08L67,165l2.13-2.39a14.18,14.18,0,0,0,1-1.25,4.1,4.1,0,0,0,.55-1.05,3.1,3.1,0,0,0,.17-1,1.57,1.57,0,0,0-.42-1.14,1.63,1.63,0,0,0-1.19-.45,1.74,1.74,0,0,0-1.09.36,4.38,4.38,0,0,0-.92,1l-.14-.08a4.42,4.42,0,0,1,1.11-1.46,2.29,2.29,0,0,1,1.48-.53,2,2,0,0,1,1.42.52,1.87,1.87,0,0,1,.56,1.44,2.64,2.64,0,0,1-.22,1.1,4.86,4.86,0,0,1-.64,1c-.27.35-.62.74-1,1.17l-2,2.12h1.84a5,5,0,0,0,1-.08,1.22,1.22,0,0,0,.6-.3,2.56,2.56,0,0,0,.49-.65L72,163Z"
              />
              <path
                class="cls-5"
                d="M28,194.44a2.75,2.75,0,0,1-.35,1.36,2.62,2.62,0,0,1-.91.93,2.54,2.54,0,0,1-1.28.36,2.45,2.45,0,0,1-2.24-1.39,3.72,3.72,0,0,1-.36-1.65,4.58,4.58,0,0,1,1-3,8,8,0,0,1,3.35-2.31l.09.17a7,7,0,0,0-2.2,1.45,4,4,0,0,0-1,1.63,6.11,6.11,0,0,0-.22,1.84,4.51,4.51,0,0,0,.46,2.27,1.42,1.42,0,0,0,1.27.76,1.21,1.21,0,0,0,1.09-.6,3.25,3.25,0,0,0,.34-1.62,4.35,4.35,0,0,0-.14-1.12,1.64,1.64,0,0,0-.49-.79,1.4,1.4,0,0,0-.94-.32,2.62,2.62,0,0,0-.67.08l-.05-.15a3.21,3.21,0,0,1,1-.18,2.21,2.21,0,0,1,1.63.61A2.26,2.26,0,0,1,28,194.44Zm-7.19-5.72-.36,1.09H17.5l-.65,1.43a5.63,5.63,0,0,1,2.61.8,2.13,2.13,0,0,1,.88,1.88,2.93,2.93,0,0,1-.51,1.68,3.38,3.38,0,0,1-1.23,1.09,3.11,3.11,0,0,1-1.48.38,1.22,1.22,0,0,1-.76-.19.55.55,0,0,1-.22-.42c0-.3.19-.46.56-.48a1,1,0,0,1,.57.18,3.81,3.81,0,0,1,.61.53,2.68,2.68,0,0,0,1.39-.84,2.23,2.23,0,0,0,.55-1.52,1.73,1.73,0,0,0-.85-1.58,6.21,6.21,0,0,0-2.62-.69l-.09-.11L17.6,189h2a2.87,2.87,0,0,0,.65-.06.79.79,0,0,0,.43-.23Z"
              />
              <path
                class="cls-5"
                d="M27.8,215.4l-.36,1.08H24.51l-.64,1.43a5.58,5.58,0,0,1,2.6.8,2.16,2.16,0,0,1,.89,1.89,3.06,3.06,0,0,1-.52,1.68,3.24,3.24,0,0,1-1.22,1.08,3.16,3.16,0,0,1-1.49.39,1.27,1.27,0,0,1-.75-.2.53.53,0,0,1-.23-.42c0-.3.2-.46.57-.47a1,1,0,0,1,.57.18,4.14,4.14,0,0,1,.61.52,2.59,2.59,0,0,0,1.39-.84,2.28,2.28,0,0,0,.55-1.52,1.75,1.75,0,0,0-.85-1.58,6.26,6.26,0,0,0-2.62-.69l-.09-.1,1.34-2.94h2a2.93,2.93,0,0,0,.65-.06.94.94,0,0,0,.43-.23Zm-6.48,0L21,216.48H18l-.65,1.43a5.63,5.63,0,0,1,2.61.8,2.15,2.15,0,0,1,.88,1.89,3,3,0,0,1-.51,1.68,3.35,3.35,0,0,1-1.23,1.08,3.09,3.09,0,0,1-1.48.39,1.31,1.31,0,0,1-.76-.2.52.52,0,0,1-.22-.42c0-.3.19-.46.56-.47a1.07,1.07,0,0,1,.58.18,3.67,3.67,0,0,1,.6.52,2.62,2.62,0,0,0,1.4-.84,2.28,2.28,0,0,0,.54-1.52,1.73,1.73,0,0,0-.85-1.58,6.16,6.16,0,0,0-2.61-.69l-.1-.1,1.35-2.94h2a2.84,2.84,0,0,0,.64-.06.9.9,0,0,0,.43-.23Z"
              />
              <path
                class="cls-5"
                d="M28.3,241.79H27v2.34h-.84v-2.34H22.56l-.08-.11,4.13-5.59H27v5.32H28.3Zm-2.12-.38V237.1L23,241.41Zm-5.4-5.55L20.42,237H17.5l-.65,1.42a5.74,5.74,0,0,1,2.61.81,2.13,2.13,0,0,1,.88,1.88,2.93,2.93,0,0,1-.51,1.68,3.47,3.47,0,0,1-1.23,1.09,3.23,3.23,0,0,1-1.48.38,1.22,1.22,0,0,1-.76-.2.52.52,0,0,1-.22-.41c0-.3.19-.46.56-.48a1,1,0,0,1,.57.18,3.81,3.81,0,0,1,.61.53,2.68,2.68,0,0,0,1.39-.84,2.23,2.23,0,0,0,.55-1.52,1.72,1.72,0,0,0-.85-1.58,5.93,5.93,0,0,0-2.62-.69l-.09-.11,1.34-2.94h2a2.87,2.87,0,0,0,.65-.06.86.86,0,0,0,.43-.23Z"
              />
              <path
                class="cls-5"
                d="M27.3,261.42a2.69,2.69,0,0,1-.55,1.64,3.49,3.49,0,0,1-1.28,1,3.57,3.57,0,0,1-1.48.34,1.44,1.44,0,0,1-.82-.19.56.56,0,0,1-.28-.47.5.5,0,0,1,.15-.35.58.58,0,0,1,.34-.11,1,1,0,0,1,.59.19,2.64,2.64,0,0,1,.58.61,2.55,2.55,0,0,0,1-.32,2.12,2.12,0,0,0,.76-.73,2.15,2.15,0,0,0,.3-1.1,1.5,1.5,0,0,0-.47-1.18,1.86,1.86,0,0,0-1.24-.39,1.93,1.93,0,0,0-.55.07,2.9,2.9,0,0,0-.54.19l-.12-.19a12.72,12.72,0,0,0,1.65-1,2.87,2.87,0,0,0,.76-.79,1.39,1.39,0,0,0,.18-.73,1,1,0,0,0-.31-.75,1.35,1.35,0,0,0-.95-.3,2.24,2.24,0,0,0-1,.24,4.07,4.07,0,0,0-.91.68l-.12-.13a4.44,4.44,0,0,1,1.25-1.08,2.75,2.75,0,0,1,1.3-.32,1.79,1.79,0,0,1,1.18.36,1.28,1.28,0,0,1,.44,1,1.65,1.65,0,0,1-.43,1,5.77,5.77,0,0,1-1.34,1.06,2.36,2.36,0,0,1,1.42.49A1.56,1.56,0,0,1,27.3,261.42Zm-6.24-5.36-.36,1.09H17.77l-.64,1.42a5.62,5.62,0,0,1,2.6.81,2.14,2.14,0,0,1,.89,1.88,3,3,0,0,1-.52,1.68A3.36,3.36,0,0,1,18.88,264a3.26,3.26,0,0,1-1.49.38,1.26,1.26,0,0,1-.76-.2.52.52,0,0,1-.22-.41c0-.31.2-.46.57-.48a1,1,0,0,1,.57.18,4.3,4.3,0,0,1,.61.53,2.72,2.72,0,0,0,1.39-.84,2.28,2.28,0,0,0,.55-1.52,1.77,1.77,0,0,0-.85-1.59,6.12,6.12,0,0,0-2.62-.68l-.09-.11,1.34-2.94h2a2.93,2.93,0,0,0,.65-.06.79.79,0,0,0,.42-.23Z"
              />
              <path
                class="cls-5"
                d="M27.67,282.63,27,284.75H22.64l-.08-.12,2.14-2.38a13.82,13.82,0,0,0,1-1.26,4.29,4.29,0,0,0,.56-1,3.21,3.21,0,0,0,.17-1,1.54,1.54,0,0,0-.43-1.14,1.56,1.56,0,0,0-1.18-.44,1.72,1.72,0,0,0-1.09.36,4.19,4.19,0,0,0-.92,1l-.14-.08a4.45,4.45,0,0,1,1.1-1.47,2.31,2.31,0,0,1,1.49-.52,2,2,0,0,1,1.42.51,1.93,1.93,0,0,1,.56,1.44,2.8,2.8,0,0,1-.22,1.1,4.86,4.86,0,0,1-.64,1c-.28.35-.62.74-1,1.17L23.42,284h1.84a5.12,5.12,0,0,0,1-.07,1.15,1.15,0,0,0,.61-.31,2.88,2.88,0,0,0,.49-.65l.22-.38Zm-6.89-6.09-.36,1.08H17.5l-.65,1.43a5.63,5.63,0,0,1,2.61.8,2.15,2.15,0,0,1,.88,1.89,3,3,0,0,1-.51,1.68,3.35,3.35,0,0,1-1.23,1.08,3.12,3.12,0,0,1-1.48.39,1.28,1.28,0,0,1-.76-.2.52.52,0,0,1-.22-.42c0-.3.19-.46.56-.47a1,1,0,0,1,.57.18,3.69,3.69,0,0,1,.61.52,2.55,2.55,0,0,0,1.39-.84,2.23,2.23,0,0,0,.55-1.52,1.73,1.73,0,0,0-.85-1.58,6.21,6.21,0,0,0-2.62-.69l-.09-.1,1.34-2.94h2a2.87,2.87,0,0,0,.65-.06.94.94,0,0,0,.43-.23Z"
              />
              <path
                class="cls-5"
                d="M27.33,305.22H23.91v-.12l.46-.06a1.15,1.15,0,0,0,.53-.16.61.61,0,0,0,.26-.43,4,4,0,0,0,.07-.89v-4.44a3.66,3.66,0,0,0-.07-.86.52.52,0,0,0-.3-.38,1.55,1.55,0,0,0-.63-.08h-.32v-.13a9.44,9.44,0,0,0,1.13-.23c.37-.11.7-.22,1-.33l.1.05v6.4a4.74,4.74,0,0,0,.07.89.67.67,0,0,0,.25.43,1,1,0,0,0,.49.16l.4.06ZM21.59,297l-.36,1.09H18.31l-.65,1.42a5.74,5.74,0,0,1,2.61.81,2.13,2.13,0,0,1,.88,1.88,2.93,2.93,0,0,1-.51,1.68A3.47,3.47,0,0,1,19.41,305a3.23,3.23,0,0,1-1.48.38,1.22,1.22,0,0,1-.76-.2.53.53,0,0,1-.23-.41q0-.45.57-.48a1,1,0,0,1,.57.18,3.81,3.81,0,0,1,.61.53,2.72,2.72,0,0,0,1.39-.84,2.28,2.28,0,0,0,.55-1.52,1.72,1.72,0,0,0-.85-1.58,5.93,5.93,0,0,0-2.62-.69l-.09-.11,1.34-2.94h2a2.87,2.87,0,0,0,.65-.06.86.86,0,0,0,.43-.23Z"
              />
              <path
                class="cls-5"
                d="M28,321.45a6.52,6.52,0,0,1-.32,2.1,3.54,3.54,0,0,1-.93,1.46,2.18,2.18,0,0,1-1.45.55,2.25,2.25,0,0,1-1.53-.55,3.29,3.29,0,0,1-.89-1.47,7,7,0,0,1-.29-2.09,6.52,6.52,0,0,1,.32-2.1,3.54,3.54,0,0,1,.93-1.46,2.18,2.18,0,0,1,1.46-.55,2.25,2.25,0,0,1,1.52.55,3.29,3.29,0,0,1,.89,1.47A7,7,0,0,1,28,321.45Zm-1,.23a8.32,8.32,0,0,0-.42-3.06,1.48,1.48,0,0,0-1.37-1.1,1.31,1.31,0,0,0-1.2,1,7.75,7.75,0,0,0-.38,2.75,8.32,8.32,0,0,0,.42,3.06,1.49,1.49,0,0,0,1.37,1.1,1.31,1.31,0,0,0,1.2-.95A7.75,7.75,0,0,0,27,321.68Zm-6.51-4.48-.35,1.09H17.23l-.65,1.42a5.62,5.62,0,0,1,2.61.81,2.14,2.14,0,0,1,.89,1.88,3,3,0,0,1-.52,1.68,3.44,3.44,0,0,1-1.22,1.09,3.26,3.26,0,0,1-1.49.38,1.24,1.24,0,0,1-.76-.2.52.52,0,0,1-.22-.41c0-.3.19-.46.56-.48a1,1,0,0,1,.58.18,3.79,3.79,0,0,1,.6.53,2.75,2.75,0,0,0,1.4-.84,2.34,2.34,0,0,0,.55-1.52,1.77,1.77,0,0,0-.85-1.59,6.12,6.12,0,0,0-2.62-.68l-.1-.11,1.35-2.94h2a2.78,2.78,0,0,0,.64-.06.82.82,0,0,0,.43-.23Z"
              />
              <path
                class="cls-5"
                d="M28.36,340.85a4.58,4.58,0,0,1-1,3A8,8,0,0,1,24,346.12l-.08-.17a7.1,7.1,0,0,0,2.19-1.45,4,4,0,0,0,1-1.63,6.11,6.11,0,0,0,.23-1.84,4.61,4.61,0,0,0-.47-2.27,1.42,1.42,0,0,0-1.27-.76,1.22,1.22,0,0,0-1.09.6,3.25,3.25,0,0,0-.34,1.62,4.35,4.35,0,0,0,.14,1.12,1.72,1.72,0,0,0,.49.8,1.45,1.45,0,0,0,.94.31,3.84,3.84,0,0,0,.67-.08l0,.15a3.21,3.21,0,0,1-1,.18,2.17,2.17,0,0,1-1.63-.61,2.26,2.26,0,0,1-.59-1.63,2.75,2.75,0,0,1,.35-1.36,2.62,2.62,0,0,1,.91-.93,2.47,2.47,0,0,1,3.52,1A3.47,3.47,0,0,1,28.36,340.85Zm-7.07,2.76H20V346h-.85v-2.34H15.55l-.08-.12,4.13-5.58H20v5.31h1.27Zm-2.12-.39v-4.3L16,343.22Z"
              />
              <path
                class="cls-5"
                d="M28.24,364.36a2,2,0,0,1-.36,1.13,2.35,2.35,0,0,1-.92.75,3.11,3.11,0,0,1-1.28.26,3,3,0,0,1-1.17-.22,2.13,2.13,0,0,1-.89-.65,1.61,1.61,0,0,1-.36-1,2,2,0,0,1,.45-1.31,4,4,0,0,1,1.37-1,2.82,2.82,0,0,1-1.16-.83,2.07,2.07,0,0,1-.42-1.3,1.71,1.71,0,0,1,.64-1.35,2.61,2.61,0,0,1,1.69-.57,2.55,2.55,0,0,1,1.56.51A1.57,1.57,0,0,1,28,360a1.72,1.72,0,0,1-.43,1.14,3.62,3.62,0,0,1-1.2.85,3.81,3.81,0,0,1,1.43,1A2.1,2.1,0,0,1,28.24,364.36Zm-1.08-4.19a1.87,1.87,0,0,0-.38-1.24,1.45,1.45,0,0,0-1.16-.46,1.33,1.33,0,0,0-1,.42,1.54,1.54,0,0,0-.39,1.05,1.39,1.39,0,0,0,.44,1.07,5,5,0,0,0,1.54.91,2.21,2.21,0,0,0,.73-.69A2,2,0,0,0,27.16,360.17Zm.35,4.45a1.55,1.55,0,0,0-.47-1.19,6,6,0,0,0-1.75-1,2.36,2.36,0,0,0-.88.87,2.48,2.48,0,0,0-.24,1.2,1.93,1.93,0,0,0,.46,1.36,1.65,1.65,0,0,0,1.25.48,1.6,1.6,0,0,0,1.18-.47A1.75,1.75,0,0,0,27.51,364.62Zm-6.22-.55H20v2.34h-.85v-2.34H15.55l-.08-.11,4.13-5.59H20v5.32h1.27Zm-2.12-.38v-4.31L16,363.69Z"
              />
              <path
                class="cls-5"
                d="M28.31,379l-1.65,3.29c-.55,1.11-1,2-1.34,2.75s-.59,1.29-.76,1.7a.33.33,0,0,1-.2.2.48.48,0,0,1-.24-.07.17.17,0,0,1-.1-.15.48.48,0,0,1,.09-.25c.25-.39.57-.94.95-1.63s.83-1.59,1.37-2.68l1.28-2.56H25.13a3.62,3.62,0,0,0-.73.06,1,1,0,0,0-.44.19,1.49,1.49,0,0,0-.34.44l-.22.38h-.11l.66-2H24a.58.58,0,0,0,.25.15,1.75,1.75,0,0,0,.53.07h3.44Zm-6.75,5.54H20.28v2.34h-.84v-2.34H15.82l-.08-.12,4.13-5.58h.41v5.32h1.28Zm-2.12-.38v-4.31l-3.19,4.31Z"
              />
              <path
                class="cls-5"
                d="M28.48,404.54a2.82,2.82,0,0,1-.35,1.35,2.53,2.53,0,0,1-2.19,1.29,2.54,2.54,0,0,1-1.31-.35,2.51,2.51,0,0,1-.94-1,3.72,3.72,0,0,1-.36-1.65,4.69,4.69,0,0,1,1-3,8,8,0,0,1,3.35-2.31l.08.18a7.28,7.28,0,0,0-2.19,1.44,3.82,3.82,0,0,0-1,1.63,6.15,6.15,0,0,0-.23,1.84,4.61,4.61,0,0,0,.47,2.27,1.41,1.41,0,0,0,1.27.76,1.18,1.18,0,0,0,1.08-.6,3.19,3.19,0,0,0,.35-1.62,3.82,3.82,0,0,0-.15-1.11,1.6,1.6,0,0,0-.49-.8,1.37,1.37,0,0,0-.93-.31,2.16,2.16,0,0,0-.67.08l-.05-.15a3.44,3.44,0,0,1,1-.19,2.2,2.2,0,0,1,1.62.61A2.29,2.29,0,0,1,28.48,404.54Zm-7.19.21H20v2.34h-.85v-2.34H15.55l-.08-.12,4.13-5.58H20v5.31h1.27Zm-2.12-.39v-4.3L16,404.36Z"
              />
              <path
                class="cls-5"
                d="M28.3,419.28l-.36,1.09H25l-.64,1.42a5.73,5.73,0,0,1,2.6.81,2.14,2.14,0,0,1,.89,1.88,3,3,0,0,1-.52,1.68,3.34,3.34,0,0,1-2.71,1.47,1.31,1.31,0,0,1-.76-.19.55.55,0,0,1-.22-.42q0-.45.57-.48a1,1,0,0,1,.57.18,3.79,3.79,0,0,1,.6.53,2.7,2.7,0,0,0,1.4-.84,2.28,2.28,0,0,0,.55-1.52,1.74,1.74,0,0,0-.85-1.58,6.11,6.11,0,0,0-2.62-.69l-.09-.11,1.34-2.94h2a2.93,2.93,0,0,0,.65-.06.79.79,0,0,0,.42-.23Zm-6.48,5.93H20.55v2.34h-.84v-2.34H16.09L16,425.1l4.12-5.59h.42v5.32h1.27Zm-2.11-.38v-4.31l-3.19,4.31Z"
              />
              <path
                class="cls-5"
                d="M28.89,445.69H27.62V448h-.85v-2.34H23.15l-.08-.12L27.2,440h.42v5.32h1.27Zm-2.12-.38V441l-3.19,4.31Zm-5.74.38H19.76V448h-.85v-2.34H15.29l-.08-.12L19.34,440h.42v5.32H21Zm-2.12-.38V441l-3.19,4.31Z"
              />
              <path
                class="cls-5"
                d="M27.8,465.32a2.72,2.72,0,0,1-.55,1.64A3.49,3.49,0,0,1,26,468a3.73,3.73,0,0,1-1.48.34,1.44,1.44,0,0,1-.82-.19.56.56,0,0,1-.28-.47.48.48,0,0,1,.15-.35.52.52,0,0,1,.34-.12,1.09,1.09,0,0,1,.59.19,2.64,2.64,0,0,1,.58.61,2.38,2.38,0,0,0,1-.31,2.21,2.21,0,0,0,.76-.73,2.15,2.15,0,0,0,.3-1.1,1.54,1.54,0,0,0-.47-1.19,1.87,1.87,0,0,0-1.25-.38,2.35,2.35,0,0,0-.54.06,3.93,3.93,0,0,0-.54.2l-.12-.2a11.82,11.82,0,0,0,1.65-1,2.87,2.87,0,0,0,.76-.79,1.41,1.41,0,0,0,.18-.73,1,1,0,0,0-.32-.76,1.41,1.41,0,0,0-.94-.3,2.25,2.25,0,0,0-1,.25,3.79,3.79,0,0,0-.91.68l-.12-.13a4.3,4.3,0,0,1,1.25-1.08,2.63,2.63,0,0,1,1.3-.32,1.79,1.79,0,0,1,1.17.35,1.25,1.25,0,0,1,.44,1,1.64,1.64,0,0,1-.42,1.05,6.29,6.29,0,0,1-1.34,1.06,2.32,2.32,0,0,1,1.42.49A1.55,1.55,0,0,1,27.8,465.32Zm-6.24.57H20.28v2.34h-.84v-2.34H15.82l-.08-.12,4.13-5.58h.41v5.31h1.28Zm-2.12-.39v-4.3l-3.19,4.3Z"
              />
              <path
                class="cls-5"
                d="M28.52,486.51l-.69,2.12H23.5l-.08-.11,2.13-2.39a12.84,12.84,0,0,0,1-1.26,4.21,4.21,0,0,0,.55-1,3.15,3.15,0,0,0,.17-1,1.57,1.57,0,0,0-.42-1.14,1.63,1.63,0,0,0-1.19-.45,1.74,1.74,0,0,0-1.09.36,4.38,4.38,0,0,0-.92,1l-.14-.08a4.42,4.42,0,0,1,1.11-1.46,2.29,2.29,0,0,1,1.48-.53,2,2,0,0,1,1.42.52,1.87,1.87,0,0,1,.56,1.44,2.64,2.64,0,0,1-.22,1.1,4.86,4.86,0,0,1-.64,1c-.27.34-.62.73-1,1.17l-1.95,2.12h1.84a5.18,5.18,0,0,0,1-.08,1.22,1.22,0,0,0,.6-.3,2.56,2.56,0,0,0,.49-.65l.22-.39Zm-7.23-.16H20v2.34h-.85v-2.34H15.55l-.08-.11,4.13-5.59H20V486h1.27ZM19.17,486v-4.31L16,486Z"
              />
              <path
                class="cls-5"
                d="M27.52,509.12h-.43l-.64,0H25.28l-.71,0h-.46V509l.45-.05a1.38,1.38,0,0,0,.54-.16.64.64,0,0,0,.26-.43,4.78,4.78,0,0,0,.07-.9V503a3.65,3.65,0,0,0-.08-.87.53.53,0,0,0-.29-.37,1.61,1.61,0,0,0-.64-.08h-.31v-.13a7.74,7.74,0,0,0,1.12-.24,6.57,6.57,0,0,0,1-.33l.11.06v6.39a4.06,4.06,0,0,0,.07.9.63.63,0,0,0,.25.43,1.18,1.18,0,0,0,.49.16l.39.05Zm-5.16-2.29H21.09v2.34h-.84v-2.34H16.63l-.08-.12,4.13-5.58h.41v5.32h1.27Zm-2.11-.38v-4.31l-3.19,4.31Z"
              />
              <path
                class="cls-5"
                d="M28.55,525.61a6.26,6.26,0,0,1-.32,2.1,3.51,3.51,0,0,1-.93,1.47,2.23,2.23,0,0,1-1.45.55,2.26,2.26,0,0,1-1.53-.56,3.18,3.18,0,0,1-.89-1.47,7,7,0,0,1-.29-2.09,6.19,6.19,0,0,1,.33-2.09,3.32,3.32,0,0,1,.93-1.47,2.16,2.16,0,0,1,1.45-.55,2.25,2.25,0,0,1,1.52.56,3.2,3.2,0,0,1,.89,1.46A6.77,6.77,0,0,1,28.55,525.61Zm-1,.24a8.56,8.56,0,0,0-.43-3.07,1.46,1.46,0,0,0-1.37-1.09,1.29,1.29,0,0,0-1.19.95,7.44,7.44,0,0,0-.39,2.74,8.41,8.41,0,0,0,.42,3.07A1.48,1.48,0,0,0,26,529.54a1.3,1.3,0,0,0,1.2-.95A7.44,7.44,0,0,0,27.54,525.85ZM21,527.29H19.76v2.34h-.85v-2.34H15.29l-.08-.11,4.13-5.58h.42v5.31H21Zm-2.12-.38V522.6l-3.19,4.31Z"
              />
              <path
                class="cls-5"
                d="M27.82,544.74a4.68,4.68,0,0,1-1,3A8,8,0,0,1,23.47,550l-.08-.18a7.34,7.34,0,0,0,2.2-1.44,4,4,0,0,0,1-1.63,6.15,6.15,0,0,0,.22-1.84,4.58,4.58,0,0,0-.46-2.28,1.43,1.43,0,0,0-1.27-.75,1.17,1.17,0,0,0-1.09.6,3.2,3.2,0,0,0-.34,1.62,3.83,3.83,0,0,0,.14,1.11,1.67,1.67,0,0,0,.49.8,1.4,1.4,0,0,0,.94.31,2.62,2.62,0,0,0,.67-.08l0,.15a3.37,3.37,0,0,1-1,.19,2.21,2.21,0,0,1-1.63-.61,2.24,2.24,0,0,1-.59-1.64A2.61,2.61,0,0,1,23,543a2.57,2.57,0,0,1,.91-.94,2.64,2.64,0,0,1,1.28-.35,2.57,2.57,0,0,1,1.31.35,2.49,2.49,0,0,1,.93,1A3.72,3.72,0,0,1,27.82,544.74Zm-7.54,2.18a2.57,2.57,0,0,1-.55,1.64,3.31,3.31,0,0,1-1.28,1,3.49,3.49,0,0,1-1.47.34,1.51,1.51,0,0,1-.82-.18.55.55,0,0,1-.28-.48.5.5,0,0,1,.15-.35.52.52,0,0,1,.33-.11A1,1,0,0,1,17,549a2.45,2.45,0,0,1,.58.61,2.53,2.53,0,0,0,1-.31,2.13,2.13,0,0,0,.76-.73,2.17,2.17,0,0,0,.3-1.1,1.49,1.49,0,0,0-.47-1.19,1.84,1.84,0,0,0-1.24-.39,2,2,0,0,0-.55.07,3.62,3.62,0,0,0-.54.2l-.11-.2a13,13,0,0,0,1.65-1,2.68,2.68,0,0,0,.75-.79,1.4,1.4,0,0,0,.19-.73,1,1,0,0,0-.32-.75,1.43,1.43,0,0,0-.94-.3,2.14,2.14,0,0,0-1.05.25,4.16,4.16,0,0,0-.91.67l-.11-.12a4.23,4.23,0,0,1,1.25-1.09,2.56,2.56,0,0,1,1.29-.31,1.77,1.77,0,0,1,1.18.35,1.25,1.25,0,0,1,.44,1,1.58,1.58,0,0,1-.43,1,5.33,5.33,0,0,1-1.34,1.06,2.36,2.36,0,0,1,1.42.49A1.53,1.53,0,0,1,20.28,546.92Z"
              />
              <path
                class="cls-5"
                d="M28,568.26a2,2,0,0,1-.36,1.13,2.18,2.18,0,0,1-.92.74,3.13,3.13,0,0,1-2.45,0,2.24,2.24,0,0,1-.89-.64,1.7,1.7,0,0,1-.35-1,2,2,0,0,1,.45-1.31,3.92,3.92,0,0,1,1.37-1,2.94,2.94,0,0,1-1.16-.83,2.07,2.07,0,0,1-.43-1.3,1.72,1.72,0,0,1,.65-1.35,2.53,2.53,0,0,1,1.69-.57,2.41,2.41,0,0,1,1.55.51,1.58,1.58,0,0,1,.62,1.22,1.74,1.74,0,0,1-.44,1.15,3.61,3.61,0,0,1-1.19.85,3.56,3.56,0,0,1,1.42,1A2,2,0,0,1,28,568.26Zm-1.07-4.19a1.82,1.82,0,0,0-.39-1.24,1.46,1.46,0,0,0-1.15-.47,1.38,1.38,0,0,0-1.05.43,1.48,1.48,0,0,0-.38,1,1.39,1.39,0,0,0,.43,1.08,5.13,5.13,0,0,0,1.54.9,2.12,2.12,0,0,0,.74-.68A2,2,0,0,0,26.89,564.07Zm.34,4.44a1.51,1.51,0,0,0-.47-1.18,5.88,5.88,0,0,0-1.75-1,2.44,2.44,0,0,0-.88.87,2.55,2.55,0,0,0-.24,1.19,2,2,0,0,0,.47,1.36,1.77,1.77,0,0,0,2.42,0A1.71,1.71,0,0,0,27.23,568.51Zm-6.68-1.11A2.63,2.63,0,0,1,20,569a3.49,3.49,0,0,1-1.28,1,3.57,3.57,0,0,1-1.48.34,1.44,1.44,0,0,1-.82-.19.55.55,0,0,1-.27-.47.41.41,0,0,1,.15-.35.47.47,0,0,1,.33-.11,1,1,0,0,1,.59.19,2.38,2.38,0,0,1,.58.6,2.38,2.38,0,0,0,1-.31,2.06,2.06,0,0,0,1.06-1.83,1.5,1.5,0,0,0-.47-1.19,1.89,1.89,0,0,0-1.24-.38,2,2,0,0,0-.55.07,3.51,3.51,0,0,0-.54.19l-.11-.19a13.21,13.21,0,0,0,1.64-1,2.72,2.72,0,0,0,.76-.79,1.5,1.5,0,0,0,.19-.73,1,1,0,0,0-.32-.75,1.38,1.38,0,0,0-.94-.31,2.26,2.26,0,0,0-1.05.25,4.31,4.31,0,0,0-.91.68l-.11-.13a4.28,4.28,0,0,1,1.24-1.08,2.63,2.63,0,0,1,1.3-.32,1.79,1.79,0,0,1,1.18.36,1.28,1.28,0,0,1,.44,1,1.6,1.6,0,0,1-.43,1,5.77,5.77,0,0,1-1.34,1.06,2.36,2.36,0,0,1,1.42.49A1.56,1.56,0,0,1,20.55,567.4Z"
              />
              <path
                class="cls-5"
                d="M28,582.9l-1.64,3.29c-.56,1.1-1,2-1.34,2.74s-.6,1.29-.77,1.7c-.05.12-.12.19-.19.2a.49.49,0,0,1-.25-.06.19.19,0,0,1-.1-.16.45.45,0,0,1,.09-.24c.26-.4.57-.94.95-1.64s.84-1.58,1.38-2.67l1.27-2.56H24.86a4.48,4.48,0,0,0-.72,0,1,1,0,0,0-.45.2,1.56,1.56,0,0,0-.33.43l-.22.39H23l.66-2h.07a.72.72,0,0,0,.25.16,2.31,2.31,0,0,0,.53.06H28Zm-7.21,5a2.69,2.69,0,0,1-.55,1.63,3.34,3.34,0,0,1-1.29,1,3.49,3.49,0,0,1-1.47.34,1.51,1.51,0,0,1-.82-.18.54.54,0,0,1-.28-.48.45.45,0,0,1,.15-.34.5.5,0,0,1,.34-.12,1,1,0,0,1,.59.19,2.63,2.63,0,0,1,.57.61,2.58,2.58,0,0,0,1-.31,2.1,2.1,0,0,0,.75-.73,2,2,0,0,0,.3-1.1,1.49,1.49,0,0,0-.46-1.19,1.87,1.87,0,0,0-1.25-.39,2.51,2.51,0,0,0-.55.07,3.16,3.16,0,0,0-.53.2l-.12-.2a13.17,13.17,0,0,0,1.65-1,2.82,2.82,0,0,0,.75-.8,1.31,1.31,0,0,0,.19-.73,1,1,0,0,0-.32-.75,1.41,1.41,0,0,0-.94-.3,2.17,2.17,0,0,0-1,.25,3.68,3.68,0,0,0-.9.68l-.12-.13A4.3,4.3,0,0,1,17.74,583a2.62,2.62,0,0,1,1.29-.32,1.82,1.82,0,0,1,1.18.35,1.26,1.26,0,0,1,.44,1,1.56,1.56,0,0,1-.43,1.05,5.33,5.33,0,0,1-1.34,1.06,2.39,2.39,0,0,1,1.43.49A1.6,1.6,0,0,1,20.83,587.87Z"
              />
              <path
                class="cls-5"
                d="M28.2,614.35a2.67,2.67,0,0,1-.35,1.36,2.62,2.62,0,0,1-.91.93,2.44,2.44,0,0,1-1.28.35,2.42,2.42,0,0,1-2.24-1.38,3.72,3.72,0,0,1-.36-1.65,4.69,4.69,0,0,1,1-3,8.08,8.08,0,0,1,3.36-2.3l.08.17a7.16,7.16,0,0,0-2.2,1.45,4,4,0,0,0-1,1.63,6.09,6.09,0,0,0-.22,1.83,4.43,4.43,0,0,0,.47,2.28,1.39,1.39,0,0,0,1.26.76,1.21,1.21,0,0,0,1.09-.6,3.25,3.25,0,0,0,.34-1.62,4,4,0,0,0-.14-1.12,1.67,1.67,0,0,0-.49-.8,1.43,1.43,0,0,0-.94-.31,2.62,2.62,0,0,0-.67.08l0-.15a3.1,3.1,0,0,1,1-.18,2.21,2.21,0,0,1,1.63.6A2.26,2.26,0,0,1,28.2,614.35ZM20.55,614a2.63,2.63,0,0,1-.55,1.64,3.39,3.39,0,0,1-1.28,1,3.57,3.57,0,0,1-1.48.34,1.53,1.53,0,0,1-.82-.18.56.56,0,0,1-.27-.48.43.43,0,0,1,.15-.35.52.52,0,0,1,.33-.11,1,1,0,0,1,.59.19,2.45,2.45,0,0,1,.58.61,2.53,2.53,0,0,0,1-.31,2.21,2.21,0,0,0,.76-.73,2.17,2.17,0,0,0,.3-1.1,1.49,1.49,0,0,0-.47-1.19,1.84,1.84,0,0,0-1.24-.39,2,2,0,0,0-.55.07,3.62,3.62,0,0,0-.54.2L17,613a13.36,13.36,0,0,0,1.64-1,2.74,2.74,0,0,0,.76-.8,1.5,1.5,0,0,0,.19-.73,1,1,0,0,0-.32-.75,1.43,1.43,0,0,0-.94-.3,2.14,2.14,0,0,0-1.05.25,3.94,3.94,0,0,0-.91.67l-.11-.12a4.33,4.33,0,0,1,1.24-1.09,2.62,2.62,0,0,1,1.3-.31,1.79,1.79,0,0,1,1.18.35,1.28,1.28,0,0,1,.44,1,1.58,1.58,0,0,1-.43,1.05,5.52,5.52,0,0,1-1.34,1.06,2.36,2.36,0,0,1,1.42.49A1.56,1.56,0,0,1,20.55,614Z"
              />
              <path
                class="cls-5"
                d="M202.08,616.4a2.78,2.78,0,0,1-.55.39,1.34,1.34,0,0,1-.64.15.91.91,0,0,1-1-1v-3.33h-.7v-.08l.71-.25.6-1.5h.13v1.49H202v.34h-1.36v3.21c0,.51.23.78.67.78a1.06,1.06,0,0,0,.37-.06,1.53,1.53,0,0,0,.33-.2Zm-3.65-3.92a.7.7,0,0,1-.12.44.33.33,0,0,1-.25.15.72.72,0,0,1-.31-.11,3.42,3.42,0,0,1-.52-.34,2.2,2.2,0,0,0-.43.27,2.31,2.31,0,0,0-.36.33v2.47a3.17,3.17,0,0,0,.05.63.37.37,0,0,0,.2.29,1.14,1.14,0,0,0,.46.11l.26,0v.11H195v-.11l.21,0a.68.68,0,0,0,.34-.11.39.39,0,0,0,.15-.29,3.34,3.34,0,0,0,0-.63v-2.36a1,1,0,0,0-.09-.49.7.7,0,0,0-.37-.24l-.29-.11v-.08l1.4-.33.09.06V613a4.27,4.27,0,0,1,.79-.71,1.21,1.21,0,0,1,.68-.2.63.63,0,0,1,.38.1A.34.34,0,0,1,198.43,612.48Zm-4.05,4.38c-.57,0-1.06,0-1.48,0v-.71a4.07,4.07,0,0,1-.76.57,1.69,1.69,0,0,1-.84.21c-.91,0-1.38-.48-1.39-1.48v-2.15a.81.81,0,0,0-.09-.49.7.7,0,0,0-.37-.24l-.29-.11v-.08l1.41-.33.08.06v3.23a1.33,1.33,0,0,0,.26.89.86.86,0,0,0,.7.29,1.5,1.5,0,0,0,.7-.16,2.16,2.16,0,0,0,.59-.41v-2.65a.81.81,0,0,0-.09-.49.67.67,0,0,0-.36-.24l-.29-.11v-.08l1.4-.33.09.06v3.55a4.85,4.85,0,0,0,0,.63.47.47,0,0,0,.15.29.72.72,0,0,0,.35.11l.2,0Zm-5.74-2.3a2.66,2.66,0,0,1-.31,1.25,2.21,2.21,0,0,1-.81.85,2.16,2.16,0,0,1-1.15.32,2.28,2.28,0,0,1-1.13-.28,2,2,0,0,1-.82-.83,3,3,0,0,1-.32-1.4,2.66,2.66,0,0,1,.31-1.25,2.37,2.37,0,0,1,.81-.85,2.23,2.23,0,0,1,1.15-.32,2.28,2.28,0,0,1,1.13.28,2,2,0,0,1,.82.83A3.08,3.08,0,0,1,188.64,614.56Zm-.85.19a3.49,3.49,0,0,0-.44-1.83,1.33,1.33,0,0,0-1.14-.7,1,1,0,0,0-.92.48,2.92,2.92,0,0,0-.34,1.58,3.46,3.46,0,0,0,.43,1.83,1.36,1.36,0,0,0,1.15.7,1,1,0,0,0,.92-.48A3,3,0,0,0,187.79,614.75Zm-4.78.33-.24,1.39a3.57,3.57,0,0,1-1,.37,5.11,5.11,0,0,1-1.31.14,4,4,0,0,1-1.84-.42,3.11,3.11,0,0,1-1.27-1.22,3.6,3.6,0,0,1-.48-1.9,3.38,3.38,0,0,1,.54-1.88,3.54,3.54,0,0,1,1.32-1.23,3.61,3.61,0,0,1,1.69-.42,5.18,5.18,0,0,1,1.29.13,4.7,4.7,0,0,1,.9.34l.24,1.43h-.12l-.13-.28a2.69,2.69,0,0,0-.81-1,2.54,2.54,0,0,0-3.29.45,3.88,3.88,0,0,0-.71,2.41,4,4,0,0,0,.77,2.54,2.46,2.46,0,0,0,2,.92,2.25,2.25,0,0,0,1.33-.36,2.58,2.58,0,0,0,.84-1.09l.13-.28Zm-9.2-2.8-.18,0a.63.63,0,0,0-.44.24,3.31,3.31,0,0,0-.4.76l-1.92,4.59a2.79,2.79,0,0,1-.52.86.76.76,0,0,1-.57.24.4.4,0,0,1-.32-.11.44.44,0,0,1-.1-.3.43.43,0,0,1,.3-.4,1.58,1.58,0,0,1,.85-.08c.18-.33.38-.75.6-1.27l-1.53-3.6a3.2,3.2,0,0,0-.37-.72.57.57,0,0,0-.42-.21l-.21,0v-.11h2.23v.11l-.26,0a.62.62,0,0,0-.31.1.24.24,0,0,0-.07.2,1.47,1.47,0,0,0,0,.27c0,.1.06.2.1.3l1.15,2.87.95-2.44a3,3,0,0,0,.26-1,.36.36,0,0,0-.36-.35l-.27,0v-.11h1.77Zm-5.65,4.58h-1.32a8.24,8.24,0,0,0-.64-1l-1-1.47-.34.32v1a3.34,3.34,0,0,0,0,.63.39.39,0,0,0,.15.29.77.77,0,0,0,.36.11l.2,0v.11h-2.23v-.11l.21,0a.68.68,0,0,0,.34-.11.39.39,0,0,0,.15-.29,3.34,3.34,0,0,0,0-.63v-4.91a1,1,0,0,0-.09-.5.76.76,0,0,0-.37-.23l-.29-.11v-.08l1.4-.33.09.06v4.87l1.19-1.11.41-.41a.48.48,0,0,0,.13-.29c0-.18-.13-.28-.4-.32l-.21,0v-.12h2v.11h-.11a.9.9,0,0,0-.48.15,4.31,4.31,0,0,0-.62.5l-1.08,1,1.52,2.1a4.33,4.33,0,0,0,.45.53.65.65,0,0,0,.36.16l.18,0ZM162.63,615a1.63,1.63,0,0,1-.33,1,2.21,2.21,0,0,1-.89.67,3.3,3.3,0,0,1-1.29.24,4.65,4.65,0,0,1-1.06-.1,2.4,2.4,0,0,1-.69-.23l-.23-1.31h.12l.14.29a2.1,2.1,0,0,0,.75.92,1.86,1.86,0,0,0,1,.26,2.08,2.08,0,0,0,1.33-.37,1.33,1.33,0,0,0,.46-1.08,1.22,1.22,0,0,0-.36-1,3,3,0,0,0-1.25-.59,3.78,3.78,0,0,1-1.52-.72,1.81,1.81,0,0,1-.21-2.26,2,2,0,0,1,.8-.64,2.57,2.57,0,0,1,1.13-.23,4.47,4.47,0,0,1,1,.08,2.73,2.73,0,0,1,.68.21l.22,1.35h-.12l-.13-.29a2.38,2.38,0,0,0-.69-.92,1.65,1.65,0,0,0-1-.26,1.67,1.67,0,0,0-1.14.36,1.27,1.27,0,0,0-.39,1,1.14,1.14,0,0,0,.34.92,3.14,3.14,0,0,0,1.27.58,3.48,3.48,0,0,1,1.57.79A1.72,1.72,0,0,1,162.63,615Z"
              />
              <path
                class="cls-15"
                d="M271,666.66V657h.82l5.28,5.73V657H279v9.62h-.83l-5.27-5.73v5.73Zm-10.73-7.22a3.68,3.68,0,0,0,0,4.82,3.26,3.26,0,0,0,4.54,0,3.71,3.71,0,0,0,0-4.82,3.29,3.29,0,0,0-4.54,0Zm-2.45,4.4a5.15,5.15,0,0,1,0-4,5,5,0,0,1,1.08-1.59,5.17,5.17,0,0,1,1.63-1,5.48,5.48,0,0,1,4,0,5.06,5.06,0,0,1,1.63,1,4.67,4.67,0,0,1,1.08,1.59,5.15,5.15,0,0,1,0,4,4.67,4.67,0,0,1-1.08,1.59,4.9,4.9,0,0,1-1.63,1,5.48,5.48,0,0,1-4,0,4.78,4.78,0,0,1-2.71-2.63Zm-5.33,2.82V657h1.95v9.62Zm-9.87-8V657h6.55v1.65h-2.3v8h-1.94v-8Zm-11.11,3.16a5,5,0,0,1,.67-2.57,4.72,4.72,0,0,1,1.84-1.79,5.42,5.42,0,0,1,2.61-.64,5.82,5.82,0,0,1,1.49.17,4.93,4.93,0,0,1,1.26.56l.16,2h-.26a4.26,4.26,0,0,0-2.57-1,3.1,3.1,0,0,0-2.38.91,3.22,3.22,0,0,0-.87,2.33,3.26,3.26,0,0,0,.87,2.34,3.14,3.14,0,0,0,2.38.91,4.23,4.23,0,0,0,2.57-1h.26l-.16,2a5,5,0,0,1-1.27.56,5.33,5.33,0,0,1-1.48.17,5.46,5.46,0,0,1-2-.37,5.14,5.14,0,0,1-1.63-1,4.79,4.79,0,0,1-1.07-1.59A5.18,5.18,0,0,1,231.49,661.85Zm-8.91,4.81V657h6.1v1.65h-4.15v2.2h4v1.65h-4V665h4.21v1.65Zm-10,0V657h2v8h4.69v1.65Zm-10,0V657h1.94v8h4.69v1.65Zm-10.74-7.22a3.71,3.71,0,0,0,0,4.82,3.27,3.27,0,0,0,4.55,0,3.71,3.71,0,0,0,0-4.82,3.3,3.3,0,0,0-4.55,0Zm-2.44,4.4a5.15,5.15,0,0,1,0-4,4.67,4.67,0,0,1,1.08-1.59,5.06,5.06,0,0,1,1.63-1,5.48,5.48,0,0,1,4,0,5.17,5.17,0,0,1,1.63,1,5,5,0,0,1,1.08,1.59,5.15,5.15,0,0,1,0,4,4.78,4.78,0,0,1-2.71,2.63,5.48,5.48,0,0,1-4,0,4.9,4.9,0,0,1-1.63-1A4.67,4.67,0,0,1,189.39,663.84Zm-11-2a5,5,0,0,1,.67-2.57,4.72,4.72,0,0,1,1.84-1.79,5.42,5.42,0,0,1,2.61-.64A5.82,5.82,0,0,1,185,657a4.93,4.93,0,0,1,1.26.56l.16,2h-.26a4.26,4.26,0,0,0-2.57-1,3.1,3.1,0,0,0-2.38.91,3.22,3.22,0,0,0-.87,2.33,3.26,3.26,0,0,0,.87,2.34,3.14,3.14,0,0,0,2.38.91,4.23,4.23,0,0,0,2.57-1h.26l-.16,2a5,5,0,0,1-1.27.56,5.33,5.33,0,0,1-1.48.17,5.46,5.46,0,0,1-2-.37,5.14,5.14,0,0,1-1.63-1,4.79,4.79,0,0,1-1.07-1.59A5.18,5.18,0,0,1,178.43,661.85Zm-17.54,4.81V657h.82l5.27,5.73V657h2v9.62h-.82l-5.28-5.73v5.73Zm-10.6-7.22a3.68,3.68,0,0,0,0,4.82,3.26,3.26,0,0,0,4.54,0,3.68,3.68,0,0,0,0-4.82,3.29,3.29,0,0,0-4.54,0Zm-2.45,4.4a5.27,5.27,0,0,1,0-4,4.84,4.84,0,0,1,1.09-1.59,5,5,0,0,1,1.63-1,5.48,5.48,0,0,1,4,0,5.17,5.17,0,0,1,1.63,1,5,5,0,0,1,1.08,1.59,5.15,5.15,0,0,1,0,4,4.78,4.78,0,0,1-2.71,2.63,5.48,5.48,0,0,1-4,0,4.84,4.84,0,0,1-2.72-2.63Zm-10.4,2.82v-.27l4.51-7.7h-4.1V657h7v.28L140.33,665H145v1.65Zm-4.93,0V657h1.94v9.62Zm-8.2-5.74h.91c1,0,1.44-.37,1.44-1.1s-.48-1.1-1.44-1.1h-.91Zm-2,5.74V657h3a3.57,3.57,0,0,1,2.33.74,2.54,2.54,0,0,1,.89,2,2.63,2.63,0,0,1-.48,1.59,2.78,2.78,0,0,1-1.33,1l2.56,4.29h-2.15l-2.44-4.06h-.46v4.06Zm-10.46-7.22a3.68,3.68,0,0,0,0,4.82,3.26,3.26,0,0,0,4.54,0,3.68,3.68,0,0,0,0-4.82,3.29,3.29,0,0,0-4.54,0Zm-2.44,4.4a5.15,5.15,0,0,1,0-4,4.67,4.67,0,0,1,1.08-1.59,5,5,0,0,1,1.63-1,5.48,5.48,0,0,1,4,0,5.17,5.17,0,0,1,1.63,1,5,5,0,0,1,1.08,1.59,5.15,5.15,0,0,1,0,4,4.78,4.78,0,0,1-2.71,2.63,5.48,5.48,0,0,1-4,0,4.8,4.8,0,0,1-1.63-1A4.67,4.67,0,0,1,109.46,663.84Zm-11.37,2.82V657h2v3.72h3.81V657h2v9.62h-2v-4.25H100v4.25Z"
              />
              <path
                class="cls-5"
                d="M27.76,643.92,27.4,645H24.48l-.65,1.43a5.63,5.63,0,0,1,2.61.8,2.13,2.13,0,0,1,.88,1.88,2.93,2.93,0,0,1-.51,1.68,3.38,3.38,0,0,1-1.23,1.09,3.23,3.23,0,0,1-1.48.38,1.29,1.29,0,0,1-.76-.19.56.56,0,0,1-.23-.42q0-.45.57-.48a1,1,0,0,1,.57.18,3.81,3.81,0,0,1,.61.53,2.72,2.72,0,0,0,1.39-.84,2.28,2.28,0,0,0,.55-1.52A1.72,1.72,0,0,0,26,648a6.21,6.21,0,0,0-2.62-.69l-.09-.11,1.34-2.94h2a2.87,2.87,0,0,0,.65-.06.86.86,0,0,0,.43-.23Zm-6.93,5.36a2.69,2.69,0,0,1-.55,1.64,3.34,3.34,0,0,1-1.29,1,3.49,3.49,0,0,1-1.47.34,1.51,1.51,0,0,1-.82-.18.55.55,0,0,1-.28-.48.5.5,0,0,1,.15-.35.55.55,0,0,1,.34-.11,1,1,0,0,1,.59.19,2.63,2.63,0,0,1,.57.61,2.58,2.58,0,0,0,1-.31,2.18,2.18,0,0,0,.75-.73,2,2,0,0,0,.3-1.1,1.49,1.49,0,0,0-.46-1.19,1.87,1.87,0,0,0-1.25-.39,2,2,0,0,0-.55.07,3.16,3.16,0,0,0-.53.2l-.12-.2a13,13,0,0,0,1.65-1,2.68,2.68,0,0,0,.75-.79,1.31,1.31,0,0,0,.19-.73,1,1,0,0,0-.32-.75,1.41,1.41,0,0,0-.94-.3,2.17,2.17,0,0,0-1,.25,3.89,3.89,0,0,0-.9.67l-.12-.12a4.35,4.35,0,0,1,1.25-1.09A2.61,2.61,0,0,1,19,644.1a1.77,1.77,0,0,1,1.18.35,1.25,1.25,0,0,1,.44,1,1.58,1.58,0,0,1-.43,1,5.33,5.33,0,0,1-1.34,1.06,2.39,2.39,0,0,1,1.43.49A1.59,1.59,0,0,1,20.83,649.28Z"
              />
              <path
                class="cls-5"
                d="M24.06,676.75a2.69,2.69,0,0,1-.55,1.64,3.34,3.34,0,0,1-1.29,1,3.49,3.49,0,0,1-1.47.34,1.51,1.51,0,0,1-.82-.18.55.55,0,0,1-.28-.48.45.45,0,0,1,.15-.34.5.5,0,0,1,.34-.12,1,1,0,0,1,.59.19,2.63,2.63,0,0,1,.57.61,2.58,2.58,0,0,0,1-.31,2.1,2.1,0,0,0,.75-.73,2,2,0,0,0,.3-1.1,1.46,1.46,0,0,0-.47-1.19,1.82,1.82,0,0,0-1.24-.39,2,2,0,0,0-.55.07,3.16,3.16,0,0,0-.53.2l-.12-.2a14.47,14.47,0,0,0,1.65-1,2.82,2.82,0,0,0,.75-.8,1.31,1.31,0,0,0,.19-.73,1,1,0,0,0-.32-.75,1.41,1.41,0,0,0-.94-.3,2.17,2.17,0,0,0-1.05.25,3.89,3.89,0,0,0-.9.67l-.12-.12A4.35,4.35,0,0,1,21,671.88a2.59,2.59,0,0,1,1.29-.31,1.77,1.77,0,0,1,1.18.35,1.25,1.25,0,0,1,.44,1,1.58,1.58,0,0,1-.43,1.05A5.33,5.33,0,0,1,22.11,675a2.34,2.34,0,0,1,1.42.49A1.57,1.57,0,0,1,24.06,676.75Z"
              />
              <line
                class="cls-3"
                x1="22.11"
                y1="656.17"
                x2="22.11"
                y2="666.14"
              />
              <path
                class="cls-5"
                d="M381.26,643.92,380.9,645H378l-.65,1.43a5.63,5.63,0,0,1,2.61.8,2.13,2.13,0,0,1,.88,1.88,2.93,2.93,0,0,1-.51,1.68,3.38,3.38,0,0,1-1.23,1.09,3.23,3.23,0,0,1-1.48.38,1.29,1.29,0,0,1-.76-.19.55.55,0,0,1-.22-.42c0-.3.19-.46.56-.48a1,1,0,0,1,.57.18,3.42,3.42,0,0,1,.61.53,2.68,2.68,0,0,0,1.39-.84,2.23,2.23,0,0,0,.55-1.52,1.72,1.72,0,0,0-.85-1.58,6.2,6.2,0,0,0-2.61-.69l-.1-.11,1.34-2.94h2a2.84,2.84,0,0,0,.64-.06.86.86,0,0,0,.43-.23Zm-6.93,5.36a2.69,2.69,0,0,1-.55,1.64,3.34,3.34,0,0,1-1.29,1,3.49,3.49,0,0,1-1.47.34,1.51,1.51,0,0,1-.82-.18.55.55,0,0,1-.28-.48.5.5,0,0,1,.15-.35.58.58,0,0,1,.34-.11,1,1,0,0,1,.59.19,2.64,2.64,0,0,1,.58.61,2.58,2.58,0,0,0,1-.31,2.18,2.18,0,0,0,.75-.73,2,2,0,0,0,.3-1.1,1.49,1.49,0,0,0-.46-1.19,1.87,1.87,0,0,0-1.25-.39,2,2,0,0,0-.55.07,3.16,3.16,0,0,0-.53.2l-.12-.2a11.71,11.71,0,0,0,1.65-1,2.74,2.74,0,0,0,.76-.79,1.39,1.39,0,0,0,.18-.73A.93.93,0,0,0,373,645a1.41,1.41,0,0,0-.94-.3A2.2,2.2,0,0,0,371,645a3.89,3.89,0,0,0-.9.67l-.12-.12a4.35,4.35,0,0,1,1.25-1.09,2.62,2.62,0,0,1,1.3-.31,1.74,1.74,0,0,1,1.17.35,1.22,1.22,0,0,1,.44,1,1.62,1.62,0,0,1-.42,1,5.6,5.6,0,0,1-1.35,1.06,2.39,2.39,0,0,1,1.43.49A1.56,1.56,0,0,1,374.33,649.28Z"
              />
              <path
                class="cls-5"
                d="M377.56,676.75a2.57,2.57,0,0,1-.55,1.64,3.31,3.31,0,0,1-1.28,1,3.49,3.49,0,0,1-1.47.34,1.51,1.51,0,0,1-.82-.18.55.55,0,0,1-.28-.48.45.45,0,0,1,.15-.34.48.48,0,0,1,.33-.12,1,1,0,0,1,.59.19,2.45,2.45,0,0,1,.58.61,2.53,2.53,0,0,0,1-.31,2,2,0,0,0,.76-.73,2.17,2.17,0,0,0,.3-1.1,1.49,1.49,0,0,0-.47-1.19,1.84,1.84,0,0,0-1.24-.39,2,2,0,0,0-.55.07,3.62,3.62,0,0,0-.54.2l-.11-.2a14.47,14.47,0,0,0,1.65-1,2.82,2.82,0,0,0,.75-.8,1.4,1.4,0,0,0,.19-.73,1,1,0,0,0-.32-.75,1.43,1.43,0,0,0-.94-.3,2.14,2.14,0,0,0-1.05.25,4.16,4.16,0,0,0-.91.67l-.11-.12a4.23,4.23,0,0,1,1.25-1.09,2.56,2.56,0,0,1,1.29-.31,1.77,1.77,0,0,1,1.18.35,1.25,1.25,0,0,1,.44,1A1.58,1.58,0,0,1,377,674a5.33,5.33,0,0,1-1.34,1.06,2.36,2.36,0,0,1,1.42.49A1.53,1.53,0,0,1,377.56,676.75Z"
              />
              <line
                class="cls-3"
                x1="375.6"
                y1="656.17"
                x2="375.6"
                y2="666.14"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="209.33"
                x2="956.57"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="209.33"
                x2="1010.17"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="1063.77"
                y1="209.33"
                x2="1063.77"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="209.33"
                x2="1010.17"
                y2="209.33"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="209.33"
                x2="1064.03"
                y2="209.33"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="229.53"
                x2="1010.17"
                y2="209.6"
              />
              <line
                class="cls-14"
                x1="1063.77"
                y1="229.53"
                x2="1063.77"
                y2="209.6"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="229.8"
                x2="1010.17"
                y2="229.8"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="229.8"
                x2="1064.03"
                y2="229.8"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="250"
                x2="1010.17"
                y2="230.07"
              />
              <line
                class="cls-14"
                x1="1063.77"
                y1="250"
                x2="1063.77"
                y2="230.07"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="250.27"
                x2="1010.17"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="250.27"
                x2="1064.03"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="270.47"
                x2="1010.17"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="1063.77"
                y1="270.47"
                x2="1063.77"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="270.47"
                x2="1010.17"
                y2="270.47"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="270.47"
                x2="1064.03"
                y2="270.47"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="290.67"
                x2="1010.17"
                y2="270.74"
              />
              <line
                class="cls-14"
                x1="1063.77"
                y1="290.67"
                x2="1063.77"
                y2="270.74"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="290.94"
                x2="1010.17"
                y2="290.94"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="290.94"
                x2="1064.03"
                y2="290.94"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="311.14"
                x2="1010.17"
                y2="291.21"
              />
              <line
                class="cls-14"
                x1="1063.77"
                y1="311.14"
                x2="1063.77"
                y2="291.21"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="311.41"
                x2="1010.17"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="311.41"
                x2="1064.03"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="331.61"
                x2="1010.17"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="1063.77"
                y1="331.61"
                x2="1063.77"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="331.61"
                x2="1010.17"
                y2="331.61"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="331.61"
                x2="1064.03"
                y2="331.61"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="351.81"
                x2="1010.17"
                y2="331.88"
              />
              <line
                class="cls-14"
                x1="1063.77"
                y1="351.81"
                x2="1063.77"
                y2="331.88"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="352.08"
                x2="1010.17"
                y2="352.08"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="352.08"
                x2="1064.03"
                y2="352.08"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="372.28"
                x2="1010.17"
                y2="352.35"
              />
              <line
                class="cls-14"
                x1="1063.77"
                y1="372.28"
                x2="1063.77"
                y2="352.35"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="372.55"
                x2="1010.17"
                y2="372.55"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="372.55"
                x2="1064.03"
                y2="372.55"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="392.75"
                x2="1010.17"
                y2="372.82"
              />
              <line
                class="cls-14"
                x1="1063.77"
                y1="392.75"
                x2="1063.77"
                y2="372.82"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="393.02"
                x2="1010.17"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="393.02"
                x2="1064.03"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="413.22"
                x2="1010.17"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="1063.77"
                y1="413.22"
                x2="1063.77"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="413.22"
                x2="1010.17"
                y2="413.22"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="413.22"
                x2="1064.03"
                y2="413.22"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="433.42"
                x2="1010.17"
                y2="413.49"
              />
              <line
                class="cls-14"
                x1="1063.77"
                y1="433.42"
                x2="1063.77"
                y2="413.49"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="433.69"
                x2="1010.17"
                y2="433.69"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="433.69"
                x2="1064.03"
                y2="433.69"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="453.89"
                x2="1010.17"
                y2="433.96"
              />
              <line
                class="cls-14"
                x1="1063.77"
                y1="453.89"
                x2="1063.77"
                y2="433.96"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="454.16"
                x2="1010.17"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="454.16"
                x2="1064.03"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="474.36"
                x2="1010.17"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="1063.77"
                y1="474.36"
                x2="1063.77"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="474.36"
                x2="1010.17"
                y2="474.36"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="474.36"
                x2="1064.03"
                y2="474.36"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="494.56"
                x2="1010.17"
                y2="474.63"
              />
              <line
                class="cls-14"
                x1="1063.77"
                y1="494.56"
                x2="1063.77"
                y2="474.63"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="494.83"
                x2="1010.17"
                y2="494.83"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="494.83"
                x2="1064.03"
                y2="494.83"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="515.03"
                x2="1010.17"
                y2="495.1"
              />
              <line
                class="cls-14"
                x1="1063.77"
                y1="515.03"
                x2="1063.77"
                y2="495.1"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="515.3"
                x2="1010.17"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="515.3"
                x2="1064.03"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="535.5"
                x2="1010.17"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="1063.77"
                y1="535.5"
                x2="1063.77"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="535.5"
                x2="1010.17"
                y2="535.5"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="535.5"
                x2="1064.03"
                y2="535.5"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="555.97"
                x2="1010.17"
                y2="535.77"
              />
              <line
                class="cls-14"
                x1="1063.77"
                y1="555.97"
                x2="1063.77"
                y2="535.77"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="555.97"
                x2="1010.17"
                y2="555.97"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="555.97"
                x2="1064.03"
                y2="555.97"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="576.17"
                x2="1010.17"
                y2="556.24"
              />
              <line
                class="cls-14"
                x1="1063.77"
                y1="576.17"
                x2="1063.77"
                y2="556.24"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="576.44"
                x2="1010.17"
                y2="576.44"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="576.44"
                x2="1064.03"
                y2="576.44"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="596.64"
                x2="1010.17"
                y2="576.71"
              />
              <line
                class="cls-14"
                x1="1063.77"
                y1="596.64"
                x2="1063.77"
                y2="576.71"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="596.91"
                x2="1010.17"
                y2="596.91"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="596.91"
                x2="1064.03"
                y2="596.91"
              />
              <line
                class="cls-14"
                x1="779.34"
                y1="209.33"
                x2="779.34"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="209.33"
                x2="849.64"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="779.07"
                y1="209.33"
                x2="849.64"
                y2="209.33"
              />
              <line
                class="cls-14"
                x1="779.34"
                y1="229.53"
                x2="779.34"
                y2="209.6"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="229.53"
                x2="849.64"
                y2="209.6"
              />
              <line
                class="cls-14"
                x1="779.07"
                y1="229.8"
                x2="849.64"
                y2="229.8"
              />
              <line
                class="cls-14"
                x1="779.34"
                y1="250"
                x2="779.34"
                y2="230.07"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="250"
                x2="849.64"
                y2="230.07"
              />
              <line
                class="cls-14"
                x1="779.07"
                y1="250.27"
                x2="849.64"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="779.34"
                y1="270.47"
                x2="779.34"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="270.47"
                x2="849.64"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="779.07"
                y1="270.47"
                x2="849.64"
                y2="270.47"
              />
              <line
                class="cls-14"
                x1="779.34"
                y1="290.67"
                x2="779.34"
                y2="270.74"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="290.67"
                x2="849.64"
                y2="270.74"
              />
              <line
                class="cls-14"
                x1="779.07"
                y1="290.94"
                x2="849.64"
                y2="290.94"
              />
              <line
                class="cls-14"
                x1="779.34"
                y1="311.14"
                x2="779.34"
                y2="291.21"
              />
              <line
                class="cls-14"
                x1="779.07"
                y1="311.41"
                x2="849.64"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="779.34"
                y1="331.61"
                x2="779.34"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="779.07"
                y1="331.61"
                x2="849.64"
                y2="331.61"
              />
              <line
                class="cls-14"
                x1="779.34"
                y1="351.81"
                x2="779.34"
                y2="331.88"
              />
              <line
                class="cls-14"
                x1="779.07"
                y1="352.08"
                x2="849.64"
                y2="352.08"
              />
              <line
                class="cls-14"
                x1="779.34"
                y1="372.28"
                x2="779.34"
                y2="352.35"
              />
              <line
                class="cls-14"
                x1="779.07"
                y1="372.55"
                x2="849.64"
                y2="372.55"
              />
              <line
                class="cls-14"
                x1="779.34"
                y1="392.75"
                x2="779.34"
                y2="372.82"
              />
              <line
                class="cls-14"
                x1="779.07"
                y1="393.02"
                x2="849.64"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="779.34"
                y1="413.22"
                x2="779.34"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="413.22"
                x2="849.64"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="779.07"
                y1="413.22"
                x2="849.64"
                y2="413.22"
              />
              <line
                class="cls-14"
                x1="779.34"
                y1="433.42"
                x2="779.34"
                y2="413.49"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="433.42"
                x2="849.64"
                y2="413.49"
              />
              <line
                class="cls-14"
                x1="779.07"
                y1="433.69"
                x2="849.64"
                y2="433.69"
              />
              <line
                class="cls-14"
                x1="779.34"
                y1="453.89"
                x2="779.34"
                y2="433.96"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="453.89"
                x2="849.64"
                y2="433.96"
              />
              <line
                class="cls-14"
                x1="779.07"
                y1="454.16"
                x2="849.64"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="779.34"
                y1="474.36"
                x2="779.34"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="779.07"
                y1="474.36"
                x2="849.64"
                y2="474.36"
              />
              <line
                class="cls-14"
                x1="779.34"
                y1="494.56"
                x2="779.34"
                y2="474.63"
              />
              <line
                class="cls-14"
                x1="779.07"
                y1="494.83"
                x2="849.64"
                y2="494.83"
              />
              <line
                class="cls-14"
                x1="779.34"
                y1="515.03"
                x2="779.34"
                y2="495.1"
              />
              <line
                class="cls-14"
                x1="779.07"
                y1="515.3"
                x2="849.64"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="779.34"
                y1="535.5"
                x2="779.34"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="779.07"
                y1="535.5"
                x2="849.64"
                y2="535.5"
              />
              <line
                class="cls-14"
                x1="779.34"
                y1="555.97"
                x2="779.34"
                y2="535.77"
              />
              <line
                class="cls-14"
                x1="779.07"
                y1="555.97"
                x2="849.64"
                y2="555.97"
              />
              <line
                class="cls-14"
                x1="779.34"
                y1="576.17"
                x2="779.34"
                y2="556.24"
              />
              <line
                class="cls-14"
                x1="779.07"
                y1="576.44"
                x2="849.64"
                y2="576.44"
              />
              <line
                class="cls-14"
                x1="779.34"
                y1="596.64"
                x2="779.34"
                y2="576.71"
              />
              <line
                class="cls-14"
                x1="779.07"
                y1="596.91"
                x2="849.64"
                y2="596.91"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="209.33"
                x2="956.57"
                y2="209.33"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="229.53"
                x2="903.24"
                y2="209.6"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="229.53"
                x2="956.57"
                y2="209.6"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="229.8"
                x2="956.57"
                y2="229.8"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="250"
                x2="903.24"
                y2="230.07"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="250"
                x2="956.57"
                y2="230.07"
              />
              <line
                class="cls-14"
                x1="902.97"
                y1="250.27"
                x2="956.57"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="270.47"
                x2="903.24"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="270.47"
                x2="956.57"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="902.97"
                y1="270.47"
                x2="956.57"
                y2="270.47"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="290.67"
                x2="903.24"
                y2="270.74"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="290.67"
                x2="956.57"
                y2="270.74"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="290.94"
                x2="956.57"
                y2="290.94"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="311.14"
                x2="956.57"
                y2="291.21"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="311.41"
                x2="956.57"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="331.61"
                x2="956.57"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="331.61"
                x2="956.57"
                y2="331.61"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="351.81"
                x2="956.57"
                y2="331.88"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="352.08"
                x2="956.57"
                y2="352.08"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="372.28"
                x2="956.57"
                y2="352.35"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="372.55"
                x2="956.57"
                y2="372.55"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="392.75"
                x2="956.57"
                y2="372.82"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="393.02"
                x2="956.57"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="413.22"
                x2="903.24"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="413.22"
                x2="956.57"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="902.97"
                y1="413.22"
                x2="956.57"
                y2="413.22"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="433.42"
                x2="903.24"
                y2="413.49"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="433.42"
                x2="956.57"
                y2="413.49"
              />
              <line
                class="cls-14"
                x1="902.97"
                y1="433.69"
                x2="956.57"
                y2="433.69"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="453.89"
                x2="903.24"
                y2="433.96"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="453.89"
                x2="956.57"
                y2="433.96"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="454.16"
                x2="956.57"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="474.36"
                x2="956.57"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="474.36"
                x2="956.57"
                y2="474.36"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="494.56"
                x2="956.57"
                y2="474.63"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="494.83"
                x2="956.57"
                y2="494.83"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="515.03"
                x2="956.57"
                y2="495.1"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="515.3"
                x2="956.57"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="535.5"
                x2="956.57"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="535.5"
                x2="956.57"
                y2="535.5"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="555.97"
                x2="956.57"
                y2="535.77"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="555.97"
                x2="956.57"
                y2="555.97"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="576.17"
                x2="956.57"
                y2="556.24"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="576.44"
                x2="956.57"
                y2="576.44"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="596.64"
                x2="956.57"
                y2="576.71"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="596.91"
                x2="956.57"
                y2="596.91"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="454.16"
                x2="903.24"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="474.36"
                x2="849.64"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="474.36"
                x2="903.24"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="474.36"
                x2="903.24"
                y2="474.36"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="494.56"
                x2="849.64"
                y2="474.63"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="494.56"
                x2="903.24"
                y2="474.63"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="494.83"
                x2="903.24"
                y2="494.83"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="515.03"
                x2="849.64"
                y2="495.1"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="515.03"
                x2="903.24"
                y2="495.1"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="515.3"
                x2="903.24"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="535.5"
                x2="849.64"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="535.5"
                x2="903.24"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="535.5"
                x2="903.24"
                y2="535.5"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="555.97"
                x2="849.64"
                y2="535.77"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="555.97"
                x2="903.24"
                y2="535.77"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="555.97"
                x2="903.24"
                y2="555.97"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="576.17"
                x2="849.64"
                y2="556.24"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="576.17"
                x2="903.24"
                y2="556.24"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="576.44"
                x2="903.24"
                y2="576.44"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="596.64"
                x2="849.64"
                y2="576.71"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="596.64"
                x2="903.24"
                y2="576.71"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="596.91"
                x2="903.24"
                y2="596.91"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="290.94"
                x2="903.24"
                y2="290.94"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="311.14"
                x2="849.64"
                y2="291.21"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="311.14"
                x2="903.24"
                y2="291.21"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="311.41"
                x2="903.24"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="331.61"
                x2="849.64"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="331.61"
                x2="903.24"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="331.61"
                x2="903.24"
                y2="331.61"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="351.81"
                x2="849.64"
                y2="331.88"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="351.81"
                x2="903.24"
                y2="331.88"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="352.08"
                x2="903.24"
                y2="352.08"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="372.28"
                x2="849.64"
                y2="352.35"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="372.28"
                x2="903.24"
                y2="352.35"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="372.55"
                x2="903.24"
                y2="372.55"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="392.75"
                x2="849.64"
                y2="372.82"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="392.75"
                x2="903.24"
                y2="372.82"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="393.02"
                x2="903.24"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="779.34"
                y1="144.42"
                x2="849.64"
                y2="144.42"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="144.42"
                x2="903.24"
                y2="144.42"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="144.42"
                x2="956.57"
                y2="144.42"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="144.42"
                x2="1010.17"
                y2="144.42"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="144.42"
                x2="1063.77"
                y2="144.42"
              />
              <line
                class="cls-14"
                x1="779.07"
                y1="177.01"
                x2="849.64"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="177.01"
                x2="903.24"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="177.01"
                x2="956.57"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="177.01"
                x2="1010.17"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="177.01"
                x2="1064.03"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="779.34"
                y1="694.15"
                x2="849.64"
                y2="694.15"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="694.15"
                x2="903.24"
                y2="694.15"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="694.15"
                x2="956.57"
                y2="694.15"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="694.15"
                x2="1010.17"
                y2="694.15"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="694.15"
                x2="1063.77"
                y2="694.15"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="209.33"
                x2="903.24"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="209.33"
                x2="903.24"
                y2="209.33"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="229.8"
                x2="903.24"
                y2="229.8"
              />
              <line
                class="cls-14"
                x1="779.34"
                y1="629.24"
                x2="849.64"
                y2="629.24"
              />
              <line
                class="cls-14"
                x1="849.64"
                y1="629.24"
                x2="903.24"
                y2="629.24"
              />
              <line
                class="cls-14"
                x1="903.24"
                y1="629.24"
                x2="956.57"
                y2="629.24"
              />
              <line
                class="cls-14"
                x1="956.57"
                y1="629.24"
                x2="1010.17"
                y2="629.24"
              />
              <line
                class="cls-14"
                x1="1010.17"
                y1="629.24"
                x2="1063.77"
                y2="629.24"
              />
              <path
                class="cls-5"
                d="M769.85,152.65l-3.63,7-.19-.09,3.63-7Zm-4.73,6.4a2.83,2.83,0,0,1-.56.39,1.34,1.34,0,0,1-.64.15.91.91,0,0,1-1-1v-3.33h-.7v-.08l.71-.25.6-1.5h.13v1.49H765v.34h-1.37v3.21c0,.51.23.78.67.78a1.06,1.06,0,0,0,.37-.06,1.57,1.57,0,0,0,.34-.2Zm-4.39-5.92a.5.5,0,0,1-.15.38.56.56,0,0,1-.38.14.51.51,0,0,1-.37-.14.52.52,0,0,1,0-.75.48.48,0,0,1,.37-.15.52.52,0,0,1,.38.15A.5.5,0,0,1,760.73,153.13Zm.69,6.38h-2.23v-.11l.21,0a.72.72,0,0,0,.34-.11.42.42,0,0,0,.15-.29,4.85,4.85,0,0,0,0-.63V156a.82.82,0,0,0-.09-.5.67.67,0,0,0-.36-.24l-.29-.11v-.08l1.4-.33.09.06v3.55a4.74,4.74,0,0,0,0,.63.43.43,0,0,0,.16.29.77.77,0,0,0,.36.11l.2,0Zm-3.29,0H755.9v-.11l.2,0a.77.77,0,0,0,.36-.11.43.43,0,0,0,.16-.29,4.74,4.74,0,0,0,0-.63v-2a1.35,1.35,0,0,0-.25-.89.9.9,0,0,0-.7-.29,1.54,1.54,0,0,0-.71.16,2.13,2.13,0,0,0-.59.42v2.63a3.27,3.27,0,0,0,0,.63.39.39,0,0,0,.15.29.77.77,0,0,0,.36.11l.2,0v.11h-2.23v-.11l.21,0a.68.68,0,0,0,.34-.11.39.39,0,0,0,.15-.29,4.49,4.49,0,0,0,0-.63V156a1,1,0,0,0-.09-.5.7.7,0,0,0-.37-.24l-.29-.11v-.08l1.4-.33.09.06v.71a4.47,4.47,0,0,1,.77-.57,1.63,1.63,0,0,1,.83-.21c.92,0,1.38.48,1.4,1.48v2.14a4.74,4.74,0,0,0,0,.63.39.39,0,0,0,.15.29.72.72,0,0,0,.34.11l.21,0Zm-5.83-6.72-.14,0a1,1,0,0,0-.46.14.71.71,0,0,0-.27.37,2.47,2.47,0,0,0-.09.75l0,3a2.58,2.58,0,0,1-.7,1.9,2.74,2.74,0,0,1-2,.67,2.86,2.86,0,0,1-2-.63,2.3,2.3,0,0,1-.66-1.75v-3.12a2.49,2.49,0,0,0-.12-1,.51.51,0,0,0-.47-.29l-.37-.05v-.11h2.84v.11l-.46.06a.56.56,0,0,0-.5.28,2.44,2.44,0,0,0-.13,1v3a2.31,2.31,0,0,0,.56,1.69,2.14,2.14,0,0,0,1.54.5,2.29,2.29,0,0,0,1.63-.56,2.15,2.15,0,0,0,.61-1.68l0-3a1.74,1.74,0,0,0-.2-.95.84.84,0,0,0-.62-.28l-.27,0v-.11h2.35Z"
              />
              <path
                class="cls-5"
                d="M769.32,166.44a.77.77,0,0,1-.12.44.33.33,0,0,1-.26.15.74.74,0,0,1-.3-.11,3.42,3.42,0,0,1-.52-.34,2.2,2.2,0,0,0-.43.27,2,2,0,0,0-.36.34v2.46a3.29,3.29,0,0,0,0,.64.36.36,0,0,0,.2.28,1.14,1.14,0,0,0,.46.11l.26,0v.11h-2.45v-.11l.21,0a.68.68,0,0,0,.34-.11.39.39,0,0,0,.15-.29,3.34,3.34,0,0,0,0-.63V167.3a1,1,0,0,0-.09-.5.7.7,0,0,0-.37-.24l-.29-.11v-.08l1.4-.33.09.06v.83a4.27,4.27,0,0,1,.79-.71,1.21,1.21,0,0,1,.68-.2.65.65,0,0,1,.38.1A.37.37,0,0,1,769.32,166.44Zm-4.72,2.08a2.66,2.66,0,0,1-.31,1.25,2.21,2.21,0,0,1-.81.85,2.16,2.16,0,0,1-1.15.32,2.28,2.28,0,0,1-1.13-.28,2,2,0,0,1-.82-.83,2.93,2.93,0,0,1-.32-1.4,2.55,2.55,0,0,1,.32-1.25,2.28,2.28,0,0,1,.81-.85,2.19,2.19,0,0,1,1.14-.32,2.28,2.28,0,0,1,1.13.28,2.08,2.08,0,0,1,.82.84A2.88,2.88,0,0,1,764.6,168.52Zm-.85.19a3.39,3.39,0,0,0-.44-1.83,1.33,1.33,0,0,0-1.14-.7,1,1,0,0,0-.92.48,2.92,2.92,0,0,0-.34,1.58,3.35,3.35,0,0,0,.44,1.83,1.31,1.31,0,0,0,1.14.7,1,1,0,0,0,.92-.48A2.89,2.89,0,0,0,763.75,168.71Zm-5.12-.19a2.66,2.66,0,0,1-.31,1.25,2.21,2.21,0,0,1-.81.85,2.14,2.14,0,0,1-1.15.32,2.28,2.28,0,0,1-1.13-.28,2,2,0,0,1-.82-.83,3,3,0,0,1-.32-1.4,2.66,2.66,0,0,1,.32-1.25,2.28,2.28,0,0,1,.81-.85,2.22,2.22,0,0,1,1.14-.32,2.28,2.28,0,0,1,1.13.28,2,2,0,0,1,.82.84A2.88,2.88,0,0,1,758.63,168.52Zm-.85.19a3.49,3.49,0,0,0-.43-1.83,1.36,1.36,0,0,0-1.15-.7,1,1,0,0,0-.92.48,3,3,0,0,0-.34,1.58,3.44,3.44,0,0,0,.44,1.83,1.31,1.31,0,0,0,1.14.7,1,1,0,0,0,.92-.48A2.89,2.89,0,0,0,757.78,168.71Zm-4.52,2.11H751v-.11l.21,0a.68.68,0,0,0,.34-.11.39.39,0,0,0,.15-.29,3.34,3.34,0,0,0,0-.63v-4.91a1,1,0,0,0-.09-.49.7.7,0,0,0-.37-.24l-.29-.11v-.08l1.4-.33.09.06v6.1a3.46,3.46,0,0,0,0,.64.37.37,0,0,0,.15.28.77.77,0,0,0,.36.11l.2,0Zm-3.21-5.57h-.12l-.18-.3a1.9,1.9,0,0,0-.39-.49.94.94,0,0,0-.48-.23,3.73,3.73,0,0,0-.74-.06H748a6.13,6.13,0,0,0-.68,0,2.11,2.11,0,0,0-.44.09v2.92l.82,0a2.2,2.2,0,0,0,1-.15.63.63,0,0,0,.31-.56l0-.41h.14v.32c0,.15,0,.3,0,.46s0,.31,0,.45,0,.41,0,.64,0,.41,0,.53H749l0-.28a1,1,0,0,0-.16-.47.62.62,0,0,0-.39-.22,3.45,3.45,0,0,0-.75-.07l-.82,0v2a3.66,3.66,0,0,0,.06.77.56.56,0,0,0,.23.37,1,1,0,0,0,.46.13l.39.05v.11h-2.89v-.11l.37-.05a.51.51,0,0,0,.47-.29,2.49,2.49,0,0,0,.12-1v-4a2.49,2.49,0,0,0-.12-1,.51.51,0,0,0-.47-.29l-.37-.05V164h4.68Z"
              />
              <path
                class="cls-5"
                d="M1042.5,165.17h-3.41V165l.45-.06a1.11,1.11,0,0,0,.54-.16.64.64,0,0,0,.26-.42,4.18,4.18,0,0,0,.07-.9v-4.44a3.72,3.72,0,0,0-.07-.86.52.52,0,0,0-.3-.38,1.61,1.61,0,0,0-.64-.08h-.31v-.13a8.91,8.91,0,0,0,1.12-.23q.57-.16,1-.33l.1,0v6.4a4.18,4.18,0,0,0,.07.9.67.67,0,0,0,.25.42,1,1,0,0,0,.49.16l.39.06Zm-5.15-2.3h-1.27v2.34h-.85v-2.34h-3.62l-.08-.11,4.13-5.59h.42v5.32h1.27Zm-2.12-.38v-4.31l-3.19,4.31ZM990,161.19a6.52,6.52,0,0,1-.32,2.1,3.41,3.41,0,0,1-.93,1.46,2.13,2.13,0,0,1-1.45.55,2.21,2.21,0,0,1-1.53-.55,3.18,3.18,0,0,1-.89-1.47,7,7,0,0,1-.29-2.09,6.15,6.15,0,0,1,.33-2.09,3.32,3.32,0,0,1,.93-1.47,2.14,2.14,0,0,1,1.45-.55,2.21,2.21,0,0,1,1.52.56,3.2,3.2,0,0,1,.89,1.46A6.77,6.77,0,0,1,990,161.19Zm-1,.23a8.5,8.5,0,0,0-.43-3.06,1.46,1.46,0,0,0-1.37-1.09,1.28,1.28,0,0,0-1.19.95,7.44,7.44,0,0,0-.39,2.74A8.32,8.32,0,0,0,986,164a1.48,1.48,0,0,0,1.37,1.1,1.3,1.3,0,0,0,1.2-1A7.49,7.49,0,0,0,989,161.42Zm-6.51,1.45h-1.27v2.34h-.85v-2.34H976.7l-.08-.11,4.13-5.59h.42v5.32h1.27Zm-2.12-.38v-4.31l-3.19,4.31Zm-44.45-2.37a4.62,4.62,0,0,1-1,3,8,8,0,0,1-3.35,2.31l-.08-.18a7.28,7.28,0,0,0,2.19-1.44,3.82,3.82,0,0,0,1-1.63,6.15,6.15,0,0,0,.23-1.84,4.61,4.61,0,0,0-.47-2.27,1.42,1.42,0,0,0-1.27-.76,1.18,1.18,0,0,0-1.08.6,3.09,3.09,0,0,0-.35,1.62,4.21,4.21,0,0,0,.14,1.11,1.67,1.67,0,0,0,.49.8,1.42,1.42,0,0,0,.94.31,2.56,2.56,0,0,0,.67-.08l.05.15a3.5,3.5,0,0,1-1,.19,2.23,2.23,0,0,1-1.63-.61,2.33,2.33,0,0,1-.59-1.64,2.71,2.71,0,0,1,.35-1.35,2.52,2.52,0,0,1,.92-.94,2.6,2.6,0,0,1,1.27-.35,2.54,2.54,0,0,1,1.31.35,2.58,2.58,0,0,1,.94,1A3.59,3.59,0,0,1,935.87,160.12Zm-7.53,2.18a2.69,2.69,0,0,1-.55,1.64,3.34,3.34,0,0,1-1.29,1,3.49,3.49,0,0,1-1.47.34,1.51,1.51,0,0,1-.82-.18.55.55,0,0,1-.28-.48.45.45,0,0,1,.15-.34.5.5,0,0,1,.34-.12,1,1,0,0,1,.59.19,2.87,2.87,0,0,1,.58.61,2.58,2.58,0,0,0,1-.31,2.1,2.1,0,0,0,.75-.73,2,2,0,0,0,.3-1.1,1.49,1.49,0,0,0-.46-1.19,1.87,1.87,0,0,0-1.25-.39,2,2,0,0,0-.55.07,3.16,3.16,0,0,0-.53.2l-.12-.2a12.46,12.46,0,0,0,1.65-1,3,3,0,0,0,.76-.8,1.39,1.39,0,0,0,.18-.73A1,1,0,0,0,927,158a1.41,1.41,0,0,0-.94-.3A2.2,2.2,0,0,0,925,158a3.68,3.68,0,0,0-.9.68l-.12-.13a4.35,4.35,0,0,1,1.25-1.09,2.61,2.61,0,0,1,1.29-.31,1.75,1.75,0,0,1,1.18.35,1.23,1.23,0,0,1,.44,1,1.6,1.6,0,0,1-.42,1.05,5.6,5.6,0,0,1-1.35,1.06,2.39,2.39,0,0,1,1.43.49A1.56,1.56,0,0,1,928.34,162.3Zm-46.12.86a1.9,1.9,0,0,1-.35,1.13,2.42,2.42,0,0,1-.92.75,3.25,3.25,0,0,1-2.45,0,2.13,2.13,0,0,1-.89-.65,1.61,1.61,0,0,1-.36-1,2,2,0,0,1,.45-1.31,3.8,3.8,0,0,1,1.37-1,2.86,2.86,0,0,1-1.16-.84,2.07,2.07,0,0,1-.43-1.3,1.76,1.76,0,0,1,.65-1.35,2.66,2.66,0,0,1,1.69-.57,2.5,2.5,0,0,1,1.55.51,1.57,1.57,0,0,1,.62,1.23,1.73,1.73,0,0,1-.44,1.14,3.47,3.47,0,0,1-1.19.85,3.77,3.77,0,0,1,1.42,1A2.06,2.06,0,0,1,882.22,163.16ZM881.15,159a1.87,1.87,0,0,0-.38-1.24,1.45,1.45,0,0,0-1.16-.46,1.38,1.38,0,0,0-1.05.42,1.53,1.53,0,0,0-.38,1.05,1.39,1.39,0,0,0,.44,1.07,5,5,0,0,0,1.53.91,2.06,2.06,0,0,0,.74-.69A2,2,0,0,0,881.15,159Zm.35,4.45a1.55,1.55,0,0,0-.47-1.18,5.6,5.6,0,0,0-1.75-1,2.27,2.27,0,0,0-.88.86,2.6,2.6,0,0,0-.25,1.2,2,2,0,0,0,.47,1.36,1.65,1.65,0,0,0,1.25.48,1.6,1.6,0,0,0,1.17-.46A1.75,1.75,0,0,0,881.5,163.42Zm-6.69-1.12a2.57,2.57,0,0,1-.55,1.64,3.31,3.31,0,0,1-1.28,1,3.49,3.49,0,0,1-1.47.34,1.51,1.51,0,0,1-.82-.18.55.55,0,0,1-.28-.48.45.45,0,0,1,.15-.34.48.48,0,0,1,.33-.12,1,1,0,0,1,.59.19,2.45,2.45,0,0,1,.58.61,2.53,2.53,0,0,0,1-.31,2,2,0,0,0,.76-.73,2.17,2.17,0,0,0,.3-1.1,1.49,1.49,0,0,0-.47-1.19,1.84,1.84,0,0,0-1.24-.39,2,2,0,0,0-.55.07,3.62,3.62,0,0,0-.54.2l-.11-.2a13.17,13.17,0,0,0,1.65-1,2.82,2.82,0,0,0,.75-.8,1.4,1.4,0,0,0,.19-.73,1,1,0,0,0-.32-.75,1.43,1.43,0,0,0-.94-.3,2.14,2.14,0,0,0-1,.25,3.92,3.92,0,0,0-.91.68l-.11-.13a4.23,4.23,0,0,1,1.25-1.09,2.56,2.56,0,0,1,1.29-.31,1.77,1.77,0,0,1,1.18.35,1.26,1.26,0,0,1,.44,1,1.56,1.56,0,0,1-.43,1.05,5.33,5.33,0,0,1-1.34,1.06,2.36,2.36,0,0,1,1.42.49A1.53,1.53,0,0,1,874.81,162.3Zm-54.51-5-1.64,3.29c-.56,1.1-1,2-1.35,2.74s-.59,1.29-.76,1.7a.3.3,0,0,1-.2.2.48.48,0,0,1-.24-.06.19.19,0,0,1-.1-.16.45.45,0,0,1,.09-.24c.25-.4.57-.94.95-1.64s.83-1.58,1.37-2.67l1.28-2.56h-2.58a4.48,4.48,0,0,0-.72.05,1,1,0,0,0-.45.2,1.28,1.28,0,0,0-.33.43l-.22.38h-.12l.66-2H816a.72.72,0,0,0,.25.16,2.31,2.31,0,0,0,.53.06h3.44Zm-7.22,5a2.57,2.57,0,0,1-.55,1.64,3.31,3.31,0,0,1-1.28,1,3.49,3.49,0,0,1-1.47.34,1.51,1.51,0,0,1-.82-.18.55.55,0,0,1-.28-.48.45.45,0,0,1,.15-.34.48.48,0,0,1,.33-.12,1,1,0,0,1,.59.19,2.45,2.45,0,0,1,.58.61,2.53,2.53,0,0,0,1-.31,2,2,0,0,0,.76-.73,2.17,2.17,0,0,0,.3-1.1,1.49,1.49,0,0,0-.47-1.19,1.84,1.84,0,0,0-1.24-.39,2,2,0,0,0-.55.07,3.62,3.62,0,0,0-.54.2l-.11-.2a13.17,13.17,0,0,0,1.65-1,2.82,2.82,0,0,0,.75-.8,1.4,1.4,0,0,0,.19-.73,1,1,0,0,0-.32-.75,1.43,1.43,0,0,0-.94-.3,2.14,2.14,0,0,0-1.05.25,3.92,3.92,0,0,0-.91.68l-.11-.13a4.23,4.23,0,0,1,1.25-1.09,2.56,2.56,0,0,1,1.29-.31,1.77,1.77,0,0,1,1.18.35,1.26,1.26,0,0,1,.44,1,1.56,1.56,0,0,1-.43,1.05,5.33,5.33,0,0,1-1.34,1.06,2.36,2.36,0,0,1,1.42.49A1.53,1.53,0,0,1,813.08,162.3Z"
              />
              <path
                class="cls-5"
                d="M761,194.44a2.75,2.75,0,0,1-.35,1.36,2.62,2.62,0,0,1-.91.93,2.57,2.57,0,0,1-1.28.36,2.45,2.45,0,0,1-2.24-1.39,3.47,3.47,0,0,1-.36-1.65,4.58,4.58,0,0,1,1-3,8,8,0,0,1,3.35-2.31l.08.17a7.1,7.1,0,0,0-2.19,1.45,3.86,3.86,0,0,0-1,1.63,6.11,6.11,0,0,0-.23,1.84,4.61,4.61,0,0,0,.47,2.27,1.42,1.42,0,0,0,1.27.76,1.2,1.2,0,0,0,1.08-.6,3.14,3.14,0,0,0,.35-1.62,4.35,4.35,0,0,0-.14-1.12,1.64,1.64,0,0,0-.49-.79,1.42,1.42,0,0,0-.94-.32,2.56,2.56,0,0,0-.67.08l0-.15a3.21,3.21,0,0,1,1-.18,2.21,2.21,0,0,1,1.63.61A2.26,2.26,0,0,1,761,194.44Zm-7.19-5.72-.36,1.09H750.5l-.65,1.43a5.63,5.63,0,0,1,2.61.8,2.13,2.13,0,0,1,.88,1.88,3,3,0,0,1-.51,1.68,3.38,3.38,0,0,1-1.23,1.09,3.11,3.11,0,0,1-1.48.38,1.22,1.22,0,0,1-.76-.19.56.56,0,0,1-.23-.42q0-.45.57-.48a1,1,0,0,1,.57.18,3.81,3.81,0,0,1,.61.53,2.72,2.72,0,0,0,1.39-.84,2.28,2.28,0,0,0,.55-1.52,1.73,1.73,0,0,0-.85-1.58,6.21,6.21,0,0,0-2.62-.69l-.09-.11L750.6,189h2a2.87,2.87,0,0,0,.65-.06.79.79,0,0,0,.43-.23Z"
              />
              <path
                class="cls-5"
                d="M760.8,215.4l-.36,1.08h-2.93l-.64,1.43a5.62,5.62,0,0,1,2.6.8,2.16,2.16,0,0,1,.89,1.89,3.06,3.06,0,0,1-.52,1.68,3.24,3.24,0,0,1-1.22,1.08,3.16,3.16,0,0,1-1.49.39,1.31,1.31,0,0,1-.76-.2.52.52,0,0,1-.22-.42c0-.3.2-.46.57-.47a1,1,0,0,1,.57.18,3.67,3.67,0,0,1,.6.52,2.58,2.58,0,0,0,1.4-.84,2.28,2.28,0,0,0,.55-1.52,1.75,1.75,0,0,0-.85-1.58,6.26,6.26,0,0,0-2.62-.69l-.09-.1,1.34-2.94h2a2.93,2.93,0,0,0,.65-.06.86.86,0,0,0,.42-.23Zm-6.48,0-.36,1.08H751l-.65,1.43a5.63,5.63,0,0,1,2.61.8,2.15,2.15,0,0,1,.88,1.89,3,3,0,0,1-.51,1.68,3.35,3.35,0,0,1-1.23,1.08,3.12,3.12,0,0,1-1.48.39,1.28,1.28,0,0,1-.76-.2.52.52,0,0,1-.22-.42c0-.3.19-.46.56-.47a1,1,0,0,1,.57.18,3.32,3.32,0,0,1,.61.52,2.55,2.55,0,0,0,1.39-.84,2.23,2.23,0,0,0,.55-1.52,1.73,1.73,0,0,0-.85-1.58,6.2,6.2,0,0,0-2.61-.69l-.1-.1,1.34-2.94h2a2.84,2.84,0,0,0,.64-.06.94.94,0,0,0,.43-.23Z"
              />
              <path
                class="cls-5"
                d="M761.29,241.79H760v2.34h-.84v-2.34h-3.62l-.08-.11,4.13-5.59H760v5.32h1.27Zm-2.11-.38V237.1L756,241.41Zm-5.4-5.55-.36,1.09H750.5l-.65,1.42a5.74,5.74,0,0,1,2.61.81,2.13,2.13,0,0,1,.88,1.88,3,3,0,0,1-.51,1.68,3.47,3.47,0,0,1-1.23,1.09,3.23,3.23,0,0,1-1.48.38,1.22,1.22,0,0,1-.76-.2.53.53,0,0,1-.23-.41q0-.45.57-.48a1,1,0,0,1,.57.18,3.81,3.81,0,0,1,.61.53,2.72,2.72,0,0,0,1.39-.84,2.28,2.28,0,0,0,.55-1.52,1.72,1.72,0,0,0-.85-1.58,5.93,5.93,0,0,0-2.62-.69l-.09-.11,1.34-2.94h2a2.87,2.87,0,0,0,.65-.06.86.86,0,0,0,.43-.23Z"
              />
              <path
                class="cls-5"
                d="M760.57,261.42a2.69,2.69,0,0,1-.55,1.64,3.44,3.44,0,0,1-1.29,1,3.49,3.49,0,0,1-1.47.34,1.42,1.42,0,0,1-.82-.19.54.54,0,0,1-.28-.47.5.5,0,0,1,.15-.35.55.55,0,0,1,.34-.11,1,1,0,0,1,.59.19,2.63,2.63,0,0,1,.57.61,2.59,2.59,0,0,0,1-.32,2,2,0,0,0,.75-.73,2,2,0,0,0,.3-1.1,1.44,1.44,0,0,0-.47-1.18,1.82,1.82,0,0,0-1.24-.39,2,2,0,0,0-.55.07,3.09,3.09,0,0,0-.53.19l-.12-.19a14.3,14.3,0,0,0,1.65-1,2.81,2.81,0,0,0,.75-.79,1.31,1.31,0,0,0,.19-.73,1,1,0,0,0-.32-.75,1.31,1.31,0,0,0-.94-.3,2.28,2.28,0,0,0-1,.24,4.26,4.26,0,0,0-.9.68l-.12-.13a4.3,4.3,0,0,1,1.25-1.08,2.71,2.71,0,0,1,1.29-.32,1.77,1.77,0,0,1,1.18.36,1.25,1.25,0,0,1,.44,1,1.6,1.6,0,0,1-.43,1,5.56,5.56,0,0,1-1.34,1.06,2.34,2.34,0,0,1,1.42.49A1.57,1.57,0,0,1,760.57,261.42Zm-6.25-5.36-.36,1.09H751l-.65,1.42a5.62,5.62,0,0,1,2.61.81,2.13,2.13,0,0,1,.88,1.88,2.93,2.93,0,0,1-.51,1.68,3.47,3.47,0,0,1-1.23,1.09,3.23,3.23,0,0,1-1.48.38,1.22,1.22,0,0,1-.76-.2.52.52,0,0,1-.22-.41c0-.31.19-.46.56-.48a1,1,0,0,1,.57.18,3.42,3.42,0,0,1,.61.53,2.68,2.68,0,0,0,1.39-.84,2.23,2.23,0,0,0,.55-1.52,1.75,1.75,0,0,0-.85-1.59,6.07,6.07,0,0,0-2.61-.68l-.1-.11,1.34-2.94h2a2.84,2.84,0,0,0,.64-.06.86.86,0,0,0,.43-.23Z"
              />
              <path
                class="cls-5"
                d="M761,282.63l-.7,2.12h-4.33l-.08-.12,2.13-2.38a14.14,14.14,0,0,0,1-1.26,4.22,4.22,0,0,0,.55-1,3.21,3.21,0,0,0,.17-1,1.48,1.48,0,0,0-1.61-1.58,1.74,1.74,0,0,0-1.09.36,4.19,4.19,0,0,0-.92,1l-.14-.08a4.47,4.47,0,0,1,1.11-1.47,2.28,2.28,0,0,1,1.48-.52,2,2,0,0,1,1.42.51,1.9,1.9,0,0,1,.56,1.44,2.64,2.64,0,0,1-.22,1.1,4.86,4.86,0,0,1-.64,1,15.44,15.44,0,0,1-1,1.17L756.69,284h1.84a5.24,5.24,0,0,0,1-.07,1.16,1.16,0,0,0,.6-.31,2.39,2.39,0,0,0,.49-.65l.22-.38Zm-6.89-6.09-.36,1.08h-2.93l-.64,1.43a5.62,5.62,0,0,1,2.6.8,2.16,2.16,0,0,1,.89,1.89,3.06,3.06,0,0,1-.52,1.68,3.32,3.32,0,0,1-1.22,1.08,3.16,3.16,0,0,1-1.49.39,1.31,1.31,0,0,1-.76-.2.52.52,0,0,1-.22-.42c0-.3.19-.46.56-.47a1,1,0,0,1,.58.18,3.67,3.67,0,0,1,.6.52,2.62,2.62,0,0,0,1.4-.84,2.28,2.28,0,0,0,.55-1.52,1.75,1.75,0,0,0-.85-1.58,6.26,6.26,0,0,0-2.62-.69l-.09-.1,1.34-2.94h2a2.93,2.93,0,0,0,.65-.06.91.91,0,0,0,.42-.23Z"
              />
              <path
                class="cls-5"
                d="M760.32,305.22h-3.41v-.12l.45-.06a1.19,1.19,0,0,0,.54-.16.61.61,0,0,0,.26-.43,4,4,0,0,0,.07-.89v-4.44a3.66,3.66,0,0,0-.07-.86.52.52,0,0,0-.3-.38,1.55,1.55,0,0,0-.63-.08h-.32v-.13a8.91,8.91,0,0,0,1.12-.23q.57-.17,1-.33l.1.05v6.4a4,4,0,0,0,.07.89.67.67,0,0,0,.25.43,1,1,0,0,0,.49.16l.39.06ZM754.59,297l-.36,1.09h-2.92l-.65,1.42a5.74,5.74,0,0,1,2.61.81,2.13,2.13,0,0,1,.88,1.88,3,3,0,0,1-.51,1.68,3.47,3.47,0,0,1-1.23,1.09,3.23,3.23,0,0,1-1.48.38,1.22,1.22,0,0,1-.76-.2.53.53,0,0,1-.23-.41q0-.45.57-.48a1,1,0,0,1,.57.18,4.3,4.3,0,0,1,.61.53,2.72,2.72,0,0,0,1.39-.84,2.28,2.28,0,0,0,.55-1.52,1.72,1.72,0,0,0-.85-1.58,6,6,0,0,0-2.62-.69l-.09-.11,1.34-2.94h2a2.93,2.93,0,0,0,.65-.06.86.86,0,0,0,.43-.23Z"
              />
              <path
                class="cls-5"
                d="M761,321.45a6.52,6.52,0,0,1-.32,2.1,3.45,3.45,0,0,1-.94,1.46,2.14,2.14,0,0,1-1.45.55,2.25,2.25,0,0,1-1.52-.55,3.29,3.29,0,0,1-.89-1.47,7,7,0,0,1-.29-2.09,6.52,6.52,0,0,1,.32-2.1,3.54,3.54,0,0,1,.93-1.46,2.18,2.18,0,0,1,1.45-.55,2.25,2.25,0,0,1,1.53.55,3.29,3.29,0,0,1,.89,1.47A7,7,0,0,1,761,321.45Zm-1,.23a8.32,8.32,0,0,0-.42-3.06,1.49,1.49,0,0,0-1.37-1.1,1.31,1.31,0,0,0-1.2,1,7.75,7.75,0,0,0-.38,2.75,8.32,8.32,0,0,0,.42,3.06,1.48,1.48,0,0,0,1.37,1.1,1.29,1.29,0,0,0,1.19-.95A7.49,7.49,0,0,0,760,321.68Zm-6.51-4.48-.35,1.09h-2.93l-.65,1.42a5.62,5.62,0,0,1,2.61.81,2.13,2.13,0,0,1,.88,1.88,2.93,2.93,0,0,1-.51,1.68,3.47,3.47,0,0,1-1.23,1.09,3.19,3.19,0,0,1-1.48.38,1.22,1.22,0,0,1-.76-.2.52.52,0,0,1-.22-.41c0-.3.19-.46.56-.48a1.07,1.07,0,0,1,.58.18,3.79,3.79,0,0,1,.6.53,2.68,2.68,0,0,0,1.39-.84,2.23,2.23,0,0,0,.55-1.52,1.75,1.75,0,0,0-.85-1.59,6,6,0,0,0-2.61-.68l-.1-.11,1.34-2.94h2a2.84,2.84,0,0,0,.64-.06.82.82,0,0,0,.43-.23Z"
              />
              <path
                class="cls-5"
                d="M761.36,340.85a4.58,4.58,0,0,1-1,3,8,8,0,0,1-3.36,2.31l-.08-.17a7.16,7.16,0,0,0,2.2-1.45,4,4,0,0,0,1-1.63,6.11,6.11,0,0,0,.22-1.84,4.51,4.51,0,0,0-.46-2.27,1.42,1.42,0,0,0-1.27-.76,1.21,1.21,0,0,0-1.09.6,3.25,3.25,0,0,0-.34,1.62,4,4,0,0,0,.14,1.12,1.72,1.72,0,0,0,.49.8,1.45,1.45,0,0,0,.94.31,4,4,0,0,0,.67-.08l.05.15a3.21,3.21,0,0,1-1,.18,2.17,2.17,0,0,1-1.63-.61,2.22,2.22,0,0,1-.59-1.63,2.65,2.65,0,0,1,.35-1.36,2.62,2.62,0,0,1,.91-.93,2.44,2.44,0,0,1,1.28-.35A2.42,2.42,0,0,1,761,339.2,3.72,3.72,0,0,1,761.36,340.85Zm-7.07,2.76H753V346h-.85v-2.34h-3.62l-.08-.12,4.13-5.58H753v5.31h1.27Zm-2.12-.39v-4.3l-3.19,4.3Z"
              />
              <path
                class="cls-5"
                d="M761.23,364.36a1.9,1.9,0,0,1-.35,1.13,2.42,2.42,0,0,1-.92.75,3.11,3.11,0,0,1-1.28.26,3,3,0,0,1-1.17-.22,2.13,2.13,0,0,1-.89-.65,1.61,1.61,0,0,1-.36-1,2,2,0,0,1,.45-1.31,4,4,0,0,1,1.37-1,2.82,2.82,0,0,1-1.16-.83,2.07,2.07,0,0,1-.43-1.3,1.76,1.76,0,0,1,.65-1.35,2.61,2.61,0,0,1,1.69-.57,2.5,2.5,0,0,1,1.55.51A1.55,1.55,0,0,1,761,360a1.68,1.68,0,0,1-.44,1.14,3.47,3.47,0,0,1-1.19.85,3.77,3.77,0,0,1,1.42,1A2,2,0,0,1,761.23,364.36Zm-1.07-4.19a1.87,1.87,0,0,0-.38-1.24,1.45,1.45,0,0,0-1.16-.46,1.31,1.31,0,0,0-1,.42,1.49,1.49,0,0,0-.39,1.05,1.39,1.39,0,0,0,.44,1.07,5,5,0,0,0,1.53.91,2.15,2.15,0,0,0,.74-.69A2,2,0,0,0,760.16,360.17Zm.35,4.45a1.55,1.55,0,0,0-.47-1.19,6,6,0,0,0-1.75-1,2.36,2.36,0,0,0-.88.87,2.48,2.48,0,0,0-.24,1.2,1.93,1.93,0,0,0,.46,1.36,1.65,1.65,0,0,0,1.25.48,1.6,1.6,0,0,0,1.18-.47A1.75,1.75,0,0,0,760.51,364.62Zm-6.22-.55H753v2.34h-.85v-2.34h-3.62l-.08-.11,4.13-5.59H753v5.32h1.27Zm-2.12-.38v-4.31L749,363.69Z"
              />
              <path
                class="cls-5"
                d="M761.31,379l-1.65,3.29c-.55,1.11-1,2-1.34,2.75s-.59,1.29-.76,1.7a.33.33,0,0,1-.2.2.48.48,0,0,1-.24-.07.17.17,0,0,1-.1-.15.48.48,0,0,1,.09-.25c.25-.39.57-.94.95-1.63s.83-1.59,1.37-2.68l1.27-2.56h-2.57a3.56,3.56,0,0,0-.73.06.94.94,0,0,0-.44.19,1.49,1.49,0,0,0-.34.44l-.22.38h-.11l.66-2H757a.61.61,0,0,0,.24.15,1.89,1.89,0,0,0,.54.07h3.44Zm-6.76,5.54h-1.27v2.34h-.84v-2.34h-3.62l-.08-.12,4.13-5.58h.41v5.32h1.27Zm-2.11-.38v-4.31l-3.19,4.31Z"
              />
              <path
                class="cls-5"
                d="M761.48,404.54a2.72,2.72,0,0,1-.36,1.35,2.49,2.49,0,0,1-.91.94,2.64,2.64,0,0,1-1.28.35,2.53,2.53,0,0,1-1.3-.35,2.44,2.44,0,0,1-.94-1,3.72,3.72,0,0,1-.36-1.65,4.69,4.69,0,0,1,1-3,8,8,0,0,1,3.35-2.31l.08.18a7.47,7.47,0,0,0-2.2,1.44,3.89,3.89,0,0,0-1,1.63,5.85,5.85,0,0,0-.23,1.84,4.5,4.5,0,0,0,.47,2.27,1.39,1.39,0,0,0,1.26.76,1.18,1.18,0,0,0,1.09-.6,3.19,3.19,0,0,0,.35-1.62,3.82,3.82,0,0,0-.15-1.11,1.6,1.6,0,0,0-.49-.8,1.37,1.37,0,0,0-.93-.31,2.27,2.27,0,0,0-.68.08l0-.15a3.38,3.38,0,0,1,1-.19,2.2,2.2,0,0,1,1.62.61A2.29,2.29,0,0,1,761.48,404.54Zm-7.19.21H753v2.34h-.85v-2.34h-3.62l-.08-.12,4.13-5.58H753v5.31h1.27Zm-2.12-.39v-4.3l-3.19,4.3Z"
              />
              <path
                class="cls-5"
                d="M761.29,419.28l-.35,1.09H758l-.65,1.42a5.74,5.74,0,0,1,2.61.81,2.14,2.14,0,0,1,.89,1.88,3,3,0,0,1-.52,1.68,3.35,3.35,0,0,1-1.22,1.09,3.26,3.26,0,0,1-1.49.38,1.31,1.31,0,0,1-.76-.19.55.55,0,0,1-.22-.42c0-.3.19-.46.56-.48a1,1,0,0,1,.58.18,3.79,3.79,0,0,1,.6.53,2.75,2.75,0,0,0,1.4-.84,2.34,2.34,0,0,0,.55-1.52,1.74,1.74,0,0,0-.85-1.58,6.11,6.11,0,0,0-2.62-.69l-.1-.11,1.35-2.94h2a2.78,2.78,0,0,0,.64-.06.82.82,0,0,0,.43-.23Zm-6.47,5.93h-1.27v2.34h-.84v-2.34h-3.62l-.08-.11,4.12-5.59h.42v5.32h1.27Zm-2.11-.38v-4.31l-3.19,4.31Z"
              />
              <path
                class="cls-5"
                d="M762.15,445.69h-1.27V448H760v-2.34h-3.62l-.08-.12,4.13-5.58h.42v5.32h1.27Zm-2.12-.38V441l-3.19,4.31Zm-5.74.38H753V448h-.85v-2.34h-3.62l-.08-.12L752.6,440H753v5.32h1.27Zm-2.12-.38V441L749,445.31Z"
              />
              <path
                class="cls-5"
                d="M761.06,465.32a2.59,2.59,0,0,1-.55,1.64,3.41,3.41,0,0,1-1.28,1,3.65,3.65,0,0,1-1.47.34,1.42,1.42,0,0,1-.82-.19.54.54,0,0,1-.28-.47.46.46,0,0,1,.48-.47,1.06,1.06,0,0,1,.59.19,2.45,2.45,0,0,1,.58.61,2.38,2.38,0,0,0,1-.31,2,2,0,0,0,.76-.73,2.15,2.15,0,0,0,.3-1.1,1.5,1.5,0,0,0-.47-1.19,1.84,1.84,0,0,0-1.24-.38,2.51,2.51,0,0,0-.55.06,5.21,5.21,0,0,0-.54.2l-.11-.2a13.17,13.17,0,0,0,1.65-1,2.81,2.81,0,0,0,.75-.79,1.42,1.42,0,0,0,.19-.73,1,1,0,0,0-.32-.76,1.43,1.43,0,0,0-.94-.3,2.26,2.26,0,0,0-1,.25,4.22,4.22,0,0,0-.91.68l-.11-.13a4.18,4.18,0,0,1,1.25-1.08,2.57,2.57,0,0,1,1.29-.32,1.82,1.82,0,0,1,1.18.35,1.28,1.28,0,0,1,.44,1,1.6,1.6,0,0,1-.43,1.05,5.82,5.82,0,0,1-1.34,1.06,2.3,2.3,0,0,1,1.42.49A1.51,1.51,0,0,1,761.06,465.32Zm-6.24.57h-1.27v2.34h-.84v-2.34h-3.62l-.08-.12,4.12-5.58h.42v5.31h1.27Zm-2.11-.39v-4.3l-3.19,4.3Z"
              />
              <path
                class="cls-5"
                d="M761.79,486.51l-.69,2.12h-4.34l-.08-.11,2.14-2.39a14.17,14.17,0,0,0,1-1.26,4,4,0,0,0,.56-1,3.15,3.15,0,0,0,.17-1,1.58,1.58,0,0,0-.43-1.14,1.61,1.61,0,0,0-1.18-.45,1.72,1.72,0,0,0-1.09.36,4.17,4.17,0,0,0-.92,1l-.14-.08a4.28,4.28,0,0,1,1.1-1.46,2.32,2.32,0,0,1,1.49-.53,2,2,0,0,1,1.42.52,1.86,1.86,0,0,1,.55,1.44,2.64,2.64,0,0,1-.22,1.1,4.42,4.42,0,0,1-.63,1c-.28.34-.62.73-1,1.17l-2,2.12h1.83a5,5,0,0,0,1-.08,1.21,1.21,0,0,0,.61-.3,3.12,3.12,0,0,0,.49-.65l.21-.39Zm-7.24-.16h-1.27v2.34h-.84v-2.34h-3.62l-.08-.11,4.13-5.59h.41V486h1.27Zm-2.11-.38v-4.31L749.25,486Z"
              />
              <path
                class="cls-5"
                d="M760.52,509.12h-.43l-.64,0h-1.17l-.71,0h-.46V509l.45-.05a1.38,1.38,0,0,0,.54-.16.68.68,0,0,0,.26-.43,4.78,4.78,0,0,0,.07-.9V503a3.65,3.65,0,0,0-.08-.87.53.53,0,0,0-.29-.37,1.61,1.61,0,0,0-.64-.08h-.31v-.13a7.74,7.74,0,0,0,1.12-.24,6.57,6.57,0,0,0,1-.33l.11.06v6.39a4.06,4.06,0,0,0,.07.9.66.66,0,0,0,.24.43,1.23,1.23,0,0,0,.5.16l.39.05Zm-5.16-2.29h-1.27v2.34h-.84v-2.34h-3.62l-.08-.12,4.13-5.58h.41v5.32h1.27Zm-2.11-.38v-4.31l-3.19,4.31Z"
              />
              <path
                class="cls-5"
                d="M761.54,525.61a6.25,6.25,0,0,1-.33,2.1,3.32,3.32,0,0,1-.93,1.47,2.19,2.19,0,0,1-1.45.55,2.25,2.25,0,0,1-1.52-.56,3.18,3.18,0,0,1-.89-1.47,6.73,6.73,0,0,1-.29-2.09,6.46,6.46,0,0,1,.32-2.09,3.51,3.51,0,0,1,.93-1.47,2.18,2.18,0,0,1,1.45-.55,2.26,2.26,0,0,1,1.53.56,3.2,3.2,0,0,1,.89,1.46A7.08,7.08,0,0,1,761.54,525.61Zm-1,.24a8.38,8.38,0,0,0-.42-3.07,1.48,1.48,0,0,0-1.37-1.09,1.3,1.3,0,0,0-1.2.95,7.44,7.44,0,0,0-.39,2.74,8.6,8.6,0,0,0,.43,3.07,1.47,1.47,0,0,0,1.37,1.09,1.29,1.29,0,0,0,1.19-.95A7.44,7.44,0,0,0,760.52,525.85ZM754,527.29h-1.27v2.34h-.84v-2.34h-3.62l-.08-.11,4.12-5.58h.42v5.31H754Zm-2.11-.38V522.6l-3.19,4.31Z"
              />
              <path
                class="cls-5"
                d="M761.09,544.74a4.69,4.69,0,0,1-1,3,8,8,0,0,1-3.35,2.31l-.08-.18a7.47,7.47,0,0,0,2.2-1.44,3.89,3.89,0,0,0,1-1.63,6.15,6.15,0,0,0,.23-1.84,4.57,4.57,0,0,0-.47-2.28,1.41,1.41,0,0,0-1.26-.75,1.16,1.16,0,0,0-1.09.6,3.19,3.19,0,0,0-.35,1.62,3.82,3.82,0,0,0,.15,1.11,1.6,1.6,0,0,0,.49.8,1.37,1.37,0,0,0,.93.31,2.51,2.51,0,0,0,.67-.08l.05.15a3.38,3.38,0,0,1-1,.19,2.2,2.2,0,0,1-1.62-.61,2.29,2.29,0,0,1-.6-1.64,2.72,2.72,0,0,1,.36-1.35,2.49,2.49,0,0,1,.91-.94,2.64,2.64,0,0,1,1.28-.35,2.53,2.53,0,0,1,1.3.35,2.44,2.44,0,0,1,.94,1A3.72,3.72,0,0,1,761.09,544.74Zm-7.54,2.18a2.69,2.69,0,0,1-.55,1.64,3.39,3.39,0,0,1-1.28,1,3.57,3.57,0,0,1-1.48.34,1.53,1.53,0,0,1-.82-.18.56.56,0,0,1-.27-.48.43.43,0,0,1,.15-.35.52.52,0,0,1,.33-.11,1,1,0,0,1,.59.19,2.45,2.45,0,0,1,.58.61,2.53,2.53,0,0,0,1-.31,2.31,2.31,0,0,0,.76-.73,2.17,2.17,0,0,0,.3-1.1,1.52,1.52,0,0,0-.47-1.19,1.86,1.86,0,0,0-1.24-.39,1.93,1.93,0,0,0-.55.07,3.25,3.25,0,0,0-.54.2l-.12-.2a11.71,11.71,0,0,0,1.65-1,2.61,2.61,0,0,0,.76-.79,1.39,1.39,0,0,0,.18-.73,1,1,0,0,0-.31-.75,1.46,1.46,0,0,0-1-.3,2.13,2.13,0,0,0-1,.25,3.94,3.94,0,0,0-.91.67l-.12-.12a4.49,4.49,0,0,1,1.25-1.09,2.62,2.62,0,0,1,1.3-.31,1.79,1.79,0,0,1,1.18.35,1.28,1.28,0,0,1,.44,1,1.63,1.63,0,0,1-.43,1,5.52,5.52,0,0,1-1.34,1.06,2.36,2.36,0,0,1,1.42.49A1.56,1.56,0,0,1,753.55,546.92Z"
              />
              <path
                class="cls-5"
                d="M761,568.26a2,2,0,0,1-.36,1.13,2.24,2.24,0,0,1-.92.74,3,3,0,0,1-1.28.27,2.91,2.91,0,0,1-1.17-.23,2.24,2.24,0,0,1-.89-.64,1.63,1.63,0,0,1-.35-1,2,2,0,0,1,.44-1.31,4.12,4.12,0,0,1,1.37-1,3,3,0,0,1-1.15-.83,2.07,2.07,0,0,1-.43-1.3,1.72,1.72,0,0,1,.65-1.35,2.52,2.52,0,0,1,1.69-.57,2.43,2.43,0,0,1,1.55.51,1.58,1.58,0,0,1,.62,1.22,1.79,1.79,0,0,1-.44,1.15,3.71,3.71,0,0,1-1.19.85,3.56,3.56,0,0,1,1.42,1A2,2,0,0,1,761,568.26Zm-1.08-4.19a1.82,1.82,0,0,0-.38-1.24,1.46,1.46,0,0,0-1.15-.47,1.38,1.38,0,0,0-1.05.43,1.53,1.53,0,0,0-.39,1,1.43,1.43,0,0,0,.44,1.08,5.13,5.13,0,0,0,1.54.9,2,2,0,0,0,.73-.68A1.87,1.87,0,0,0,759.88,564.07Zm.35,4.44a1.51,1.51,0,0,0-.47-1.18,5.88,5.88,0,0,0-1.75-1,2.1,2.1,0,0,0-1.12,2.06,1.91,1.91,0,0,0,.47,1.36,1.6,1.6,0,0,0,1.24.49,1.63,1.63,0,0,0,1.18-.47A1.75,1.75,0,0,0,760.23,568.51Zm-6.68-1.11A2.69,2.69,0,0,1,753,569a3.49,3.49,0,0,1-1.28,1,3.57,3.57,0,0,1-1.48.34,1.44,1.44,0,0,1-.82-.19.55.55,0,0,1-.27-.47.41.41,0,0,1,.15-.35.47.47,0,0,1,.33-.11,1,1,0,0,1,.59.19,2.38,2.38,0,0,1,.58.6,2.38,2.38,0,0,0,1-.31,2.21,2.21,0,0,0,.76-.73,2.15,2.15,0,0,0,.3-1.1,1.54,1.54,0,0,0-.47-1.19,2.21,2.21,0,0,0-1.79-.31,3.18,3.18,0,0,0-.54.19l-.12-.19a12.72,12.72,0,0,0,1.65-1,2.72,2.72,0,0,0,.76-.79,1.39,1.39,0,0,0,.18-.73,1,1,0,0,0-.31-.75,1.4,1.4,0,0,0-1-.31,2.25,2.25,0,0,0-1,.25,4.31,4.31,0,0,0-.91.68l-.12-.13a4.44,4.44,0,0,1,1.25-1.08,2.63,2.63,0,0,1,1.3-.32,1.79,1.79,0,0,1,1.18.36,1.28,1.28,0,0,1,.44,1,1.65,1.65,0,0,1-.43,1,5.77,5.77,0,0,1-1.34,1.06,2.36,2.36,0,0,1,1.42.49A1.56,1.56,0,0,1,753.55,567.4Z"
              />
              <path
                class="cls-5"
                d="M761,582.9l-1.64,3.29c-.56,1.1-1,2-1.34,2.74s-.6,1.29-.77,1.7c0,.12-.12.19-.19.2a.49.49,0,0,1-.25-.06.19.19,0,0,1-.1-.16.45.45,0,0,1,.09-.24c.26-.4.57-.94.95-1.64s.84-1.58,1.37-2.67l1.28-2.56h-2.58a4.48,4.48,0,0,0-.72,0,1,1,0,0,0-.45.2,1.56,1.56,0,0,0-.33.43l-.22.39H756l.66-2h.07a.72.72,0,0,0,.25.16,2.31,2.31,0,0,0,.53.06H761Zm-7.22,5a2.62,2.62,0,0,1-.54,1.63,3.42,3.42,0,0,1-1.29,1,3.49,3.49,0,0,1-1.47.34,1.51,1.51,0,0,1-.82-.18.54.54,0,0,1-.28-.48.45.45,0,0,1,.15-.34.49.49,0,0,1,.34-.12,1,1,0,0,1,.58.19,2.45,2.45,0,0,1,.58.61,2.48,2.48,0,0,0,1-.31,2,2,0,0,0,.76-.73,2.17,2.17,0,0,0,.3-1.1,1.49,1.49,0,0,0-.47-1.19,1.82,1.82,0,0,0-1.24-.39,2.51,2.51,0,0,0-.55.07,3.62,3.62,0,0,0-.54.2l-.11-.2a13.17,13.17,0,0,0,1.65-1,2.82,2.82,0,0,0,.75-.8,1.4,1.4,0,0,0,.19-.73,1,1,0,0,0-.32-.75,1.43,1.43,0,0,0-.94-.3,2.14,2.14,0,0,0-1,.25,3.92,3.92,0,0,0-.91.68l-.11-.13a4.3,4.3,0,0,1,1.25-1.08,2.6,2.6,0,0,1,1.29-.32,1.82,1.82,0,0,1,1.18.35,1.26,1.26,0,0,1,.44,1,1.56,1.56,0,0,1-.43,1.05,5.33,5.33,0,0,1-1.34,1.06,2.36,2.36,0,0,1,1.42.49A1.53,1.53,0,0,1,753.82,587.87Z"
              />
              <path
                class="cls-5"
                d="M761.2,614.35a2.78,2.78,0,0,1-.35,1.36,2.62,2.62,0,0,1-.91.93,2.44,2.44,0,0,1-1.28.35,2.42,2.42,0,0,1-2.24-1.38,3.72,3.72,0,0,1-.36-1.65,4.63,4.63,0,0,1,1-3,8.11,8.11,0,0,1,3.35-2.3l.09.17a7,7,0,0,0-2.2,1.45,4,4,0,0,0-1,1.63,6.09,6.09,0,0,0-.22,1.83,4.55,4.55,0,0,0,.46,2.28,1.42,1.42,0,0,0,1.27.76,1.22,1.22,0,0,0,1.09-.6,3.25,3.25,0,0,0,.34-1.62,4.35,4.35,0,0,0-.14-1.12,1.67,1.67,0,0,0-.49-.8,1.45,1.45,0,0,0-.94-.31,2.62,2.62,0,0,0-.67.08l0-.15a3.21,3.21,0,0,1,1-.18,2.21,2.21,0,0,1,1.63.6A2.3,2.3,0,0,1,761.2,614.35Zm-7.65-.36a2.69,2.69,0,0,1-.55,1.64,3.39,3.39,0,0,1-1.28,1,3.57,3.57,0,0,1-1.48.34,1.53,1.53,0,0,1-.82-.18.56.56,0,0,1-.27-.48.43.43,0,0,1,.15-.35.52.52,0,0,1,.33-.11,1,1,0,0,1,.59.19,2.45,2.45,0,0,1,.58.61,2.53,2.53,0,0,0,1-.31,2.31,2.31,0,0,0,.76-.73,2.17,2.17,0,0,0,.3-1.1,1.52,1.52,0,0,0-.47-1.19,1.86,1.86,0,0,0-1.24-.39,1.93,1.93,0,0,0-.55.07,3.25,3.25,0,0,0-.54.2L750,613a12.86,12.86,0,0,0,1.65-1,2.74,2.74,0,0,0,.76-.8,1.39,1.39,0,0,0,.18-.73,1,1,0,0,0-.31-.75,1.46,1.46,0,0,0-1-.3,2.13,2.13,0,0,0-1,.25,3.94,3.94,0,0,0-.91.67l-.12-.12a4.49,4.49,0,0,1,1.25-1.09,2.62,2.62,0,0,1,1.3-.31,1.79,1.79,0,0,1,1.18.35,1.28,1.28,0,0,1,.44,1,1.63,1.63,0,0,1-.43,1.05,5.52,5.52,0,0,1-1.34,1.06,2.36,2.36,0,0,1,1.42.49A1.56,1.56,0,0,1,753.55,614Z"
              />
              <path
                class="cls-5"
                d="M943.41,616.4a2.78,2.78,0,0,1-.55.39,1.34,1.34,0,0,1-.64.15.92.92,0,0,1-1-1v-3.33h-.69v-.08l.7-.25.61-1.5H942v1.49h1.36v.34H942v3.21c0,.51.23.78.67.78a1.06,1.06,0,0,0,.37-.06,1.53,1.53,0,0,0,.33-.2Zm-3.65-3.92a.77.77,0,0,1-.12.44.33.33,0,0,1-.26.15.74.74,0,0,1-.3-.11,3.42,3.42,0,0,1-.52-.34,2.2,2.2,0,0,0-.43.27,2.31,2.31,0,0,0-.36.33v2.47a3.17,3.17,0,0,0,.05.63.37.37,0,0,0,.2.29,1.14,1.14,0,0,0,.46.11l.26,0v.11h-2.45v-.11l.21,0a.68.68,0,0,0,.34-.11.39.39,0,0,0,.15-.29,3.34,3.34,0,0,0,0-.63v-2.36a1,1,0,0,0-.09-.49.7.7,0,0,0-.37-.24l-.29-.11v-.08l1.4-.33.09.06V613a4,4,0,0,1,.79-.71,1.21,1.21,0,0,1,.68-.2.65.65,0,0,1,.38.1A.36.36,0,0,1,939.76,612.48Zm-4,4.38c-.57,0-1.06,0-1.48,0v-.71a4.07,4.07,0,0,1-.76.57,1.69,1.69,0,0,1-.84.21c-.91,0-1.38-.48-1.39-1.48v-2.15a1,1,0,0,0-.09-.49.7.7,0,0,0-.37-.24l-.29-.11v-.08l1.4-.33.09.06v3.23a1.33,1.33,0,0,0,.26.89.86.86,0,0,0,.7.29,1.53,1.53,0,0,0,.7-.16,2.16,2.16,0,0,0,.59-.41v-2.65a.81.81,0,0,0-.09-.49.66.66,0,0,0-.37-.24l-.28-.11v-.08l1.4-.33.09.06v3.55a4.85,4.85,0,0,0,0,.63.47.47,0,0,0,.15.29.72.72,0,0,0,.35.11l.2,0Zm-5.75-2.3a2.54,2.54,0,0,1-.3,1.25,2.23,2.23,0,0,1-2,1.17,2.28,2.28,0,0,1-1.13-.28,2,2,0,0,1-.82-.83,3,3,0,0,1-.32-1.4,2.66,2.66,0,0,1,.31-1.25,2.23,2.23,0,0,1,2-1.17,2.31,2.31,0,0,1,1.13.28,2,2,0,0,1,.82.83A3,3,0,0,1,930,614.56Zm-.84.19a3.49,3.49,0,0,0-.44-1.83,1.33,1.33,0,0,0-1.14-.7,1,1,0,0,0-.92.48,3,3,0,0,0-.35,1.58,3.56,3.56,0,0,0,.44,1.83,1.36,1.36,0,0,0,1.15.7,1,1,0,0,0,.92-.48A3,3,0,0,0,929.12,614.75Zm-4.79.33-.23,1.39a3.7,3.7,0,0,1-1,.37,5.11,5.11,0,0,1-1.31.14,4,4,0,0,1-1.84-.42,3.19,3.19,0,0,1-1.28-1.22,3.69,3.69,0,0,1-.47-1.9,3.46,3.46,0,0,1,.53-1.88,3.64,3.64,0,0,1,1.33-1.23,3.59,3.59,0,0,1,1.69-.42,5.18,5.18,0,0,1,1.29.13,4.7,4.7,0,0,1,.9.34l.24,1.43h-.12l-.13-.28a2.69,2.69,0,0,0-.81-1,2.54,2.54,0,0,0-3.29.45,3.88,3.88,0,0,0-.71,2.41,4,4,0,0,0,.77,2.54,2.46,2.46,0,0,0,2,.92,2.25,2.25,0,0,0,1.33-.36,2.58,2.58,0,0,0,.84-1.09l.13-.28Zm-9.19-2.8-.19,0a.63.63,0,0,0-.43.24,3,3,0,0,0-.4.76l-1.92,4.59a2.79,2.79,0,0,1-.52.86.76.76,0,0,1-.57.24.4.4,0,0,1-.32-.11.44.44,0,0,1-.1-.3.43.43,0,0,1,.3-.4,1.58,1.58,0,0,1,.85-.08c.18-.33.38-.75.6-1.27l-1.53-3.6a3.2,3.2,0,0,0-.37-.72.57.57,0,0,0-.42-.21l-.21,0v-.11h2.23v.11l-.26,0a.62.62,0,0,0-.31.1.24.24,0,0,0-.07.2,1.47,1.47,0,0,0,0,.27c0,.1.06.2.1.3l1.15,2.87,1-2.44a3,3,0,0,0,.26-1,.36.36,0,0,0-.36-.35l-.27,0v-.11h1.77Zm-5.65,4.58h-1.32a7.39,7.39,0,0,0-.65-1l-1-1.47-.34.32v1a3.34,3.34,0,0,0,0,.63.39.39,0,0,0,.15.29.77.77,0,0,0,.36.11l.2,0v.11h-2.23v-.11l.21,0a.68.68,0,0,0,.34-.11.39.39,0,0,0,.15-.29,4.49,4.49,0,0,0,0-.63v-4.91a1,1,0,0,0-.09-.5.76.76,0,0,0-.37-.23l-.29-.11v-.08l1.4-.33.09.06v4.87l1.19-1.11.41-.41a.48.48,0,0,0,.13-.29c0-.18-.13-.28-.41-.32l-.2,0v-.12h2v.11h-.11a.9.9,0,0,0-.48.15,4.31,4.31,0,0,0-.62.5l-1.08,1,1.52,2.1a4.33,4.33,0,0,0,.45.53.65.65,0,0,0,.36.16l.18,0ZM904,615a1.63,1.63,0,0,1-.33,1,2.28,2.28,0,0,1-.89.67,3.3,3.3,0,0,1-1.29.24,4.65,4.65,0,0,1-1.06-.1,2.4,2.4,0,0,1-.69-.23l-.23-1.31h.12l.14.29a2.1,2.1,0,0,0,.75.92,1.86,1.86,0,0,0,1,.26,2,2,0,0,0,1.32-.37,1.31,1.31,0,0,0,.47-1.08,1.22,1.22,0,0,0-.36-1,3,3,0,0,0-1.25-.59,3.78,3.78,0,0,1-1.52-.72,1.65,1.65,0,0,1-.51-1.3,1.59,1.59,0,0,1,.3-1,2,2,0,0,1,.8-.64,2.55,2.55,0,0,1,1.12-.23,4.57,4.57,0,0,1,1,.08,2.87,2.87,0,0,1,.68.21l.21,1.35h-.11l-.13-.29a2.3,2.3,0,0,0-.7-.92,1.62,1.62,0,0,0-1-.26,1.66,1.66,0,0,0-1.13.36,1.27,1.27,0,0,0-.39,1,1.14,1.14,0,0,0,.34.92,3.08,3.08,0,0,0,1.26.58,3.47,3.47,0,0,1,1.58.79A1.76,1.76,0,0,1,904,615Z"
              />
              <path
                class="cls-15"
                d="M1004,667.2v-9.61h.82l5.28,5.72v-5.72h2v9.61h-.83l-5.27-5.72v5.72ZM993.22,660a3.71,3.71,0,0,0,0,4.82,3.3,3.3,0,0,0,4.55,0,3.71,3.71,0,0,0,0-4.82,3.3,3.3,0,0,0-4.55,0Zm-2.44,4.4a5,5,0,0,1,1.08-5.57,5,5,0,0,1,1.63-1,5.48,5.48,0,0,1,4,0,4.9,4.9,0,0,1,1.63,1,4.67,4.67,0,0,1,1.08,1.59,5.15,5.15,0,0,1,0,4,4.67,4.67,0,0,1-1.08,1.59,5.06,5.06,0,0,1-1.63,1,5.48,5.48,0,0,1-4,0,5.17,5.17,0,0,1-1.63-1A5,5,0,0,1,990.78,664.39Zm-5.33,2.81v-9.61h1.95v9.61Zm-9.88-8v-1.65h6.56v1.65h-2.3v8h-2v-8Zm-11.1,3.16a5,5,0,0,1,.67-2.58A4.7,4.7,0,0,1,967,658a5.27,5.27,0,0,1,2.6-.64,5.43,5.43,0,0,1,1.5.17,4.88,4.88,0,0,1,1.26.55l.16,2h-.27a4.21,4.21,0,0,0-2.56-1,3.17,3.17,0,0,0-2.39.9,3.6,3.6,0,0,0,0,4.67,3.14,3.14,0,0,0,2.39.91,4.23,4.23,0,0,0,2.56-1h.27l-.16,2a5.55,5.55,0,0,1-1.27.56,5.82,5.82,0,0,1-1.49.17,5.45,5.45,0,0,1-2-.38,5,5,0,0,1-1.63-1,4.79,4.79,0,0,1-1.07-1.59A5.13,5.13,0,0,1,964.47,662.4Zm-8.91,4.8v-9.61h6.1v1.65h-4.15v2.2h4v1.65h-4v2.47h4.2v1.64Zm-10,0v-9.61h2v8h4.69v1.64Zm-10,0v-9.61h2v8h4.69v1.64ZM924.81,660a3.71,3.71,0,0,0,0,4.82,3.29,3.29,0,0,0,4.54,0,3.68,3.68,0,0,0,0-4.82,3.29,3.29,0,0,0-4.54,0Zm-2.44,4.4a5.15,5.15,0,0,1,0-4,4.67,4.67,0,0,1,1.08-1.59,4.9,4.9,0,0,1,1.63-1,5.48,5.48,0,0,1,4,0,4.78,4.78,0,0,1,2.71,2.63,5.15,5.15,0,0,1,0,4,5,5,0,0,1-1.08,1.59,5.17,5.17,0,0,1-1.63,1,5.48,5.48,0,0,1-4,0,5.06,5.06,0,0,1-1.63-1A4.67,4.67,0,0,1,922.37,664.39Zm-11-2a5,5,0,0,1,.67-2.58,4.7,4.7,0,0,1,1.84-1.78,5.3,5.3,0,0,1,2.6-.64,5.43,5.43,0,0,1,1.5.17,4.88,4.88,0,0,1,1.26.55l.16,2h-.26a4.26,4.26,0,0,0-2.57-1,3.14,3.14,0,0,0-2.38.9,3.57,3.57,0,0,0,0,4.67,3.1,3.1,0,0,0,2.38.91,4.28,4.28,0,0,0,2.57-1h.26l-.16,2a5.36,5.36,0,0,1-1.27.56,5.82,5.82,0,0,1-1.49.17,5.45,5.45,0,0,1-2-.38,5,5,0,0,1-1.63-1,4.79,4.79,0,0,1-1.07-1.59A5.13,5.13,0,0,1,911.41,662.4Zm-17.55,4.8v-9.61h.83l5.27,5.72v-5.72h1.95v9.61h-.82l-5.28-5.72v5.72ZM883.27,660a3.68,3.68,0,0,0,0,4.82,3.29,3.29,0,0,0,4.54,0,3.68,3.68,0,0,0,0-4.82,3.29,3.29,0,0,0-4.54,0Zm-2.45,4.4a5.15,5.15,0,0,1,0-4,4.78,4.78,0,0,1,2.71-2.63,5.48,5.48,0,0,1,4,0,4.84,4.84,0,0,1,2.72,2.63,5.27,5.27,0,0,1,0,4,4.84,4.84,0,0,1-1.09,1.59,5,5,0,0,1-1.63,1,5.48,5.48,0,0,1-4,0,5.17,5.17,0,0,1-1.63-1A5,5,0,0,1,880.82,664.39Zm-10.4,2.81v-.27l4.51-7.69h-4.1v-1.65h7v.27l-4.51,7.7H878v1.64Zm-4.94,0v-9.61h1.95v9.61Zm-8.19-5.74h.91c1,0,1.44-.36,1.44-1.1s-.48-1.1-1.44-1.1h-.91Zm-1.95,5.74v-9.61h3a3.48,3.48,0,0,1,2.33.74,2.48,2.48,0,0,1,.9,2,2.64,2.64,0,0,1-.48,1.6,2.78,2.78,0,0,1-1.33,1l2.56,4.28h-2.15l-2.44-4.06h-.46v4.06ZM844.88,660a3.68,3.68,0,0,0,0,4.82,3.29,3.29,0,0,0,4.54,0,3.68,3.68,0,0,0,0-4.82,3.29,3.29,0,0,0-4.54,0Zm-2.45,4.4a5.27,5.27,0,0,1,0-4,4.76,4.76,0,0,1,2.72-2.63,5.45,5.45,0,0,1,4,0,4.76,4.76,0,0,1,2.72,2.63,5.27,5.27,0,0,1,0,4,5,5,0,0,1-1.08,1.59,5.1,5.1,0,0,1-1.64,1,5.45,5.45,0,0,1-4,0,5.1,5.1,0,0,1-1.64-1A5,5,0,0,1,842.43,664.39Zm-11.36,2.81v-9.61H833v3.72h3.81v-3.72h1.95v9.61h-1.95V663H833v4.24Z"
              />
              <path
                class="cls-5"
                d="M760.49,643.92l-.36,1.09H757.2l-.64,1.43a5.62,5.62,0,0,1,2.6.8,2.14,2.14,0,0,1,.89,1.88,3,3,0,0,1-.52,1.68,3.35,3.35,0,0,1-1.22,1.09,3.26,3.26,0,0,1-1.49.38,1.31,1.31,0,0,1-.76-.19.55.55,0,0,1-.22-.42c0-.3.2-.46.56-.48a1,1,0,0,1,.58.18,3.79,3.79,0,0,1,.6.53,2.75,2.75,0,0,0,1.4-.84,2.28,2.28,0,0,0,.55-1.52,1.74,1.74,0,0,0-.85-1.58,6.26,6.26,0,0,0-2.62-.69l-.09-.11,1.34-2.94h2a2.93,2.93,0,0,0,.65-.06.83.83,0,0,0,.42-.23Zm-6.94,5.36a2.69,2.69,0,0,1-.55,1.64,3.39,3.39,0,0,1-1.28,1,3.57,3.57,0,0,1-1.48.34,1.53,1.53,0,0,1-.82-.18.56.56,0,0,1-.27-.48.43.43,0,0,1,.15-.35.52.52,0,0,1,.33-.11,1,1,0,0,1,.59.19,2.45,2.45,0,0,1,.58.61,2.53,2.53,0,0,0,1-.31,2.31,2.31,0,0,0,.76-.73,2.17,2.17,0,0,0,.3-1.1,1.52,1.52,0,0,0-.47-1.19,1.86,1.86,0,0,0-1.24-.39,1.93,1.93,0,0,0-.55.07,3.25,3.25,0,0,0-.54.2l-.12-.2a11.71,11.71,0,0,0,1.65-1,2.61,2.61,0,0,0,.76-.79,1.39,1.39,0,0,0,.18-.73,1,1,0,0,0-.31-.75,1.46,1.46,0,0,0-1-.3,2.13,2.13,0,0,0-1,.25,3.94,3.94,0,0,0-.91.67l-.12-.12a4.49,4.49,0,0,1,1.25-1.09,2.62,2.62,0,0,1,1.3-.31,1.79,1.79,0,0,1,1.18.35,1.28,1.28,0,0,1,.44,1,1.63,1.63,0,0,1-.43,1,5.52,5.52,0,0,1-1.34,1.06,2.36,2.36,0,0,1,1.42.49A1.56,1.56,0,0,1,753.55,649.28Z"
              />
              <path
                class="cls-5"
                d="M756.79,676.75a2.69,2.69,0,0,1-.55,1.64,3.34,3.34,0,0,1-1.29,1,3.49,3.49,0,0,1-1.47.34,1.51,1.51,0,0,1-.82-.18.55.55,0,0,1-.28-.48.45.45,0,0,1,.15-.34.5.5,0,0,1,.34-.12,1,1,0,0,1,.59.19,2.87,2.87,0,0,1,.58.61,2.58,2.58,0,0,0,1-.31,2.1,2.1,0,0,0,.75-.73,2,2,0,0,0,.3-1.1,1.49,1.49,0,0,0-.46-1.19,1.87,1.87,0,0,0-1.25-.39,2,2,0,0,0-.55.07,3.16,3.16,0,0,0-.53.2l-.12-.2a13.62,13.62,0,0,0,1.65-1,3,3,0,0,0,.76-.8,1.39,1.39,0,0,0,.18-.73,1,1,0,0,0-.32-.75,1.41,1.41,0,0,0-.94-.3,2.2,2.2,0,0,0-1,.25,3.89,3.89,0,0,0-.9.67l-.12-.12a4.35,4.35,0,0,1,1.25-1.09,2.61,2.61,0,0,1,1.29-.31,1.75,1.75,0,0,1,1.18.35,1.22,1.22,0,0,1,.44,1,1.62,1.62,0,0,1-.42,1.05,5.6,5.6,0,0,1-1.35,1.06,2.39,2.39,0,0,1,1.43.49A1.56,1.56,0,0,1,756.79,676.75Z"
              />
              <line
                class="cls-3"
                x1="754.83"
                y1="656.17"
                x2="754.83"
                y2="666.14"
              />
              <path
                class="cls-5"
                d="M1114.26,643.92l-.36,1.09H1111l-.65,1.43a5.63,5.63,0,0,1,2.61.8,2.16,2.16,0,0,1,.88,1.88,3,3,0,0,1-.52,1.68,3.27,3.27,0,0,1-1.22,1.09,3.23,3.23,0,0,1-1.49.38,1.28,1.28,0,0,1-.75-.19.56.56,0,0,1-.23-.42q0-.45.57-.48a1,1,0,0,1,.57.18,4.3,4.3,0,0,1,.61.53,2.72,2.72,0,0,0,1.39-.84,2.28,2.28,0,0,0,.55-1.52,1.72,1.72,0,0,0-.85-1.58,6.26,6.26,0,0,0-2.62-.69l-.09-.11,1.34-2.94h2a2.93,2.93,0,0,0,.65-.06.86.86,0,0,0,.43-.23Zm-6.94,5.36a2.63,2.63,0,0,1-.55,1.64,3.31,3.31,0,0,1-1.28,1,3.53,3.53,0,0,1-1.47.34,1.49,1.49,0,0,1-.82-.18.55.55,0,0,1-.28-.48.5.5,0,0,1,.15-.35.52.52,0,0,1,.33-.11,1,1,0,0,1,.59.19,2.45,2.45,0,0,1,.58.61,2.53,2.53,0,0,0,1-.31,2.21,2.21,0,0,0,.76-.73,2.17,2.17,0,0,0,.3-1.1,1.49,1.49,0,0,0-.47-1.19,1.84,1.84,0,0,0-1.24-.39,2,2,0,0,0-.55.07,3.62,3.62,0,0,0-.54.2l-.11-.2a12.12,12.12,0,0,0,1.64-1,2.61,2.61,0,0,0,.76-.79,1.5,1.5,0,0,0,.19-.73,1,1,0,0,0-.32-.75,1.43,1.43,0,0,0-.94-.3,2.14,2.14,0,0,0-1,.25,4.16,4.16,0,0,0-.91.67l-.11-.12a4.23,4.23,0,0,1,1.25-1.09,2.56,2.56,0,0,1,1.29-.31,1.79,1.79,0,0,1,1.18.35,1.25,1.25,0,0,1,.44,1,1.58,1.58,0,0,1-.43,1,5.33,5.33,0,0,1-1.34,1.06,2.36,2.36,0,0,1,1.42.49A1.56,1.56,0,0,1,1107.32,649.28Z"
              />
              <path
                class="cls-5"
                d="M1110.55,676.75a2.69,2.69,0,0,1-.55,1.64,3.39,3.39,0,0,1-1.28,1,3.57,3.57,0,0,1-1.48.34,1.53,1.53,0,0,1-.82-.18.57.57,0,0,1-.28-.48.45.45,0,0,1,.15-.34.52.52,0,0,1,.34-.12,1,1,0,0,1,.59.19,2.64,2.64,0,0,1,.58.61,2.53,2.53,0,0,0,1-.31,2.21,2.21,0,0,0,.76-.73,2.17,2.17,0,0,0,.3-1.1,1.52,1.52,0,0,0-.47-1.19,1.86,1.86,0,0,0-1.24-.39,1.93,1.93,0,0,0-.55.07,3,3,0,0,0-.54.2l-.12-.2a12.86,12.86,0,0,0,1.65-1,2.88,2.88,0,0,0,.76-.8,1.39,1.39,0,0,0,.18-.73.93.93,0,0,0-.32-.75,1.41,1.41,0,0,0-.94-.3,2.13,2.13,0,0,0-1,.25,3.74,3.74,0,0,0-.91.67l-.12-.12a4.49,4.49,0,0,1,1.25-1.09,2.62,2.62,0,0,1,1.3-.31,1.79,1.79,0,0,1,1.18.35,1.24,1.24,0,0,1,.43,1A1.62,1.62,0,0,1,1110,674a5.72,5.72,0,0,1-1.34,1.06,2.39,2.39,0,0,1,1.42.49A1.56,1.56,0,0,1,1110.55,676.75Z"
              />
              <line
                class="cls-3"
                x1="1108.32"
                y1="656.17"
                x2="1108.32"
                y2="666.14"
              />
              <line
                class="cls-16"
                x1="1133.1"
                y1="144.42"
                x2="1186.7"
                y2="144.42"
              />
              <line
                class="cls-16"
                x1="1186.7"
                y1="144.42"
                x2="1240.3"
                y2="144.42"
              />
              <line
                class="cls-16"
                x1="1240.3"
                y1="144.42"
                x2="1256.46"
                y2="144.42"
              />
              <line
                class="cls-16"
                x1="1256.73"
                y1="144.42"
                x2="1310.06"
                y2="144.42"
              />
              <line
                class="cls-16"
                x1="1310.06"
                y1="144.42"
                x2="1363.66"
                y2="144.42"
              />
              <line
                class="cls-16"
                x1="1363.66"
                y1="144.42"
                x2="1417.26"
                y2="144.42"
              />
              <line
                class="cls-14"
                x1="1256.46"
                y1="177.01"
                x2="1310.06"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="1256.73"
                y1="209.33"
                x2="1256.73"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="177.01"
                x2="1363.66"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="209.33"
                x2="1310.06"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="177.01"
                x2="1417.53"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="209.33"
                x2="1363.66"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="1417.26"
                y1="209.33"
                x2="1417.26"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="1256.46"
                y1="209.33"
                x2="1310.06"
                y2="209.33"
              />
              <line
                class="cls-14"
                x1="1256.73"
                y1="229.53"
                x2="1256.73"
                y2="209.6"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="209.33"
                x2="1363.66"
                y2="209.33"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="229.53"
                x2="1310.06"
                y2="209.6"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="209.33"
                x2="1417.53"
                y2="209.33"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="229.53"
                x2="1363.66"
                y2="209.6"
              />
              <line
                class="cls-14"
                x1="1417.26"
                y1="229.53"
                x2="1417.26"
                y2="209.6"
              />
              <line
                class="cls-14"
                x1="1256.46"
                y1="229.8"
                x2="1310.06"
                y2="229.8"
              />
              <line
                class="cls-14"
                x1="1256.73"
                y1="250"
                x2="1256.73"
                y2="230.07"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="229.8"
                x2="1363.66"
                y2="229.8"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="250"
                x2="1310.06"
                y2="230.07"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="229.8"
                x2="1417.53"
                y2="229.8"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="250"
                x2="1363.66"
                y2="230.07"
              />
              <line
                class="cls-14"
                x1="1417.26"
                y1="250"
                x2="1417.26"
                y2="230.07"
              />
              <line
                class="cls-14"
                x1="1256.46"
                y1="250.27"
                x2="1310.06"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="1256.73"
                y1="270.47"
                x2="1256.73"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="250.27"
                x2="1363.66"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="270.47"
                x2="1310.06"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="250.27"
                x2="1417.53"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="270.47"
                x2="1363.66"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="1417.26"
                y1="270.47"
                x2="1417.26"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="1256.46"
                y1="270.47"
                x2="1310.06"
                y2="270.47"
              />
              <line
                class="cls-14"
                x1="1256.73"
                y1="290.67"
                x2="1256.73"
                y2="270.74"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="270.47"
                x2="1363.66"
                y2="270.47"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="290.67"
                x2="1310.06"
                y2="270.74"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="270.47"
                x2="1417.53"
                y2="270.47"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="290.67"
                x2="1363.66"
                y2="270.74"
              />
              <line
                class="cls-14"
                x1="1417.26"
                y1="290.67"
                x2="1417.26"
                y2="270.74"
              />
              <line
                class="cls-14"
                x1="1256.46"
                y1="290.94"
                x2="1310.06"
                y2="290.94"
              />
              <line
                class="cls-14"
                x1="1256.73"
                y1="311.14"
                x2="1256.73"
                y2="291.21"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="290.94"
                x2="1363.66"
                y2="290.94"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="311.14"
                x2="1310.06"
                y2="291.21"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="290.94"
                x2="1417.53"
                y2="290.94"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="311.14"
                x2="1363.66"
                y2="291.21"
              />
              <line
                class="cls-14"
                x1="1417.26"
                y1="311.14"
                x2="1417.26"
                y2="291.21"
              />
              <line
                class="cls-14"
                x1="1256.46"
                y1="311.41"
                x2="1310.06"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="1256.73"
                y1="331.61"
                x2="1256.73"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="311.41"
                x2="1363.66"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="331.61"
                x2="1310.06"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="311.41"
                x2="1417.53"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="331.61"
                x2="1363.66"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="1417.26"
                y1="331.61"
                x2="1417.26"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="1256.46"
                y1="331.61"
                x2="1310.06"
                y2="331.61"
              />
              <line
                class="cls-14"
                x1="1256.73"
                y1="351.81"
                x2="1256.73"
                y2="331.88"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="331.61"
                x2="1363.66"
                y2="331.61"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="351.81"
                x2="1310.06"
                y2="331.88"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="331.61"
                x2="1417.53"
                y2="331.61"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="351.81"
                x2="1363.66"
                y2="331.88"
              />
              <line
                class="cls-14"
                x1="1417.26"
                y1="351.81"
                x2="1417.26"
                y2="331.88"
              />
              <line
                class="cls-14"
                x1="1256.46"
                y1="352.08"
                x2="1310.06"
                y2="352.08"
              />
              <line
                class="cls-14"
                x1="1256.73"
                y1="372.28"
                x2="1256.73"
                y2="352.35"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="352.08"
                x2="1363.66"
                y2="352.08"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="372.28"
                x2="1310.06"
                y2="352.35"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="352.08"
                x2="1417.53"
                y2="352.08"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="372.28"
                x2="1363.66"
                y2="352.35"
              />
              <line
                class="cls-14"
                x1="1417.26"
                y1="372.28"
                x2="1417.26"
                y2="352.35"
              />
              <line
                class="cls-14"
                x1="1256.46"
                y1="372.55"
                x2="1310.06"
                y2="372.55"
              />
              <line
                class="cls-14"
                x1="1256.73"
                y1="392.75"
                x2="1256.73"
                y2="372.82"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="372.55"
                x2="1363.66"
                y2="372.55"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="392.75"
                x2="1310.06"
                y2="372.82"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="372.55"
                x2="1417.53"
                y2="372.55"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="392.75"
                x2="1363.66"
                y2="372.82"
              />
              <line
                class="cls-14"
                x1="1417.26"
                y1="392.75"
                x2="1417.26"
                y2="372.82"
              />
              <line
                class="cls-14"
                x1="1256.46"
                y1="393.02"
                x2="1310.06"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="1256.73"
                y1="413.22"
                x2="1256.73"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="393.02"
                x2="1363.66"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="413.22"
                x2="1310.06"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="393.02"
                x2="1417.53"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="413.22"
                x2="1363.66"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="1417.26"
                y1="413.22"
                x2="1417.26"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="1256.46"
                y1="413.22"
                x2="1310.06"
                y2="413.22"
              />
              <line
                class="cls-14"
                x1="1256.73"
                y1="433.42"
                x2="1256.73"
                y2="413.49"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="413.22"
                x2="1363.66"
                y2="413.22"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="433.42"
                x2="1310.06"
                y2="413.49"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="413.22"
                x2="1417.53"
                y2="413.22"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="433.42"
                x2="1363.66"
                y2="413.49"
              />
              <line
                class="cls-14"
                x1="1417.26"
                y1="433.42"
                x2="1417.26"
                y2="413.49"
              />
              <line
                class="cls-14"
                x1="1256.46"
                y1="433.69"
                x2="1310.06"
                y2="433.69"
              />
              <line
                class="cls-14"
                x1="1256.73"
                y1="453.89"
                x2="1256.73"
                y2="433.96"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="433.69"
                x2="1363.66"
                y2="433.69"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="453.89"
                x2="1310.06"
                y2="433.96"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="433.69"
                x2="1417.53"
                y2="433.69"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="453.89"
                x2="1363.66"
                y2="433.96"
              />
              <line
                class="cls-14"
                x1="1417.26"
                y1="453.89"
                x2="1417.26"
                y2="433.96"
              />
              <line
                class="cls-14"
                x1="1256.46"
                y1="454.16"
                x2="1310.06"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="1256.73"
                y1="474.36"
                x2="1256.73"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="454.16"
                x2="1363.66"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="474.36"
                x2="1310.06"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="454.16"
                x2="1417.53"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="474.36"
                x2="1363.66"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="1417.26"
                y1="474.36"
                x2="1417.26"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="1256.46"
                y1="474.36"
                x2="1310.06"
                y2="474.36"
              />
              <line
                class="cls-14"
                x1="1256.73"
                y1="494.56"
                x2="1256.73"
                y2="474.63"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="474.36"
                x2="1363.66"
                y2="474.36"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="494.56"
                x2="1310.06"
                y2="474.63"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="474.36"
                x2="1417.53"
                y2="474.36"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="494.56"
                x2="1363.66"
                y2="474.63"
              />
              <line
                class="cls-14"
                x1="1417.26"
                y1="494.56"
                x2="1417.26"
                y2="474.63"
              />
              <line
                class="cls-14"
                x1="1256.46"
                y1="494.83"
                x2="1310.06"
                y2="494.83"
              />
              <line
                class="cls-14"
                x1="1256.73"
                y1="515.03"
                x2="1256.73"
                y2="495.1"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="494.83"
                x2="1363.66"
                y2="494.83"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="515.03"
                x2="1310.06"
                y2="495.1"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="494.83"
                x2="1417.53"
                y2="494.83"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="515.03"
                x2="1363.66"
                y2="495.1"
              />
              <line
                class="cls-14"
                x1="1417.26"
                y1="515.03"
                x2="1417.26"
                y2="495.1"
              />
              <line
                class="cls-14"
                x1="1256.46"
                y1="515.3"
                x2="1310.06"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="1256.73"
                y1="535.5"
                x2="1256.73"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="515.3"
                x2="1363.66"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="535.5"
                x2="1310.06"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="515.3"
                x2="1417.53"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="535.5"
                x2="1363.66"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="1417.26"
                y1="535.5"
                x2="1417.26"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="1256.46"
                y1="535.5"
                x2="1310.06"
                y2="535.5"
              />
              <line
                class="cls-14"
                x1="1256.73"
                y1="555.97"
                x2="1256.73"
                y2="535.77"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="535.5"
                x2="1363.66"
                y2="535.5"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="555.97"
                x2="1310.06"
                y2="535.77"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="535.5"
                x2="1417.53"
                y2="535.5"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="555.97"
                x2="1363.66"
                y2="535.77"
              />
              <line
                class="cls-14"
                x1="1417.26"
                y1="555.97"
                x2="1417.26"
                y2="535.77"
              />
              <line
                class="cls-14"
                x1="1256.46"
                y1="555.97"
                x2="1310.06"
                y2="555.97"
              />
              <line
                class="cls-14"
                x1="1256.73"
                y1="576.17"
                x2="1256.73"
                y2="556.24"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="555.97"
                x2="1363.66"
                y2="555.97"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="576.17"
                x2="1310.06"
                y2="556.24"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="555.97"
                x2="1417.53"
                y2="555.97"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="576.17"
                x2="1363.66"
                y2="556.24"
              />
              <line
                class="cls-14"
                x1="1417.26"
                y1="576.17"
                x2="1417.26"
                y2="556.24"
              />
              <line
                class="cls-14"
                x1="1256.46"
                y1="576.44"
                x2="1310.06"
                y2="576.44"
              />
              <line
                class="cls-14"
                x1="1256.73"
                y1="596.64"
                x2="1256.73"
                y2="576.71"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="576.44"
                x2="1363.66"
                y2="576.44"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="596.64"
                x2="1310.06"
                y2="576.71"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="576.44"
                x2="1417.53"
                y2="576.44"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="596.64"
                x2="1363.66"
                y2="576.71"
              />
              <line
                class="cls-14"
                x1="1417.26"
                y1="596.64"
                x2="1417.26"
                y2="576.71"
              />
              <line
                class="cls-14"
                x1="1256.46"
                y1="596.91"
                x2="1310.06"
                y2="596.91"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="596.91"
                x2="1363.66"
                y2="596.91"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="596.91"
                x2="1417.53"
                y2="596.91"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="177.01"
                x2="1186.7"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="209.33"
                x2="1133.1"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="209.33"
                x2="1186.7"
                y2="209.33"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="229.53"
                x2="1133.1"
                y2="209.6"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="229.8"
                x2="1186.7"
                y2="229.8"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="250"
                x2="1133.1"
                y2="230.07"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="250.27"
                x2="1186.7"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="270.47"
                x2="1133.1"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="270.47"
                x2="1186.7"
                y2="270.47"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="290.67"
                x2="1133.1"
                y2="270.74"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="290.94"
                x2="1186.7"
                y2="290.94"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="311.14"
                x2="1133.1"
                y2="291.21"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="311.14"
                x2="1186.7"
                y2="291.21"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="311.41"
                x2="1186.97"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="331.61"
                x2="1133.1"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="331.61"
                x2="1186.7"
                y2="311.41"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="331.61"
                x2="1186.97"
                y2="331.61"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="351.81"
                x2="1133.1"
                y2="331.88"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="351.81"
                x2="1186.7"
                y2="331.88"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="352.08"
                x2="1186.7"
                y2="352.08"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="372.28"
                x2="1133.1"
                y2="352.35"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="372.55"
                x2="1186.7"
                y2="372.55"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="392.75"
                x2="1133.1"
                y2="372.82"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="393.02"
                x2="1186.7"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="413.22"
                x2="1133.1"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="413.22"
                x2="1186.7"
                y2="413.22"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="433.42"
                x2="1133.1"
                y2="413.49"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="433.69"
                x2="1186.7"
                y2="433.69"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="453.89"
                x2="1133.1"
                y2="433.96"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="454.16"
                x2="1186.7"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="474.36"
                x2="1133.1"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="474.36"
                x2="1186.7"
                y2="474.36"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="494.56"
                x2="1133.1"
                y2="474.63"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="494.83"
                x2="1186.7"
                y2="494.83"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="515.03"
                x2="1133.1"
                y2="495.1"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="515.3"
                x2="1186.7"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="535.5"
                x2="1133.1"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="535.5"
                x2="1186.7"
                y2="535.5"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="555.97"
                x2="1133.1"
                y2="535.77"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="555.97"
                x2="1186.7"
                y2="555.97"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="576.17"
                x2="1133.1"
                y2="556.24"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="576.44"
                x2="1186.7"
                y2="576.44"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="596.64"
                x2="1133.1"
                y2="576.71"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="596.91"
                x2="1186.7"
                y2="596.91"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="250.27"
                x2="1240.57"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="270.47"
                x2="1186.7"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="1240.3"
                y1="270.47"
                x2="1240.3"
                y2="250.27"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="270.47"
                x2="1240.57"
                y2="270.47"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="290.67"
                x2="1186.7"
                y2="270.74"
              />
              <line
                class="cls-14"
                x1="1240.3"
                y1="290.67"
                x2="1240.3"
                y2="270.74"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="352.08"
                x2="1240.57"
                y2="352.08"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="372.28"
                x2="1186.7"
                y2="352.35"
              />
              <line
                class="cls-14"
                x1="1240.3"
                y1="372.28"
                x2="1240.3"
                y2="352.35"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="372.55"
                x2="1240.57"
                y2="372.55"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="392.75"
                x2="1186.7"
                y2="372.82"
              />
              <line
                class="cls-14"
                x1="1240.3"
                y1="392.75"
                x2="1240.3"
                y2="372.82"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="393.02"
                x2="1240.57"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="413.22"
                x2="1186.7"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="1240.3"
                y1="413.22"
                x2="1240.3"
                y2="393.02"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="413.22"
                x2="1240.57"
                y2="413.22"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="433.42"
                x2="1186.7"
                y2="413.49"
              />
              <line
                class="cls-14"
                x1="1240.3"
                y1="433.42"
                x2="1240.3"
                y2="413.49"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="433.69"
                x2="1240.57"
                y2="433.69"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="453.89"
                x2="1186.7"
                y2="433.96"
              />
              <line
                class="cls-14"
                x1="1240.3"
                y1="453.89"
                x2="1240.3"
                y2="433.96"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="454.16"
                x2="1240.57"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="474.36"
                x2="1186.7"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="1240.3"
                y1="474.36"
                x2="1240.3"
                y2="454.16"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="474.36"
                x2="1240.57"
                y2="474.36"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="494.56"
                x2="1186.7"
                y2="474.63"
              />
              <line
                class="cls-14"
                x1="1240.3"
                y1="494.56"
                x2="1240.3"
                y2="474.63"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="494.83"
                x2="1240.57"
                y2="494.83"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="515.03"
                x2="1186.7"
                y2="495.1"
              />
              <line
                class="cls-14"
                x1="1240.3"
                y1="515.03"
                x2="1240.3"
                y2="495.1"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="515.3"
                x2="1240.57"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="535.5"
                x2="1186.7"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="1240.3"
                y1="535.5"
                x2="1240.3"
                y2="515.3"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="535.5"
                x2="1240.57"
                y2="535.5"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="555.97"
                x2="1186.7"
                y2="535.77"
              />
              <line
                class="cls-14"
                x1="1240.3"
                y1="555.97"
                x2="1240.3"
                y2="535.77"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="555.97"
                x2="1240.57"
                y2="555.97"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="576.17"
                x2="1186.7"
                y2="556.24"
              />
              <line
                class="cls-14"
                x1="1240.3"
                y1="576.17"
                x2="1240.3"
                y2="556.24"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="576.44"
                x2="1240.57"
                y2="576.44"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="596.64"
                x2="1186.7"
                y2="576.71"
              />
              <line
                class="cls-14"
                x1="1240.3"
                y1="596.64"
                x2="1240.3"
                y2="576.71"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="596.91"
                x2="1240.57"
                y2="596.91"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="177.01"
                x2="1240.57"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="209.33"
                x2="1186.7"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="1240.3"
                y1="209.33"
                x2="1240.3"
                y2="177.01"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="209.33"
                x2="1240.57"
                y2="209.33"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="229.53"
                x2="1186.7"
                y2="209.6"
              />
              <line
                class="cls-14"
                x1="1240.3"
                y1="229.53"
                x2="1240.3"
                y2="209.6"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="229.8"
                x2="1240.57"
                y2="229.8"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="250"
                x2="1186.7"
                y2="230.07"
              />
              <line
                class="cls-14"
                x1="1240.3"
                y1="250"
                x2="1240.3"
                y2="230.07"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="290.94"
                x2="1240.57"
                y2="290.94"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="629.24"
                x2="1186.7"
                y2="629.24"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="629.24"
                x2="1240.3"
                y2="629.24"
              />
              <line
                class="cls-14"
                x1="1240.3"
                y1="629.24"
                x2="1256.46"
                y2="629.24"
              />
              <line
                class="cls-14"
                x1="1256.73"
                y1="629.24"
                x2="1310.06"
                y2="629.24"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="629.24"
                x2="1363.66"
                y2="629.24"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="629.24"
                x2="1417.26"
                y2="629.24"
              />
              <line
                class="cls-14"
                x1="1133.1"
                y1="694.15"
                x2="1186.7"
                y2="694.15"
              />
              <line
                class="cls-14"
                x1="1186.7"
                y1="694.15"
                x2="1240.3"
                y2="694.15"
              />
              <line
                class="cls-14"
                x1="1240.3"
                y1="694.15"
                x2="1256.46"
                y2="694.15"
              />
              <line
                class="cls-14"
                x1="1256.73"
                y1="694.15"
                x2="1310.06"
                y2="694.15"
              />
              <line
                class="cls-14"
                x1="1310.06"
                y1="694.15"
                x2="1363.66"
                y2="694.15"
              />
              <line
                class="cls-14"
                x1="1363.66"
                y1="694.15"
                x2="1417.26"
                y2="694.15"
              />
              <path
                class="cls-5"
                d="M1123.61,152.65l-3.63,7-.18-.09,3.63-7Zm-4.73,6.4a2.78,2.78,0,0,1-.55.39,1.34,1.34,0,0,1-.64.15c-.67,0-1-.35-1-1v-3.33H1116v-.08l.7-.25.61-1.5h.13v1.49h1.36v.34h-1.36v3.21c0,.51.23.78.66.78a1,1,0,0,0,.37-.06,1.37,1.37,0,0,0,.34-.2Zm-4.39-5.92a.5.5,0,0,1-.15.38.53.53,0,0,1-.37.14.54.54,0,0,1-.38-.14.54.54,0,0,1,0-.75.5.5,0,0,1,.38-.15.51.51,0,0,1,.52.52Zm.69,6.38H1113v-.11l.21,0a.68.68,0,0,0,.34-.11.39.39,0,0,0,.15-.29,3.34,3.34,0,0,0,0-.63V156a1,1,0,0,0-.09-.5.7.7,0,0,0-.37-.24l-.29-.11v-.08l1.4-.33.09.06v3.55a4.37,4.37,0,0,0,0,.63.39.39,0,0,0,.15.29.77.77,0,0,0,.36.11l.2,0Zm-3.28,0h-2.23v-.11l.2,0a.77.77,0,0,0,.36-.11.39.39,0,0,0,.15-.29,4.37,4.37,0,0,0,0-.63v-2a1.35,1.35,0,0,0-.26-.89.89.89,0,0,0-.7-.29,1.5,1.5,0,0,0-.7.16,2,2,0,0,0-.59.42v2.63a4.74,4.74,0,0,0,0,.63.43.43,0,0,0,.16.29.76.76,0,0,0,.35.11l.2,0v.11h-2.22v-.11l.2,0a.72.72,0,0,0,.35-.11.47.47,0,0,0,.15-.29,4.85,4.85,0,0,0,0-.63V156a.82.82,0,0,0-.09-.5.66.66,0,0,0-.37-.24l-.28-.11v-.08l1.4-.33.09.06v.71a4.42,4.42,0,0,1,.76-.57,1.69,1.69,0,0,1,.84-.21c.91,0,1.38.48,1.39,1.48v2.14a3.27,3.27,0,0,0,0,.63.39.39,0,0,0,.15.29.68.68,0,0,0,.34.11l.21,0Zm-5.83-6.72-.14,0a1,1,0,0,0-.46.14.67.67,0,0,0-.28.37,2.47,2.47,0,0,0-.09.75l0,3a2.58,2.58,0,0,1-.69,1.9,2.76,2.76,0,0,1-2,.67,2.89,2.89,0,0,1-2-.63,2.3,2.3,0,0,1-.66-1.75v-3.12a2.54,2.54,0,0,0-.11-1,.51.51,0,0,0-.47-.29l-.37-.05v-.11h2.83v.11l-.46.06a.57.57,0,0,0-.5.28,2.31,2.31,0,0,0-.12,1v3a2.23,2.23,0,0,0,.56,1.69,2.11,2.11,0,0,0,1.54.5,2.27,2.27,0,0,0,1.62-.56,2.15,2.15,0,0,0,.62-1.68l0-3a1.72,1.72,0,0,0-.21-.95.82.82,0,0,0-.61-.28l-.28,0v-.11h2.36Z"
              />
              <path
                class="cls-5"
                d="M1123.09,166.44a.77.77,0,0,1-.13.44.31.31,0,0,1-.25.15.77.77,0,0,1-.31-.11,4.83,4.83,0,0,1-.52-.34,2.47,2.47,0,0,0-.42.27,2,2,0,0,0-.36.34v2.46a3.46,3.46,0,0,0,0,.64.38.38,0,0,0,.2.28,1.19,1.19,0,0,0,.46.11l.26,0v.11h-2.44v-.11l.21,0a.72.72,0,0,0,.34-.11.47.47,0,0,0,.15-.29,4.85,4.85,0,0,0,0-.63V167.3a.82.82,0,0,0-.09-.5.66.66,0,0,0-.37-.24l-.28-.11v-.08l1.4-.33.09.06v.83a4,4,0,0,1,.78-.71,1.23,1.23,0,0,1,.68-.2.61.61,0,0,1,.38.1A.36.36,0,0,1,1123.09,166.44Zm-4.73,2.08a2.54,2.54,0,0,1-.31,1.25,2.07,2.07,0,0,1-.81.85,2.14,2.14,0,0,1-1.15.32,2.24,2.24,0,0,1-1.12-.28,1.93,1.93,0,0,1-.82-.83,2.81,2.81,0,0,1-.32-1.4,2.54,2.54,0,0,1,.31-1.25,2.28,2.28,0,0,1,.81-.85,2.22,2.22,0,0,1,1.14-.32,2.26,2.26,0,0,1,1.13.28,2,2,0,0,1,.82.84A2.77,2.77,0,0,1,1118.36,168.52Zm-.84.19a3.58,3.58,0,0,0-.44-1.83,1.36,1.36,0,0,0-1.14-.7,1,1,0,0,0-.92.48,2.91,2.91,0,0,0-.35,1.58,3.53,3.53,0,0,0,.44,1.83,1.34,1.34,0,0,0,1.14.7,1,1,0,0,0,.92-.48A2.88,2.88,0,0,0,1117.52,168.71Zm-5.13-.19a2.54,2.54,0,0,1-.3,1.25,2.23,2.23,0,0,1-2,1.17,2.28,2.28,0,0,1-1.13-.28,2,2,0,0,1-.82-.83,2.93,2.93,0,0,1-.32-1.4,2.66,2.66,0,0,1,.31-1.25,2.28,2.28,0,0,1,.81-.85,2.23,2.23,0,0,1,1.15-.32,2.31,2.31,0,0,1,1.13.28,2.08,2.08,0,0,1,.82.84A2.89,2.89,0,0,1,1112.39,168.52Zm-.84.19a3.49,3.49,0,0,0-.44-1.83,1.33,1.33,0,0,0-1.14-.7,1,1,0,0,0-.92.48,3,3,0,0,0-.35,1.58,3.53,3.53,0,0,0,.44,1.83,1.34,1.34,0,0,0,1.15.7,1,1,0,0,0,.92-.48A3,3,0,0,0,1111.55,168.71Zm-4.53,2.11h-2.22v-.11l.2,0a.72.72,0,0,0,.35-.11.47.47,0,0,0,.15-.29,4.85,4.85,0,0,0,0-.63v-4.91a.81.81,0,0,0-.09-.49.66.66,0,0,0-.37-.24l-.28-.11v-.08l1.4-.33.09.06v6.1a5,5,0,0,0,0,.64.4.4,0,0,0,.16.28.76.76,0,0,0,.35.11l.2,0Zm-3.21-5.57h-.12l-.18-.3a1.7,1.7,0,0,0-.38-.49,1,1,0,0,0-.48-.23,3.84,3.84,0,0,0-.75-.06h-.19a6.26,6.26,0,0,0-.68,0,1.88,1.88,0,0,0-.43.09v2.92l.81,0a2.25,2.25,0,0,0,1-.15.65.65,0,0,0,.31-.56l0-.41h.14c0,.07,0,.18,0,.32s0,.3,0,.46v.45c0,.2,0,.41,0,.64s0,.41,0,.53h-.14l0-.28a1.08,1.08,0,0,0-.16-.47.62.62,0,0,0-.39-.22,3.56,3.56,0,0,0-.76-.07l-.81,0v2a3.66,3.66,0,0,0,.06.77.55.55,0,0,0,.22.37,1,1,0,0,0,.46.13l.39.05v.11h-2.88v-.11l.37-.05a.52.52,0,0,0,.47-.29,2.54,2.54,0,0,0,.11-1v-4a2.54,2.54,0,0,0-.11-1,.52.52,0,0,0-.47-.29l-.37-.05V164h4.67Z"
              />
              <path
                class="cls-5"
                d="M1397,162.66a2.86,2.86,0,0,1-.35,1.36,2.64,2.64,0,0,1-.92.93,2.4,2.4,0,0,1-1.27.35,2.45,2.45,0,0,1-1.31-.35,2.48,2.48,0,0,1-.94-1,3.72,3.72,0,0,1-.36-1.65,4.65,4.65,0,0,1,1-3,8,8,0,0,1,3.35-2.31l.08.17a7.1,7.1,0,0,0-2.19,1.45,3.76,3.76,0,0,0-1,1.63,6.09,6.09,0,0,0-.23,1.83,4.65,4.65,0,0,0,.47,2.28,1.41,1.41,0,0,0,1.27.76,1.2,1.2,0,0,0,1.08-.6,3.25,3.25,0,0,0,.35-1.62,3.94,3.94,0,0,0-.15-1.12,1.64,1.64,0,0,0-.49-.8,1.42,1.42,0,0,0-.93-.31,2.51,2.51,0,0,0-.67.08l0-.15a3.16,3.16,0,0,1,1-.18,2.16,2.16,0,0,1,1.62.61A2.26,2.26,0,0,1,1397,162.66Zm-7.19.21h-1.27v2.34h-.85v-2.34h-3.62l-.08-.11,4.13-5.59h.42v5.32h1.27Zm-2.12-.38v-4.31l-3.19,4.31Zm-44.47-5.55-.36,1.09H1340l-.65,1.43a5.63,5.63,0,0,1,2.61.8,2.13,2.13,0,0,1,.88,1.88,2.93,2.93,0,0,1-.51,1.68,3.38,3.38,0,0,1-1.23,1.09,3.11,3.11,0,0,1-1.48.38,1.22,1.22,0,0,1-.76-.19.56.56,0,0,1-.23-.42q0-.45.57-.48a1,1,0,0,1,.57.18,3.81,3.81,0,0,1,.61.53,2.72,2.72,0,0,0,1.39-.84,2.28,2.28,0,0,0,.55-1.52,1.73,1.73,0,0,0-.85-1.58,6.21,6.21,0,0,0-2.62-.69l-.09-.11,1.34-2.94h2a2.87,2.87,0,0,0,.65-.06.79.79,0,0,0,.43-.23Zm-6.47,5.93h-1.27v2.34h-.85v-2.34h-3.62l-.08-.11,4.13-5.59h.42v5.32h1.27Zm-2.12-.38v-4.31l-3.19,4.31Zm-44.58.38h-1.28v2.34H1288v-2.34h-3.62l-.08-.11,4.13-5.59h.41v5.32h1.28Zm-2.12-.38v-4.31l-3.19,4.31Zm-5.63.38h-1.27v2.34h-.84v-2.34h-3.62l-.08-.11,4.12-5.59h.42v5.32h1.27Zm-2.11-.38v-4.31l-3.2,4.31Zm-60.89-.19a2.69,2.69,0,0,1-.55,1.64,3.39,3.39,0,0,1-1.28,1,3.57,3.57,0,0,1-1.48.34,1.53,1.53,0,0,1-.82-.18.57.57,0,0,1-.28-.48.45.45,0,0,1,.15-.34.52.52,0,0,1,.34-.12,1,1,0,0,1,.59.19,2.64,2.64,0,0,1,.58.61,2.53,2.53,0,0,0,1-.31,2.21,2.21,0,0,0,.76-.73,2.17,2.17,0,0,0,.3-1.1,1.52,1.52,0,0,0-.47-1.19,1.86,1.86,0,0,0-1.24-.39,1.93,1.93,0,0,0-.55.07,3,3,0,0,0-.54.2l-.12-.2a11.82,11.82,0,0,0,1.65-1,2.88,2.88,0,0,0,.76-.8,1.39,1.39,0,0,0,.18-.73,1,1,0,0,0-.31-.75,1.46,1.46,0,0,0-1-.3,2.13,2.13,0,0,0-1,.25,3.54,3.54,0,0,0-.91.68l-.12-.13a4.49,4.49,0,0,1,1.25-1.09,2.62,2.62,0,0,1,1.3-.31,1.79,1.79,0,0,1,1.18.35,1.29,1.29,0,0,1,.44,1,1.61,1.61,0,0,1-.43,1.05,5.52,5.52,0,0,1-1.34,1.06,2.36,2.36,0,0,1,1.42.49A1.56,1.56,0,0,1,1219.34,162.3Zm-6.24.57h-1.28v2.34H1211v-2.34h-3.62l-.08-.11,4.13-5.59h.41v5.32h1.28Zm-2.12-.38v-4.31l-3.19,4.31Zm-44.52.54-.69,2.12h-4.34l-.08-.11,2.14-2.39a14.18,14.18,0,0,0,1-1.25,4.44,4.44,0,0,0,.55-1.05,3.1,3.1,0,0,0,.17-1,1.57,1.57,0,0,0-.42-1.14,1.65,1.65,0,0,0-1.19-.45,1.72,1.72,0,0,0-1.09.36,4.38,4.38,0,0,0-.92,1l-.14-.08a4.42,4.42,0,0,1,1.11-1.46,2.29,2.29,0,0,1,1.48-.53,2,2,0,0,1,1.42.52,1.9,1.9,0,0,1,.56,1.44,2.8,2.8,0,0,1-.22,1.1,4.86,4.86,0,0,1-.64,1c-.28.35-.62.74-1,1.17l-2,2.12h1.84a5.18,5.18,0,0,0,1-.08,1.22,1.22,0,0,0,.6-.3,2.81,2.81,0,0,0,.49-.65l.22-.39Zm-7.23-.16H1158v2.34h-.85v-2.34h-3.62l-.08-.11,4.13-5.59h.42v5.32h1.27Zm-2.12-.38v-4.31l-3.19,4.31Z"
              />
              <path
                class="cls-5"
                d="M1115,194.44a2.86,2.86,0,0,1-.35,1.36,2.56,2.56,0,0,1-.92.93,2.5,2.5,0,0,1-1.27.36,2.46,2.46,0,0,1-1.31-.36,2.55,2.55,0,0,1-.94-1,3.59,3.59,0,0,1-.35-1.65,4.58,4.58,0,0,1,1-3,8,8,0,0,1,3.35-2.31l.08.17a7.1,7.1,0,0,0-2.19,1.45,3.76,3.76,0,0,0-1,1.63,6.11,6.11,0,0,0-.23,1.84,4.61,4.61,0,0,0,.47,2.27,1.42,1.42,0,0,0,1.27.76,1.2,1.2,0,0,0,1.08-.6,3.25,3.25,0,0,0,.35-1.62,4.35,4.35,0,0,0-.14-1.12,1.59,1.59,0,0,0-.5-.79,1.38,1.38,0,0,0-.93-.32,2.56,2.56,0,0,0-.67.08l0-.15a3.16,3.16,0,0,1,1-.18,2.19,2.19,0,0,1,1.62.61A2.26,2.26,0,0,1,1115,194.44Zm-7.19-5.72-.36,1.09h-2.92l-.65,1.43a5.63,5.63,0,0,1,2.61.8,2.13,2.13,0,0,1,.88,1.88,3,3,0,0,1-.51,1.68,3.38,3.38,0,0,1-1.23,1.09,3.11,3.11,0,0,1-1.48.38,1.22,1.22,0,0,1-.76-.19.56.56,0,0,1-.23-.42q0-.45.57-.48a1,1,0,0,1,.57.18,4.3,4.3,0,0,1,.61.53,2.72,2.72,0,0,0,1.39-.84,2.28,2.28,0,0,0,.55-1.52,1.73,1.73,0,0,0-.85-1.58,6.26,6.26,0,0,0-2.62-.69l-.09-.11,1.34-2.94h2a2.93,2.93,0,0,0,.65-.06.79.79,0,0,0,.43-.23Z"
              />
              <path
                class="cls-5"
                d="M1114.84,215.4l-.36,1.08h-2.93l-.64,1.43a5.62,5.62,0,0,1,2.6.8,2.16,2.16,0,0,1,.89,1.89,3.06,3.06,0,0,1-.52,1.68,3.24,3.24,0,0,1-1.22,1.08,3.16,3.16,0,0,1-1.49.39,1.27,1.27,0,0,1-.75-.2.51.51,0,0,1-.23-.42c0-.3.2-.46.57-.47a1,1,0,0,1,.57.18,4.14,4.14,0,0,1,.61.52,2.59,2.59,0,0,0,1.39-.84,2.28,2.28,0,0,0,.55-1.52,1.75,1.75,0,0,0-.85-1.58,6.26,6.26,0,0,0-2.62-.69l-.09-.1,1.34-2.94h2a2.93,2.93,0,0,0,.65-.06.86.86,0,0,0,.42-.23Zm-6.48,0-.36,1.08h-2.92l-.65,1.43a5.63,5.63,0,0,1,2.61.8,2.15,2.15,0,0,1,.88,1.89,3,3,0,0,1-.51,1.68,3.35,3.35,0,0,1-1.23,1.08,3.12,3.12,0,0,1-1.48.39,1.28,1.28,0,0,1-.76-.2.52.52,0,0,1-.22-.42c0-.3.19-.46.56-.47a1,1,0,0,1,.57.18,3.32,3.32,0,0,1,.61.52,2.55,2.55,0,0,0,1.39-.84,2.23,2.23,0,0,0,.55-1.52,1.73,1.73,0,0,0-.85-1.58,6.2,6.2,0,0,0-2.61-.69l-.1-.1,1.34-2.94h2a2.84,2.84,0,0,0,.64-.06.9.9,0,0,0,.43-.23Z"
              />
              <path
                class="cls-5"
                d="M1115.07,241.79h-1.27v2.34H1113v-2.34h-3.62l-.08-.11,4.13-5.59h.42v5.32h1.27Zm-2.12-.38V237.1l-3.19,4.31Zm-5.4-5.55-.35,1.09h-2.93l-.65,1.42a5.74,5.74,0,0,1,2.61.81,2.13,2.13,0,0,1,.88,1.88,2.93,2.93,0,0,1-.51,1.68,3.47,3.47,0,0,1-1.23,1.09,3.19,3.19,0,0,1-1.48.38,1.22,1.22,0,0,1-.76-.2.52.52,0,0,1-.22-.41c0-.3.19-.46.56-.48a1.07,1.07,0,0,1,.58.18,3.79,3.79,0,0,1,.6.53,2.75,2.75,0,0,0,1.4-.84,2.28,2.28,0,0,0,.54-1.52,1.72,1.72,0,0,0-.85-1.58,5.88,5.88,0,0,0-2.61-.69l-.1-.11,1.34-2.94h2a2.84,2.84,0,0,0,.64-.06.82.82,0,0,0,.43-.23Z"
              />
              <path
                class="cls-5"
                d="M1114.33,261.42a2.69,2.69,0,0,1-.55,1.64,3.49,3.49,0,0,1-1.28,1,3.57,3.57,0,0,1-1.48.34,1.44,1.44,0,0,1-.82-.19.56.56,0,0,1-.28-.47.5.5,0,0,1,.15-.35.58.58,0,0,1,.34-.11,1,1,0,0,1,.59.19,2.64,2.64,0,0,1,.58.61,2.55,2.55,0,0,0,1-.32,2.12,2.12,0,0,0,.76-.73,2.15,2.15,0,0,0,.3-1.1,1.5,1.5,0,0,0-.47-1.18,1.87,1.87,0,0,0-1.25-.39,1.9,1.9,0,0,0-.54.07,2.9,2.9,0,0,0-.54.19l-.12-.19a12.72,12.72,0,0,0,1.65-1,2.87,2.87,0,0,0,.76-.79,1.39,1.39,0,0,0,.18-.73.93.93,0,0,0-.32-.75,1.31,1.31,0,0,0-.94-.3,2.24,2.24,0,0,0-1,.24,4.07,4.07,0,0,0-.91.68l-.12-.13a4.44,4.44,0,0,1,1.25-1.08,2.75,2.75,0,0,1,1.3-.32,1.79,1.79,0,0,1,1.18.36,1.24,1.24,0,0,1,.43,1,1.64,1.64,0,0,1-.42,1,6,6,0,0,1-1.34,1.06,2.39,2.39,0,0,1,1.42.49A1.56,1.56,0,0,1,1114.33,261.42Zm-6.24-5.36-.36,1.09h-2.93l-.64,1.42a5.62,5.62,0,0,1,2.6.81,2.14,2.14,0,0,1,.89,1.88,3,3,0,0,1-.52,1.68,3.44,3.44,0,0,1-1.22,1.09,3.26,3.26,0,0,1-1.49.38,1.24,1.24,0,0,1-.76-.2.52.52,0,0,1-.22-.41c0-.31.19-.46.56-.48a1,1,0,0,1,.58.18,3.79,3.79,0,0,1,.6.53,2.75,2.75,0,0,0,1.4-.84,2.28,2.28,0,0,0,.55-1.52,1.77,1.77,0,0,0-.85-1.59,6.12,6.12,0,0,0-2.62-.68l-.09-.11,1.34-2.94h2a2.93,2.93,0,0,0,.65-.06.83.83,0,0,0,.42-.23Z"
              />
              <path
                class="cls-5"
                d="M1114.71,282.63l-.69,2.12h-4.34l-.08-.12,2.14-2.38a15.78,15.78,0,0,0,1-1.26,4.67,4.67,0,0,0,.56-1,3.2,3.2,0,0,0,.16-1,1.48,1.48,0,0,0-1.6-1.58,1.77,1.77,0,0,0-1.1.36,4.17,4.17,0,0,0-.91,1l-.14-.08a4.32,4.32,0,0,1,1.1-1.47,2.31,2.31,0,0,1,1.49-.52,2,2,0,0,1,1.42.51,1.89,1.89,0,0,1,.55,1.44,2.64,2.64,0,0,1-.22,1.1,4.42,4.42,0,0,1-.63,1c-.28.35-.62.74-1,1.17l-2,2.12h1.83a5.17,5.17,0,0,0,1-.07,1.19,1.19,0,0,0,.61-.31,2.6,2.6,0,0,0,.48-.65l.22-.38Zm-6.89-6.09-.36,1.08h-2.92l-.65,1.43a5.63,5.63,0,0,1,2.61.8,2.15,2.15,0,0,1,.88,1.89,3.06,3.06,0,0,1-.51,1.68,3.35,3.35,0,0,1-1.23,1.08,3.12,3.12,0,0,1-1.48.39,1.28,1.28,0,0,1-.76-.2.53.53,0,0,1-.23-.42c0-.3.2-.46.57-.47a1,1,0,0,1,.57.18,4.14,4.14,0,0,1,.61.52,2.59,2.59,0,0,0,1.39-.84,2.28,2.28,0,0,0,.55-1.52,1.73,1.73,0,0,0-.85-1.58,6.26,6.26,0,0,0-2.62-.69l-.09-.1,1.34-2.94h2a2.93,2.93,0,0,0,.65-.06.94.94,0,0,0,.43-.23Z"
              />
              <path
                class="cls-5"
                d="M1114.36,305.22H1111v-.12l.45-.06a1.23,1.23,0,0,0,.54-.16.64.64,0,0,0,.26-.43,4,4,0,0,0,.07-.89v-4.44a3.66,3.66,0,0,0-.07-.86.54.54,0,0,0-.3-.38,1.61,1.61,0,0,0-.64-.08H1111v-.13a8.91,8.91,0,0,0,1.12-.23q.57-.17,1-.33l.1.05v6.4a4,4,0,0,0,.07.89.67.67,0,0,0,.25.43,1,1,0,0,0,.49.16l.39.06Zm-5.73-8.22-.36,1.09h-2.92l-.65,1.42a5.74,5.74,0,0,1,2.61.81,2.16,2.16,0,0,1,.88,1.88,3.09,3.09,0,0,1-.51,1.68,3.47,3.47,0,0,1-1.23,1.09,3.23,3.23,0,0,1-1.49.38,1.2,1.2,0,0,1-.75-.2.53.53,0,0,1-.23-.41q0-.45.57-.48a1,1,0,0,1,.57.18,4.3,4.3,0,0,1,.61.53,2.72,2.72,0,0,0,1.39-.84,2.28,2.28,0,0,0,.55-1.52,1.72,1.72,0,0,0-.85-1.58,6,6,0,0,0-2.62-.69l-.09-.11,1.34-2.94h2a2.93,2.93,0,0,0,.65-.06.86.86,0,0,0,.43-.23Z"
              />
              <path
                class="cls-5"
                d="M1115.08,321.45a6.52,6.52,0,0,1-.32,2.1,3.54,3.54,0,0,1-.93,1.46,2.18,2.18,0,0,1-1.46.55,2.25,2.25,0,0,1-1.52-.55,3.29,3.29,0,0,1-.89-1.47,7,7,0,0,1-.29-2.09,6.52,6.52,0,0,1,.32-2.1,3.54,3.54,0,0,1,.93-1.46,2.18,2.18,0,0,1,1.45-.55,2.25,2.25,0,0,1,1.53.55,3.29,3.29,0,0,1,.89,1.47A7,7,0,0,1,1115.08,321.45Zm-1,.23a8.32,8.32,0,0,0-.42-3.06,1.49,1.49,0,0,0-1.37-1.1,1.31,1.31,0,0,0-1.2,1,7.75,7.75,0,0,0-.38,2.75,8.32,8.32,0,0,0,.42,3.06,1.48,1.48,0,0,0,1.37,1.1,1.29,1.29,0,0,0,1.19-.95A7.49,7.49,0,0,0,1114.06,321.68Zm-6.51-4.48-.35,1.09h-2.93l-.65,1.42a5.62,5.62,0,0,1,2.61.81,2.13,2.13,0,0,1,.88,1.88,2.93,2.93,0,0,1-.51,1.68,3.47,3.47,0,0,1-1.23,1.09,3.19,3.19,0,0,1-1.48.38,1.22,1.22,0,0,1-.76-.2.52.52,0,0,1-.22-.41c0-.3.19-.46.56-.48a1.07,1.07,0,0,1,.58.18,3.79,3.79,0,0,1,.6.53,2.75,2.75,0,0,0,1.4-.84,2.28,2.28,0,0,0,.54-1.52,1.75,1.75,0,0,0-.85-1.59,6,6,0,0,0-2.61-.68l-.1-.11,1.34-2.94h2a2.84,2.84,0,0,0,.64-.06.82.82,0,0,0,.43-.23Z"
              />
              <path
                class="cls-5"
                d="M1115.39,340.85a4.58,4.58,0,0,1-1,3,8,8,0,0,1-3.36,2.31L1111,346a7,7,0,0,0,2.2-1.45,4,4,0,0,0,1-1.63,6.11,6.11,0,0,0,.22-1.84,4.51,4.51,0,0,0-.46-2.27,1.42,1.42,0,0,0-1.27-.76,1.21,1.21,0,0,0-1.09.6,3.25,3.25,0,0,0-.34,1.62,4,4,0,0,0,.14,1.12,1.72,1.72,0,0,0,.49.8,1.45,1.45,0,0,0,.94.31,4,4,0,0,0,.67-.08l0,.15a3.21,3.21,0,0,1-1,.18,2.17,2.17,0,0,1-1.63-.61,2.26,2.26,0,0,1-.59-1.63,2.75,2.75,0,0,1,.35-1.36,2.62,2.62,0,0,1,.91-.93,2.44,2.44,0,0,1,1.28-.35,2.42,2.42,0,0,1,2.24,1.38A3.72,3.72,0,0,1,1115.39,340.85Zm-7.07,2.76h-1.27V346h-.85v-2.34h-3.62l-.08-.12,4.13-5.58h.42v5.31h1.27Zm-2.12-.39v-4.3l-3.19,4.3Z"
              />
              <path
                class="cls-5"
                d="M1115.26,364.36a1.9,1.9,0,0,1-.35,1.13,2.42,2.42,0,0,1-.92.75,3.11,3.11,0,0,1-1.28.26,3,3,0,0,1-1.17-.22,2.13,2.13,0,0,1-.89-.65,1.61,1.61,0,0,1-.36-1,2,2,0,0,1,.45-1.31,4,4,0,0,1,1.37-1,2.82,2.82,0,0,1-1.16-.83,2.13,2.13,0,0,1-.43-1.3,1.76,1.76,0,0,1,.65-1.35,2.61,2.61,0,0,1,1.69-.57,2.5,2.5,0,0,1,1.55.51A1.55,1.55,0,0,1,1115,360a1.68,1.68,0,0,1-.44,1.14,3.47,3.47,0,0,1-1.19.85,3.9,3.9,0,0,1,1.43,1A2,2,0,0,1,1115.26,364.36Zm-1.07-4.19a1.87,1.87,0,0,0-.38-1.24,1.45,1.45,0,0,0-1.16-.46,1.31,1.31,0,0,0-1,.42,1.54,1.54,0,0,0-.39,1.05,1.39,1.39,0,0,0,.44,1.07,5,5,0,0,0,1.54.91,2.21,2.21,0,0,0,.73-.69A2,2,0,0,0,1114.19,360.17Zm.35,4.45a1.55,1.55,0,0,0-.47-1.19,6,6,0,0,0-1.75-1,2.36,2.36,0,0,0-.88.87,2.48,2.48,0,0,0-.24,1.2,1.93,1.93,0,0,0,.46,1.36,1.65,1.65,0,0,0,1.25.48,1.6,1.6,0,0,0,1.18-.47A1.75,1.75,0,0,0,1114.54,364.62Zm-6.22-.55h-1.27v2.34h-.85v-2.34h-3.62l-.08-.11,4.13-5.59h.42v5.32h1.27Zm-2.12-.38v-4.31l-3.19,4.31Z"
              />
              <path
                class="cls-5"
                d="M1115.35,379l-1.65,3.29c-.55,1.11-1,2-1.34,2.75s-.59,1.29-.76,1.7a.33.33,0,0,1-.2.2.48.48,0,0,1-.24-.07.17.17,0,0,1-.1-.15.48.48,0,0,1,.09-.25c.25-.39.57-.94.95-1.63s.83-1.59,1.37-2.68l1.27-2.56h-2.57a3.56,3.56,0,0,0-.73.06.94.94,0,0,0-.44.19,1.49,1.49,0,0,0-.34.44l-.22.38h-.11l.66-2h.07a.58.58,0,0,0,.25.15,1.75,1.75,0,0,0,.53.07h3.44Zm-6.76,5.54h-1.27v2.34h-.84v-2.34h-3.62l-.08-.12,4.13-5.58h.41v5.32h1.27Zm-2.11-.38v-4.31l-3.19,4.31Z"
              />
              <path
                class="cls-5"
                d="M1115.51,404.54a2.72,2.72,0,0,1-.36,1.35,2.49,2.49,0,0,1-.91.94,2.64,2.64,0,0,1-1.28.35,2.53,2.53,0,0,1-1.3-.35,2.44,2.44,0,0,1-.94-1,3.72,3.72,0,0,1-.36-1.65,4.69,4.69,0,0,1,1-3,8,8,0,0,1,3.35-2.31l.08.18a7.47,7.47,0,0,0-2.2,1.44,3.89,3.89,0,0,0-1,1.63,5.85,5.85,0,0,0-.23,1.84,4.5,4.5,0,0,0,.47,2.27,1.39,1.39,0,0,0,1.26.76,1.18,1.18,0,0,0,1.09-.6,3.19,3.19,0,0,0,.35-1.62,3.82,3.82,0,0,0-.15-1.11,1.6,1.6,0,0,0-.49-.8,1.37,1.37,0,0,0-.93-.31,2.27,2.27,0,0,0-.68.08l0-.15a3.38,3.38,0,0,1,1-.19,2.2,2.2,0,0,1,1.62.61A2.29,2.29,0,0,1,1115.51,404.54Zm-7.19.21h-1.27v2.34h-.85v-2.34h-3.62l-.08-.12,4.13-5.58h.42v5.31h1.27Zm-2.12-.39v-4.3l-3.19,4.3Z"
              />
              <path
                class="cls-5"
                d="M1115.33,419.28l-.35,1.09h-2.93l-.65,1.42a5.74,5.74,0,0,1,2.61.81,2.13,2.13,0,0,1,.88,1.88,2.93,2.93,0,0,1-.51,1.68,3.38,3.38,0,0,1-1.23,1.09,3.19,3.19,0,0,1-1.48.38,1.29,1.29,0,0,1-.76-.19.55.55,0,0,1-.22-.42c0-.3.19-.46.56-.48a1.07,1.07,0,0,1,.58.18,3.79,3.79,0,0,1,.6.53,2.75,2.75,0,0,0,1.4-.84,2.28,2.28,0,0,0,.54-1.52,1.72,1.72,0,0,0-.85-1.58,6,6,0,0,0-2.61-.69l-.1-.11,1.34-2.94h2a2.84,2.84,0,0,0,.64-.06.82.82,0,0,0,.43-.23Zm-6.47,5.93h-1.27v2.34h-.85v-2.34h-3.61l-.08-.11,4.12-5.59h.42v5.32h1.27Zm-2.12-.38v-4.31l-3.19,4.31Z"
              />
              <path
                class="cls-5"
                d="M1115.91,445.69h-1.27V448h-.84v-2.34h-3.62l-.08-.12,4.12-5.58h.42v5.32h1.27Zm-2.11-.38V441l-3.19,4.31Zm-5.75.38h-1.27V448h-.84v-2.34h-3.62l-.08-.12,4.12-5.58h.42v5.32h1.27Zm-2.11-.38V441l-3.2,4.31Z"
              />
              <path
                class="cls-5"
                d="M1114.84,465.32a2.72,2.72,0,0,1-.55,1.64,3.44,3.44,0,0,1-1.29,1,3.65,3.65,0,0,1-1.47.34,1.42,1.42,0,0,1-.82-.19.54.54,0,0,1-.28-.47.48.48,0,0,1,.15-.35.5.5,0,0,1,.34-.12,1.09,1.09,0,0,1,.59.19,2.87,2.87,0,0,1,.58.61,2.43,2.43,0,0,0,1-.31,2.1,2.1,0,0,0,.75-.73,2,2,0,0,0,.3-1.1,1.5,1.5,0,0,0-.46-1.19,1.87,1.87,0,0,0-1.25-.38,2.51,2.51,0,0,0-.55.06,4.36,4.36,0,0,0-.53.2l-.12-.2a12.46,12.46,0,0,0,1.65-1,3,3,0,0,0,.76-.79,1.41,1.41,0,0,0,.18-.73,1,1,0,0,0-.32-.76,1.41,1.41,0,0,0-.94-.3,2.32,2.32,0,0,0-1,.25,4,4,0,0,0-.9.68l-.12-.13a4.3,4.3,0,0,1,1.25-1.08,2.62,2.62,0,0,1,1.29-.32,1.8,1.8,0,0,1,1.18.35,1.25,1.25,0,0,1,.44,1,1.64,1.64,0,0,1-.42,1.05,6.14,6.14,0,0,1-1.35,1.06,2.33,2.33,0,0,1,1.43.49A1.55,1.55,0,0,1,1114.84,465.32Zm-6.25.57h-1.27v2.34h-.84v-2.34h-3.62l-.08-.12,4.13-5.58h.41v5.31h1.27Zm-2.11-.39v-4.3l-3.19,4.3Z"
              />
              <path
                class="cls-5"
                d="M1115.55,486.51l-.69,2.12h-4.34l-.08-.11,2.14-2.39a12.84,12.84,0,0,0,1-1.26,4.21,4.21,0,0,0,.55-1,3.15,3.15,0,0,0,.17-1,1.57,1.57,0,0,0-.42-1.14,1.65,1.65,0,0,0-1.19-.45,1.72,1.72,0,0,0-1.09.36,4.38,4.38,0,0,0-.92,1l-.14-.08a4.29,4.29,0,0,1,1.11-1.46,2.27,2.27,0,0,1,1.48-.53,2,2,0,0,1,1.42.52,1.9,1.9,0,0,1,.56,1.44,2.8,2.8,0,0,1-.22,1.1,4.86,4.86,0,0,1-.64,1c-.28.34-.62.73-1,1.17l-2,2.12h1.84a5.18,5.18,0,0,0,1-.08,1.22,1.22,0,0,0,.6-.3,2.81,2.81,0,0,0,.49-.65l.22-.39Zm-7.23-.16h-1.27v2.34h-.85v-2.34h-3.62l-.08-.11,4.13-5.59h.42V486h1.27Zm-2.12-.38v-4.31L1103,486Z"
              />
              <path
                class="cls-5"
                d="M1114.56,509.12h-.43l-.64,0h-1.17l-.71,0h-.46V509l.45-.05a1.38,1.38,0,0,0,.54-.16.68.68,0,0,0,.26-.43,4.78,4.78,0,0,0,.07-.9V503a3.65,3.65,0,0,0-.08-.87.53.53,0,0,0-.29-.37,1.61,1.61,0,0,0-.64-.08h-.31v-.13a7.74,7.74,0,0,0,1.12-.24,6.57,6.57,0,0,0,1-.33l.11.06v6.39a4.06,4.06,0,0,0,.07.9.66.66,0,0,0,.24.43,1.23,1.23,0,0,0,.5.16l.39.05Zm-5.16-2.29h-1.27v2.34h-.84v-2.34h-3.62l-.08-.12,4.13-5.58h.41v5.32h1.27Zm-2.11-.38v-4.31l-3.19,4.31Z"
              />
              <path
                class="cls-5"
                d="M1115.58,525.35a6.15,6.15,0,0,1-.33,2.09,3.32,3.32,0,0,1-.93,1.47,2.16,2.16,0,0,1-1.45.55,2.21,2.21,0,0,1-1.52-.56,3.12,3.12,0,0,1-.89-1.46,6.77,6.77,0,0,1-.29-2.09,6.26,6.26,0,0,1,.32-2.1,3.47,3.47,0,0,1,.93-1.46,2.13,2.13,0,0,1,1.45-.55,2.21,2.21,0,0,1,1.53.55,3.27,3.27,0,0,1,.89,1.47A7,7,0,0,1,1115.58,525.35Zm-1,.23a8.32,8.32,0,0,0-.42-3.06,1.48,1.48,0,0,0-1.37-1.1,1.31,1.31,0,0,0-1.2,1,7.49,7.49,0,0,0-.39,2.75,8.5,8.5,0,0,0,.43,3.06,1.45,1.45,0,0,0,1.37,1.09,1.29,1.29,0,0,0,1.19-.95A7.44,7.44,0,0,0,1114.56,525.58Zm-6.51,1.45h-1.27v2.34h-.84V527h-3.62l-.08-.12,4.12-5.58h.42v5.31h1.27Zm-2.11-.39v-4.3l-3.2,4.3Z"
              />
              <path
                class="cls-5"
                d="M1114.86,544.74a4.68,4.68,0,0,1-1,3,8,8,0,0,1-3.36,2.31l-.08-.18a7.34,7.34,0,0,0,2.2-1.44,4,4,0,0,0,1-1.63,6.15,6.15,0,0,0,.22-1.84,4.57,4.57,0,0,0-.47-2.28,1.4,1.4,0,0,0-1.26-.75,1.17,1.17,0,0,0-1.09.6,3.19,3.19,0,0,0-.35,1.62,3.82,3.82,0,0,0,.15,1.11,1.67,1.67,0,0,0,.49.8,1.38,1.38,0,0,0,.94.31,2.62,2.62,0,0,0,.67-.08l0,.15a3.37,3.37,0,0,1-1,.19,2.21,2.21,0,0,1-1.63-.61,2.24,2.24,0,0,1-.59-1.64,2.61,2.61,0,0,1,.35-1.35,2.57,2.57,0,0,1,.91-.94,2.64,2.64,0,0,1,1.28-.35,2.57,2.57,0,0,1,1.31.35,2.49,2.49,0,0,1,.93,1A3.72,3.72,0,0,1,1114.86,544.74Zm-7.54,2.18a2.63,2.63,0,0,1-.55,1.64,3.31,3.31,0,0,1-1.28,1,3.53,3.53,0,0,1-1.47.34,1.49,1.49,0,0,1-.82-.18.55.55,0,0,1-.28-.48.5.5,0,0,1,.15-.35.52.52,0,0,1,.33-.11,1,1,0,0,1,.59.19,2.45,2.45,0,0,1,.58.61,2.53,2.53,0,0,0,1-.31,2.21,2.21,0,0,0,.76-.73,2.17,2.17,0,0,0,.3-1.1,1.49,1.49,0,0,0-.47-1.19,1.84,1.84,0,0,0-1.24-.39,2,2,0,0,0-.55.07,3.62,3.62,0,0,0-.54.2l-.11-.2a12.12,12.12,0,0,0,1.64-1,2.61,2.61,0,0,0,.76-.79,1.5,1.5,0,0,0,.19-.73,1,1,0,0,0-.32-.75,1.43,1.43,0,0,0-.94-.3,2.14,2.14,0,0,0-1,.25,4.16,4.16,0,0,0-.91.67l-.11-.12a4.23,4.23,0,0,1,1.25-1.09,2.56,2.56,0,0,1,1.29-.31,1.79,1.79,0,0,1,1.18.35,1.25,1.25,0,0,1,.44,1,1.58,1.58,0,0,1-.43,1,5.33,5.33,0,0,1-1.34,1.06,2.36,2.36,0,0,1,1.42.49A1.56,1.56,0,0,1,1107.32,546.92Z"
              />
              <path
                class="cls-5"
                d="M1115,568.26a2,2,0,0,1-.36,1.13,2.24,2.24,0,0,1-.92.74,3,3,0,0,1-1.28.27,2.91,2.91,0,0,1-1.17-.23,2.17,2.17,0,0,1-.89-.64,1.63,1.63,0,0,1-.35-1,2,2,0,0,1,.44-1.31,4.12,4.12,0,0,1,1.37-1,2.9,2.9,0,0,1-1.15-.83,2.07,2.07,0,0,1-.43-1.3,1.72,1.72,0,0,1,.65-1.35,2.51,2.51,0,0,1,1.68-.57,2.43,2.43,0,0,1,1.56.51,1.58,1.58,0,0,1,.62,1.22,1.79,1.79,0,0,1-.44,1.15,3.71,3.71,0,0,1-1.19.85,3.63,3.63,0,0,1,1.42,1A2,2,0,0,1,1115,568.26Zm-1.08-4.19a1.82,1.82,0,0,0-.38-1.24,1.46,1.46,0,0,0-1.15-.47,1.38,1.38,0,0,0-1.05.43,1.53,1.53,0,0,0-.39,1,1.4,1.4,0,0,0,.44,1.08,5,5,0,0,0,1.54.9,2,2,0,0,0,.73-.68A1.87,1.87,0,0,0,1113.92,564.07Zm.35,4.44a1.51,1.51,0,0,0-.47-1.18,6,6,0,0,0-1.75-1,2.36,2.36,0,0,0-.88.87,2.44,2.44,0,0,0-.24,1.19,1.91,1.91,0,0,0,.47,1.36,1.6,1.6,0,0,0,1.24.49,1.63,1.63,0,0,0,1.18-.47A1.75,1.75,0,0,0,1114.27,568.51Zm-6.68-1.11A2.69,2.69,0,0,1,1107,569a3.49,3.49,0,0,1-1.28,1,3.57,3.57,0,0,1-1.48.34,1.44,1.44,0,0,1-.82-.19.56.56,0,0,1-.28-.47.48.48,0,0,1,.15-.35.51.51,0,0,1,.34-.11,1,1,0,0,1,.59.19,2.57,2.57,0,0,1,.58.6,2.38,2.38,0,0,0,1-.31,2.21,2.21,0,0,0,.76-.73,2.15,2.15,0,0,0,.3-1.1,1.54,1.54,0,0,0-.47-1.19,2.21,2.21,0,0,0-1.79-.31,2.9,2.9,0,0,0-.54.19l-.12-.19a12.72,12.72,0,0,0,1.65-1,2.87,2.87,0,0,0,.76-.79,1.39,1.39,0,0,0,.18-.73.93.93,0,0,0-.32-.75,1.36,1.36,0,0,0-.94-.31,2.25,2.25,0,0,0-1,.25,4.07,4.07,0,0,0-.91.68l-.12-.13a4.44,4.44,0,0,1,1.25-1.08,2.63,2.63,0,0,1,1.3-.32,1.79,1.79,0,0,1,1.18.36,1.28,1.28,0,0,1,.44,1,1.65,1.65,0,0,1-.43,1,5.77,5.77,0,0,1-1.34,1.06,2.36,2.36,0,0,1,1.42.49A1.56,1.56,0,0,1,1107.59,567.4Z"
              />
              <path
                class="cls-5"
                d="M1115.07,582.9l-1.64,3.29c-.56,1.1-1,2-1.34,2.74s-.6,1.29-.77,1.7c0,.12-.12.19-.19.2a.49.49,0,0,1-.25-.06.19.19,0,0,1-.1-.16.45.45,0,0,1,.09-.24c.26-.4.57-.94,1-1.64s.84-1.58,1.37-2.67l1.28-2.56h-2.58a4.48,4.48,0,0,0-.72,0,1,1,0,0,0-.45.2,1.56,1.56,0,0,0-.33.43l-.22.39h-.12l.66-2h.07a.72.72,0,0,0,.25.16,2.31,2.31,0,0,0,.53.06H1115Zm-7.22,5a2.62,2.62,0,0,1-.54,1.63,3.42,3.42,0,0,1-1.29,1,3.49,3.49,0,0,1-1.47.34,1.51,1.51,0,0,1-.82-.18.54.54,0,0,1-.28-.48.45.45,0,0,1,.15-.34.49.49,0,0,1,.34-.12,1,1,0,0,1,.59.19,2.63,2.63,0,0,1,.57.61,2.48,2.48,0,0,0,1-.31,2,2,0,0,0,.76-.73,2.17,2.17,0,0,0,.3-1.1,1.49,1.49,0,0,0-.47-1.19,1.82,1.82,0,0,0-1.24-.39,2.51,2.51,0,0,0-.55.07,3.62,3.62,0,0,0-.54.2l-.11-.2a13.17,13.17,0,0,0,1.65-1,2.82,2.82,0,0,0,.75-.8,1.4,1.4,0,0,0,.19-.73,1,1,0,0,0-.32-.75,1.43,1.43,0,0,0-.94-.3,2.14,2.14,0,0,0-1,.25,3.92,3.92,0,0,0-.91.68l-.11-.13a4.3,4.3,0,0,1,1.25-1.08,2.6,2.6,0,0,1,1.29-.32,1.82,1.82,0,0,1,1.18.35,1.26,1.26,0,0,1,.44,1,1.56,1.56,0,0,1-.43,1.05,5.33,5.33,0,0,1-1.34,1.06,2.34,2.34,0,0,1,1.42.49A1.53,1.53,0,0,1,1107.85,587.87Z"
              />
              <path
                class="cls-5"
                d="M1115.24,614.35a2.78,2.78,0,0,1-.35,1.36,2.62,2.62,0,0,1-.91.93,2.47,2.47,0,0,1-3.52-1,3.47,3.47,0,0,1-.36-1.65,4.63,4.63,0,0,1,1-3,8.11,8.11,0,0,1,3.35-2.3l.08.17a7.1,7.1,0,0,0-2.19,1.45,3.86,3.86,0,0,0-1,1.63,6.09,6.09,0,0,0-.23,1.83,4.65,4.65,0,0,0,.47,2.28,1.42,1.42,0,0,0,1.27.76,1.2,1.2,0,0,0,1.08-.6,3.14,3.14,0,0,0,.35-1.62,4.35,4.35,0,0,0-.14-1.12,1.67,1.67,0,0,0-.49-.8,1.47,1.47,0,0,0-.94-.31,2.56,2.56,0,0,0-.67.08l0-.15a3.21,3.21,0,0,1,1-.18,2.21,2.21,0,0,1,1.63.6A2.3,2.3,0,0,1,1115.24,614.35Zm-7.65-.36a2.69,2.69,0,0,1-.55,1.64,3.39,3.39,0,0,1-1.28,1,3.57,3.57,0,0,1-1.48.34,1.53,1.53,0,0,1-.82-.18.57.57,0,0,1-.28-.48.5.5,0,0,1,.15-.35.58.58,0,0,1,.34-.11,1,1,0,0,1,.59.19,2.64,2.64,0,0,1,.58.61,2.53,2.53,0,0,0,1-.31,2.31,2.31,0,0,0,.76-.73,2.17,2.17,0,0,0,.3-1.1,1.52,1.52,0,0,0-.47-1.19,1.86,1.86,0,0,0-1.24-.39,1.93,1.93,0,0,0-.55.07,3,3,0,0,0-.54.2l-.12-.2a12.86,12.86,0,0,0,1.65-1,2.88,2.88,0,0,0,.76-.8,1.39,1.39,0,0,0,.18-.73.93.93,0,0,0-.32-.75,1.41,1.41,0,0,0-.94-.3,2.13,2.13,0,0,0-1,.25,3.74,3.74,0,0,0-.91.67l-.12-.12a4.49,4.49,0,0,1,1.25-1.09,2.62,2.62,0,0,1,1.3-.31,1.79,1.79,0,0,1,1.18.35,1.28,1.28,0,0,1,.44,1,1.63,1.63,0,0,1-.43,1.05,5.52,5.52,0,0,1-1.34,1.06,2.36,2.36,0,0,1,1.42.49A1.56,1.56,0,0,1,1107.59,614Z"
              />
              <path
                class="cls-5"
                d="M1297.19,616.13a3.1,3.1,0,0,1-.55.39,1.38,1.38,0,0,1-.65.15c-.66,0-1-.35-1-1v-3.33h-.7v-.08l.71-.25.61-1.49h.13V612h1.36v.34h-1.36v3.21c0,.52.22.78.66.79a.87.87,0,0,0,.37-.07,1.31,1.31,0,0,0,.34-.19Zm-3.65-3.93a.74.74,0,0,1-.13.44.31.31,0,0,1-.25.15.72.72,0,0,1-.31-.1,5.25,5.25,0,0,1-.52-.35,4.94,4.94,0,0,0-.42.27,2.36,2.36,0,0,0-.36.34v2.46a3.39,3.39,0,0,0,0,.64.4.4,0,0,0,.2.29,1.4,1.4,0,0,0,.46.11l.26,0v.11h-2.44v-.11l.2,0a.85.85,0,0,0,.35-.11.47.47,0,0,0,.15-.29,5.14,5.14,0,0,0,0-.64v-2.35a.84.84,0,0,0-.09-.5.66.66,0,0,0-.37-.24l-.28-.11v-.08l1.4-.33.09.06v.83a3.86,3.86,0,0,1,.78-.7,1.34,1.34,0,0,1,.68-.21.69.69,0,0,1,.38.1A.37.37,0,0,1,1293.54,612.2Zm-4,4.39c-.57,0-1.07,0-1.48,0v-.71a4.42,4.42,0,0,1-.76.57,1.69,1.69,0,0,1-.84.21c-.92,0-1.38-.48-1.4-1.49v-2.14a.84.84,0,0,0-.09-.5.67.67,0,0,0-.36-.24l-.29-.11v-.08l1.4-.33.09.06v3.23a1.36,1.36,0,0,0,.25.9.9.9,0,0,0,.7.29,1.47,1.47,0,0,0,.7-.16,2.49,2.49,0,0,0,.6-.42v-2.64a1,1,0,0,0-.09-.5.7.7,0,0,0-.37-.24l-.29-.11v-.08l1.4-.33.09.06v3.55a3.39,3.39,0,0,0,0,.64.39.39,0,0,0,.15.29.8.8,0,0,0,.34.11l.21,0Zm-5.75-2.3a2.69,2.69,0,0,1-.31,1.25,2.28,2.28,0,0,1-.81.85,2.33,2.33,0,0,1-1.15.32,2.39,2.39,0,0,1-1.13-.28,2.14,2.14,0,0,1-.82-.84,3,3,0,0,1-.32-1.39,2.52,2.52,0,0,1,.32-1.25,2.24,2.24,0,0,1,.81-.86,2.32,2.32,0,0,1,1.14-.32,2.39,2.39,0,0,1,1.13.28,2.07,2.07,0,0,1,.82.84A2.93,2.93,0,0,1,1283.74,614.29Zm-.85.19a3.44,3.44,0,0,0-.43-1.83,1.37,1.37,0,0,0-1.15-.71,1,1,0,0,0-.92.49,3,3,0,0,0-.34,1.58,3.49,3.49,0,0,0,.44,1.83,1.33,1.33,0,0,0,1.14.7,1,1,0,0,0,.92-.49A2.86,2.86,0,0,0,1282.89,614.48Zm-4.78.32-.24,1.4a3.84,3.84,0,0,1-1,.37,5.68,5.68,0,0,1-1.32.14,3.8,3.8,0,0,1-1.83-.43,3.11,3.11,0,0,1-1.28-1.21,3.8,3.8,0,0,1-.48-1.9,3.52,3.52,0,0,1,.54-1.89,3.59,3.59,0,0,1,1.32-1.22,3.51,3.51,0,0,1,1.69-.43,5.15,5.15,0,0,1,1.3.14,4.23,4.23,0,0,1,.89.34l.24,1.43h-.12l-.13-.28a2.45,2.45,0,0,0-.8-1,2.38,2.38,0,0,0-1.43-.42,2.31,2.31,0,0,0-1.87.87,3.86,3.86,0,0,0-.7,2.41,4,4,0,0,0,.77,2.54,2.5,2.5,0,0,0,2,.92,2.28,2.28,0,0,0,1.34-.36,2.62,2.62,0,0,0,.83-1.1l.13-.28Zm-9.19-2.8-.19,0a.63.63,0,0,0-.44.24,3.93,3.93,0,0,0-.4.77l-1.92,4.58a2.57,2.57,0,0,1-.52.87.74.74,0,0,1-.57.24.42.42,0,0,1-.31-.11.45.45,0,0,1-.11-.31c0-.17.1-.3.31-.4a1.67,1.67,0,0,1,.85-.08,13.14,13.14,0,0,0,.59-1.26l-1.53-3.6a3.44,3.44,0,0,0-.36-.73.61.61,0,0,0-.42-.21l-.21,0v-.11h2.22V612l-.25,0a.65.65,0,0,0-.31.1.21.21,0,0,0-.07.2.93.93,0,0,0,0,.27,1.76,1.76,0,0,0,.1.3l1.14,2.87,1-2.43a2.94,2.94,0,0,0,.25-1c0-.2-.12-.31-.35-.35l-.27,0v-.11h1.77Zm-5.65,4.59H1262a9.38,9.38,0,0,0-.65-1l-1-1.46-.34.32v1a4.92,4.92,0,0,0,0,.64.39.39,0,0,0,.16.29.85.85,0,0,0,.35.11l.2,0v.11h-2.23v-.11l.21,0a.85.85,0,0,0,.35-.11.47.47,0,0,0,.15-.29,5.14,5.14,0,0,0,0-.64v-4.9a.84.84,0,0,0-.09-.5.7.7,0,0,0-.37-.24l-.29-.11v-.08l1.41-.33.09.06v4.88l1.18-1.11a3.8,3.8,0,0,0,.41-.42.46.46,0,0,0,.14-.29c0-.17-.13-.28-.41-.32l-.21,0v-.12h2V612h-.11a1,1,0,0,0-.47.15,4.47,4.47,0,0,0-.62.5l-1.09,1,1.52,2.09a3.63,3.63,0,0,0,.46.53.58.58,0,0,0,.35.17l.19,0Zm-5.53-1.84a1.72,1.72,0,0,1-.33,1,2.14,2.14,0,0,1-.9.67,3.06,3.06,0,0,1-1.29.25,5.38,5.38,0,0,1-1.06-.1,3.07,3.07,0,0,1-.69-.23l-.23-1.32h.12l.14.29a2.15,2.15,0,0,0,.76.93,1.85,1.85,0,0,0,1,.26,2.07,2.07,0,0,0,1.33-.38,1.28,1.28,0,0,0,.46-1.08,1.19,1.19,0,0,0-.35-.94,2.84,2.84,0,0,0-1.26-.59,3.85,3.85,0,0,1-1.52-.72,1.67,1.67,0,0,1-.51-1.3,1.71,1.71,0,0,1,.3-1,2,2,0,0,1,.8-.64,2.6,2.6,0,0,1,1.13-.24,5.14,5.14,0,0,1,1,.08,2.73,2.73,0,0,1,.68.21l.22,1.36h-.12l-.13-.29a2.14,2.14,0,0,0-.69-.92,1.59,1.59,0,0,0-1-.27,1.63,1.63,0,0,0-1.13.37,1.26,1.26,0,0,0-.39,1,1.12,1.12,0,0,0,.33.91,3.07,3.07,0,0,0,1.27.58,3.53,3.53,0,0,1,1.57.79A1.77,1.77,0,0,1,1257.74,614.75Z"
              />
              <path
                class="cls-15"
                d="M1357.72,667.2v-9.61h.83l5.27,5.72v-5.72h2v9.61H1365l-5.28-5.72v5.72ZM1347,660a3.71,3.71,0,0,0,0,4.82,3.29,3.29,0,0,0,4.54,0,3.68,3.68,0,0,0,0-4.82,3.29,3.29,0,0,0-4.54,0Zm-2.44,4.4a5.15,5.15,0,0,1,0-4,4.67,4.67,0,0,1,1.08-1.59,4.9,4.9,0,0,1,1.63-1,5.48,5.48,0,0,1,4,0,4.78,4.78,0,0,1,2.71,2.63,5.15,5.15,0,0,1,0,4,5,5,0,0,1-1.08,1.59,5.17,5.17,0,0,1-1.63,1,5.48,5.48,0,0,1-4,0,5.06,5.06,0,0,1-1.63-1A4.67,4.67,0,0,1,1344.55,664.39Zm-5.33,2.81v-9.61h1.94v9.61Zm-9.88-8v-1.65h6.55v1.65h-2.3v8h-1.94v-8Zm-11.11,3.16a5.09,5.09,0,0,1,.67-2.58,4.7,4.7,0,0,1,1.84-1.78,5.31,5.31,0,0,1,2.61-.64,5.41,5.41,0,0,1,1.49.17,5.09,5.09,0,0,1,1.27.55l.15,2H1326a4.23,4.23,0,0,0-2.56-1,3.16,3.16,0,0,0-2.39.9,3.57,3.57,0,0,0,0,4.67,3.13,3.13,0,0,0,2.39.91,4.26,4.26,0,0,0,2.56-1h.26l-.15,2a5.55,5.55,0,0,1-1.27.56,5.88,5.88,0,0,1-1.49.17,5.51,5.51,0,0,1-2-.38,4.83,4.83,0,0,1-1.62-1,4.64,4.64,0,0,1-1.07-1.59A5.14,5.14,0,0,1,1318.23,662.4Zm-8.9,4.8v-9.61h6.1v1.65h-4.16v2.2h4v1.65h-4v2.47h4.21v1.64Zm-10,0v-9.61h2v8H1306v1.64Zm-10,0v-9.61h2v8h4.68v1.64ZM1278.57,660a3.71,3.71,0,0,0,0,4.82,3.3,3.3,0,0,0,4.55,0,3.71,3.71,0,0,0,0-4.82,3.3,3.3,0,0,0-4.55,0Zm-2.44,4.4a5.15,5.15,0,0,1,0-4,4.78,4.78,0,0,1,2.71-2.63,5.48,5.48,0,0,1,4,0,4.9,4.9,0,0,1,1.63,1,4.67,4.67,0,0,1,1.08,1.59,5.15,5.15,0,0,1,0,4,4.67,4.67,0,0,1-1.08,1.59,5.06,5.06,0,0,1-1.63,1,5.48,5.48,0,0,1-4,0,5.17,5.17,0,0,1-1.63-1A5,5,0,0,1,1276.13,664.39Zm-11-2a5.08,5.08,0,0,1,.66-2.58,4.7,4.7,0,0,1,1.84-1.78,5.31,5.31,0,0,1,2.61-.64,5.41,5.41,0,0,1,1.49.17,4.94,4.94,0,0,1,1.27.55l.15,2h-.26a4.23,4.23,0,0,0-2.56-1,3.16,3.16,0,0,0-2.39.9,3.57,3.57,0,0,0,0,4.67,3.13,3.13,0,0,0,2.39.91,4.26,4.26,0,0,0,2.56-1h.26l-.15,2a5.55,5.55,0,0,1-1.27.56,5.82,5.82,0,0,1-1.49.17,5.51,5.51,0,0,1-2-.38,4.69,4.69,0,0,1-2.69-2.62A5.13,5.13,0,0,1,1265.18,662.4Zm-17.55,4.8v-9.61h.82l5.28,5.72v-5.72h2v9.61h-.83l-5.27-5.72v5.72ZM1237,660a3.71,3.71,0,0,0,0,4.82,3.3,3.3,0,0,0,4.55,0,3.71,3.71,0,0,0,0-4.82,3.3,3.3,0,0,0-4.55,0Zm-2.44,4.4a5.15,5.15,0,0,1,0-4,4.67,4.67,0,0,1,1.08-1.59,4.9,4.9,0,0,1,1.63-1,5.48,5.48,0,0,1,4,0,5,5,0,0,1,1.63,1,4.81,4.81,0,0,1,1.08,1.59,5.15,5.15,0,0,1,0,4,4.81,4.81,0,0,1-1.08,1.59,5.17,5.17,0,0,1-1.63,1,5.48,5.48,0,0,1-4,0,5.06,5.06,0,0,1-1.63-1A4.67,4.67,0,0,1,1234.59,664.39Zm-10.41,2.81v-.27l4.52-7.69h-4.11v-1.65h7v.27l-4.51,7.7h4.67v1.64Zm-4.93,0v-9.61h2v9.61Zm-8.2-5.74h.92c1,0,1.44-.36,1.44-1.1s-.48-1.1-1.44-1.1h-.92Zm-2,5.74v-9.61h3a3.52,3.52,0,0,1,2.33.74,2.48,2.48,0,0,1,.9,2,2.65,2.65,0,0,1-.49,1.6,2.74,2.74,0,0,1-1.33,1l2.57,4.28H1214l-2.45-4.06h-.46v4.06ZM1198.51,660a3.68,3.68,0,0,0,0,4.82,3.29,3.29,0,0,0,4.54,0,3.71,3.71,0,0,0,0-4.82,3.29,3.29,0,0,0-4.54,0Zm-2.45,4.4a5.15,5.15,0,0,1,0-4,4.78,4.78,0,0,1,2.71-2.63,5.48,5.48,0,0,1,4,0,4.9,4.9,0,0,1,1.63,1,4.67,4.67,0,0,1,1.08,1.59,5.15,5.15,0,0,1,0,4,4.67,4.67,0,0,1-1.08,1.59,5.06,5.06,0,0,1-1.63,1,5.48,5.48,0,0,1-4,0,5.17,5.17,0,0,1-1.63-1A5,5,0,0,1,1196.06,664.39Zm-11.22,2.81v-9.61h1.94v3.72h3.81v-3.72h2v9.61h-2V663h-3.81v4.24Z"
              />
              <text class="cls-17" transform="translate(224.5 274.66)">
                Sky
                <tspan x="-8.86" y="10">Garden</tspan>
              </text>
              <text class="cls-17" transform="translate(224.5 437.66)">
                Sky
                <tspan x="-8.86" y="10">Garden</tspan>
              </text>
              <text class="cls-17" transform="translate(867.5 274.66)">
                Sky
                <tspan x="-8.86" y="10">Garden</tspan>
              </text>
              <text class="cls-17" transform="translate(867.5 437.66)">
                Sky
                <tspan x="-8.86" y="10">Garden</tspan>
              </text>
              <text class="cls-17" transform="translate(594.5 335.66)">
                Sky
                <tspan x="-8.86" y="10">Garden</tspan>
              </text>
              <text class="cls-17" transform="translate(1205.5 335.66)">
                Sky
                <tspan x="-8.86" y="10">Garden</tspan>
              </text>
            </g>
            <g id="Floorplan_title" data-name="Floorplan title">
              <path
                class="cls-5"
                d="M821.64,18V.34h1.51l9.69,10.52V.34h3.58V18H834.9L825.22,7.49V18ZM801.93,4.75a6,6,0,0,0-1.64,4.42,6,6,0,0,0,1.64,4.43,6,6,0,0,0,8.34,0,6,6,0,0,0,1.65-4.43,6,6,0,0,0-1.65-4.42,6,6,0,0,0-8.34,0Zm-4.49,8.08a9.17,9.17,0,0,1-.73-3.66,9.15,9.15,0,0,1,.73-3.65,9,9,0,0,1,2-2.92,9.1,9.1,0,0,1,3-1.9,10,10,0,0,1,7.36,0,9.25,9.25,0,0,1,3,1.9,9.16,9.16,0,0,1,2.71,6.57,9.17,9.17,0,0,1-.73,3.66,8.87,8.87,0,0,1-2,2.92,9.27,9.27,0,0,1-3,1.91,10,10,0,0,1-7.36,0,9.12,9.12,0,0,1-3-1.91A8.75,8.75,0,0,1,797.44,12.83ZM786.9,18V.34h3.58V18ZM768.77,3.37v-3h12v3h-4.23V18H773V3.37Zm-19.89,5.8a9.18,9.18,0,0,1,1.23-4.72,8.57,8.57,0,0,1,3.37-3.28A9.85,9.85,0,0,1,758.27,0,10.34,10.34,0,0,1,761,.31a8.94,8.94,0,0,1,2.32,1L763.62,5h-.48a7.76,7.76,0,0,0-4.71-1.76,5.77,5.77,0,0,0-4.38,1.66,6,6,0,0,0-1.59,4.28,6,6,0,0,0,1.59,4.3,5.77,5.77,0,0,0,4.38,1.67,7.84,7.84,0,0,0,4.71-1.78h.48L763.33,17a9.56,9.56,0,0,1-2.33,1,10.31,10.31,0,0,1-2.73.31,10,10,0,0,1-3.72-.69,9.18,9.18,0,0,1-3-1.89,8.77,8.77,0,0,1-2-2.92A9.41,9.41,0,0,1,748.88,9.17ZM732,18V.34h11.2v3H735.6v4H743v3H735.6V15h7.71v3Zm-17.88,0V.34h3.58V15h8.61v3Zm-18.37,0V.34h3.57V15H708v3ZM676.05,4.75a6.07,6.07,0,0,0-1.64,4.42,6.07,6.07,0,0,0,1.64,4.43,6,6,0,0,0,8.35,0A6,6,0,0,0,686,9.17a6,6,0,0,0-1.64-4.42,6.05,6.05,0,0,0-8.35,0Zm-4.48,8.08a9.17,9.17,0,0,1-.73-3.66,9.16,9.16,0,0,1,2.71-6.57,9.25,9.25,0,0,1,3-1.9,10,10,0,0,1,7.36,0,9.1,9.1,0,0,1,3,1.9,9,9,0,0,1,2,2.92,9.15,9.15,0,0,1,.73,3.65,9.17,9.17,0,0,1-.73,3.66,8.75,8.75,0,0,1-2,2.92,9.12,9.12,0,0,1-3,1.91,10,10,0,0,1-7.36,0,9.27,9.27,0,0,1-3-1.91A8.87,8.87,0,0,1,671.57,12.83ZM650.7,9.17a9.18,9.18,0,0,1,1.23-4.72,8.57,8.57,0,0,1,3.37-3.28A9.85,9.85,0,0,1,660.09,0a10.34,10.34,0,0,1,2.74.31,8.94,8.94,0,0,1,2.32,1L665.44,5H665a7.76,7.76,0,0,0-4.71-1.76,5.77,5.77,0,0,0-4.38,1.66,5.91,5.91,0,0,0-1.6,4.28,6,6,0,0,0,1.6,4.3,5.77,5.77,0,0,0,4.38,1.67A7.84,7.84,0,0,0,665,13.36h.48L665.15,17a9.56,9.56,0,0,1-2.33,1,10.36,10.36,0,0,1-2.73.31,10,10,0,0,1-3.72-.69,9.08,9.08,0,0,1-3-1.89,8.77,8.77,0,0,1-2-2.92A9.41,9.41,0,0,1,650.7,9.17Zm-31,8.84V.34h3.58v8l6.15-8h3.89L626.73,8.9,634,18h-4.23l-6.44-8V18ZM603.55,12h4.58L605.84,6.6Zm-6,6.06L605.32.34h1L614.18,18H610.7l-1.31-3h-7.1L601,18ZM581,18V.34h11.2v3h-7.62v4h7.35v3h-7.35V15h7.72v3ZM567.43,8.26H569c1.91,0,2.87-.8,2.87-2.41s-1-2.43-2.87-2.43h-1.58ZM563.85,18V.34H569a7,7,0,0,1,4.73,1.49,5,5,0,0,1,1.74,4,5,5,0,0,1-1.74,4A7,7,0,0,1,569,11.34h-1.56V18Z"
              />
              <path
                class="cls-5"
                d="M1137.56,107.64a6,6,0,0,1-1.18,3.48,7.79,7.79,0,0,1-2.84,2.34,8.14,8.14,0,0,1-3.49.87,3.74,3.74,0,0,1-2-.48,1.36,1.36,0,0,1-.68-1.16,1.21,1.21,0,0,1,.39-.89,1.24,1.24,0,0,1,.84-.32,2.44,2.44,0,0,1,1.44.46,6.21,6.21,0,0,1,1.45,1.51,4.82,4.82,0,0,0,2.73-1.43,4.17,4.17,0,0,0,1.08-3,3,3,0,0,0-1-2.47,4.09,4.09,0,0,0-2.59-.77,6.44,6.44,0,0,0-2.23.4l-.25-.5a27.88,27.88,0,0,0,3.32-2.11,6.66,6.66,0,0,0,1.62-1.66,2.72,2.72,0,0,0,.43-1.54,1.87,1.87,0,0,0-.64-1.49,2.88,2.88,0,0,0-1.89-.6,5.08,5.08,0,0,0-2.21.47,8.61,8.61,0,0,0-1.94,1.29l-.3-.37a9.73,9.73,0,0,1,2.7-2.29,6.34,6.34,0,0,1,3.1-.78,4.61,4.61,0,0,1,2.81.79,2.53,2.53,0,0,1,1,2.13,3.28,3.28,0,0,1-.93,2.2,11.89,11.89,0,0,1-2.88,2.17,5.33,5.33,0,0,1,3,1.11A3.32,3.32,0,0,1,1137.56,107.64Zm-15.24,6.43h-1l-1.6,0-1.33,0-1.39,0-1.71,0h-1.09v-.37l1-.15a2.53,2.53,0,0,0,1.14-.39,1.64,1.64,0,0,0,.52-1.07,16.73,16.73,0,0,0,.12-2.34V101.3a9.69,9.69,0,0,0-.16-2.09,1.2,1.2,0,0,0-.62-.89,2.7,2.7,0,0,0-1.28-.19h-.7v-.4c.55-.07,1.16-.18,1.81-.32s1.28-.3,1.88-.46,1.11-.33,1.53-.48l.33.2v13.08a16.44,16.44,0,0,0,.12,2.31,1.76,1.76,0,0,0,.49,1.08,2.07,2.07,0,0,0,1,.41l.93.15ZM1100,103.13a2.58,2.58,0,0,1-.34,1.4.9.9,0,0,1-.71.44,3.35,3.35,0,0,1-.91-.2,16.47,16.47,0,0,1-1.6-.68,5.94,5.94,0,0,0-1.51,1v5.55a9,9,0,0,0,.13,1.81,1.16,1.16,0,0,0,.5.83,2.93,2.93,0,0,0,1.15.33l.48.08v.37h-6.75v-.37l.47-.08a1.29,1.29,0,0,0,.77-.29,1.38,1.38,0,0,0,.35-.85,13.4,13.4,0,0,0,.09-1.8v-5.26a2.9,2.9,0,0,0-.21-1.38,1.77,1.77,0,0,0-.9-.71l-.6-.3v-.27l4.19-.93.33.22v2.27a9.15,9.15,0,0,1,2-2,2.82,2.82,0,0,1,1.65-.5,1.63,1.63,0,0,1,1.06.31A1.2,1.2,0,0,1,1100,103.13Zm-22.39,3.8v.18a6.55,6.55,0,0,0,1.32,4.07,4,4,0,0,0,3.12,1.49,4.2,4.2,0,0,0,1.82-.38,5.5,5.5,0,0,0,1.55-1.16l.32.25a7.3,7.3,0,0,1-2.26,2.15,5.66,5.66,0,0,1-2.91.8,5.52,5.52,0,0,1-4-1.56,6.05,6.05,0,0,1-1.59-4.38,6.94,6.94,0,0,1,.89-3.52,6.34,6.34,0,0,1,2.22-2.29,5.48,5.48,0,0,1,2.86-.8,4.65,4.65,0,0,1,3.63,1.32,5.7,5.7,0,0,1,1.24,3.83Zm5.27-.68a5.64,5.64,0,0,0-.7-2.86,2,2,0,0,0-1.73-1,2.35,2.35,0,0,0-2,1,5.33,5.33,0,0,0-.86,2.83Zm-11.72-3.77-.41.07a1.92,1.92,0,0,0-1.18.71,7.77,7.77,0,0,0-1,2l-3.59,9-.63.12-3.24-8-3.38,7.9-.66.12-3.71-9.18a10.24,10.24,0,0,0-1-2,1.7,1.7,0,0,0-1.17-.66l-.43-.07v-.38h1.43l1.78,0,1.72,0H1057v.38l-.5.07a1.39,1.39,0,0,0-.71.28.69.69,0,0,0-.2.48,5.58,5.58,0,0,0,.3,1.31l2.39,6.54,2.38-5.76-.37-.91a5.81,5.81,0,0,0-.76-1.41,1.53,1.53,0,0,0-1-.53l-.43-.07v-.38h1.33l1.68,0,1.82,0h1.42v.38l-.52.07a1.49,1.49,0,0,0-.76.28.7.7,0,0,0-.2.5,4.08,4.08,0,0,0,.28,1.39l2.28,6.24,1.86-5.19a7,7,0,0,0,.55-2.26c0-.52-.31-.84-1-1l-.55-.07v-.38l2.54,0,1.31,0h.95ZM1047,108.14a6.64,6.64,0,0,1-.8,3.16,5.7,5.7,0,0,1-2.13,2.2,6.41,6.41,0,0,1-3.17.83,6.6,6.6,0,0,1-3.13-.73,5.27,5.27,0,0,1-2.15-2.14,7.39,7.39,0,0,1-.8-3.5,6.68,6.68,0,0,1,.79-3.15,5.63,5.63,0,0,1,2.13-2.2,6.27,6.27,0,0,1,3.18-.83,6.52,6.52,0,0,1,3.11.72,5.33,5.33,0,0,1,2.15,2.14A7.27,7.27,0,0,1,1047,108.14Zm-3.09.7a10.51,10.51,0,0,0-.88-4.69,2.77,2.77,0,0,0-2.46-1.75,2.16,2.16,0,0,0-2,1.1,7.38,7.38,0,0,0-.71,3.76,10.92,10.92,0,0,0,.89,4.69,2.75,2.75,0,0,0,2.45,1.75,2.17,2.17,0,0,0,2-1.1A7.53,7.53,0,0,0,1043.87,108.84Zm-11.22-12.52-.76,4.78h-.4l-.25-1.24a2.48,2.48,0,0,0-.88-1.67,4.23,4.23,0,0,0-2.36-.51l-2.58-.05v12.12a14.88,14.88,0,0,0,.13,2.33,1.69,1.69,0,0,0,.54,1.06,2.49,2.49,0,0,0,1.21.41l.93.15v.37h-1.12l-1.74,0-1.44,0-1.4,0-1.75,0h-1.11v-.37l.93-.15a2.48,2.48,0,0,0,1.2-.41,1.6,1.6,0,0,0,.54-1.06,14.62,14.62,0,0,0,.14-2.33V97.63l-2.26.05a7.23,7.23,0,0,0-1.88.23,2.62,2.62,0,0,0-1.18.7,4.76,4.76,0,0,0-.83,1.25l-.6,1.24h-.41l.58-4.78h.45a2.62,2.62,0,0,0,.52.3,3.64,3.64,0,0,0,1,.19c.48,0,1.2.07,2.17.09l4,0,4.16,0c1,0,1.79-.05,2.3-.09a5,5,0,0,0,1.12-.19,2.8,2.8,0,0,0,.6-.3Zm-629,17.75h-1l-1.6,0-1.33,0-1.39,0-1.71,0h-1.09v-.37l1-.15a2.53,2.53,0,0,0,1.14-.39,1.64,1.64,0,0,0,.52-1.07,16.73,16.73,0,0,0,.12-2.34V101.3a9.69,9.69,0,0,0-.16-2.09,1.23,1.23,0,0,0-.62-.89,2.72,2.72,0,0,0-1.28-.19h-.7v-.4c.55-.07,1.15-.18,1.81-.32s1.28-.3,1.88-.46,1.11-.33,1.53-.48l.33.2v13.08a16.44,16.44,0,0,0,.12,2.31,1.76,1.76,0,0,0,.49,1.08,2,2,0,0,0,1,.41l.93.15Zm-13.06,0h-1l-1.59,0-1.33,0-1.4,0-1.7,0h-1.09v-.37l1-.15a2.53,2.53,0,0,0,1.15-.39,1.59,1.59,0,0,0,.51-1.07,16.4,16.4,0,0,0,.13-2.34V101.3a9.55,9.55,0,0,0-.17-2.09,1.22,1.22,0,0,0-.61-.89,2.72,2.72,0,0,0-1.28-.19h-.7v-.4c.55-.07,1.15-.18,1.8-.32s1.28-.3,1.89-.46,1.11-.33,1.53-.48l.32.2v13.08a16.12,16.12,0,0,0,.13,2.31,1.71,1.71,0,0,0,.49,1.08,2,2,0,0,0,1,.41l.92.15Zm-22.11-10.94a2.58,2.58,0,0,1-.34,1.4.9.9,0,0,1-.72.44,3.3,3.3,0,0,1-.9-.2,16.45,16.45,0,0,1-1.61-.68,5.88,5.88,0,0,0-1.5,1v5.55a10,10,0,0,0,.12,1.81,1.16,1.16,0,0,0,.5.83,3,3,0,0,0,1.16.33l.48.08v.37h-6.76v-.37l.48-.08a1.26,1.26,0,0,0,.76-.29,1.38,1.38,0,0,0,.36-.85,15.81,15.81,0,0,0,.08-1.8v-5.26a2.78,2.78,0,0,0-.21-1.38,1.78,1.78,0,0,0-.89-.71l-.6-.3v-.27l4.19-.93.33.22v2.27a8.93,8.93,0,0,1,2-2,2.81,2.81,0,0,1,1.64-.5,1.66,1.66,0,0,1,1.07.31A1.2,1.2,0,0,1,368.45,103.13Zm-22.4,3.8v.18a6.61,6.61,0,0,0,1.32,4.07,4,4,0,0,0,3.13,1.49,4.23,4.23,0,0,0,1.82-.38,5.47,5.47,0,0,0,1.54-1.16l.33.25a7.52,7.52,0,0,1-2.26,2.15,5.72,5.72,0,0,1-2.91.8,5.51,5.51,0,0,1-4-1.56,6.1,6.1,0,0,1-1.6-4.38,7.15,7.15,0,0,1,.89-3.52,6.29,6.29,0,0,1,2.23-2.29,5.45,5.45,0,0,1,2.86-.8,4.66,4.66,0,0,1,3.63,1.32,5.76,5.76,0,0,1,1.24,3.83Zm5.28-.68a5.64,5.64,0,0,0-.71-2.86,2,2,0,0,0-1.73-1,2.33,2.33,0,0,0-2,1,5.42,5.42,0,0,0-.87,2.83Zm-11.73-3.77-.4.07a1.9,1.9,0,0,0-1.18.71,7.47,7.47,0,0,0-1,2l-3.59,9-.63.12-3.24-8-3.39,7.9-.65.12-3.72-9.18a9.21,9.21,0,0,0-1-2,1.68,1.68,0,0,0-1.17-.66l-.42-.07v-.38h1.43l1.78,0,1.72,0h1.34v.38l-.5.07a1.35,1.35,0,0,0-.7.28.65.65,0,0,0-.2.48,4.74,4.74,0,0,0,.3,1.31l2.38,6.54,2.39-5.76-.38-.91a6.22,6.22,0,0,0-.75-1.41,1.56,1.56,0,0,0-1-.53l-.42-.07v-.38h1.33l1.68,0,1.82,0h1.42v.38l-.53.07a1.41,1.41,0,0,0-.75.28.66.66,0,0,0-.2.5,4.3,4.3,0,0,0,.27,1.39l2.29,6.24,1.86-5.19a7.31,7.31,0,0,0,.55-2.26c0-.52-.31-.84-1-1l-.55-.07v-.38l2.53,0,1.32,0h.94Zm-24.15,5.66a6.75,6.75,0,0,1-.79,3.16,5.7,5.7,0,0,1-2.13,2.2,6.45,6.45,0,0,1-3.18.83,6.59,6.59,0,0,1-3.12-.73,5.22,5.22,0,0,1-2.15-2.14,7.27,7.27,0,0,1-.8-3.5,6.57,6.57,0,0,1,.79-3.15,5.63,5.63,0,0,1,2.13-2.2,6.22,6.22,0,0,1,3.18-.83,6.52,6.52,0,0,1,3.11.72,5.4,5.4,0,0,1,2.15,2.14A7.39,7.39,0,0,1,315.45,108.14Zm-3.09.7a10.37,10.37,0,0,0-.88-4.69A2.75,2.75,0,0,0,309,102.4a2.17,2.17,0,0,0-2,1.1,7.4,7.4,0,0,0-.7,3.76,10.63,10.63,0,0,0,.89,4.69,2.74,2.74,0,0,0,2.45,1.75,2.16,2.16,0,0,0,2-1.1A7.53,7.53,0,0,0,312.36,108.84ZM301.14,96.32l-.75,4.78H300l-.25-1.24a2.52,2.52,0,0,0-.88-1.67,4.23,4.23,0,0,0-2.36-.51l-2.59-.05v12.12a14.62,14.62,0,0,0,.14,2.33,1.6,1.6,0,0,0,.54,1.06,2.48,2.48,0,0,0,1.2.41l.93.15v.37h-1.11l-1.75,0-1.43,0L291,114l-1.74,0h-1.12v-.37l.93-.15a2.49,2.49,0,0,0,1.21-.41,1.69,1.69,0,0,0,.54-1.06,14.88,14.88,0,0,0,.13-2.33V97.63l-2.26.05a7.29,7.29,0,0,0-1.88.23,2.68,2.68,0,0,0-1.18.7,4.76,4.76,0,0,0-.83,1.25l-.6,1.24h-.4l.58-4.78h.45a2.54,2.54,0,0,0,.51.3,3.74,3.74,0,0,0,1,.19c.47,0,1.2.07,2.17.09l4,0,4.17,0c1,0,1.78-.05,2.3-.09a4.74,4.74,0,0,0,1.11-.19,2.4,2.4,0,0,0,.6-.3Z"
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
                <div class="left_imgcontent">
      <h2 style="margin-top: 2vh;text-align: end; width: 80%">FLOOR PLAN</h2>
    </div>
  </div>
</template>

<script>
import "viewerjs/dist/viewer.css";
import VueViewer from "v-viewer";
import Vue from "vue";
import { api as viewerApi } from "v-viewer";
Vue.use(VueViewer);

export default {
  data() {
    return {};
  },
  methods: {
    setimgpop(e) {
      // 图片预览组件
      //   console.log(e, e.path[1].id);
      // if (!e.path[1].id) {
      //   window.alert("click img error !");
      //   return;
      // }
      // API使用方式必须以下面的列表格式传值
      this.nowimglist = [
        {
          src: `${this.Main.imgserve}/FLOORPLAN/${e}.png`,
          // src: `${this.Main.imgserve}/FLOORPLAN/${e.path[1].id}.png`,
          // "data-source": `${this.Main.imgserve}/FLOORPLAN/${e.path[1].id}.png`,
        },
      ];
      // console.log(this.nowimglist)
      // 配置并执行this.$viewerApi({options:{参数}},images:[图片列表])
      this.$viewer = this.$viewerApi({
        options: {
          toolbar: false, // 功能栏
          navbar: false, // 图片预览列表
          title: false, // 图片标题
          //   tooltip:10,
          // url: "data-source",
          //   initialViewIndex:0,
        },
        images: this.nowimglist,
      });

      setTimeout(() => {
        // 延时处理 图片缩放、位置偏移，
        //
        this.win_w =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
        this.win_h =
          window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight;
        // 取消移动端缩放大小效果、移动端缩放4倍时图片过大、故不做处理。
        if (this.win_w < 860 || this.win_h < 860) return;

        this.$viewer.move(0, 400);
        this.$viewer.zoomTo(0.4);
      }, 1000);
    },
  },
  mounted() {},
};
</script>

<style lang="less">
.FLOORPLAN {
  width: 100%;
  height: 100%;
  margin: auto;
  background-color: rgb(237, 230, 220);
  .floorcontent {
    width: 95%;
    height: 100%;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      position: relative;
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
  }
}
.cls-1 {
font-size: 28px;
fill: #77746e;
font-family: Value-Bold, Value;
font-weight: 700;
}
.cls-2 {
letter-spacing: -0.04em;
}
.cls-14,
.cls-16,
.cls-3,
.cls-6 {
fill: none;
}
.cls-13,
.cls-14,
.cls-3 {
stroke: #9d9588;
}
.cls-13,
.cls-14,
.cls-16,
.cls-3,
.cls-6 {
stroke-width: 0.24px;
}
.cls-4 {
fill: #f4dad7;
}
.cls-17,
.cls-5 {
fill: #9d9588;
}
.cls-6 {
stroke: #000;
}
.cls-7 {
fill: #dccfdf;
}
.cls-8 {
fill: #f1f0d2;
}
.cls-9 {
fill: #d5e3ed;
}
.cls-10,
.cls-17 {
font-size: 12px;
font-family: TimesNewRomanPSMT, Times New Roman;
letter-spacing: 0.03em;
}
.cls-11 {
fill: #ecd2d3;
}
.cls-12,
.cls-13 {
fill: #fff;
}
.cls-13,
.cls-14,
.cls-16 {
stroke-miterlimit: 10;
}
.cls-15 {
fill: #618b67;
}
.cls-16 {
stroke: #618b67;
}
</style>
